const Airports = [
  {
    "value": "UTK",
    "label": "Utirik Island (UTK)"
  },
  {
    "value": "FIV",
    "label": "Five Finger (FIV)"
  },
  {
    "value": "FAK",
    "label": "False Island (FAK)"
  },
  {
    "value": "BYW",
    "label": "Blakely Island (BYW)"
  },
  {
    "value": "BDF",
    "label": "Bradford (BDF)"
  },
  {
    "value": "ATT",
    "label": "Atmautluak (ATT)"
  },
  {
    "value": "WKK",
    "label": "Aleknagik (WKK)"
  },
  {
    "value": "BCS",
    "label": "Belle Chasse (BCS)"
  },
  {
    "value": "TSS",
    "label": "New York (TSS)"
  },
  {
    "value": "BWL",
    "label": "Blackwell (BWL)"
  },
  {
    "value": "DUF",
    "label": "Corolla (DUF)"
  },
  {
    "value": "FOB",
    "label": "Fort Bragg (FOB)"
  },
  {
    "value": "CCD",
    "label": "Los Angeles (CCD)"
  },
  {
    "value": "CHU",
    "label": "Chuathbaluk (CHU)"
  },
  {
    "value": "ABP",
    "label": "Atkamba Mission (ABP)"
  },
  {
    "value": "ALV",
    "label": "Andorra La Vella (ALV)"
  },
  {
    "value": "ADC",
    "label": "Andekombe (ADC)"
  },
  {
    "value": "TJP",
    "label": "Areopuerto Internacional Michael Gonzalez (TJP)"
  },
  {
    "value": "AEE",
    "label": "Adareil Airport (AEE)"
  },
  {
    "value": "AEI",
    "label": "Algeciras (AEI)"
  },
  {
    "value": "AEK",
    "label": "Aseki (AEK)"
  },
  {
    "value": "OLR",
    "label": "Salerno Landing Zone Airport (OLR)"
  },
  {
    "value": "AFR",
    "label": "Afore Airstrip (AFR)"
  },
  {
    "value": "AFT",
    "label": "Bila (AFT)"
  },
  {
    "value": "RNA",
    "label": "Arona (RNA)"
  },
  {
    "value": "ATD",
    "label": "Atoifi (ATD)"
  },
  {
    "value": "VEV",
    "label": "Barakoma (VEV)"
  },
  {
    "value": "GEF",
    "label": "Liangia (GEF)"
  },
  {
    "value": "AGG",
    "label": "Angoram (AGG)"
  },
  {
    "value": "AKS",
    "label": "Auki (AKS)"
  },
  {
    "value": "BNY",
    "label": "Anua (BNY)"
  },
  {
    "value": "CHY",
    "label": "Choiseul Bay Airport (CHY)"
  },
  {
    "value": "BAS",
    "label": "Ballalae (BAS)"
  },
  {
    "value": "FRE",
    "label": "Fera Island (FRE)"
  },
  {
    "value": "HIR",
    "label": "Honiara (HIR)"
  },
  {
    "value": "MBU",
    "label": "Mbambanakira (MBU)"
  },
  {
    "value": "AVU",
    "label": "Avu Avu Airport (AVU)"
  },
  {
    "value": "IRA",
    "label": "Kirakira (IRA)"
  },
  {
    "value": "SCZ",
    "label": "Santa Cruz/Graciosa Bay/Luova (SCZ)"
  },
  {
    "value": "MUA",
    "label": "Munda Airport (MUA)"
  },
  {
    "value": "GZO",
    "label": "Gizo (GZO)"
  },
  {
    "value": "MNY",
    "label": "Stirling Island (MNY)"
  },
  {
    "value": "PRS",
    "label": "Parasi (PRS)"
  },
  {
    "value": "RNL",
    "label": "Rennell Island (RNL)"
  },
  {
    "value": "EGM",
    "label": "Sege (EGM)"
  },
  {
    "value": "RUS",
    "label": "Marau (RUS)"
  },
  {
    "value": "VAO",
    "label": "Suavanao (VAO)"
  },
  {
    "value": "XYA",
    "label": "Yandina (XYA)"
  },
  {
    "value": "AGK",
    "label": "Kagua (AGK)"
  },
  {
    "value": "KGE",
    "label": "Kagau Island (KGE)"
  },
  {
    "value": "AGL",
    "label": "Wanigela Airport (AGL)"
  },
  {
    "value": "RIN",
    "label": "Ringi Cove (RIN)"
  },
  {
    "value": "RBV",
    "label": "Ramata (RBV)"
  },
  {
    "value": "TLG",
    "label": "Tulaghi Island (TLG)"
  },
  {
    "value": "AHY",
    "label": "Ambatolahy (AHY)"
  },
  {
    "value": "AIE",
    "label": "Aiome (AIE)"
  },
  {
    "value": "AIH",
    "label": "Aiambak (AIH)"
  },
  {
    "value": "AIP",
    "label": "Bigatyelang Island (AIP)"
  },
  {
    "value": "LNI",
    "label": "Lonely (LNI)"
  },
  {
    "value": "CDL",
    "label": "Candle (CDL)"
  },
  {
    "value": "AOS",
    "label": "Amook Bay (AOS)"
  },
  {
    "value": "BSZ",
    "label": "Egegik (BSZ)"
  },
  {
    "value": "BSW",
    "label": "Boswell Bay (BSW)"
  },
  {
    "value": "AKM",
    "label": "ZaKouma (AKM)"
  },
  {
    "value": "ALZ",
    "label": "Lazy Bay (ALZ)"
  },
  {
    "value": "AME",
    "label": "Alto Molocue (AME)"
  },
  {
    "value": "AMF",
    "label": "AMA Airport (AMF)"
  },
  {
    "value": "AMU",
    "label": "Amanab (AMU)"
  },
  {
    "value": "AMY",
    "label": "Ambatomainty Airport (AMY)"
  },
  {
    "value": "INU",
    "label": "Yaren District (INU)"
  },
  {
    "value": "ANL",
    "label": "Andulo Airport (ANL)"
  },
  {
    "value": "CNZ",
    "label": "Cangamba (CNZ)"
  },
  {
    "value": "DRC",
    "label": "Dirico (DRC)"
  },
  {
    "value": "GGC",
    "label": "Lumbala (GGC)"
  },
  {
    "value": "JMB",
    "label": "Jamba (JMB)"
  },
  {
    "value": "KNP",
    "label": "Capanda (KNP)"
  },
  {
    "value": "NDF",
    "label": "Ndalatandos (NDF)"
  },
  {
    "value": "AOB",
    "label": "Annanberg Airport (AOB)"
  },
  {
    "value": "APP",
    "label": "Asapa Airport (APP)"
  },
  {
    "value": "APR",
    "label": "April River Airport (APR)"
  },
  {
    "value": "AQY",
    "label": "Girdwood (AQY)"
  },
  {
    "value": "QRF",
    "label": "Bragado (QRF)"
  },
  {
    "value": "CSZ",
    "label": "Coronel Suarez (CSZ)"
  },
  {
    "value": "CVI",
    "label": "Caleta Olivia (CVI)"
  },
  {
    "value": "CNT",
    "label": "Charata (CNT)"
  },
  {
    "value": "VGS",
    "label": "General Villegas (VGS)"
  },
  {
    "value": "LMD",
    "label": "Los Menucos (LMD)"
  },
  {
    "value": "VCF",
    "label": "Valcheta (VCF)"
  },
  {
    "value": "VME",
    "label": "Villa Mercedes (VME)"
  },
  {
    "value": "NCJ",
    "label": "Sunchales (NCJ)"
  },
  {
    "value": "CPG",
    "label": "Carmen de Patagones (CPG)"
  },
  {
    "value": "PRQ",
    "label": "Presidencia Roque SÃ¡enz PeÃ±a (PRQ)"
  },
  {
    "value": "ARP",
    "label": "Aragip Airport (ARP)"
  },
  {
    "value": "TAV",
    "label": "Tau Village (TAV)"
  },
  {
    "value": "ASZ",
    "label": "Asirim Airport (ASZ)"
  },
  {
    "value": "ATN",
    "label": "Namatanai (ATN)"
  },
  {
    "value": "ATP",
    "label": "Aitape (ATP)"
  },
  {
    "value": "BCZ",
    "label": "Bickerton Island (BCZ)"
  },
  {
    "value": "AGW",
    "label": "Agnew (AGW)"
  },
  {
    "value": "AYD",
    "label": "Alroy Downs (AYD)"
  },
  {
    "value": "BCK",
    "label": "Bolwarra (BCK)"
  },
  {
    "value": "BFC",
    "label": "Bloomfield (BFC)"
  },
  {
    "value": "BVW",
    "label": "Batavia Downs (BVW)"
  },
  {
    "value": "BYX",
    "label": "Baniyala (BYX)"
  },
  {
    "value": "COB",
    "label": "Coolibah (COB)"
  },
  {
    "value": "CQP",
    "label": "Cape Flattery (CQP)"
  },
  {
    "value": "CRJ",
    "label": "Coorabie (CRJ)"
  },
  {
    "value": "CRY",
    "label": "Carlton Hill (CRY)"
  },
  {
    "value": "CSD",
    "label": "Cresswell Downs (CSD)"
  },
  {
    "value": "CTR",
    "label": "Cattle Creek (CTR)"
  },
  {
    "value": "DYM",
    "label": "Diamantina Lakes (DYM)"
  },
  {
    "value": "EDD",
    "label": "Erldunda (EDD)"
  },
  {
    "value": "EKD",
    "label": "Elkedra (EKD)"
  },
  {
    "value": "HAT",
    "label": "Heathlands (HAT)"
  },
  {
    "value": "HIG",
    "label": "Highbury (HIG)"
  },
  {
    "value": "HIS",
    "label": "Hayman Island (HIS)"
  },
  {
    "value": "HLV",
    "label": "Helenvale (HLV)"
  },
  {
    "value": "KBD",
    "label": "Kimberley Downs (KBD)"
  },
  {
    "value": "KGR",
    "label": "Kulgera (KGR)"
  },
  {
    "value": "KOH",
    "label": "Koolatah (KOH)"
  },
  {
    "value": "KYF",
    "label": "Yeelirrie (KYF)"
  },
  {
    "value": "LIB",
    "label": "Limbunya (LIB)"
  },
  {
    "value": "MNW",
    "label": "Macdonald Downs (MNW)"
  },
  {
    "value": "MUP",
    "label": "Mulga Park (MUP)"
  },
  {
    "value": "MWY",
    "label": "Miranda Downs (MWY)"
  },
  {
    "value": "MYO",
    "label": "Myroodah (MYO)"
  },
  {
    "value": "NKB",
    "label": "Noonkanbah (NKB)"
  },
  {
    "value": "OKB",
    "label": "Orchid Beach (OKB)"
  },
  {
    "value": "PEP",
    "label": "Peppimenarti (PEP)"
  },
  {
    "value": "RDA",
    "label": "Rockhampton Downs (RDA)"
  },
  {
    "value": "SSK",
    "label": "Sturt Creek (SSK)"
  },
  {
    "value": "SWB",
    "label": "Shaw River (SWB)"
  },
  {
    "value": "TPR",
    "label": "Tom Price (TPR)"
  },
  {
    "value": "TWP",
    "label": "Torwood (TWP)"
  },
  {
    "value": "WRW",
    "label": "Warrawagine (WRW)"
  },
  {
    "value": "WSY",
    "label": "Airlie Beach (WSY)"
  },
  {
    "value": "ZVG",
    "label": "Springvale (ZVG)"
  },
  {
    "value": "AUI",
    "label": "Aua Island Airport (AUI)"
  },
  {
    "value": "AUJ",
    "label": "Ambunti (AUJ)"
  },
  {
    "value": "AUP",
    "label": "Agaun Airport (AUP)"
  },
  {
    "value": "AUV",
    "label": "Aumo Airport (AUV)"
  },
  {
    "value": "AWE",
    "label": "Wonga Wongue Reserve (AWE)"
  },
  {
    "value": "BUA",
    "label": "Buka Island (BUA)"
  },
  {
    "value": "CMU",
    "label": "Kundiawa (CMU)"
  },
  {
    "value": "DAU",
    "label": "Daru (DAU)"
  },
  {
    "value": "FAQ",
    "label": "Frieda River (FAQ)"
  },
  {
    "value": "GKA",
    "label": "Goronka (GKA)"
  },
  {
    "value": "GUR",
    "label": "Gurney (GUR)"
  },
  {
    "value": "GAP",
    "label": "Gusap (GAP)"
  },
  {
    "value": "PNP",
    "label": "Popondetta (PNP)"
  },
  {
    "value": "HKN",
    "label": "Hoskins (HKN)"
  },
  {
    "value": "LSA",
    "label": "Losuia (LSA)"
  },
  {
    "value": "UNG",
    "label": "Kiunga (UNG)"
  },
  {
    "value": "KRI",
    "label": "Kikori (KRI)"
  },
  {
    "value": "KMA",
    "label": "Kerema (KMA)"
  },
  {
    "value": "KVG",
    "label": "Kavieng (KVG)"
  },
  {
    "value": "LNV",
    "label": "Londolovit (LNV)"
  },
  {
    "value": "MAG",
    "label": "Madang (MAG)"
  },
  {
    "value": "HGU",
    "label": "Mount Hagen (HGU)"
  },
  {
    "value": "MDU",
    "label": "Mendi Airport (MDU)"
  },
  {
    "value": "MAS",
    "label": "Momote Airport (MAS)"
  },
  {
    "value": "MXH",
    "label": "Moro (MXH)"
  },
  {
    "value": "MIS",
    "label": "Misima Island (MIS)"
  },
  {
    "value": "LAE",
    "label": "Nadzab (LAE)"
  },
  {
    "value": "POM",
    "label": "Port Moresby (POM)"
  },
  {
    "value": "RMN",
    "label": "Rumginae Airport (RMN)"
  },
  {
    "value": "SBE",
    "label": "Suabi Airport (SBE)"
  },
  {
    "value": "NIS",
    "label": "Simberi Island (NIS)"
  },
  {
    "value": "SIL",
    "label": "Sila Mission (SIL)"
  },
  {
    "value": "SIM",
    "label": "Simbai (SIM)"
  },
  {
    "value": "TIZ",
    "label": "Tari (TIZ)"
  },
  {
    "value": "TBG",
    "label": "Tabubil (TBG)"
  },
  {
    "value": "TPI",
    "label": "Tapini (TPI)"
  },
  {
    "value": "RAB",
    "label": "Tokua (RAB)"
  },
  {
    "value": "TKW",
    "label": "Tekin (TKW)"
  },
  {
    "value": "AYU",
    "label": "Aiyura Valley (AYU)"
  },
  {
    "value": "VAI",
    "label": "Vanimo Airport (VAI)"
  },
  {
    "value": "WAO",
    "label": "Wabo (WAO)"
  },
  {
    "value": "WBM",
    "label": "Wapenamanda Airport (WBM)"
  },
  {
    "value": "WWK",
    "label": "Wewak (WWK)"
  },
  {
    "value": "WOA",
    "label": "Wonenara (WOA)"
  },
  {
    "value": "WSU",
    "label": "Wasu (WSU)"
  },
  {
    "value": "WTP",
    "label": "Fatima Mission (WTP)"
  },
  {
    "value": "WUG",
    "label": "Wau (WUG)"
  },
  {
    "value": "AYY",
    "label": "Pottuvil (AYY)"
  },
  {
    "value": "AZB",
    "label": "Amazon Bay Airport (AZB)"
  },
  {
    "value": "BAJ",
    "label": "Unea Island (BAJ)"
  },
  {
    "value": "BKG",
    "label": "Branson (BKG)"
  },
  {
    "value": "BCP",
    "label": "Bambu (BCP)"
  },
  {
    "value": "BCW",
    "label": "Benguera Island (BCW)"
  },
  {
    "value": "BDZ",
    "label": "Baindoung Airport (BDZ)"
  },
  {
    "value": "HKV",
    "label": "Haskovo (HKV)"
  },
  {
    "value": "JAM",
    "label": "Yambol (JAM)"
  },
  {
    "value": "JEG",
    "label": "Aasiaat (JEG)"
  },
  {
    "value": "AAP",
    "label": "Qaasuitsup (AAP)"
  },
  {
    "value": "AGM",
    "label": "Tasiilaq (AGM)"
  },
  {
    "value": "LLU",
    "label": "Alluitsup Paa (LLU)"
  },
  {
    "value": "QUV",
    "label": "Nanortalik (QUV)"
  },
  {
    "value": "QUW",
    "label": "Ammassivik Heliport (QUW)"
  },
  {
    "value": "QGQ",
    "label": "Attu (QGQ)"
  },
  {
    "value": "UAK",
    "label": "Narsarsuaq (UAK)"
  },
  {
    "value": "JCH",
    "label": "Qasigiannguit (JCH)"
  },
  {
    "value": "CNP",
    "label": "Neerlerit Inaat (CNP)"
  },
  {
    "value": "QFG",
    "label": "Eqalugaarsuit (QFG)"
  },
  {
    "value": "QFN",
    "label": "Narsaq Kujalleq (QFN)"
  },
  {
    "value": "JFR",
    "label": "Paamiut (JFR)"
  },
  {
    "value": "GOH",
    "label": "Nuuk (GOH)"
  },
  {
    "value": "JGO",
    "label": "Qeqertarsuaq Airport (JGO)"
  },
  {
    "value": "IKE",
    "label": "Ikerasak (IKE)"
  },
  {
    "value": "QFI",
    "label": "Iginniarfik (QFI)"
  },
  {
    "value": "XIQ",
    "label": "Ilimanaq (XIQ)"
  },
  {
    "value": "INN",
    "label": "Innarsuit (INN)"
  },
  {
    "value": "ISO",
    "label": "Isortoq (ISO)"
  },
  {
    "value": "QJI",
    "label": "Ikamiut (QJI)"
  },
  {
    "value": "JJU",
    "label": "Qaqortoq (JJU)"
  },
  {
    "value": "JAV",
    "label": "Ilulissat (JAV)"
  },
  {
    "value": "QPW",
    "label": "Kangaatsiaq (QPW)"
  },
  {
    "value": "KUS",
    "label": "Kulusuk (KUS)"
  },
  {
    "value": "UPK",
    "label": "Upernavik Kujalleq (UPK)"
  },
  {
    "value": "KMT",
    "label": "Kuummiut (KMT)"
  },
  {
    "value": "KLQ",
    "label": "Kullorsuaq (KLQ)"
  },
  {
    "value": "QJE",
    "label": "Kitsissuarsuit (QJE)"
  },
  {
    "value": "ILL",
    "label": "Illorsuit (ILL)"
  },
  {
    "value": "MOR",
    "label": "Moriusaq Heliport (MOR)"
  },
  {
    "value": "JSU",
    "label": "Maniitsoq (JSU)"
  },
  {
    "value": "QMK",
    "label": "Niaqornaarsuk (QMK)"
  },
  {
    "value": "JNN",
    "label": "Nanortalik (JNN)"
  },
  {
    "value": "NUG",
    "label": "Nuugaatsiaq (NUG)"
  },
  {
    "value": "JNS",
    "label": "Narsaq (JNS)"
  },
  {
    "value": "NIA",
    "label": "Niaqornat (NIA)"
  },
  {
    "value": "NUS",
    "label": "Nuussuaq (NUS)"
  },
  {
    "value": "QQT",
    "label": "Qeqertaq (QQT)"
  },
  {
    "value": "NAQ",
    "label": "Qaanaaq (NAQ)"
  },
  {
    "value": "OBY",
    "label": "Ittoqqortoormiit (OBY)"
  },
  {
    "value": "SFJ",
    "label": "Kangerlussuaq (SFJ)"
  },
  {
    "value": "SMG",
    "label": "Ittoqqortoormiit (SMG)"
  },
  {
    "value": "SIO",
    "label": "Siorapaluk (SIO)"
  },
  {
    "value": "QUP",
    "label": "Saqqaq (QUP)"
  },
  {
    "value": "JHS",
    "label": "Sisimiut (JHS)"
  },
  {
    "value": "SAA",
    "label": "Saattut (SAA)"
  },
  {
    "value": "SAV",
    "label": "Savissivik (SAV)"
  },
  {
    "value": "THU",
    "label": "Thule (THU)"
  },
  {
    "value": "TNT",
    "label": "Tiniteqilaaq (TNT)"
  },
  {
    "value": "JUV",
    "label": "Upernavik (JUV)"
  },
  {
    "value": "UMD",
    "label": "Uummannaq (UMD)"
  },
  {
    "value": "JQA",
    "label": "Uummannaq (JQA)"
  },
  {
    "value": "UKK",
    "label": "Ukkusissat (UKK)"
  },
  {
    "value": "BHL",
    "label": "Bahia de los Angeles (BHL)"
  },
  {
    "value": "BHT",
    "label": "Brighton Downs Airport (BHT)"
  },
  {
    "value": "AEY",
    "label": "Akureyri (AEY)"
  },
  {
    "value": "BIU",
    "label": "Bildudalur (BIU)"
  },
  {
    "value": "BGJ",
    "label": "Borgrfjordr Eystr (BGJ)"
  },
  {
    "value": "BJD",
    "label": "Bakkafjordur (BJD)"
  },
  {
    "value": "BLO",
    "label": "Blonduos (BLO)"
  },
  {
    "value": "BXV",
    "label": "Breiddalsvik (BXV)"
  },
  {
    "value": "DJU",
    "label": "Djupivogur (DJU)"
  },
  {
    "value": "EGS",
    "label": "Egilsstadir (EGS)"
  },
  {
    "value": "FAS",
    "label": "Faskrudsfjordur (FAS)"
  },
  {
    "value": "FAG",
    "label": "Fagurholsmyri (FAG)"
  },
  {
    "value": "GUU",
    "label": "Grundarfjordur (GUU)"
  },
  {
    "value": "GJR",
    "label": "Gjogur (GJR)"
  },
  {
    "value": "GRY",
    "label": "Grimsey (GRY)"
  },
  {
    "value": "HVK",
    "label": "Holmavik (HVK)"
  },
  {
    "value": "HFN",
    "label": "Hornafjordur (HFN)"
  },
  {
    "value": "FLI",
    "label": "Flateyri (FLI)"
  },
  {
    "value": "HZK",
    "label": "Husavik (HZK)"
  },
  {
    "value": "KEF",
    "label": "Keflavik (KEF)"
  },
  {
    "value": "NOR",
    "label": "Nordfjordur (NOR)"
  },
  {
    "value": "PFJ",
    "label": "Patreksfjordur (PFJ)"
  },
  {
    "value": "OLI",
    "label": "Rif (OLI)"
  },
  {
    "value": "RFN",
    "label": "Raufarhofn (RFN)"
  },
  {
    "value": "REK",
    "label": "Reykjavik (REK)"
  },
  {
    "value": "MVA",
    "label": "Myvatn (MVA)"
  },
  {
    "value": "SIJ",
    "label": "Siglufjordur (SIJ)"
  },
  {
    "value": "TEY",
    "label": "Thingeyri (TEY)"
  },
  {
    "value": "THO",
    "label": "Thorshofn (THO)"
  },
  {
    "value": "VEY",
    "label": "Vestmannaeyjar (VEY)"
  },
  {
    "value": "VPN",
    "label": "Vopnafjordur (VPN)"
  },
  {
    "value": "BJE",
    "label": "Baleela Base Camp (BJE)"
  },
  {
    "value": "BJQ",
    "label": "Bahja (BJQ)"
  },
  {
    "value": "PRN",
    "label": "Prishtina (PRN)"
  },
  {
    "value": "BLM",
    "label": "Bahia De Los Angelos South (BLM)"
  },
  {
    "value": "BMH",
    "label": "Bomai Airport (BMH)"
  },
  {
    "value": "BMQ",
    "label": "Bamburi Airport (BMQ)"
  },
  {
    "value": "BMZ",
    "label": "Airua (BMZ)"
  },
  {
    "value": "BNF",
    "label": "Baranof (BNF)"
  },
  {
    "value": "BNM",
    "label": "Bodinumu Airport (BNM)"
  },
  {
    "value": "BNT",
    "label": "Bundi Airport (BNT)"
  },
  {
    "value": "RBQ",
    "label": "Rurenabaque (RBQ)"
  },
  {
    "value": "BVL",
    "label": "Baures (BVL)"
  },
  {
    "value": "BOF",
    "label": "Washington (BOF)"
  },
  {
    "value": "BOK",
    "label": "Brookings (BOK)"
  },
  {
    "value": "BOT",
    "label": "Bosset (BOT)"
  },
  {
    "value": "BPF",
    "label": "Batuna Mission Station (BPF)"
  },
  {
    "value": "BQV",
    "label": "Gustavus (BQV)"
  },
  {
    "value": "NSB",
    "label": "Bimini (NSB)"
  },
  {
    "value": "BSI",
    "label": "Blairsville (BSI)"
  },
  {
    "value": "BSP",
    "label": "Bensbach Airport (BSP)"
  },
  {
    "value": "BSV",
    "label": "Besakoa (BSV)"
  },
  {
    "value": "BUL",
    "label": "Bulolo (BUL)"
  },
  {
    "value": "BVR",
    "label": "Brava Island (BVR)"
  },
  {
    "value": "HUK",
    "label": "Hukuntsi (HUK)"
  },
  {
    "value": "BWJ",
    "label": "Bawan Airport (BWJ)"
  },
  {
    "value": "BWP",
    "label": "Bewani (BWP)"
  },
  {
    "value": "BXL",
    "label": "Nanuya Lailai Island (BXL)"
  },
  {
    "value": "BYA",
    "label": "Boundary (BYA)"
  },
  {
    "value": "BYL",
    "label": "Beliyela (BYL)"
  },
  {
    "value": "BYV",
    "label": "Colombo (BYV)"
  },
  {
    "value": "BCV",
    "label": "Belmopan (BCV)"
  },
  {
    "value": "BGK",
    "label": "Big Creek (BGK)"
  },
  {
    "value": "CUK",
    "label": "Caye Caulker (CUK)"
  },
  {
    "value": "CYC",
    "label": "Caye Chapel (CYC)"
  },
  {
    "value": "CZH",
    "label": "Corozal (CZH)"
  },
  {
    "value": "DGA",
    "label": "Dangriga (DGA)"
  },
  {
    "value": "INB",
    "label": "Independence (INB)"
  },
  {
    "value": "MDB",
    "label": "Melinda (MDB)"
  },
  {
    "value": "ORZ",
    "label": "Orange Walk (ORZ)"
  },
  {
    "value": "PLJ",
    "label": "Placencia (PLJ)"
  },
  {
    "value": "PND",
    "label": "Punta Gorda (PND)"
  },
  {
    "value": "SJX",
    "label": "Sartaneja (SJX)"
  },
  {
    "value": "SPR",
    "label": "San Pedro (SPR)"
  },
  {
    "value": "SQS",
    "label": "San Ignacio (SQS)"
  },
  {
    "value": "STU",
    "label": "Santa Cruz (STU)"
  },
  {
    "value": "SVK",
    "label": "Silver Creek (SVK)"
  },
  {
    "value": "TZA",
    "label": "Belize City (TZA)"
  },
  {
    "value": "BZB",
    "label": "Bazaruto Island (BZB)"
  },
  {
    "value": "BZM",
    "label": "Bemolanga (BZM)"
  },
  {
    "value": "YMV",
    "label": "Mary River Aerodrome (YMV)"
  },
  {
    "value": "YBW",
    "label": "Bedwell Harbour (YBW)"
  },
  {
    "value": "ZNA",
    "label": "Nanaimo (ZNA)"
  },
  {
    "value": "YZZ",
    "label": "Trail (YZZ)"
  },
  {
    "value": "YWS",
    "label": "Whistler (YWS)"
  },
  {
    "value": "YPT",
    "label": "Pender Harbour Seaplane Base (YPT)"
  },
  {
    "value": "YAA",
    "label": "Anahim Lake (YAA)"
  },
  {
    "value": "DGF",
    "label": "Douglas Lake (DGF)"
  },
  {
    "value": "JHL",
    "label": "Albian Village (JHL)"
  },
  {
    "value": "DUQ",
    "label": "Duncan (DUQ)"
  },
  {
    "value": "YMU",
    "label": "Mansons Landing Seaplane Base (YMU)"
  },
  {
    "value": "CBC",
    "label": "Cherrabun Airport (CBC)"
  },
  {
    "value": "YWM",
    "label": "Williams Harbour (YWM)"
  },
  {
    "value": "YFX",
    "label": "St. Lewis (YFX)"
  },
  {
    "value": "YHA",
    "label": "Port Hope Simpson (YHA)"
  },
  {
    "value": "YRG",
    "label": "Rigolet (YRG)"
  },
  {
    "value": "CDK",
    "label": "Cedar Key (CDK)"
  },
  {
    "value": "DVK",
    "label": "Diavik (DVK)"
  },
  {
    "value": "YCK",
    "label": "Colville Lake (YCK)"
  },
  {
    "value": "YLE",
    "label": "Whati (YLE)"
  },
  {
    "value": "NML",
    "label": "Fort McMurray (NML)"
  },
  {
    "value": "DAS",
    "label": "Great Bear Lake (DAS)"
  },
  {
    "value": "YFI",
    "label": "Suncor Energy Site (YFI)"
  },
  {
    "value": "OKG",
    "label": "Okoyo (OKG)"
  },
  {
    "value": "CGA",
    "label": "Craig (CGA)"
  },
  {
    "value": "SUR",
    "label": "Summer Beaver (SUR)"
  },
  {
    "value": "YAX",
    "label": "Angling Lake (YAX)"
  },
  {
    "value": "WNN",
    "label": "Wunnumin Lake (WNN)"
  },
  {
    "value": "YNO",
    "label": "North Spirit Lake (YNO)"
  },
  {
    "value": "OHE",
    "label": "Mohe (OHE)"
  },
  {
    "value": "BSD",
    "label": "Baoshan Yunduan Airport (BSD)"
  },
  {
    "value": "FUO",
    "label": "Foshan (FUO)"
  },
  {
    "value": "HUZ",
    "label": "Huizhou (HUZ)"
  },
  {
    "value": "JGS",
    "label": "Ji'an (JGS)"
  },
  {
    "value": "AEB",
    "label": "Baise (AEB)"
  },
  {
    "value": "DOY",
    "label": "Dongying (DOY)"
  },
  {
    "value": "XEN",
    "label": "Xingcheng Air Base (XEN)"
  },
  {
    "value": "AAT",
    "label": "Altay (AAT)"
  },
  {
    "value": "YZY",
    "label": "Zhangye Southeast Air Base (YZY)"
  },
  {
    "value": "DDG",
    "label": "Dandong (DDG)"
  },
  {
    "value": "NTG",
    "label": "Nantong (NTG)"
  },
  {
    "value": "XBE",
    "label": "Bearskin Lake (XBE)"
  },
  {
    "value": "KIF",
    "label": "Kingfisher Lake (KIF)"
  },
  {
    "value": "YOG",
    "label": "Ogoki Post (YOG)"
  },
  {
    "value": "PRM",
    "label": "Bogota (PRM)"
  },
  {
    "value": "ISG",
    "label": "Giron (ISG)"
  },
  {
    "value": "API",
    "label": "Apiay (API)"
  },
  {
    "value": "APO",
    "label": "Apartado (APO)"
  },
  {
    "value": "ARQ",
    "label": "Arauquita (ARQ)"
  },
  {
    "value": "LCR",
    "label": "La Chorrera (LCR)"
  },
  {
    "value": "SNT",
    "label": "Sabana De Torres (SNT)"
  },
  {
    "value": "TCD",
    "label": "Tarapaca (TCD)"
  },
  {
    "value": "YEB",
    "label": "Bar River (YEB)"
  },
  {
    "value": "CPI",
    "label": "Cape Orford Airport (CPI)"
  },
  {
    "value": "YHP",
    "label": "Poplar Hill (YHP)"
  },
  {
    "value": "YNX",
    "label": "Snap Lake (YNX)"
  },
  {
    "value": "YKU",
    "label": "Chisasibi (YKU)"
  },
  {
    "value": "ZTB",
    "label": "Tete-a-la Baleine (ZTB)"
  },
  {
    "value": "YAU",
    "label": "Kattiniq (YAU)"
  },
  {
    "value": "TR7",
    "label": "Ottawa (TR7)"
  },
  {
    "value": "ZLT",
    "label": "La Tabatiere (ZLT)"
  },
  {
    "value": "PST",
    "label": "Preston (PST)"
  },
  {
    "value": "CVL",
    "label": "Cape Vogel (CVL)"
  },
  {
    "value": "GEC",
    "label": "Gecitkale (GEC)"
  },
  {
    "value": "YAC",
    "label": "Cat Lake (YAC)"
  },
  {
    "value": "YAG",
    "label": "Fort Frances (YAG)"
  },
  {
    "value": "YAH",
    "label": "La Grande-4 (YAH)"
  },
  {
    "value": "YAL",
    "label": "Alert Bay (YAL)"
  },
  {
    "value": "YAM",
    "label": "Sault Ste Marie (YAM)"
  },
  {
    "value": "XKS",
    "label": "Kasabonika (XKS)"
  },
  {
    "value": "YKG",
    "label": "Kangirsuk (YKG)"
  },
  {
    "value": "YAT",
    "label": "Attawapiskat (YAT)"
  },
  {
    "value": "YAV",
    "label": "Winnipeg (YAV)"
  },
  {
    "value": "YAW",
    "label": "Halifax (YAW)"
  },
  {
    "value": "YAY",
    "label": "St. Anthony (YAY)"
  },
  {
    "value": "YAZ",
    "label": "Tofino (YAZ)"
  },
  {
    "value": "YBB",
    "label": "Kugaaruk (YBB)"
  },
  {
    "value": "YBC",
    "label": "Baie-Comeau (YBC)"
  },
  {
    "value": "QBC",
    "label": "Bella Coola (QBC)"
  },
  {
    "value": "YBE",
    "label": "Uranium City (YBE)"
  },
  {
    "value": "YBY",
    "label": "Bonnyville (YBY)"
  },
  {
    "value": "YBG",
    "label": "Bagotville (YBG)"
  },
  {
    "value": "YBK",
    "label": "Baker Lake (YBK)"
  },
  {
    "value": "YBL",
    "label": "Campbell River (YBL)"
  },
  {
    "value": "YBN",
    "label": "Borden (YBN)"
  },
  {
    "value": "XTL",
    "label": "Tadoule Lake (XTL)"
  },
  {
    "value": "YBR",
    "label": "Brandon (YBR)"
  },
  {
    "value": "YBT",
    "label": "Brochet (YBT)"
  },
  {
    "value": "YBV",
    "label": "Berens River (YBV)"
  },
  {
    "value": "YBX",
    "label": "Lourdes-De-Blanc-Sablon (YBX)"
  },
  {
    "value": "YRF",
    "label": "Cartwright (YRF)"
  },
  {
    "value": "YCB",
    "label": "Cambridge Bay (YCB)"
  },
  {
    "value": "YCC",
    "label": "Cornwall (YCC)"
  },
  {
    "value": "YCD",
    "label": "Nanaimo (YCD)"
  },
  {
    "value": "YCE",
    "label": "Centralia (YCE)"
  },
  {
    "value": "YCG",
    "label": "Castlegar (YCG)"
  },
  {
    "value": "YCH",
    "label": "Miramichi (YCH)"
  },
  {
    "value": "XCM",
    "label": "Chatham-Kent (XCM)"
  },
  {
    "value": "YCL",
    "label": "Charlo (YCL)"
  },
  {
    "value": "YCN",
    "label": "Cochrane (YCN)"
  },
  {
    "value": "YCO",
    "label": "Kugluktuk (YCO)"
  },
  {
    "value": "YCQ",
    "label": "Chetwynd (YCQ)"
  },
  {
    "value": "YCR",
    "label": "Cross Lake (YCR)"
  },
  {
    "value": "YCS",
    "label": "Chesterfield Inlet (YCS)"
  },
  {
    "value": "YCX",
    "label": "Gagetown (YCX)"
  },
  {
    "value": "YCY",
    "label": "Clyde River (YCY)"
  },
  {
    "value": "YCZ",
    "label": "Fairmont Hot Springs (YCZ)"
  },
  {
    "value": "YDA",
    "label": "Dawson City (YDA)"
  },
  {
    "value": "YDB",
    "label": "Burwash (YDB)"
  },
  {
    "value": "YDF",
    "label": "Deer Lake (YDF)"
  },
  {
    "value": "YDM",
    "label": "Ross River (YDM)"
  },
  {
    "value": "YDN",
    "label": "Dauphin (YDN)"
  },
  {
    "value": "YDO",
    "label": "Dolbeau-St-FÃ©licien (YDO)"
  },
  {
    "value": "YDP",
    "label": "Nain (YDP)"
  },
  {
    "value": "YDQ",
    "label": "Dawson Creek (YDQ)"
  },
  {
    "value": "YED",
    "label": "Edmonton (YED)"
  },
  {
    "value": "YEG",
    "label": "Edmonton (YEG)"
  },
  {
    "value": "YEK",
    "label": "Arviat (YEK)"
  },
  {
    "value": "YEL",
    "label": "Elliot Lake (YEL)"
  },
  {
    "value": "YEM",
    "label": "Manitowaning (YEM)"
  },
  {
    "value": "YEN",
    "label": "Estevan (YEN)"
  },
  {
    "value": "YER",
    "label": "Fort Severn (YER)"
  },
  {
    "value": "YET",
    "label": "Edson (YET)"
  },
  {
    "value": "YEU",
    "label": "Eureka (YEU)"
  },
  {
    "value": "YEV",
    "label": "Inuvik (YEV)"
  },
  {
    "value": "YEY",
    "label": "Amos (YEY)"
  },
  {
    "value": "YFA",
    "label": "Fort Albany (YFA)"
  },
  {
    "value": "YFB",
    "label": "Iqaluit (YFB)"
  },
  {
    "value": "YFC",
    "label": "Fredericton (YFC)"
  },
  {
    "value": "YFE",
    "label": "Forestville (YFE)"
  },
  {
    "value": "YFH",
    "label": "Fort Hope (YFH)"
  },
  {
    "value": "YTM",
    "label": "RiviÃ¨re Rouge (YTM)"
  },
  {
    "value": "YFO",
    "label": "Flin Flon (YFO)"
  },
  {
    "value": "YFR",
    "label": "Fort Resolution (YFR)"
  },
  {
    "value": "YFS",
    "label": "Fort Simpson (YFS)"
  },
  {
    "value": "YMN",
    "label": "Makkovik (YMN)"
  },
  {
    "value": "YGB",
    "label": "Texada (YGB)"
  },
  {
    "value": "YGD",
    "label": "Goderich (YGD)"
  },
  {
    "value": "YGH",
    "label": "Fort Good Hope (YGH)"
  },
  {
    "value": "YGK",
    "label": "Kingston (YGK)"
  },
  {
    "value": "YGL",
    "label": "La Grande Riviere (YGL)"
  },
  {
    "value": "YGM",
    "label": "Gimli (YGM)"
  },
  {
    "value": "YGO",
    "label": "Gods Lake Narrows (YGO)"
  },
  {
    "value": "YGP",
    "label": "Gaspe (YGP)"
  },
  {
    "value": "YGQ",
    "label": "Geraldton (YGQ)"
  },
  {
    "value": "YGR",
    "label": "Iles de La Madeleine (YGR)"
  },
  {
    "value": "YGT",
    "label": "Igloolik (YGT)"
  },
  {
    "value": "YGV",
    "label": "Havre St-Pierre (YGV)"
  },
  {
    "value": "YGW",
    "label": "Kuujjuarapik (YGW)"
  },
  {
    "value": "YGX",
    "label": "Gillam (YGX)"
  },
  {
    "value": "YGZ",
    "label": "Grise Fiord (YGZ)"
  },
  {
    "value": "YQC",
    "label": "Quaqtaq (YQC)"
  },
  {
    "value": "CXH",
    "label": "Vancouver (CXH)"
  },
  {
    "value": "YHD",
    "label": "Dryden (YHD)"
  },
  {
    "value": "YHE",
    "label": "Hope (YHE)"
  },
  {
    "value": "YHF",
    "label": "Hearst (YHF)"
  },
  {
    "value": "YNS",
    "label": "Nemiscau (YNS)"
  },
  {
    "value": "YHI",
    "label": "Ulukhaktok (YHI)"
  },
  {
    "value": "YHK",
    "label": "Gjoa Haven (YHK)"
  },
  {
    "value": "YHM",
    "label": "Hamilton (YHM)"
  },
  {
    "value": "YHN",
    "label": "Hornepayne (YHN)"
  },
  {
    "value": "YHO",
    "label": "Hopedale (YHO)"
  },
  {
    "value": "YHR",
    "label": "Chevery (YHR)"
  },
  {
    "value": "YHT",
    "label": "Haines Junction (YHT)"
  },
  {
    "value": "YHU",
    "label": "Montreal (YHU)"
  },
  {
    "value": "YHY",
    "label": "Hay River (YHY)"
  },
  {
    "value": "YHZ",
    "label": "Halifax (YHZ)"
  },
  {
    "value": "YIB",
    "label": "Atikokan (YIB)"
  },
  {
    "value": "YDG",
    "label": "Digby (YDG)"
  },
  {
    "value": "YIF",
    "label": "St-Augustin (YIF)"
  },
  {
    "value": "YIK",
    "label": "Ivujivik (YIK)"
  },
  {
    "value": "YIO",
    "label": "Pond Inlet (YIO)"
  },
  {
    "value": "YIV",
    "label": "Island Lake (YIV)"
  },
  {
    "value": "YJF",
    "label": "Fort Liard (YJF)"
  },
  {
    "value": "YJN",
    "label": "St Jean (YJN)"
  },
  {
    "value": "YJT",
    "label": "Stephenville (YJT)"
  },
  {
    "value": "YKA",
    "label": "Kamloops (YKA)"
  },
  {
    "value": "LAK",
    "label": "Aklavik (LAK)"
  },
  {
    "value": "YKF",
    "label": "Kitchener (YKF)"
  },
  {
    "value": "YKJ",
    "label": "Key Lake (YKJ)"
  },
  {
    "value": "YKL",
    "label": "Schefferville (YKL)"
  },
  {
    "value": "AKV",
    "label": "Akulivik (AKV)"
  },
  {
    "value": "YKQ",
    "label": "Waskaganish (YKQ)"
  },
  {
    "value": "YKX",
    "label": "Kirkland Lake (YKX)"
  },
  {
    "value": "YKY",
    "label": "Kindersley (YKY)"
  },
  {
    "value": "YKZ",
    "label": "Toronto (YKZ)"
  },
  {
    "value": "YPJ",
    "label": "Aupaluk (YPJ)"
  },
  {
    "value": "YLC",
    "label": "Kimmirut (YLC)"
  },
  {
    "value": "YLD",
    "label": "Chapleau (YLD)"
  },
  {
    "value": "YLH",
    "label": "Lansdowne House (YLH)"
  },
  {
    "value": "YLJ",
    "label": "Meadow Lake (YLJ)"
  },
  {
    "value": "YSG",
    "label": "Lutselk'e (YSG)"
  },
  {
    "value": "YLL",
    "label": "Lloydminster (YLL)"
  },
  {
    "value": "YLR",
    "label": "Leaf Rapids (YLR)"
  },
  {
    "value": "YLT",
    "label": "Alert (YLT)"
  },
  {
    "value": "XGR",
    "label": "Kangiqsualujjuaq (XGR)"
  },
  {
    "value": "YLW",
    "label": "Kelowna (YLW)"
  },
  {
    "value": "YMA",
    "label": "Mayo (YMA)"
  },
  {
    "value": "YME",
    "label": "Matane (YME)"
  },
  {
    "value": "YMG",
    "label": "Manitouwadge (YMG)"
  },
  {
    "value": "YMH",
    "label": "Mary's Harbour (YMH)"
  },
  {
    "value": "YMJ",
    "label": "Moose Jaw (YMJ)"
  },
  {
    "value": "YML",
    "label": "Charlevoix (YML)"
  },
  {
    "value": "YMM",
    "label": "Fort McMurray (YMM)"
  },
  {
    "value": "YMO",
    "label": "Moosonee (YMO)"
  },
  {
    "value": "YMT",
    "label": "Chibougamau (YMT)"
  },
  {
    "value": "YUD",
    "label": "Umiujaq (YUD)"
  },
  {
    "value": "YMX",
    "label": "MontrÃ©al (YMX)"
  },
  {
    "value": "YNA",
    "label": "Natashquan (YNA)"
  },
  {
    "value": "YNC",
    "label": "Wemindji (YNC)"
  },
  {
    "value": "YND",
    "label": "Gatineau (YND)"
  },
  {
    "value": "YNE",
    "label": "Norway House (YNE)"
  },
  {
    "value": "YNL",
    "label": "Points North Landing (YNL)"
  },
  {
    "value": "YNM",
    "label": "Matagami (YNM)"
  },
  {
    "value": "YNN",
    "label": "Nejanilini Lake (YNN)"
  },
  {
    "value": "HZP",
    "label": "Fort Mackay (HZP)"
  },
  {
    "value": "YOA",
    "label": "Ekati (YOA)"
  },
  {
    "value": "YOC",
    "label": "Old Crow (YOC)"
  },
  {
    "value": "YOD",
    "label": "Cold Lake (YOD)"
  },
  {
    "value": "YOH",
    "label": "Oxford House (YOH)"
  },
  {
    "value": "YOJ",
    "label": "High Level (YOJ)"
  },
  {
    "value": "YOO",
    "label": "Oshawa (YOO)"
  },
  {
    "value": "YOP",
    "label": "Rainbow Lake (YOP)"
  },
  {
    "value": "YOS",
    "label": "Owen Sound (YOS)"
  },
  {
    "value": "YOW",
    "label": "Ottawa (YOW)"
  },
  {
    "value": "YOY",
    "label": "Valcartier (YOY)"
  },
  {
    "value": "YPA",
    "label": "Prince Albert (YPA)"
  },
  {
    "value": "YPC",
    "label": "Paulatuk (YPC)"
  },
  {
    "value": "YPS",
    "label": "Port Hawkesbury (YPS)"
  },
  {
    "value": "YPE",
    "label": "Peace River (YPE)"
  },
  {
    "value": "YPG",
    "label": "Portage (YPG)"
  },
  {
    "value": "YPH",
    "label": "Inukjuak (YPH)"
  },
  {
    "value": "YPL",
    "label": "Pickle Lake (YPL)"
  },
  {
    "value": "YPM",
    "label": "Pikangikum (YPM)"
  },
  {
    "value": "YPN",
    "label": "Port-Menier (YPN)"
  },
  {
    "value": "YPO",
    "label": "Peawanuck (YPO)"
  },
  {
    "value": "YPQ",
    "label": "Peterborough (YPQ)"
  },
  {
    "value": "YPR",
    "label": "Prince Rupert (YPR)"
  },
  {
    "value": "YPW",
    "label": "Powell River (YPW)"
  },
  {
    "value": "YPX",
    "label": "Puvirnituq (YPX)"
  },
  {
    "value": "YPY",
    "label": "Fort Chipewyan (YPY)"
  },
  {
    "value": "YQA",
    "label": "Muskoka (YQA)"
  },
  {
    "value": "YQB",
    "label": "Quebec (YQB)"
  },
  {
    "value": "YQD",
    "label": "The Pas (YQD)"
  },
  {
    "value": "YQF",
    "label": "Red Deer (YQF)"
  },
  {
    "value": "YQG",
    "label": "Windsor (YQG)"
  },
  {
    "value": "YQH",
    "label": "Watson Lake (YQH)"
  },
  {
    "value": "YQI",
    "label": "Yarmouth (YQI)"
  },
  {
    "value": "YQK",
    "label": "Kenora (YQK)"
  },
  {
    "value": "YQL",
    "label": "Lethbridge (YQL)"
  },
  {
    "value": "YQM",
    "label": "Moncton (YQM)"
  },
  {
    "value": "YQN",
    "label": "Nakina (YQN)"
  },
  {
    "value": "YQQ",
    "label": "Comox (YQQ)"
  },
  {
    "value": "YQR",
    "label": "Regina (YQR)"
  },
  {
    "value": "YQS",
    "label": "St Thomas (YQS)"
  },
  {
    "value": "YQT",
    "label": "Thunder Bay (YQT)"
  },
  {
    "value": "YQU",
    "label": "Grande Prairie (YQU)"
  },
  {
    "value": "YQV",
    "label": "Yorkton (YQV)"
  },
  {
    "value": "YQW",
    "label": "North Battleford (YQW)"
  },
  {
    "value": "YQX",
    "label": "Gander (YQX)"
  },
  {
    "value": "YQY",
    "label": "Sydney (YQY)"
  },
  {
    "value": "YQZ",
    "label": "Quesnel (YQZ)"
  },
  {
    "value": "YRA",
    "label": "GamÃ¨tÃ¬ (YRA)"
  },
  {
    "value": "YRB",
    "label": "Resolute Bay (YRB)"
  },
  {
    "value": "YRI",
    "label": "RiviÃ¨re-du-Loup (YRI)"
  },
  {
    "value": "YRJ",
    "label": "Roberval (YRJ)"
  },
  {
    "value": "YRL",
    "label": "Red Lake (YRL)"
  },
  {
    "value": "YRO",
    "label": "Ottawa (YRO)"
  },
  {
    "value": "YRP",
    "label": "Carp (YRP)"
  },
  {
    "value": "YRQ",
    "label": "Trois-RiviÃ¨res (YRQ)"
  },
  {
    "value": "YRS",
    "label": "Red Sucker Lake (YRS)"
  },
  {
    "value": "YRT",
    "label": "Rankin Inlet (YRT)"
  },
  {
    "value": "YRV",
    "label": "Revelstoke (YRV)"
  },
  {
    "value": "YSB",
    "label": "Sudbury (YSB)"
  },
  {
    "value": "YSC",
    "label": "Sherbrooke (YSC)"
  },
  {
    "value": "YSD",
    "label": "Suffield (YSD)"
  },
  {
    "value": "YSF",
    "label": "Stony Rapids (YSF)"
  },
  {
    "value": "YSH",
    "label": "Smiths Falls (YSH)"
  },
  {
    "value": "YSJ",
    "label": "Saint John (YSJ)"
  },
  {
    "value": "YSK",
    "label": "Sanikiluaq (YSK)"
  },
  {
    "value": "YSL",
    "label": "St Leonard (YSL)"
  },
  {
    "value": "YSM",
    "label": "Fort Smith (YSM)"
  },
  {
    "value": "YCM",
    "label": "St Catharines (YCM)"
  },
  {
    "value": "YSP",
    "label": "Marathon (YSP)"
  },
  {
    "value": "YST",
    "label": "St. Theresa Point (YST)"
  },
  {
    "value": "YSU",
    "label": "Summerside (YSU)"
  },
  {
    "value": "YSY",
    "label": "Sachs Harbour (YSY)"
  },
  {
    "value": "YTA",
    "label": "Pembroke (YTA)"
  },
  {
    "value": "YTE",
    "label": "Cape Dorset (YTE)"
  },
  {
    "value": "YTF",
    "label": "Alma (YTF)"
  },
  {
    "value": "YTH",
    "label": "Thompson (YTH)"
  },
  {
    "value": "YTL",
    "label": "Big Trout Lake (YTL)"
  },
  {
    "value": "YTQ",
    "label": "Tasiujaq (YTQ)"
  },
  {
    "value": "YTR",
    "label": "Trenton (YTR)"
  },
  {
    "value": "YTS",
    "label": "Timmins (YTS)"
  },
  {
    "value": "YTZ",
    "label": "Toronto (YTZ)"
  },
  {
    "value": "YUB",
    "label": "Tuktoyaktuk (YUB)"
  },
  {
    "value": "YUL",
    "label": "MontrÃ©al (YUL)"
  },
  {
    "value": "YUT",
    "label": "Repulse Bay (YUT)"
  },
  {
    "value": "YUX",
    "label": "Hall Beach (YUX)"
  },
  {
    "value": "YUY",
    "label": "Rouyn-Noranda (YUY)"
  },
  {
    "value": "YVB",
    "label": "Bonaventure (YVB)"
  },
  {
    "value": "YVC",
    "label": "La Ronge (YVC)"
  },
  {
    "value": "YVE",
    "label": "Vernon (YVE)"
  },
  {
    "value": "YVM",
    "label": "Qikiqtarjuaq (YVM)"
  },
  {
    "value": "YVO",
    "label": "Val-d'Or (YVO)"
  },
  {
    "value": "YVP",
    "label": "Kuujjuaq (YVP)"
  },
  {
    "value": "YVQ",
    "label": "Norman Wells (YVQ)"
  },
  {
    "value": "YVR",
    "label": "Vancouver (YVR)"
  },
  {
    "value": "YVT",
    "label": "Buffalo Narrows (YVT)"
  },
  {
    "value": "YVV",
    "label": "Wiarton (YVV)"
  },
  {
    "value": "YVZ",
    "label": "Deer Lake (YVZ)"
  },
  {
    "value": "YWA",
    "label": "Petawawa (YWA)"
  },
  {
    "value": "YWG",
    "label": "Winnipeg (YWG)"
  },
  {
    "value": "YWH",
    "label": "Victoria (YWH)"
  },
  {
    "value": "YWJ",
    "label": "DÃ©line (YWJ)"
  },
  {
    "value": "YWK",
    "label": "Wabush (YWK)"
  },
  {
    "value": "YWL",
    "label": "Williams Lake (YWL)"
  },
  {
    "value": "YWP",
    "label": "Webequie (YWP)"
  },
  {
    "value": "YWY",
    "label": "Wrigley (YWY)"
  },
  {
    "value": "YXC",
    "label": "Cranbrook (YXC)"
  },
  {
    "value": "YXD",
    "label": "Edmonton (YXD)"
  },
  {
    "value": "YXE",
    "label": "Saskatoon (YXE)"
  },
  {
    "value": "YXH",
    "label": "Medicine Hat (YXH)"
  },
  {
    "value": "YXJ",
    "label": "Fort St.John (YXJ)"
  },
  {
    "value": "YXK",
    "label": "Rimouski (YXK)"
  },
  {
    "value": "YXL",
    "label": "Sioux Lookout (YXL)"
  },
  {
    "value": "YXN",
    "label": "Whale Cove (YXN)"
  },
  {
    "value": "YXP",
    "label": "Pangnirtung (YXP)"
  },
  {
    "value": "YXQ",
    "label": "Beaver Creek (YXQ)"
  },
  {
    "value": "YXR",
    "label": "Earlton (YXR)"
  },
  {
    "value": "YXS",
    "label": "Prince George (YXS)"
  },
  {
    "value": "YXT",
    "label": "Terrace (YXT)"
  },
  {
    "value": "YXU",
    "label": "London (YXU)"
  },
  {
    "value": "YXX",
    "label": "Abbotsford (YXX)"
  },
  {
    "value": "YXY",
    "label": "Whitehorse (YXY)"
  },
  {
    "value": "YXZ",
    "label": "Wawa (YXZ)"
  },
  {
    "value": "YYB",
    "label": "North Bay (YYB)"
  },
  {
    "value": "YYC",
    "label": "Calgary (YYC)"
  },
  {
    "value": "YYD",
    "label": "Smithers (YYD)"
  },
  {
    "value": "YYE",
    "label": "Fort Nelson (YYE)"
  },
  {
    "value": "YYF",
    "label": "Penticton (YYF)"
  },
  {
    "value": "YYG",
    "label": "Charlottetown (YYG)"
  },
  {
    "value": "YYH",
    "label": "Taloyoak (YYH)"
  },
  {
    "value": "YYJ",
    "label": "Victoria (YYJ)"
  },
  {
    "value": "YYL",
    "label": "Lynn Lake (YYL)"
  },
  {
    "value": "YYN",
    "label": "Swift Current (YYN)"
  },
  {
    "value": "YYQ",
    "label": "Churchill (YYQ)"
  },
  {
    "value": "YYR",
    "label": "Goose Bay (YYR)"
  },
  {
    "value": "YYT",
    "label": "St. John's (YYT)"
  },
  {
    "value": "YYU",
    "label": "Kapuskasing (YYU)"
  },
  {
    "value": "YYW",
    "label": "Armstrong (YYW)"
  },
  {
    "value": "YYY",
    "label": "Mont-Joli (YYY)"
  },
  {
    "value": "YYZ",
    "label": "Toronto (YYZ)"
  },
  {
    "value": "YZD",
    "label": "Toronto (YZD)"
  },
  {
    "value": "YZE",
    "label": "Gore Bay (YZE)"
  },
  {
    "value": "YZF",
    "label": "Yellowknife (YZF)"
  },
  {
    "value": "YZG",
    "label": "Salluit (YZG)"
  },
  {
    "value": "YZH",
    "label": "Slave Lake (YZH)"
  },
  {
    "value": "YZP",
    "label": "Sandspit (YZP)"
  },
  {
    "value": "YZR",
    "label": "Sarnia (YZR)"
  },
  {
    "value": "YZS",
    "label": "Coral Harbour (YZS)"
  },
  {
    "value": "YZT",
    "label": "Port Hardy (YZT)"
  },
  {
    "value": "YZU",
    "label": "Whitecourt (YZU)"
  },
  {
    "value": "YZV",
    "label": "Sept-ÃŽles (YZV)"
  },
  {
    "value": "YZW",
    "label": "Teslin (YZW)"
  },
  {
    "value": "YZX",
    "label": "Greenwood (YZX)"
  },
  {
    "value": "ZAC",
    "label": "York Landing (ZAC)"
  },
  {
    "value": "YSN",
    "label": "Salmon Arm (YSN)"
  },
  {
    "value": "YDT",
    "label": "Burlington (YDT)"
  },
  {
    "value": "ZBD",
    "label": "Boundary Bay (ZBD)"
  },
  {
    "value": "ILF",
    "label": "Ilford (ILF)"
  },
  {
    "value": "ZBF",
    "label": "Bathurst (ZBF)"
  },
  {
    "value": "ZBM",
    "label": "Bromont (ZBM)"
  },
  {
    "value": "ZEE",
    "label": "Kelsey (ZEE)"
  },
  {
    "value": "ZEM",
    "label": "Eastmain River (ZEM)"
  },
  {
    "value": "ZFA",
    "label": "Faro (ZFA)"
  },
  {
    "value": "ZFD",
    "label": "Fond-Du-Lac (ZFD)"
  },
  {
    "value": "ZFG",
    "label": "Pukatawagan (ZFG)"
  },
  {
    "value": "ZFM",
    "label": "Fort Mcpherson (ZFM)"
  },
  {
    "value": "ZFN",
    "label": "Tulita (ZFN)"
  },
  {
    "value": "ZGF",
    "label": "Grand Forks (ZGF)"
  },
  {
    "value": "ZGI",
    "label": "Gods River (ZGI)"
  },
  {
    "value": "ZGR",
    "label": "Little Grand Rapids (ZGR)"
  },
  {
    "value": "ZJG",
    "label": "Jenpeg (ZJG)"
  },
  {
    "value": "ZJN",
    "label": "Swan River (ZJN)"
  },
  {
    "value": "ZKE",
    "label": "Kashechewan (ZKE)"
  },
  {
    "value": "YTD",
    "label": "Thicket Portage (YTD)"
  },
  {
    "value": "MSA",
    "label": "Muskrat Dam (MSA)"
  },
  {
    "value": "ZMH",
    "label": "108 Mile (ZMH)"
  },
  {
    "value": "PIW",
    "label": "Pikwitonei (PIW)"
  },
  {
    "value": "ZMT",
    "label": "Masset (ZMT)"
  },
  {
    "value": "ZNG",
    "label": "Poplar River (ZNG)"
  },
  {
    "value": "ZPB",
    "label": "Sachigo Lake (ZPB)"
  },
  {
    "value": "ZRJ",
    "label": "Round Lake (ZRJ)"
  },
  {
    "value": "ZSJ",
    "label": "Sandy Lake (ZSJ)"
  },
  {
    "value": "ZSN",
    "label": "South Indian Lake (ZSN)"
  },
  {
    "value": "ZSW",
    "label": "Prince Rupert/Seal Cove Seaplane Base (ZSW)"
  },
  {
    "value": "ZTM",
    "label": "Shamattawa (ZTM)"
  },
  {
    "value": "ZUC",
    "label": "Ignace (ZUC)"
  },
  {
    "value": "ZUM",
    "label": "Churchill Falls (ZUM)"
  },
  {
    "value": "ZWH",
    "label": "Lac Brochet (ZWH)"
  },
  {
    "value": "ZWL",
    "label": "Wollaston Lake (ZWL)"
  },
  {
    "value": "DJN",
    "label": "Delta Junction (DJN)"
  },
  {
    "value": "QLD",
    "label": "Blida Airport (QLD)"
  },
  {
    "value": "BUJ",
    "label": "Bou Saada Airport (BUJ)"
  },
  {
    "value": "BJA",
    "label": "BÃ©jaÃ¯a (BJA)"
  },
  {
    "value": "ALG",
    "label": "Algiers (ALG)"
  },
  {
    "value": "DJG",
    "label": "Djanet (DJG)"
  },
  {
    "value": "QFD",
    "label": "Boufarik Airport (QFD)"
  },
  {
    "value": "VVZ",
    "label": "Illizi (VVZ)"
  },
  {
    "value": "QSF",
    "label": "SÃ©tif (QSF)"
  },
  {
    "value": "TMR",
    "label": "Tamanrasset (TMR)"
  },
  {
    "value": "GJL",
    "label": "Jijel (GJL)"
  },
  {
    "value": "MZW",
    "label": "Mecheria (MZW)"
  },
  {
    "value": "QZN",
    "label": "Relizane Airport (QZN)"
  },
  {
    "value": "AAE",
    "label": "Annabah (AAE)"
  },
  {
    "value": "CZL",
    "label": "Constantine (CZL)"
  },
  {
    "value": "TEE",
    "label": "TÃ©bessi (TEE)"
  },
  {
    "value": "BLJ",
    "label": "Batna (BLJ)"
  },
  {
    "value": "HRM",
    "label": "Hassi R'Mel Airport (HRM)"
  },
  {
    "value": "QDJ",
    "label": "Tsletsi Airport (QDJ)"
  },
  {
    "value": "DAO",
    "label": "Dabo Airport (DAO)"
  },
  {
    "value": "TID",
    "label": "Tiaret (TID)"
  },
  {
    "value": "TIN",
    "label": "Tindouf (TIN)"
  },
  {
    "value": "QAS",
    "label": "Ech Cheliff Airport (QAS)"
  },
  {
    "value": "TAF",
    "label": "Tafaraoui Airport (TAF)"
  },
  {
    "value": "TLM",
    "label": "Tlemcen (TLM)"
  },
  {
    "value": "ORN",
    "label": "Oran (ORN)"
  },
  {
    "value": "CBH",
    "label": "BÃ©char (CBH)"
  },
  {
    "value": "BFW",
    "label": "Sidi Bel Abbes Airport (BFW)"
  },
  {
    "value": "MUW",
    "label": "Ghriss Airport (MUW)"
  },
  {
    "value": "EBH",
    "label": "El Bayadh (EBH)"
  },
  {
    "value": "INF",
    "label": "In Guezzam (INF)"
  },
  {
    "value": "BMW",
    "label": "Bordj Badji Mokhtar (BMW)"
  },
  {
    "value": "AZR",
    "label": "Touat Cheikh Sidi Mohamed Belkebir Airport (AZR)"
  },
  {
    "value": "BSK",
    "label": "Biskra (BSK)"
  },
  {
    "value": "ELG",
    "label": "El Golea Airport (ELG)"
  },
  {
    "value": "GHA",
    "label": "GhardaÃ¯a (GHA)"
  },
  {
    "value": "HME",
    "label": "Hassi Messaoud (HME)"
  },
  {
    "value": "INZ",
    "label": "In Salah (INZ)"
  },
  {
    "value": "TGR",
    "label": "Touggourt (TGR)"
  },
  {
    "value": "LOO",
    "label": "Laghouat (LOO)"
  },
  {
    "value": "ELU",
    "label": "Guemar (ELU)"
  },
  {
    "value": "TMX",
    "label": "Timimoun (TMX)"
  },
  {
    "value": "OGX",
    "label": "Ouargla (OGX)"
  },
  {
    "value": "IAM",
    "label": "AmÃ©nas (IAM)"
  },
  {
    "value": "COO",
    "label": "Cotonou (COO)"
  },
  {
    "value": "DJA",
    "label": "Djougou (DJA)"
  },
  {
    "value": "KDC",
    "label": "Kandi (KDC)"
  },
  {
    "value": "NAE",
    "label": "Natitingou (NAE)"
  },
  {
    "value": "PKO",
    "label": "Parakou (PKO)"
  },
  {
    "value": "SVF",
    "label": "SavÃ© (SVF)"
  },
  {
    "value": "DBP",
    "label": "Debepare (DBP)"
  },
  {
    "value": "DCG",
    "label": "Dubai (DCG)"
  },
  {
    "value": "DCK",
    "label": "Dahl Creek (DCK)"
  },
  {
    "value": "DCR",
    "label": "Decatur (DCR)"
  },
  {
    "value": "DDM",
    "label": "Dodoima Airport (DDM)"
  },
  {
    "value": "DER",
    "label": "Derim (DER)"
  },
  {
    "value": "XKY",
    "label": "Kaya (XKY)"
  },
  {
    "value": "OUG",
    "label": "Ouahigouya (OUG)"
  },
  {
    "value": "XDJ",
    "label": "Djibo (XDJ)"
  },
  {
    "value": "XLU",
    "label": "Leo (XLU)"
  },
  {
    "value": "PUP",
    "label": "Po (PUP)"
  },
  {
    "value": "XBO",
    "label": "Boulsa (XBO)"
  },
  {
    "value": "XBG",
    "label": "Bogande (XBG)"
  },
  {
    "value": "DIP",
    "label": "Diapaga (DIP)"
  },
  {
    "value": "DOR",
    "label": "Dori (DOR)"
  },
  {
    "value": "FNG",
    "label": "Fada N'gourma (FNG)"
  },
  {
    "value": "XGG",
    "label": "Gorom-Gorom (XGG)"
  },
  {
    "value": "XKA",
    "label": "Kantchari (XKA)"
  },
  {
    "value": "TMQ",
    "label": "Tambao (TMQ)"
  },
  {
    "value": "XPA",
    "label": "Pama (XPA)"
  },
  {
    "value": "ARL",
    "label": "Arly (ARL)"
  },
  {
    "value": "XSE",
    "label": "Sebba (XSE)"
  },
  {
    "value": "TEG",
    "label": "Tenkodogo (TEG)"
  },
  {
    "value": "XZA",
    "label": "ZabrÃ© (XZA)"
  },
  {
    "value": "OUA",
    "label": "Ouagadougou (OUA)"
  },
  {
    "value": "BNR",
    "label": "Banfora (BNR)"
  },
  {
    "value": "DGU",
    "label": "Dedougou (DGU)"
  },
  {
    "value": "XGA",
    "label": "Gaoua (XGA)"
  },
  {
    "value": "XNU",
    "label": "Nouna (XNU)"
  },
  {
    "value": "BOY",
    "label": "Bobo Dioulasso (BOY)"
  },
  {
    "value": "TUQ",
    "label": "Tougan (TUQ)"
  },
  {
    "value": "XDE",
    "label": "Diebougou (XDE)"
  },
  {
    "value": "XAR",
    "label": "Aribinda (XAR)"
  },
  {
    "value": "ACC",
    "label": "Accra (ACC)"
  },
  {
    "value": "DGG",
    "label": "Daugo Island (DGG)"
  },
  {
    "value": "TML",
    "label": "Tamale (TML)"
  },
  {
    "value": "KMS",
    "label": "Kumasi (KMS)"
  },
  {
    "value": "NYI",
    "label": "Sunyani (NYI)"
  },
  {
    "value": "TKD",
    "label": "Sekondi-Takoradi (TKD)"
  },
  {
    "value": "DHB",
    "label": "Deer Harbor (DHB)"
  },
  {
    "value": "ABJ",
    "label": "Abidjan (ABJ)"
  },
  {
    "value": "OGO",
    "label": "Abengourou (OGO)"
  },
  {
    "value": "BXI",
    "label": "Boundiali (BXI)"
  },
  {
    "value": "BYK",
    "label": "BouakÃ© Airport (BYK)"
  },
  {
    "value": "BQO",
    "label": "Bouna (BQO)"
  },
  {
    "value": "BDK",
    "label": "Bondoukou (BDK)"
  },
  {
    "value": "DIM",
    "label": "Dimbokro (DIM)"
  },
  {
    "value": "DJO",
    "label": "Daloa Airport (DJO)"
  },
  {
    "value": "FEK",
    "label": "Ferkessedougou (FEK)"
  },
  {
    "value": "GGN",
    "label": "Gagnoa (GGN)"
  },
  {
    "value": "GGO",
    "label": "Guiglo (GGO)"
  },
  {
    "value": "BBV",
    "label": "Grand-BÃ©rÃ©by (BBV)"
  },
  {
    "value": "HGO",
    "label": "Korhogo Airport (HGO)"
  },
  {
    "value": "MJC",
    "label": "Man Airport (MJC)"
  },
  {
    "value": "KEO",
    "label": "Odienne (KEO)"
  },
  {
    "value": "OFI",
    "label": "Ouango Fitini (OFI)"
  },
  {
    "value": "SEO",
    "label": "Seguela (SEO)"
  },
  {
    "value": "SPY",
    "label": "San Pedro Airport (SPY)"
  },
  {
    "value": "ZSS",
    "label": "Sassandra (ZSS)"
  },
  {
    "value": "TXU",
    "label": "Tabou (TXU)"
  },
  {
    "value": "ASK",
    "label": "Yamoussoukro (ASK)"
  },
  {
    "value": "DKA",
    "label": "Katsina (DKA)"
  },
  {
    "value": "ABV",
    "label": "Abuja (ABV)"
  },
  {
    "value": "AKR",
    "label": "Akure (AKR)"
  },
  {
    "value": "ABB",
    "label": "Asaba (ABB)"
  },
  {
    "value": "BNI",
    "label": "Benin (BNI)"
  },
  {
    "value": "CBQ",
    "label": "Calabar (CBQ)"
  },
  {
    "value": "ENU",
    "label": "Enegu (ENU)"
  },
  {
    "value": "QUS",
    "label": "Gusau (QUS)"
  },
  {
    "value": "IBA",
    "label": "Ibadan (IBA)"
  },
  {
    "value": "ILR",
    "label": "Ilorin (ILR)"
  },
  {
    "value": "QOW",
    "label": "Owerri (QOW)"
  },
  {
    "value": "JOS",
    "label": "Jos (JOS)"
  },
  {
    "value": "KAD",
    "label": "Kaduna (KAD)"
  },
  {
    "value": "KAN",
    "label": "Kano (KAN)"
  },
  {
    "value": "MIU",
    "label": "Maiduguri (MIU)"
  },
  {
    "value": "MDI",
    "label": "Makurdi (MDI)"
  },
  {
    "value": "LOS",
    "label": "Lagos (LOS)"
  },
  {
    "value": "MXJ",
    "label": "Minna (MXJ)"
  },
  {
    "value": "PHC",
    "label": "Port Harcourt (PHC)"
  },
  {
    "value": "SKO",
    "label": "Sokoto (SKO)"
  },
  {
    "value": "YOL",
    "label": "Yola (YOL)"
  },
  {
    "value": "ZAR",
    "label": "Zaria (ZAR)"
  },
  {
    "value": "STI",
    "label": "Santiago (STI)"
  },
  {
    "value": "DQA",
    "label": "Daqing Shi (DQA)"
  },
  {
    "value": "MFQ",
    "label": "Maradi (MFQ)"
  },
  {
    "value": "NIM",
    "label": "Niamey (NIM)"
  },
  {
    "value": "THZ",
    "label": "Tahoua (THZ)"
  },
  {
    "value": "AJY",
    "label": "Agadez (AJY)"
  },
  {
    "value": "ZND",
    "label": "Zinder (ZND)"
  },
  {
    "value": "DSG",
    "label": "Dilasag (DSG)"
  },
  {
    "value": "TBJ",
    "label": "Tabarka (TBJ)"
  },
  {
    "value": "MIR",
    "label": "Monastir (MIR)"
  },
  {
    "value": "TUN",
    "label": "Tunis (TUN)"
  },
  {
    "value": "OIZ",
    "label": "Sidi Ahmed (OIZ)"
  },
  {
    "value": "GAF",
    "label": "Gafsa (GAF)"
  },
  {
    "value": "GAE",
    "label": "GabÃ¨s (GAE)"
  },
  {
    "value": "DJE",
    "label": "Djerba (DJE)"
  },
  {
    "value": "EBM",
    "label": "El Borma (EBM)"
  },
  {
    "value": "SFA",
    "label": "Sfax (SFA)"
  },
  {
    "value": "TOE",
    "label": "Tozeur (TOE)"
  },
  {
    "value": "DWR",
    "label": "Camp Dwyer (DWR)"
  },
  {
    "value": "LRL",
    "label": "Niamtougou (LRL)"
  },
  {
    "value": "LFW",
    "label": "LomÃ© (LFW)"
  },
  {
    "value": "EAL",
    "label": "Mejato Island (EAL)"
  },
  {
    "value": "ANR",
    "label": "Antwerp (ANR)"
  },
  {
    "value": "BRU",
    "label": "Brussels (BRU)"
  },
  {
    "value": "CRL",
    "label": "Brussels (CRL)"
  },
  {
    "value": "KJK",
    "label": "Wevelgem (KJK)"
  },
  {
    "value": "LGG",
    "label": "LiÃ¨ge (LGG)"
  },
  {
    "value": "QNM",
    "label": "Namur (QNM)"
  },
  {
    "value": "OST",
    "label": "Ostend (OST)"
  },
  {
    "value": "QHA",
    "label": "Hasselt (QHA)"
  },
  {
    "value": "OBL",
    "label": "Zoersel (OBL)"
  },
  {
    "value": "MZD",
    "label": "Santiago de MÃ©ndez (MZD)"
  },
  {
    "value": "AOC",
    "label": "Altenburg (AOC)"
  },
  {
    "value": "HDF",
    "label": "Heringsdorf (HDF)"
  },
  {
    "value": "BBH",
    "label": "Barth Airport (BBH)"
  },
  {
    "value": "ZMG",
    "label": "Magdeburg (ZMG)"
  },
  {
    "value": "CBU",
    "label": "Cottbus (CBU)"
  },
  {
    "value": "SXF",
    "label": "Berlin (SXF)"
  },
  {
    "value": "DRS",
    "label": "Dresden (DRS)"
  },
  {
    "value": "ERF",
    "label": "Erfurt (ERF)"
  },
  {
    "value": "FRA",
    "label": "Frankfurt-am-Main (FRA)"
  },
  {
    "value": "FMO",
    "label": "MÃ¼nster (FMO)"
  },
  {
    "value": "HAM",
    "label": "Hamburg (HAM)"
  },
  {
    "value": "CGN",
    "label": "Cologne (CGN)"
  },
  {
    "value": "DUS",
    "label": "DÃ¼sseldorf (DUS)"
  },
  {
    "value": "MUC",
    "label": "Munich (MUC)"
  },
  {
    "value": "NUE",
    "label": "Nuremberg (NUE)"
  },
  {
    "value": "LEJ",
    "label": "Leipzig (LEJ)"
  },
  {
    "value": "SCN",
    "label": "SaarbrÃ¼cken (SCN)"
  },
  {
    "value": "STR",
    "label": "Stuttgart (STR)"
  },
  {
    "value": "TXL",
    "label": "Berlin (TXL)"
  },
  {
    "value": "HAJ",
    "label": "Hannover (HAJ)"
  },
  {
    "value": "BRE",
    "label": "Bremen (BRE)"
  },
  {
    "value": "QEF",
    "label": "Egelsbach (QEF)"
  },
  {
    "value": "HHN",
    "label": "Hahn (HHN)"
  },
  {
    "value": "MHG",
    "label": "Mannheim (MHG)"
  },
  {
    "value": "ZQV",
    "label": "Worms (ZQV)"
  },
  {
    "value": "QMZ",
    "label": "Mainz (QMZ)"
  },
  {
    "value": "SGE",
    "label": "Siegerland Airport (SGE)"
  },
  {
    "value": "XFW",
    "label": "Hamburg (XFW)"
  },
  {
    "value": "KEL",
    "label": "Kiel (KEL)"
  },
  {
    "value": "LBC",
    "label": "LÃ¼beck (LBC)"
  },
  {
    "value": "EUM",
    "label": "NeumÃ¼nster (EUM)"
  },
  {
    "value": "FMM",
    "label": "Memmingen (FMM)"
  },
  {
    "value": "AAH",
    "label": "Aachen (AAH)"
  },
  {
    "value": "ESS",
    "label": "Essen Mulheim Airport (ESS)"
  },
  {
    "value": "BFE",
    "label": "Bielefeld (BFE)"
  },
  {
    "value": "MGL",
    "label": "MÃ¶nchengladbach (MGL)"
  },
  {
    "value": "PAD",
    "label": "Paderborn (PAD)"
  },
  {
    "value": "NRN",
    "label": "Weeze (NRN)"
  },
  {
    "value": "DTM",
    "label": "Dortmund (DTM)"
  },
  {
    "value": "AGB",
    "label": "Augsburg (AGB)"
  },
  {
    "value": "OBF",
    "label": "Oberpfaffenhofen Airport (OBF)"
  },
  {
    "value": "RBM",
    "label": "Straubing (RBM)"
  },
  {
    "value": "FDH",
    "label": "Friedrichshafen (FDH)"
  },
  {
    "value": "FRF",
    "label": "Oschersleben (FRF)"
  },
  {
    "value": "SZW",
    "label": "Schwerin Parchim Airport (SZW)"
  },
  {
    "value": "BYU",
    "label": "Bayreuth (BYU)"
  },
  {
    "value": "QOB",
    "label": "Ansbach (QOB)"
  },
  {
    "value": "HOQ",
    "label": "Hof (HOQ)"
  },
  {
    "value": "BBJ",
    "label": "Bitburg (BBJ)"
  },
  {
    "value": "ZQW",
    "label": "ZweibrÃ¼cken (ZQW)"
  },
  {
    "value": "FKB",
    "label": "Baden-Baden (FKB)"
  },
  {
    "value": "ZQL",
    "label": "Donaueschingen (ZQL)"
  },
  {
    "value": "LHA",
    "label": "Lahr Airport (LHA)"
  },
  {
    "value": "BWE",
    "label": "Braunschweig Wolfsburg Airport (BWE)"
  },
  {
    "value": "KSF",
    "label": "Kassel (KSF)"
  },
  {
    "value": "BRV",
    "label": "Bremerhaven (BRV)"
  },
  {
    "value": "XLW",
    "label": "Lemwerder (XLW)"
  },
  {
    "value": "EME",
    "label": "Emden (EME)"
  },
  {
    "value": "AGE",
    "label": "Wangerooge (AGE)"
  },
  {
    "value": "WVN",
    "label": "Wilhelmshaven (WVN)"
  },
  {
    "value": "JUI",
    "label": "Juist (JUI)"
  },
  {
    "value": "LGO",
    "label": "Langeoog (LGO)"
  },
  {
    "value": "ZOW",
    "label": "Klausheide (ZOW)"
  },
  {
    "value": "BMK",
    "label": "Borkum (BMK)"
  },
  {
    "value": "NOD",
    "label": "Norddeich (NOD)"
  },
  {
    "value": "VAC",
    "label": "Cloppenburg (VAC)"
  },
  {
    "value": "NRD",
    "label": "Norderney (NRD)"
  },
  {
    "value": "BMR",
    "label": "Baltrum (BMR)"
  },
  {
    "value": "HEI",
    "label": "BÃ¼sum (HEI)"
  },
  {
    "value": "FLF",
    "label": "Flensburg (FLF)"
  },
  {
    "value": "HGL",
    "label": "Helgoland (HGL)"
  },
  {
    "value": "PSH",
    "label": "Sankt Peter-Ording (PSH)"
  },
  {
    "value": "GWT",
    "label": "Westerland (GWT)"
  },
  {
    "value": "OHR",
    "label": "Wyk auf FÃ¶hr (OHR)"
  },
  {
    "value": "KDL",
    "label": "KÃ¤rdla (KDL)"
  },
  {
    "value": "URE",
    "label": "Kuressaare (URE)"
  },
  {
    "value": "EPU",
    "label": "PÃ¤rnu (EPU)"
  },
  {
    "value": "TLL",
    "label": "Tallinn (TLL)"
  },
  {
    "value": "TAY",
    "label": "Tartu (TAY)"
  },
  {
    "value": "ENF",
    "label": "Enontekio (ENF)"
  },
  {
    "value": "QVE",
    "label": "Forssa (QVE)"
  },
  {
    "value": "EFG",
    "label": "Efogi (EFG)"
  },
  {
    "value": "KEV",
    "label": "Halli / Kuorevesi (KEV)"
  },
  {
    "value": "HEM",
    "label": "Helsinki (HEM)"
  },
  {
    "value": "HEL",
    "label": "Helsinki (HEL)"
  },
  {
    "value": "HYV",
    "label": "Hyvinkaa Airport (HYV)"
  },
  {
    "value": "KTQ",
    "label": "Kitee Airport (KTQ)"
  },
  {
    "value": "IVL",
    "label": "Ivalo (IVL)"
  },
  {
    "value": "JOE",
    "label": "Joensuu / Liperi (JOE)"
  },
  {
    "value": "JYV",
    "label": "JyvÃ¤skylÃ¤n Maalaiskunta (JYV)"
  },
  {
    "value": "KAU",
    "label": "Kauhava (KAU)"
  },
  {
    "value": "KEM",
    "label": "Kemi / Tornio (KEM)"
  },
  {
    "value": "KAJ",
    "label": "Kajaani (KAJ)"
  },
  {
    "value": "KHJ",
    "label": "Kauhajoki Airport (KHJ)"
  },
  {
    "value": "KOK",
    "label": "Kokkola / Kruunupyy (KOK)"
  },
  {
    "value": "KAO",
    "label": "Kuusamo (KAO)"
  },
  {
    "value": "KTT",
    "label": "Kittila (KTT)"
  },
  {
    "value": "KUO",
    "label": "Kuopio / SiilinjÃ¤rvi (KUO)"
  },
  {
    "value": "QLF",
    "label": "Lahti Vesivehmaa Airport (QLF)"
  },
  {
    "value": "LPP",
    "label": "Lappeenranta (LPP)"
  },
  {
    "value": "MHQ",
    "label": "Mariehamn Airport (MHQ)"
  },
  {
    "value": "MIK",
    "label": "Mikkeli (MIK)"
  },
  {
    "value": "OUL",
    "label": "Oulu / Oulunsalo (OUL)"
  },
  {
    "value": "POR",
    "label": "Pori (POR)"
  },
  {
    "value": "RVN",
    "label": "Rovaniemi (RVN)"
  },
  {
    "value": "SVL",
    "label": "Savonlinna (SVL)"
  },
  {
    "value": "SJY",
    "label": "SeinÃ¤joki / Ilmajoki (SJY)"
  },
  {
    "value": "SOT",
    "label": "Sodankyla (SOT)"
  },
  {
    "value": "TMP",
    "label": "Tampere / Pirkkala (TMP)"
  },
  {
    "value": "TKU",
    "label": "Turku (TKU)"
  },
  {
    "value": "UTI",
    "label": "Utti / Valkeala (UTI)"
  },
  {
    "value": "VAA",
    "label": "Vaasa (VAA)"
  },
  {
    "value": "VRK",
    "label": "Varkaus / Joroinen (VRK)"
  },
  {
    "value": "YLI",
    "label": "Ylivieska Airport (YLI)"
  },
  {
    "value": "AUE",
    "label": "Abu Rudeis (AUE)"
  },
  {
    "value": "BFS",
    "label": "Belfast (BFS)"
  },
  {
    "value": "ENK",
    "label": "Enniskillen (ENK)"
  },
  {
    "value": "BHD",
    "label": "Belfast (BHD)"
  },
  {
    "value": "LDY",
    "label": "Derry (LDY)"
  },
  {
    "value": "BHX",
    "label": "Birmingham (BHX)"
  },
  {
    "value": "CVT",
    "label": "Coventry (CVT)"
  },
  {
    "value": "GLO",
    "label": "Staverton (GLO)"
  },
  {
    "value": "ORM",
    "label": "Northampton (ORM)"
  },
  {
    "value": "NQT",
    "label": "Nottingham (NQT)"
  },
  {
    "value": "MAN",
    "label": "Manchester (MAN)"
  },
  {
    "value": "DSA",
    "label": "Doncaster (DSA)"
  },
  {
    "value": "LYE",
    "label": "Lyneham (LYE)"
  },
  {
    "value": "DGX",
    "label": "St. Athan (DGX)"
  },
  {
    "value": "YEO",
    "label": "Yeovil (YEO)"
  },
  {
    "value": "CAL",
    "label": "Campbeltown (CAL)"
  },
  {
    "value": "EOI",
    "label": "Eday (EOI)"
  },
  {
    "value": "FIE",
    "label": "Fair Isle (FIE)"
  },
  {
    "value": "WHS",
    "label": "Whalsay (WHS)"
  },
  {
    "value": "COL",
    "label": "Coll Island (COL)"
  },
  {
    "value": "NRL",
    "label": "North Ronaldsay (NRL)"
  },
  {
    "value": "OBN",
    "label": "North Connel (OBN)"
  },
  {
    "value": "PPW",
    "label": "Papa Westray (PPW)"
  },
  {
    "value": "SOY",
    "label": "Stronsay (SOY)"
  },
  {
    "value": "NDY",
    "label": "Sanday (NDY)"
  },
  {
    "value": "LWK",
    "label": "Lerwick (LWK)"
  },
  {
    "value": "WRY",
    "label": "Westray (WRY)"
  },
  {
    "value": "CSA",
    "label": "Colonsay (CSA)"
  },
  {
    "value": "HAW",
    "label": "Haverfordwest (HAW)"
  },
  {
    "value": "CWL",
    "label": "Cardiff (CWL)"
  },
  {
    "value": "SWS",
    "label": "Swansea (SWS)"
  },
  {
    "value": "BRS",
    "label": "Bristol (BRS)"
  },
  {
    "value": "LPL",
    "label": "Liverpool (LPL)"
  },
  {
    "value": "LTN",
    "label": "London (LTN)"
  },
  {
    "value": "LEQ",
    "label": "Land's End (LEQ)"
  },
  {
    "value": "PLH",
    "label": "Plymouth (PLH)"
  },
  {
    "value": "ISC",
    "label": "St. Mary's (ISC)"
  },
  {
    "value": "BOH",
    "label": "Bournemouth (BOH)"
  },
  {
    "value": "SOU",
    "label": "Southampton (SOU)"
  },
  {
    "value": "BBP",
    "label": "Bembridge (BBP)"
  },
  {
    "value": "PZE",
    "label": "Penzance (PZE)"
  },
  {
    "value": "QLA",
    "label": "Lasham (QLA)"
  },
  {
    "value": "NQY",
    "label": "Newquay (NQY)"
  },
  {
    "value": "QUG",
    "label": "Chichester (QUG)"
  },
  {
    "value": "ACI",
    "label": "Saint Anne (ACI)"
  },
  {
    "value": "GCI",
    "label": "Saint Peter Port (GCI)"
  },
  {
    "value": "JER",
    "label": "Saint Helier (JER)"
  },
  {
    "value": "ESH",
    "label": "Brighton (ESH)"
  },
  {
    "value": "BQH",
    "label": "London (BQH)"
  },
  {
    "value": "LGW",
    "label": "London (LGW)"
  },
  {
    "value": "KRH",
    "label": "Redhill (KRH)"
  },
  {
    "value": "LCY",
    "label": "London (LCY)"
  },
  {
    "value": "FAB",
    "label": "Farnborough (FAB)"
  },
  {
    "value": "BBS",
    "label": "Yateley (BBS)"
  },
  {
    "value": "LHR",
    "label": "London (LHR)"
  },
  {
    "value": "SEN",
    "label": "Southend (SEN)"
  },
  {
    "value": "LYX",
    "label": "Lydd, Ashford (LYX)"
  },
  {
    "value": "MSE",
    "label": "Manston (MSE)"
  },
  {
    "value": "CAX",
    "label": "Carlisle (CAX)"
  },
  {
    "value": "BLK",
    "label": "Blackpool (BLK)"
  },
  {
    "value": "HUY",
    "label": "Grimsby (HUY)"
  },
  {
    "value": "BWF",
    "label": "Barrow-in-Furness (BWF)"
  },
  {
    "value": "LBA",
    "label": "Leeds (LBA)"
  },
  {
    "value": "CEG",
    "label": "Hawarden (CEG)"
  },
  {
    "value": "IOM",
    "label": "Castletown (IOM)"
  },
  {
    "value": "NCL",
    "label": "Newcastle (NCL)"
  },
  {
    "value": "MME",
    "label": "Durham (MME)"
  },
  {
    "value": "EMA",
    "label": "Nottingham (EMA)"
  },
  {
    "value": "HLY",
    "label": "Angelsey (HLY)"
  },
  {
    "value": "KOI",
    "label": "Orkney Islands (KOI)"
  },
  {
    "value": "LSI",
    "label": "Lerwick (LSI)"
  },
  {
    "value": "WIC",
    "label": "Wick (WIC)"
  },
  {
    "value": "ABZ",
    "label": "Aberdeen (ABZ)"
  },
  {
    "value": "INV",
    "label": "Inverness (INV)"
  },
  {
    "value": "GLA",
    "label": "Glasgow (GLA)"
  },
  {
    "value": "EDI",
    "label": "Edinburgh (EDI)"
  },
  {
    "value": "ILY",
    "label": "Port Ellen (ILY)"
  },
  {
    "value": "PIK",
    "label": "Glasgow (PIK)"
  },
  {
    "value": "BEB",
    "label": "Balivanich (BEB)"
  },
  {
    "value": "SCS",
    "label": "Shetland Islands (SCS)"
  },
  {
    "value": "DND",
    "label": "Dundee (DND)"
  },
  {
    "value": "SYY",
    "label": "Stornoway (SYY)"
  },
  {
    "value": "BRR",
    "label": "Eoligarry (BRR)"
  },
  {
    "value": "PSL",
    "label": "Perth (PSL)"
  },
  {
    "value": "TRE",
    "label": "Balemartine (TRE)"
  },
  {
    "value": "UNT",
    "label": "Shetland Islands (UNT)"
  },
  {
    "value": "BOL",
    "label": "Ballykelly (BOL)"
  },
  {
    "value": "FSS",
    "label": "Kinloss (FSS)"
  },
  {
    "value": "ADX",
    "label": "St. Andrews (ADX)"
  },
  {
    "value": "LMO",
    "label": "Lossiemouth (LMO)"
  },
  {
    "value": "CBG",
    "label": "Cambridge (CBG)"
  },
  {
    "value": "NWI",
    "label": "Norwich (NWI)"
  },
  {
    "value": "STN",
    "label": "London (STN)"
  },
  {
    "value": "QFO",
    "label": "Duxford (QFO)"
  },
  {
    "value": "SZE",
    "label": "Sheffield (SZE)"
  },
  {
    "value": "EXT",
    "label": "Exeter (EXT)"
  },
  {
    "value": "FRK",
    "label": "Woking (FRK)"
  },
  {
    "value": "FZO",
    "label": "Bristol (FZO)"
  },
  {
    "value": "OXF",
    "label": "Kidlington (OXF)"
  },
  {
    "value": "RCS",
    "label": "Rochester (RCS)"
  },
  {
    "value": "BEX",
    "label": "Benson (BEX)"
  },
  {
    "value": "LKZ",
    "label": "Lakenheath (LKZ)"
  },
  {
    "value": "MHZ",
    "label": "Mildenhall (MHZ)"
  },
  {
    "value": "QUY",
    "label": "St. Ives (QUY)"
  },
  {
    "value": "FFD",
    "label": "Fairford (FFD)"
  },
  {
    "value": "BZZ",
    "label": "Brize Norton (BZZ)"
  },
  {
    "value": "ODH",
    "label": "Odiham (ODH)"
  },
  {
    "value": "WXF",
    "label": "Wethersfield (WXF)"
  },
  {
    "value": "ADV",
    "label": "Andover (ADV)"
  },
  {
    "value": "NHT",
    "label": "London (NHT)"
  },
  {
    "value": "QCY",
    "label": "Coningsby (QCY)"
  },
  {
    "value": "BEQ",
    "label": "Thetford (BEQ)"
  },
  {
    "value": "OKH",
    "label": "Cottesmore (OKH)"
  },
  {
    "value": "SQZ",
    "label": "Scampton (SQZ)"
  },
  {
    "value": "HRT",
    "label": "Linton-On-Ouse (HRT)"
  },
  {
    "value": "WTN",
    "label": "Waddington (WTN)"
  },
  {
    "value": "CLF",
    "label": "Norwich (CLF)"
  },
  {
    "value": "MRH",
    "label": "Marham (MRH)"
  },
  {
    "value": "MPN",
    "label": "Mount Pleasant (MPN)"
  },
  {
    "value": "AMS",
    "label": "Amsterdam (AMS)"
  },
  {
    "value": "MST",
    "label": "Maastricht (MST)"
  },
  {
    "value": "QAR",
    "label": "Arnhem (QAR)"
  },
  {
    "value": "EIN",
    "label": "Eindhoven (EIN)"
  },
  {
    "value": "GRQ",
    "label": "Groningen (GRQ)"
  },
  {
    "value": "GLZ",
    "label": "Breda (GLZ)"
  },
  {
    "value": "DHR",
    "label": "Den Helder (DHR)"
  },
  {
    "value": "LEY",
    "label": "Lelystad (LEY)"
  },
  {
    "value": "LWR",
    "label": "Leeuwarden (LWR)"
  },
  {
    "value": "RTM",
    "label": "Rotterdam (RTM)"
  },
  {
    "value": "ENS",
    "label": "Enschede (ENS)"
  },
  {
    "value": "UDE",
    "label": "Uden (UDE)"
  },
  {
    "value": "WOE",
    "label": "Bergen Op Zoom (WOE)"
  },
  {
    "value": "BYT",
    "label": "Bantry (BYT)"
  },
  {
    "value": "BLY",
    "label": "Belmullet (BLY)"
  },
  {
    "value": "NNR",
    "label": "Inverin (NNR)"
  },
  {
    "value": "CLB",
    "label": "Castlebar (CLB)"
  },
  {
    "value": "WEX",
    "label": "Wexford (WEX)"
  },
  {
    "value": "ORK",
    "label": "Cork (ORK)"
  },
  {
    "value": "GWY",
    "label": "Galway (GWY)"
  },
  {
    "value": "CFN",
    "label": "Donegal (CFN)"
  },
  {
    "value": "DUB",
    "label": "Dublin (DUB)"
  },
  {
    "value": "IOR",
    "label": "Inis MÃ³r (IOR)"
  },
  {
    "value": "INQ",
    "label": "Inis OÃ­rr (INQ)"
  },
  {
    "value": "KKY",
    "label": "Kilkenny (KKY)"
  },
  {
    "value": "NOC",
    "label": "Charleston (NOC)"
  },
  {
    "value": "KIR",
    "label": "Killarney (KIR)"
  },
  {
    "value": "LTR",
    "label": "Letterkenny (LTR)"
  },
  {
    "value": "IIA",
    "label": "Inis MeÃ¡in (IIA)"
  },
  {
    "value": "SNN",
    "label": "Shannon (SNN)"
  },
  {
    "value": "SXL",
    "label": "Sligo (SXL)"
  },
  {
    "value": "WAT",
    "label": "Waterford (WAT)"
  },
  {
    "value": "AAR",
    "label": "Aarhus (AAR)"
  },
  {
    "value": "BLL",
    "label": "Billund (BLL)"
  },
  {
    "value": "CPH",
    "label": "Copenhagen (CPH)"
  },
  {
    "value": "EBJ",
    "label": "Esbjerg (EBJ)"
  },
  {
    "value": "KRP",
    "label": "Karup (KRP)"
  },
  {
    "value": "BYR",
    "label": "LÃ¦sÃ¸ (BYR)"
  },
  {
    "value": "MRW",
    "label": "Lolland Falster / Maribo (MRW)"
  },
  {
    "value": "ODE",
    "label": "Odense (ODE)"
  },
  {
    "value": "RKE",
    "label": "Copenhagen (RKE)"
  },
  {
    "value": "RNN",
    "label": "RÃ¸nne (RNN)"
  },
  {
    "value": "SGD",
    "label": "SÃ¸nderborg (SGD)"
  },
  {
    "value": "CNL",
    "label": "Sindal (CNL)"
  },
  {
    "value": "SKS",
    "label": "Vojens (SKS)"
  },
  {
    "value": "SQW",
    "label": "Skive (SQW)"
  },
  {
    "value": "TED",
    "label": "Thisted (TED)"
  },
  {
    "value": "VDP",
    "label": "Kolding / Vamdrup (VDP)"
  },
  {
    "value": "FAE",
    "label": "Vagar (FAE)"
  },
  {
    "value": "STA",
    "label": "Skjern / RingkÃ¸bing (STA)"
  },
  {
    "value": "AAL",
    "label": "Aalborg (AAL)"
  },
  {
    "value": "LUX",
    "label": "Luxembourg (LUX)"
  },
  {
    "value": "AES",
    "label": "Ã…lesund (AES)"
  },
  {
    "value": "ANX",
    "label": "Andenes (ANX)"
  },
  {
    "value": "ALF",
    "label": "Alta (ALF)"
  },
  {
    "value": "FDE",
    "label": "FÃ¸rde (FDE)"
  },
  {
    "value": "BNN",
    "label": "BrÃ¸nnÃ¸y (BNN)"
  },
  {
    "value": "BOO",
    "label": "BodÃ¸ (BOO)"
  },
  {
    "value": "BGO",
    "label": "Bergen (BGO)"
  },
  {
    "value": "BJF",
    "label": "BÃ¥tsfjord (BJF)"
  },
  {
    "value": "BVG",
    "label": "BerlevÃ¥g (BVG)"
  },
  {
    "value": "KRS",
    "label": "Kjevik (KRS)"
  },
  {
    "value": "DLD",
    "label": "Dagali (DLD)"
  },
  {
    "value": "BDU",
    "label": "MÃ¥lselv (BDU)"
  },
  {
    "value": "EVE",
    "label": "Evenes (EVE)"
  },
  {
    "value": "VDB",
    "label": "Leirin Airport (VDB)"
  },
  {
    "value": "FRO",
    "label": "FlorÃ¸ (FRO)"
  },
  {
    "value": "OSL",
    "label": "Oslo (OSL)"
  },
  {
    "value": "HMR",
    "label": "Hamar (HMR)"
  },
  {
    "value": "HAU",
    "label": "KarmÃ¸y (HAU)"
  },
  {
    "value": "HFT",
    "label": "Hammerfest (HFT)"
  },
  {
    "value": "HAA",
    "label": "Hasvik (HAA)"
  },
  {
    "value": "HVG",
    "label": "HonningsvÃ¥g (HVG)"
  },
  {
    "value": "QKX",
    "label": "Kautokeino Air Base (QKX)"
  },
  {
    "value": "KSU",
    "label": "Kvernberget (KSU)"
  },
  {
    "value": "GLL",
    "label": "Klanten (GLL)"
  },
  {
    "value": "KKN",
    "label": "Kirkenes (KKN)"
  },
  {
    "value": "FAN",
    "label": "Farsund (FAN)"
  },
  {
    "value": "LKN",
    "label": "Leknes (LKN)"
  },
  {
    "value": "MEH",
    "label": "Mehamn (MEH)"
  },
  {
    "value": "MOL",
    "label": "Ã…rÃ¸ (MOL)"
  },
  {
    "value": "MJF",
    "label": "MosjÃ¸en Airport, KjÃ¦rstad (MJF)"
  },
  {
    "value": "LKL",
    "label": "Lakselv (LKL)"
  },
  {
    "value": "NVK",
    "label": "Narvik (NVK)"
  },
  {
    "value": "OSY",
    "label": "Namsos (OSY)"
  },
  {
    "value": "NTB",
    "label": "Notodden Airport (NTB)"
  },
  {
    "value": "OLA",
    "label": "Ã˜rland (OLA)"
  },
  {
    "value": "HOV",
    "label": "Ã˜rsta (HOV)"
  },
  {
    "value": "MQN",
    "label": "Mo i Rana (MQN)"
  },
  {
    "value": "RVK",
    "label": "RÃ¸rvik (RVK)"
  },
  {
    "value": "RRS",
    "label": "RÃ¸ros (RRS)"
  },
  {
    "value": "RET",
    "label": "RÃ¸st Airport (RET)"
  },
  {
    "value": "RYG",
    "label": "Rygge (RYG)"
  },
  {
    "value": "LYR",
    "label": "Longyearbyen (LYR)"
  },
  {
    "value": "SDN",
    "label": "Sandane (SDN)"
  },
  {
    "value": "SOG",
    "label": "Sogndal (SOG)"
  },
  {
    "value": "SVJ",
    "label": "SvolvÃ¦r (SVJ)"
  },
  {
    "value": "SKN",
    "label": "Hadsel (SKN)"
  },
  {
    "value": "SKE",
    "label": "Geiteryggen (SKE)"
  },
  {
    "value": "SRP",
    "label": "Leirvik (SRP)"
  },
  {
    "value": "SOJ",
    "label": "SÃ¸rkjosen (SOJ)"
  },
  {
    "value": "VAW",
    "label": "VardÃ¸ (VAW)"
  },
  {
    "value": "SSJ",
    "label": "Alstahaug (SSJ)"
  },
  {
    "value": "TOS",
    "label": "TromsÃ¸ (TOS)"
  },
  {
    "value": "TRF",
    "label": "Torp (TRF)"
  },
  {
    "value": "TRD",
    "label": "Trondheim (TRD)"
  },
  {
    "value": "VDS",
    "label": "VadsÃ¸ (VDS)"
  },
  {
    "value": "VRY",
    "label": "VÃ¦rÃ¸y (VRY)"
  },
  {
    "value": "SVG",
    "label": "Stavanger (SVG)"
  },
  {
    "value": "QYY",
    "label": "BiaÅ‚ystok (QYY)"
  },
  {
    "value": "BXP",
    "label": "BiaÅ‚a Podlaska (BXP)"
  },
  {
    "value": "BZG",
    "label": "Bydgoszcz (BZG)"
  },
  {
    "value": "CZW",
    "label": "CzÄ™stochowa (CZW)"
  },
  {
    "value": "GDN",
    "label": "GdaÅ„sk (GDN)"
  },
  {
    "value": "QLC",
    "label": "Gliwice Glider Airport (QLC)"
  },
  {
    "value": "KRK",
    "label": "KrakÃ³w (KRK)"
  },
  {
    "value": "OSZ",
    "label": "Koszalin Zegrze Airport (OSZ)"
  },
  {
    "value": "KTW",
    "label": "Katowice (KTW)"
  },
  {
    "value": "QEO",
    "label": "Czechowice-Dziedzice (QEO)"
  },
  {
    "value": "LCJ",
    "label": "ÅÃ³dÅº (LCJ)"
  },
  {
    "value": "QLU",
    "label": "Lublin Radwiec Airport (QLU)"
  },
  {
    "value": "QWS",
    "label": "Nowy Targ (QWS)"
  },
  {
    "value": "QYD",
    "label": "Gdynia (QYD)"
  },
  {
    "value": "QPM",
    "label": "Opole (QPM)"
  },
  {
    "value": "POZ",
    "label": "PoznaÅ„ (POZ)"
  },
  {
    "value": "RZE",
    "label": "RzeszÃ³w (RZE)"
  },
  {
    "value": "SZZ",
    "label": "Goleniow (SZZ)"
  },
  {
    "value": "WAW",
    "label": "Warsaw (WAW)"
  },
  {
    "value": "WRO",
    "label": "WrocÅ‚aw (WRO)"
  },
  {
    "value": "IEG",
    "label": "Babimost (IEG)"
  },
  {
    "value": "ERT",
    "label": "Erdenet (ERT)"
  },
  {
    "value": "RNB",
    "label": "Ronneby Airport (RNB)"
  },
  {
    "value": "XWP",
    "label": "HÃ¤ssleholm (XWP)"
  },
  {
    "value": "GOT",
    "label": "Gothenburg (GOT)"
  },
  {
    "value": "JKG",
    "label": "JÃ¶nkÃ¶ping (JKG)"
  },
  {
    "value": "LDK",
    "label": "LidkÃ¶ping (LDK)"
  },
  {
    "value": "GSE",
    "label": "Gothenburg (GSE)"
  },
  {
    "value": "KVB",
    "label": "SkÃ¶vde (KVB)"
  },
  {
    "value": "THN",
    "label": "TrollhÃ¤ttan (THN)"
  },
  {
    "value": "KSK",
    "label": "Karlskoga Airport (KSK)"
  },
  {
    "value": "MXX",
    "label": "Mora Airport (MXX)"
  },
  {
    "value": "NYO",
    "label": "Stockholm / NykÃ¶ping (NYO)"
  },
  {
    "value": "KID",
    "label": "Kristianstad (KID)"
  },
  {
    "value": "OSK",
    "label": "Oskarshamn Airport (OSK)"
  },
  {
    "value": "KLR",
    "label": "Kalmar Airport (KLR)"
  },
  {
    "value": "MMX",
    "label": "MalmÃ¶ (MMX)"
  },
  {
    "value": "HAD",
    "label": "Halmstad (HAD)"
  },
  {
    "value": "VXO",
    "label": "VÃ¤xjÃ¶ (VXO)"
  },
  {
    "value": "EVG",
    "label": "Sveg Airport (EVG)"
  },
  {
    "value": "GEV",
    "label": "GÃ¤llivare (GEV)"
  },
  {
    "value": "KRF",
    "label": "Kramfors / SollefteÃ¥ (KRF)"
  },
  {
    "value": "LYC",
    "label": "Lycksele Airport (LYC)"
  },
  {
    "value": "SDL",
    "label": "Sundsvall/ HÃ¤rnÃ¶sand (SDL)"
  },
  {
    "value": "OER",
    "label": "Ã–rnskÃ¶ldsvik (OER)"
  },
  {
    "value": "KRN",
    "label": "Kiruna Airport (KRN)"
  },
  {
    "value": "SFT",
    "label": "SkellefteÃ¥ (SFT)"
  },
  {
    "value": "UME",
    "label": "UmeÃ¥ (UME)"
  },
  {
    "value": "VHM",
    "label": "Vilhelmina Airport (VHM)"
  },
  {
    "value": "AJR",
    "label": "Arvidsjaur (AJR)"
  },
  {
    "value": "SOO",
    "label": "SÃ¶derhamn (SOO)"
  },
  {
    "value": "OSD",
    "label": "Ã–stersund (OSD)"
  },
  {
    "value": "ORB",
    "label": "Ã–rebro (ORB)"
  },
  {
    "value": "HFS",
    "label": "Hagfors Airport (HFS)"
  },
  {
    "value": "KSD",
    "label": "Karlstad (KSD)"
  },
  {
    "value": "VST",
    "label": "Stockholm / VÃ¤sterÃ¥s (VST)"
  },
  {
    "value": "LLA",
    "label": "LuleÃ¥ (LLA)"
  },
  {
    "value": "ARN",
    "label": "Stockholm (ARN)"
  },
  {
    "value": "BMA",
    "label": "Stockholm (BMA)"
  },
  {
    "value": "BLE",
    "label": "Borlange Airport (BLE)"
  },
  {
    "value": "HLF",
    "label": "Hultsfred Airport (HLF)"
  },
  {
    "value": "GVX",
    "label": "GÃ¤vle / Sandviken (GVX)"
  },
  {
    "value": "LPI",
    "label": "LinkÃ¶ping (LPI)"
  },
  {
    "value": "NRK",
    "label": "NorrkÃ¶ping (NRK)"
  },
  {
    "value": "TYF",
    "label": "Torsby Airport (TYF)"
  },
  {
    "value": "EKT",
    "label": "Eskilstuna (EKT)"
  },
  {
    "value": "VBY",
    "label": "Visby (VBY)"
  },
  {
    "value": "VVK",
    "label": "VÃ¤stervik (VVK)"
  },
  {
    "value": "AGH",
    "label": "Ã„ngelholm (AGH)"
  },
  {
    "value": "SQO",
    "label": "Storuman Airport (SQO)"
  },
  {
    "value": "IDB",
    "label": "Idre (IDB)"
  },
  {
    "value": "PJA",
    "label": "Pajala Airport (PJA)"
  },
  {
    "value": "HMV",
    "label": "Hemavan Airport (HMV)"
  },
  {
    "value": "GLC",
    "label": "Geladi (GLC)"
  },
  {
    "value": "SHC",
    "label": "Shire Indasilase (SHC)"
  },
  {
    "value": "SPM",
    "label": "Trier (SPM)"
  },
  {
    "value": "RMS",
    "label": "Ramstein (RMS)"
  },
  {
    "value": "ZCD",
    "label": "Bamberg (ZCD)"
  },
  {
    "value": "ZCN",
    "label": "Celle Airport (ZCN)"
  },
  {
    "value": "ZPQ",
    "label": "Rheine Bentlage Airport (ZPQ)"
  },
  {
    "value": "FRZ",
    "label": "Fritzlar (FRZ)"
  },
  {
    "value": "ZNF",
    "label": "Hanau Army Air Field (ZNF)"
  },
  {
    "value": "QHD",
    "label": "Heidelberg (QHD)"
  },
  {
    "value": "NDZ",
    "label": "Nordholz Airport (NDZ)"
  },
  {
    "value": "GKE",
    "label": "Geilenkirchen Airport (GKE)"
  },
  {
    "value": "RLG",
    "label": "Rostock (RLG)"
  },
  {
    "value": "QOE",
    "label": "Norvenich Airport (QOE)"
  },
  {
    "value": "WBG",
    "label": "Schleswig Airport (WBG)"
  },
  {
    "value": "FNB",
    "label": "Neubrandenburg Airport (FNB)"
  },
  {
    "value": "WIE",
    "label": "Wiesbaden (WIE)"
  },
  {
    "value": "FEL",
    "label": "FÃ¼rstenfeldbruck (FEL)"
  },
  {
    "value": "IGS",
    "label": "Manching (IGS)"
  },
  {
    "value": "GUT",
    "label": "GÃ¼tersloh (GUT)"
  },
  {
    "value": "BGN",
    "label": "Brugge Air Base (BGN)"
  },
  {
    "value": "DGP",
    "label": "Daugavpils (DGP)"
  },
  {
    "value": "LPX",
    "label": "LiepÄja (LPX)"
  },
  {
    "value": "RIX",
    "label": "Riga (RIX)"
  },
  {
    "value": "VNT",
    "label": "Ventspils (VNT)"
  },
  {
    "value": "EXI",
    "label": "Excursion Inlet (EXI)"
  },
  {
    "value": "KUN",
    "label": "Kaunas (KUN)"
  },
  {
    "value": "KLJ",
    "label": "KlaipÄ—da (KLJ)"
  },
  {
    "value": "PLQ",
    "label": "Palanga (PLQ)"
  },
  {
    "value": "PNV",
    "label": "PanevÄ—Å¾ys (PNV)"
  },
  {
    "value": "SQQ",
    "label": "Å iauliai (SQQ)"
  },
  {
    "value": "HLJ",
    "label": "Barysiai (HLJ)"
  },
  {
    "value": "VNO",
    "label": "Vilnius (VNO)"
  },
  {
    "value": "ALJ",
    "label": "Alexander Bay (ALJ)"
  },
  {
    "value": "AGZ",
    "label": "Aggeneys (AGZ)"
  },
  {
    "value": "ADY",
    "label": "Alldays (ADY)"
  },
  {
    "value": "BIY",
    "label": "Bisho (BIY)"
  },
  {
    "value": "BFN",
    "label": "Bloemfontain (BFN)"
  },
  {
    "value": "UTE",
    "label": "Butterworth (UTE)"
  },
  {
    "value": "CDO",
    "label": "Cradock (CDO)"
  },
  {
    "value": "CPT",
    "label": "Cape Town (CPT)"
  },
  {
    "value": "DUK",
    "label": "Mubatuba (DUK)"
  },
  {
    "value": "PZL",
    "label": "Phinda (PZL)"
  },
  {
    "value": "ELS",
    "label": "East London (ELS)"
  },
  {
    "value": "EMG",
    "label": "Empangeni (EMG)"
  },
  {
    "value": "ELL",
    "label": "Ellisras (ELL)"
  },
  {
    "value": "FCB",
    "label": "Ficksburg (FCB)"
  },
  {
    "value": "GCJ",
    "label": "Midrand (GCJ)"
  },
  {
    "value": "GRJ",
    "label": "George (GRJ)"
  },
  {
    "value": "GIY",
    "label": "Giyani (GIY)"
  },
  {
    "value": "QRA",
    "label": "Johannesburg (QRA)"
  },
  {
    "value": "HLW",
    "label": "Hluhluwe (HLW)"
  },
  {
    "value": "HRS",
    "label": "Harrismith (HRS)"
  },
  {
    "value": "HDS",
    "label": "Hoedspruit (HDS)"
  },
  {
    "value": "JNB",
    "label": "Johannesburg (JNB)"
  },
  {
    "value": "KXE",
    "label": "Klerksdorp (KXE)"
  },
  {
    "value": "KIM",
    "label": "Kimberley (KIM)"
  },
  {
    "value": "MQP",
    "label": "Mpumalanga (MQP)"
  },
  {
    "value": "KOF",
    "label": "Komatipoort (KOF)"
  },
  {
    "value": "KMH",
    "label": "Kuruman (KMH)"
  },
  {
    "value": "KLZ",
    "label": "Kleinsee (KLZ)"
  },
  {
    "value": "HLA",
    "label": "Johannesburg (HLA)"
  },
  {
    "value": "LMR",
    "label": "Lime Acres (LMR)"
  },
  {
    "value": "LDZ",
    "label": "Londolozi (LDZ)"
  },
  {
    "value": "DUR",
    "label": "Durban (DUR)"
  },
  {
    "value": "LUJ",
    "label": "Lusikisiki (LUJ)"
  },
  {
    "value": "LCD",
    "label": "Louis Trichardt (LCD)"
  },
  {
    "value": "LGE",
    "label": "Langebaanweg (LGE)"
  },
  {
    "value": "LAY",
    "label": "Ladysmith (LAY)"
  },
  {
    "value": "AAM",
    "label": "Malamala (AAM)"
  },
  {
    "value": "MGH",
    "label": "Margate (MGH)"
  },
  {
    "value": "MBD",
    "label": "Mafeking (MBD)"
  },
  {
    "value": "LLE",
    "label": "Malelane (LLE)"
  },
  {
    "value": "MZY",
    "label": "Mossel Bay (MZY)"
  },
  {
    "value": "MEZ",
    "label": "Silveroaks (MEZ)"
  },
  {
    "value": "MZQ",
    "label": "Mkuze (MZQ)"
  },
  {
    "value": "NCS",
    "label": "Newcastle (NCS)"
  },
  {
    "value": "NGL",
    "label": "Ngala (NGL)"
  },
  {
    "value": "NLP",
    "label": "Nelspruit (NLP)"
  },
  {
    "value": "OVG",
    "label": "Overberg (OVG)"
  },
  {
    "value": "OUH",
    "label": "Oudtshoorn (OUH)"
  },
  {
    "value": "AFD",
    "label": "Port Alfred (AFD)"
  },
  {
    "value": "PLZ",
    "label": "Port Elizabeth (PLZ)"
  },
  {
    "value": "PBZ",
    "label": "Plettenberg Bay (PBZ)"
  },
  {
    "value": "PHW",
    "label": "Phalaborwa (PHW)"
  },
  {
    "value": "PTG",
    "label": "Polokwane (PTG)"
  },
  {
    "value": "JOH",
    "label": "Port St Johns (JOH)"
  },
  {
    "value": "PRK",
    "label": "Prieska (PRK)"
  },
  {
    "value": "PZB",
    "label": "Pietermaritzburg (PZB)"
  },
  {
    "value": "NTY",
    "label": "Pilanesberg (NTY)"
  },
  {
    "value": "PCF",
    "label": "Potchefstroom (PCF)"
  },
  {
    "value": "UTW",
    "label": "Queenstown (UTW)"
  },
  {
    "value": "RCB",
    "label": "Richards Bay (RCB)"
  },
  {
    "value": "RVO",
    "label": "Reivilo (RVO)"
  },
  {
    "value": "ROD",
    "label": "Robertson (ROD)"
  },
  {
    "value": "SBU",
    "label": "Springbok (SBU)"
  },
  {
    "value": "ZEC",
    "label": "Secunda (ZEC)"
  },
  {
    "value": "SDB",
    "label": "Saldanha-Vredenburg (SDB)"
  },
  {
    "value": "GSS",
    "label": "Belfast (GSS)"
  },
  {
    "value": "SIS",
    "label": "Sishen (SIS)"
  },
  {
    "value": "SZK",
    "label": "Skukuza (SZK)"
  },
  {
    "value": "THY",
    "label": "Thohoyandou (THY)"
  },
  {
    "value": "TCU",
    "label": "Homeward (TCU)"
  },
  {
    "value": "LTA",
    "label": "Tzaneen (LTA)"
  },
  {
    "value": "ULD",
    "label": "Ulundi (ULD)"
  },
  {
    "value": "UTN",
    "label": "Upington (UTN)"
  },
  {
    "value": "UTT",
    "label": "Mthatha (UTT)"
  },
  {
    "value": "VRU",
    "label": "Vyrburg (VRU)"
  },
  {
    "value": "VIR",
    "label": "Durban (VIR)"
  },
  {
    "value": "VRE",
    "label": "Vredendal (VRE)"
  },
  {
    "value": "VYD",
    "label": "Vryheid (VYD)"
  },
  {
    "value": "PRY",
    "label": "Pretoria (PRY)"
  },
  {
    "value": "AFB",
    "label": "Waterkloof (AFB)"
  },
  {
    "value": "WEL",
    "label": "Welkom (WEL)"
  },
  {
    "value": "FRW",
    "label": "Francistown (FRW)"
  },
  {
    "value": "GNZ",
    "label": "Ghanzi (GNZ)"
  },
  {
    "value": "JWA",
    "label": "Jwaneng Airport (JWA)"
  },
  {
    "value": "BBK",
    "label": "Kasane (BBK)"
  },
  {
    "value": "KHW",
    "label": "Khwai River Lodge (KHW)"
  },
  {
    "value": "MUB",
    "label": "Maun (MUB)"
  },
  {
    "value": "ORP",
    "label": "Orapa Airport (ORP)"
  },
  {
    "value": "QPH",
    "label": "Palapye (QPH)"
  },
  {
    "value": "GBE",
    "label": "Gaborone (GBE)"
  },
  {
    "value": "SXN",
    "label": "Sua Pan Airport (SXN)"
  },
  {
    "value": "PKW",
    "label": "Selebi Phikwe Airport (PKW)"
  },
  {
    "value": "SWX",
    "label": "Shakawe (SWX)"
  },
  {
    "value": "TLD",
    "label": "Tuli Lodge (TLD)"
  },
  {
    "value": "TBY",
    "label": "Tshabong (TBY)"
  },
  {
    "value": "BZV",
    "label": "Brazzaville (BZV)"
  },
  {
    "value": "DJM",
    "label": "Djambala (DJM)"
  },
  {
    "value": "KNJ",
    "label": "Kindamba (KNJ)"
  },
  {
    "value": "LCO",
    "label": "Lague (LCO)"
  },
  {
    "value": "MUY",
    "label": "Mouyondzi (MUY)"
  },
  {
    "value": "SIB",
    "label": "Sibiti (SIB)"
  },
  {
    "value": "NKY",
    "label": "Nkayi (NKY)"
  },
  {
    "value": "ANJ",
    "label": "Zanaga (ANJ)"
  },
  {
    "value": "MSX",
    "label": "Mossendjo (MSX)"
  },
  {
    "value": "BOE",
    "label": "Boundji (BOE)"
  },
  {
    "value": "EWO",
    "label": "Ewo (EWO)"
  },
  {
    "value": "GMM",
    "label": "Gamboma (GMM)"
  },
  {
    "value": "ION",
    "label": "Impfondo (ION)"
  },
  {
    "value": "KEE",
    "label": "Kelle (KEE)"
  },
  {
    "value": "MKJ",
    "label": "Makoua (MKJ)"
  },
  {
    "value": "FTX",
    "label": "Owando (FTX)"
  },
  {
    "value": "SOE",
    "label": "Souanke (SOE)"
  },
  {
    "value": "BTB",
    "label": "Betou (BTB)"
  },
  {
    "value": "OUE",
    "label": "Ouesso Airport (OUE)"
  },
  {
    "value": "KMK",
    "label": "Makabana (KMK)"
  },
  {
    "value": "DIS",
    "label": "Loubomo (DIS)"
  },
  {
    "value": "PNR",
    "label": "Pointe Noire (PNR)"
  },
  {
    "value": "MTS",
    "label": "Manzini (MTS)"
  },
  {
    "value": "FEA",
    "label": "Fetlar Island (FEA)"
  },
  {
    "value": "CRF",
    "label": "Carnot (CRF)"
  },
  {
    "value": "BGF",
    "label": "Bangui (BGF)"
  },
  {
    "value": "BGU",
    "label": "Bangassou (BGU)"
  },
  {
    "value": "IRO",
    "label": "Birao (IRO)"
  },
  {
    "value": "BEM",
    "label": "BossembÃ©lÃ© (BEM)"
  },
  {
    "value": "BBY",
    "label": "Bambari (BBY)"
  },
  {
    "value": "NDL",
    "label": "N'DÃ©lÃ© (NDL)"
  },
  {
    "value": "BOP",
    "label": "Bouar (BOP)"
  },
  {
    "value": "BIV",
    "label": "Bria (BIV)"
  },
  {
    "value": "BSN",
    "label": "Bossangoa (BSN)"
  },
  {
    "value": "BBT",
    "label": "BerbÃ©rati (BBT)"
  },
  {
    "value": "ODA",
    "label": "Ouadda (ODA)"
  },
  {
    "value": "AIG",
    "label": "Yalinga (AIG)"
  },
  {
    "value": "IMO",
    "label": "Zemio (IMO)"
  },
  {
    "value": "MKI",
    "label": "Mboki (MKI)"
  },
  {
    "value": "BTG",
    "label": "Batangafo (BTG)"
  },
  {
    "value": "GDI",
    "label": "Melle (GDI)"
  },
  {
    "value": "BMF",
    "label": "Bakouma (BMF)"
  },
  {
    "value": "ODJ",
    "label": "Ouanda DjallÃ© (ODJ)"
  },
  {
    "value": "RFA",
    "label": "RafaÃ¯ (RFA)"
  },
  {
    "value": "BCF",
    "label": "Bouca (BCF)"
  },
  {
    "value": "BOZ",
    "label": "Bozoum (BOZ)"
  },
  {
    "value": "FEW",
    "label": "Cheyenne (FEW)"
  },
  {
    "value": "BSG",
    "label": "Bata Airport (BSG)"
  },
  {
    "value": "SSG",
    "label": "Malabo (SSG)"
  },
  {
    "value": "ASI",
    "label": "Ascension Island (ASI)"
  },
  {
    "value": "MRU",
    "label": "Port Louis (MRU)"
  },
  {
    "value": "RRG",
    "label": "Port Mathurin (RRG)"
  },
  {
    "value": "FIN",
    "label": "Buki (FIN)"
  },
  {
    "value": "NKW",
    "label": "Diego Garcia (NKW)"
  },
  {
    "value": "NKS",
    "label": "Nkongsamba (NKS)"
  },
  {
    "value": "KBI",
    "label": "Kribi (KBI)"
  },
  {
    "value": "TKC",
    "label": "Tiko (TKC)"
  },
  {
    "value": "DLA",
    "label": "Douala (DLA)"
  },
  {
    "value": "MMF",
    "label": "Mamfe (MMF)"
  },
  {
    "value": "BLC",
    "label": "Bali (BLC)"
  },
  {
    "value": "KLE",
    "label": "KaÃ©lÃ© (KLE)"
  },
  {
    "value": "OUR",
    "label": "Batouri (OUR)"
  },
  {
    "value": "GXX",
    "label": "Yagoua (GXX)"
  },
  {
    "value": "MVR",
    "label": "Maroua (MVR)"
  },
  {
    "value": "FOM",
    "label": "Foumban (FOM)"
  },
  {
    "value": "NGE",
    "label": "N'GaoundÃ©rÃ© (NGE)"
  },
  {
    "value": "BTA",
    "label": "Bertoua (BTA)"
  },
  {
    "value": "GOU",
    "label": "Garoua (GOU)"
  },
  {
    "value": "DSC",
    "label": "Dschang (DSC)"
  },
  {
    "value": "BFX",
    "label": "Bafoussam (BFX)"
  },
  {
    "value": "BPC",
    "label": "Bamenda (BPC)"
  },
  {
    "value": "EBW",
    "label": "Ebolowa (EBW)"
  },
  {
    "value": "YAO",
    "label": "YaoundÃ© (YAO)"
  },
  {
    "value": "NSI",
    "label": "YaoundÃ© (NSI)"
  },
  {
    "value": "MMQ",
    "label": "Mbala (MMQ)"
  },
  {
    "value": "CIP",
    "label": "Chipata (CIP)"
  },
  {
    "value": "ZKP",
    "label": "Kasompe (ZKP)"
  },
  {
    "value": "KLB",
    "label": "Kalabo (KLB)"
  },
  {
    "value": "KMZ",
    "label": "Kaoma (KMZ)"
  },
  {
    "value": "KAA",
    "label": "Kasama (KAA)"
  },
  {
    "value": "ZKB",
    "label": "Kasaba Bay (ZKB)"
  },
  {
    "value": "LVI",
    "label": "Livingstone (LVI)"
  },
  {
    "value": "LXU",
    "label": "Lukulu (LXU)"
  },
  {
    "value": "LUN",
    "label": "Lusaka (LUN)"
  },
  {
    "value": "MNS",
    "label": "Mansa (MNS)"
  },
  {
    "value": "MFU",
    "label": "Mfuwe (MFU)"
  },
  {
    "value": "MNR",
    "label": "Mongu (MNR)"
  },
  {
    "value": "ZGM",
    "label": "Ngoma (ZGM)"
  },
  {
    "value": "NLA",
    "label": "Ndola (NLA)"
  },
  {
    "value": "SXG",
    "label": "Senanga (SXG)"
  },
  {
    "value": "KIW",
    "label": "Kitwe (KIW)"
  },
  {
    "value": "SJQ",
    "label": "Sesheke (SJQ)"
  },
  {
    "value": "SLI",
    "label": "Solwesi (SLI)"
  },
  {
    "value": "BBZ",
    "label": "Zambezi (BBZ)"
  },
  {
    "value": "ULI",
    "label": "Falalop Island (ULI)"
  },
  {
    "value": "HAH",
    "label": "Moroni (HAH)"
  },
  {
    "value": "NWA",
    "label": "MohÃ©li Bandar Es Eslam Airport (NWA)"
  },
  {
    "value": "YVA",
    "label": "Moroni (YVA)"
  },
  {
    "value": "AJN",
    "label": "Ouani (AJN)"
  },
  {
    "value": "DZA",
    "label": "Dzaoudzi (DZA)"
  },
  {
    "value": "RUN",
    "label": "St Denis (RUN)"
  },
  {
    "value": "ZSE",
    "label": "St Pierre (ZSE)"
  },
  {
    "value": "WML",
    "label": "Malaimbandy (WML)"
  },
  {
    "value": "ATJ",
    "label": "Antsirabe (ATJ)"
  },
  {
    "value": "WAQ",
    "label": "Antsalova (WAQ)"
  },
  {
    "value": "VVB",
    "label": "Mahanoro (VVB)"
  },
  {
    "value": "TNR",
    "label": "Antananarivo (TNR)"
  },
  {
    "value": "JVA",
    "label": "Ankavandra (JVA)"
  },
  {
    "value": "BMD",
    "label": "Belo sur Tsiribihina (BMD)"
  },
  {
    "value": "ZVA",
    "label": "Miandrivazo Airport (ZVA)"
  },
  {
    "value": "MXT",
    "label": "Maintirano (MXT)"
  },
  {
    "value": "ILK",
    "label": "Ilaka (ILK)"
  },
  {
    "value": "TVA",
    "label": "Morafenobe (TVA)"
  },
  {
    "value": "SMS",
    "label": "Sainte Marie Airport (SMS)"
  },
  {
    "value": "TMM",
    "label": "Toamasina Airport (TMM)"
  },
  {
    "value": "WTA",
    "label": "Tambohorano (WTA)"
  },
  {
    "value": "MOQ",
    "label": "Morondava Airport (MOQ)"
  },
  {
    "value": "WTS",
    "label": "Tsiroanomandidy (WTS)"
  },
  {
    "value": "VAT",
    "label": "Vatomandry (VAT)"
  },
  {
    "value": "WAM",
    "label": "Ambatondrazaka (WAM)"
  },
  {
    "value": "DIE",
    "label": "Arrachart Airport (DIE)"
  },
  {
    "value": "WMR",
    "label": "Mananara Nord (WMR)"
  },
  {
    "value": "ZWA",
    "label": "Andapa Airport (ZWA)"
  },
  {
    "value": "AMB",
    "label": "Ambilobe Airport (AMB)"
  },
  {
    "value": "WBD",
    "label": "Befandriana (WBD)"
  },
  {
    "value": "WPB",
    "label": "Port BergÃ© (WPB)"
  },
  {
    "value": "ANM",
    "label": "Antsirabato Airport (ANM)"
  },
  {
    "value": "IVA",
    "label": "Ambanja (IVA)"
  },
  {
    "value": "HVA",
    "label": "Analalava Airport (HVA)"
  },
  {
    "value": "MJN",
    "label": "Amborovy Airport (MJN)"
  },
  {
    "value": "NOS",
    "label": "Nosy Be (NOS)"
  },
  {
    "value": "DWB",
    "label": "Soalala (DWB)"
  },
  {
    "value": "WMP",
    "label": "Mampikony (WMP)"
  },
  {
    "value": "BPY",
    "label": "Besalampy Airport (BPY)"
  },
  {
    "value": "WMN",
    "label": "Maroantsetra Airport (WMN)"
  },
  {
    "value": "SVB",
    "label": "Sambava Airport (SVB)"
  },
  {
    "value": "TTS",
    "label": "Tsaratanana (TTS)"
  },
  {
    "value": "VOH",
    "label": "Vohimarina Airport (VOH)"
  },
  {
    "value": "WAI",
    "label": "Antsohihy (WAI)"
  },
  {
    "value": "WMA",
    "label": "Mandritsara (WMA)"
  },
  {
    "value": "WBO",
    "label": "Beroroha (WBO)"
  },
  {
    "value": "WMD",
    "label": "Mandabe (WMD)"
  },
  {
    "value": "FTU",
    "label": "TÃ´lanaro (FTU)"
  },
  {
    "value": "WFI",
    "label": "Fianarantsoa Airport (WFI)"
  },
  {
    "value": "RVA",
    "label": "Farafangana Airport (RVA)"
  },
  {
    "value": "IHO",
    "label": "Ihosy (IHO)"
  },
  {
    "value": "MJA",
    "label": "Manja (MJA)"
  },
  {
    "value": "WVK",
    "label": "Manakara Airport (WVK)"
  },
  {
    "value": "OVA",
    "label": "Bekily (OVA)"
  },
  {
    "value": "MNJ",
    "label": "Mananjary Airport (MNJ)"
  },
  {
    "value": "TDV",
    "label": "Tanandava (TDV)"
  },
  {
    "value": "MXM",
    "label": "Morombe Airport (MXM)"
  },
  {
    "value": "TLE",
    "label": "Toliara Airport (TLE)"
  },
  {
    "value": "BKU",
    "label": "Betioky (BKU)"
  },
  {
    "value": "AMP",
    "label": "Ampanihy (AMP)"
  },
  {
    "value": "WAK",
    "label": "Ankazoabo (WAK)"
  },
  {
    "value": "AZZ",
    "label": "Ambriz (AZZ)"
  },
  {
    "value": "SSY",
    "label": "Mbanza Congo (SSY)"
  },
  {
    "value": "BUG",
    "label": "Benguela (BUG)"
  },
  {
    "value": "CAB",
    "label": "Cabinda (CAB)"
  },
  {
    "value": "CFF",
    "label": "Cafunfo (CFF)"
  },
  {
    "value": "PGI",
    "label": "Chitato (PGI)"
  },
  {
    "value": "CBT",
    "label": "Catumbela (CBT)"
  },
  {
    "value": "CTI",
    "label": "Cuito Cuanavale (CTI)"
  },
  {
    "value": "CXM",
    "label": "Camaxilo (CXM)"
  },
  {
    "value": "CAV",
    "label": "Cazombo (CAV)"
  },
  {
    "value": "DUE",
    "label": "Chitato (DUE)"
  },
  {
    "value": "FNE",
    "label": "Fane Mission (FNE)"
  },
  {
    "value": "VPE",
    "label": "Ngiva (VPE)"
  },
  {
    "value": "NOV",
    "label": "Huambo (NOV)"
  },
  {
    "value": "SVP",
    "label": "Kuito (SVP)"
  },
  {
    "value": "LAD",
    "label": "Luanda (LAD)"
  },
  {
    "value": "MEG",
    "label": "Malanje (MEG)"
  },
  {
    "value": "SPP",
    "label": "Menongue (SPP)"
  },
  {
    "value": "MSZ",
    "label": "Namibe (MSZ)"
  },
  {
    "value": "GXG",
    "label": "Negage (GXG)"
  },
  {
    "value": "PBN",
    "label": "Port Amboim (PBN)"
  },
  {
    "value": "VHC",
    "label": "Saurimo (VHC)"
  },
  {
    "value": "SZA",
    "label": "Soyo (SZA)"
  },
  {
    "value": "NDD",
    "label": "Sumbe (NDD)"
  },
  {
    "value": "UAL",
    "label": "Luau (UAL)"
  },
  {
    "value": "SDD",
    "label": "Lubango (SDD)"
  },
  {
    "value": "LUO",
    "label": "Luena (LUO)"
  },
  {
    "value": "UGO",
    "label": "Uige (UGO)"
  },
  {
    "value": "CEO",
    "label": "Waco Kungo (CEO)"
  },
  {
    "value": "XGN",
    "label": "Xangongo (XGN)"
  },
  {
    "value": "ARZ",
    "label": "N'zeto (ARZ)"
  },
  {
    "value": "BGB",
    "label": "Booue (BGB)"
  },
  {
    "value": "KDN",
    "label": "Ndende (KDN)"
  },
  {
    "value": "FOU",
    "label": "Fougamou (FOU)"
  },
  {
    "value": "MBC",
    "label": "M'Bigou (MBC)"
  },
  {
    "value": "MGX",
    "label": "Moabi (MGX)"
  },
  {
    "value": "KDJ",
    "label": "N'DjolÃ© (KDJ)"
  },
  {
    "value": "KOU",
    "label": "Koulamoutou (KOU)"
  },
  {
    "value": "MJL",
    "label": "Mouila (MJL)"
  },
  {
    "value": "OYE",
    "label": "Oyem (OYE)"
  },
  {
    "value": "OKN",
    "label": "Okondja (OKN)"
  },
  {
    "value": "LBQ",
    "label": "Lambarene (LBQ)"
  },
  {
    "value": "MVX",
    "label": "Minvoul (MVX)"
  },
  {
    "value": "BMM",
    "label": "Bitam (BMM)"
  },
  {
    "value": "MFF",
    "label": "Moanda (MFF)"
  },
  {
    "value": "MKB",
    "label": "Mekambo (MKB)"
  },
  {
    "value": "POG",
    "label": "Port Gentil (POG)"
  },
  {
    "value": "OMB",
    "label": "Omboue (OMB)"
  },
  {
    "value": "MKU",
    "label": "Makokou (MKU)"
  },
  {
    "value": "LBV",
    "label": "Libreville (LBV)"
  },
  {
    "value": "MZC",
    "label": "Mitzic (MZC)"
  },
  {
    "value": "MVB",
    "label": "Franceville (MVB)"
  },
  {
    "value": "LTL",
    "label": "Lastourville (LTL)"
  },
  {
    "value": "ZKM",
    "label": "Sette Cama (ZKM)"
  },
  {
    "value": "TCH",
    "label": "Tchibanga (TCH)"
  },
  {
    "value": "MYB",
    "label": "Mayumba (MYB)"
  },
  {
    "value": "PCP",
    "label": "Principe Airport (PCP)"
  },
  {
    "value": "TMS",
    "label": "SÃ£o TomÃ© (TMS)"
  },
  {
    "value": "ANO",
    "label": "Angoche (ANO)"
  },
  {
    "value": "BEW",
    "label": "Beira (BEW)"
  },
  {
    "value": "FXO",
    "label": "Cuamba (FXO)"
  },
  {
    "value": "VPY",
    "label": "Chimoio (VPY)"
  },
  {
    "value": "IHC",
    "label": "Inhaca (IHC)"
  },
  {
    "value": "INH",
    "label": "Inhambabe (INH)"
  },
  {
    "value": "VXC",
    "label": "Lichinga (VXC)"
  },
  {
    "value": "MPM",
    "label": "Maputo (MPM)"
  },
  {
    "value": "MUD",
    "label": "Mueda (MUD)"
  },
  {
    "value": "MZB",
    "label": "MocÃ­mboa da Praia (MZB)"
  },
  {
    "value": "MNC",
    "label": "Nacala (MNC)"
  },
  {
    "value": "APL",
    "label": "Nampula (APL)"
  },
  {
    "value": "POL",
    "label": "Pemba / Porto Amelia (POL)"
  },
  {
    "value": "UEL",
    "label": "Quelimane (UEL)"
  },
  {
    "value": "TET",
    "label": "Tete (TET)"
  },
  {
    "value": "VNX",
    "label": "Vilanculo (VNX)"
  },
  {
    "value": "VJB",
    "label": "Xai-Xai (VJB)"
  },
  {
    "value": "JCA",
    "label": "Cannes (JCA)"
  },
  {
    "value": "DES",
    "label": "Desroches Island (DES)"
  },
  {
    "value": "SEZ",
    "label": "Mahe Island (SEZ)"
  },
  {
    "value": "PRI",
    "label": "Praslin Island (PRI)"
  },
  {
    "value": "BDI",
    "label": "Bird Island (BDI)"
  },
  {
    "value": "DEI",
    "label": "Denis Island (DEI)"
  },
  {
    "value": "SRH",
    "label": "Sarh (SRH)"
  },
  {
    "value": "OGR",
    "label": "Bongor (OGR)"
  },
  {
    "value": "AEH",
    "label": "Abeche Airport (AEH)"
  },
  {
    "value": "MQQ",
    "label": "Moundou Airport (MQQ)"
  },
  {
    "value": "LTC",
    "label": "Lai (LTC)"
  },
  {
    "value": "ATV",
    "label": "Ati (ATV)"
  },
  {
    "value": "NDJ",
    "label": "N'Djamena (NDJ)"
  },
  {
    "value": "BKR",
    "label": "Bokoro (BKR)"
  },
  {
    "value": "OTC",
    "label": "Bol (OTC)"
  },
  {
    "value": "MVO",
    "label": "Mongo (MVO)"
  },
  {
    "value": "AMC",
    "label": "Am Timan (AMC)"
  },
  {
    "value": "PLF",
    "label": "Pala (PLF)"
  },
  {
    "value": "OUT",
    "label": "Bousso (OUT)"
  },
  {
    "value": "AMO",
    "label": "Mao (AMO)"
  },
  {
    "value": "FYT",
    "label": "Faya Largeau Airport (FYT)"
  },
  {
    "value": "BUQ",
    "label": "Bulawayo (BUQ)"
  },
  {
    "value": "CHJ",
    "label": "Chipinge (CHJ)"
  },
  {
    "value": "BFO",
    "label": "Chiredzi (BFO)"
  },
  {
    "value": "VFA",
    "label": "Victoria Falls (VFA)"
  },
  {
    "value": "HRE",
    "label": "Harare (HRE)"
  },
  {
    "value": "KAB",
    "label": "Kariba (KAB)"
  },
  {
    "value": "UTA",
    "label": "Mutare Airport (UTA)"
  },
  {
    "value": "MVZ",
    "label": "Masvingo (MVZ)"
  },
  {
    "value": "GWE",
    "label": "Gweru (GWE)"
  },
  {
    "value": "HWN",
    "label": "Hwange (HWN)"
  },
  {
    "value": "WKI",
    "label": "Hwange (WKI)"
  },
  {
    "value": "CEH",
    "label": "Chelinda Malawi Airport (CEH)"
  },
  {
    "value": "BLZ",
    "label": "Blantyre (BLZ)"
  },
  {
    "value": "CMK",
    "label": "Club Makokola (CMK)"
  },
  {
    "value": "DWA",
    "label": "Dwangwa (DWA)"
  },
  {
    "value": "KGJ",
    "label": "Karonga (KGJ)"
  },
  {
    "value": "KBQ",
    "label": "Kasungu (KBQ)"
  },
  {
    "value": "LLW",
    "label": "Lilongwe (LLW)"
  },
  {
    "value": "LIX",
    "label": "Likoma Island (LIX)"
  },
  {
    "value": "MAI",
    "label": "Mangochi (MAI)"
  },
  {
    "value": "MYZ",
    "label": "Monkey Bay (MYZ)"
  },
  {
    "value": "LMB",
    "label": "Salima (LMB)"
  },
  {
    "value": "ZZU",
    "label": "Mzuzu (ZZU)"
  },
  {
    "value": "LEF",
    "label": "Lebakeng (LEF)"
  },
  {
    "value": "LRB",
    "label": "Leribe (LRB)"
  },
  {
    "value": "LES",
    "label": "Lesobeng (LES)"
  },
  {
    "value": "MFC",
    "label": "Mafeteng (MFC)"
  },
  {
    "value": "MKH",
    "label": "Mokhotlong (MKH)"
  },
  {
    "value": "MSU",
    "label": "Maseru (MSU)"
  },
  {
    "value": "NKU",
    "label": "Nkaus (NKU)"
  },
  {
    "value": "PEL",
    "label": "Pelaneng (PEL)"
  },
  {
    "value": "UTG",
    "label": "Quthing (UTG)"
  },
  {
    "value": "UNE",
    "label": "Qacha's Nek (UNE)"
  },
  {
    "value": "SHK",
    "label": "Sehonghong (SHK)"
  },
  {
    "value": "SKQ",
    "label": "Sekakes (SKQ)"
  },
  {
    "value": "SOK",
    "label": "Semonkong (SOK)"
  },
  {
    "value": "SHZ",
    "label": "Seshutes (SHZ)"
  },
  {
    "value": "THB",
    "label": "Thaba-Tseka (THB)"
  },
  {
    "value": "TKO",
    "label": "Tlokoeng (TKO)"
  },
  {
    "value": "ADI",
    "label": "Arandis (ADI)"
  },
  {
    "value": "GOG",
    "label": "Gobabis (GOG)"
  },
  {
    "value": "GFY",
    "label": "Grootfontein (GFY)"
  },
  {
    "value": "MPA",
    "label": "Mpacha (MPA)"
  },
  {
    "value": "KMP",
    "label": "Keetmanshoop (KMP)"
  },
  {
    "value": "LUD",
    "label": "Luderitz (LUD)"
  },
  {
    "value": "OKU",
    "label": "Mokuti Lodge (OKU)"
  },
  {
    "value": "NNI",
    "label": "Namutoni (NNI)"
  },
  {
    "value": "OND",
    "label": "Ondangwa (OND)"
  },
  {
    "value": "OMG",
    "label": "Omega (OMG)"
  },
  {
    "value": "OMD",
    "label": "Oranjemund (OMD)"
  },
  {
    "value": "OKF",
    "label": "Okaukuejo (OKF)"
  },
  {
    "value": "NDU",
    "label": "Rundu (NDU)"
  },
  {
    "value": "SWP",
    "label": "Swakopmund (SWP)"
  },
  {
    "value": "TSB",
    "label": "Tsumeb (TSB)"
  },
  {
    "value": "WVB",
    "label": "Walvis Bay (WVB)"
  },
  {
    "value": "ERS",
    "label": "Windhoek (ERS)"
  },
  {
    "value": "WDH",
    "label": "Windhoek (WDH)"
  },
  {
    "value": "FIH",
    "label": "Kinshasa (FIH)"
  },
  {
    "value": "NLO",
    "label": "Ndolo Airport (NLO)"
  },
  {
    "value": "MNB",
    "label": "Muanda Airport (MNB)"
  },
  {
    "value": "BOA",
    "label": "Boma (BOA)"
  },
  {
    "value": "LZI",
    "label": "Luozi (LZI)"
  },
  {
    "value": "MAT",
    "label": "Matadi (MAT)"
  },
  {
    "value": "NKL",
    "label": "Nkolo Fuma (NKL)"
  },
  {
    "value": "INO",
    "label": "Inongo (INO)"
  },
  {
    "value": "NIO",
    "label": "Nioki (NIO)"
  },
  {
    "value": "FDU",
    "label": "Bandundu Airport (FDU)"
  },
  {
    "value": "KRZ",
    "label": "Kiri (KRZ)"
  },
  {
    "value": "KKW",
    "label": "Kikwit Airport (KKW)"
  },
  {
    "value": "IDF",
    "label": "Idiofa (IDF)"
  },
  {
    "value": "LUS",
    "label": "Lusanga (LUS)"
  },
  {
    "value": "MSM",
    "label": "Masi Manimba (MSM)"
  },
  {
    "value": "MDK",
    "label": "Mbandaka (MDK)"
  },
  {
    "value": "BSU",
    "label": "Basankusu (BSU)"
  },
  {
    "value": "LIE",
    "label": "Libenge (LIE)"
  },
  {
    "value": "BDT",
    "label": "Gbadolite Airport (BDT)"
  },
  {
    "value": "GMA",
    "label": "Gemena (GMA)"
  },
  {
    "value": "KLI",
    "label": "Kotakoli Airport (KLI)"
  },
  {
    "value": "BMB",
    "label": "Bumbar (BMB)"
  },
  {
    "value": "LIQ",
    "label": "Lisala Airport (LIQ)"
  },
  {
    "value": "BNB",
    "label": "Boende (BNB)"
  },
  {
    "value": "IKL",
    "label": "Ikela (IKL)"
  },
  {
    "value": "FKI",
    "label": "Kisangani (FKI)"
  },
  {
    "value": "YAN",
    "label": "Yangambi (YAN)"
  },
  {
    "value": "IRP",
    "label": "Matari Airport (IRP)"
  },
  {
    "value": "BUX",
    "label": "Bunia Airport (BUX)"
  },
  {
    "value": "BZU",
    "label": "Buta Zega Airport (BZU)"
  },
  {
    "value": "BKY",
    "label": "Bukavu Kavumu Airport (BKY)"
  },
  {
    "value": "GOM",
    "label": "Goma (GOM)"
  },
  {
    "value": "BNC",
    "label": "Beni (BNC)"
  },
  {
    "value": "KND",
    "label": "Kindu (KND)"
  },
  {
    "value": "KLY",
    "label": "Kalima (KLY)"
  },
  {
    "value": "PUN",
    "label": "Punia (PUN)"
  },
  {
    "value": "FBM",
    "label": "Lubumbashi (FBM)"
  },
  {
    "value": "PWO",
    "label": "Pweto (PWO)"
  },
  {
    "value": "KEC",
    "label": "Kasenga (KEC)"
  },
  {
    "value": "KWZ",
    "label": "Kolwezi Airport (KWZ)"
  },
  {
    "value": "MNO",
    "label": "Manono (MNO)"
  },
  {
    "value": "BDV",
    "label": "Moba (BDV)"
  },
  {
    "value": "FMI",
    "label": "Kalemie Airport (FMI)"
  },
  {
    "value": "KBO",
    "label": "Kabalo (KBO)"
  },
  {
    "value": "KOO",
    "label": "Kongolo (KOO)"
  },
  {
    "value": "KMN",
    "label": "Kamina Base Airport (KMN)"
  },
  {
    "value": "KAP",
    "label": "Kapanga (KAP)"
  },
  {
    "value": "KNM",
    "label": "Kaniama (KNM)"
  },
  {
    "value": "KGA",
    "label": "Kananga (KGA)"
  },
  {
    "value": "LZA",
    "label": "Luiza (LZA)"
  },
  {
    "value": "TSH",
    "label": "Tshikapa (TSH)"
  },
  {
    "value": "LJA",
    "label": "Lodja (LJA)"
  },
  {
    "value": "LBO",
    "label": "Lusambo (LBO)"
  },
  {
    "value": "MEW",
    "label": "Mweka (MEW)"
  },
  {
    "value": "BAN",
    "label": "Basongo (BAN)"
  },
  {
    "value": "PFR",
    "label": "Ilebo (PFR)"
  },
  {
    "value": "MJM",
    "label": "Mbuji Mayi (MJM)"
  },
  {
    "value": "GDJ",
    "label": "Gandajika (GDJ)"
  },
  {
    "value": "KBN",
    "label": "Kabinda (KBN)"
  },
  {
    "value": "AKE",
    "label": "Akieni (AKE)"
  },
  {
    "value": "GAX",
    "label": "Gamba (GAX)"
  },
  {
    "value": "GAB",
    "label": "Gabbs (GAB)"
  },
  {
    "value": "BKO",
    "label": "Senou (BKO)"
  },
  {
    "value": "GUD",
    "label": "Goundam (GUD)"
  },
  {
    "value": "GAQ",
    "label": "Gao Airport (GAQ)"
  },
  {
    "value": "KNZ",
    "label": "Kenieba (KNZ)"
  },
  {
    "value": "KTX",
    "label": "Koutiala (KTX)"
  },
  {
    "value": "KYS",
    "label": "Kayes Dag Dag Airport (KYS)"
  },
  {
    "value": "MZI",
    "label": "Ambodedjo Airport (MZI)"
  },
  {
    "value": "NRM",
    "label": "Nara (NRM)"
  },
  {
    "value": "NIX",
    "label": "Nioro du Sahel (NIX)"
  },
  {
    "value": "KSS",
    "label": "Sikasso (KSS)"
  },
  {
    "value": "TOM",
    "label": "Timbuktu (TOM)"
  },
  {
    "value": "EYL",
    "label": "YÃ©limanÃ© (EYL)"
  },
  {
    "value": "GAZ",
    "label": "Woodlark (Muyua) Island (GAZ)"
  },
  {
    "value": "DOC",
    "label": "Dornoch (DOC)"
  },
  {
    "value": "FLH",
    "label": "Flotta Isle (FLH)"
  },
  {
    "value": "FOA",
    "label": "Foula (FOA)"
  },
  {
    "value": "OUK",
    "label": "Grunay Island (OUK)"
  },
  {
    "value": "PSV",
    "label": "Papa Stour Island (PSV)"
  },
  {
    "value": "ULL",
    "label": "Glenforsa (ULL)"
  },
  {
    "value": "BJL",
    "label": "Banjul (BJL)"
  },
  {
    "value": "FUE",
    "label": "Fuerteventura Island (FUE)"
  },
  {
    "value": "GMZ",
    "label": "Alajero, La Gomera Island (GMZ)"
  },
  {
    "value": "VDE",
    "label": "El Hierro Island (VDE)"
  },
  {
    "value": "SPC",
    "label": "Sta Cruz de la Palma, La Palma Island (SPC)"
  },
  {
    "value": "LPA",
    "label": "Gran Canaria Island (LPA)"
  },
  {
    "value": "ACE",
    "label": "Lanzarote Island (ACE)"
  },
  {
    "value": "TFS",
    "label": "Tenerife Island (TFS)"
  },
  {
    "value": "TFN",
    "label": "Tenerife Island (TFN)"
  },
  {
    "value": "GDY",
    "label": "Grundy (GDY)"
  },
  {
    "value": "JCU",
    "label": "Ceuta (JCU)"
  },
  {
    "value": "MLN",
    "label": "Melilla Island (MLN)"
  },
  {
    "value": "BTE",
    "label": "Bonthe (BTE)"
  },
  {
    "value": "KBS",
    "label": "Bo (KBS)"
  },
  {
    "value": "GBK",
    "label": "Gbangbatok (GBK)"
  },
  {
    "value": "HGS",
    "label": "Freetown (HGS)"
  },
  {
    "value": "KBA",
    "label": "Kabala (KBA)"
  },
  {
    "value": "KEN",
    "label": "Kenema (KEN)"
  },
  {
    "value": "FNA",
    "label": "Freetown (FNA)"
  },
  {
    "value": "WYE",
    "label": "Yengema (WYE)"
  },
  {
    "value": "BQE",
    "label": "Bubaque (BQE)"
  },
  {
    "value": "OXB",
    "label": "Bissau (OXB)"
  },
  {
    "value": "JGR",
    "label": "Groennedal (JGR)"
  },
  {
    "value": "QCU",
    "label": "Akunaq Heliport (QCU)"
  },
  {
    "value": "UCN",
    "label": "Buchanan (UCN)"
  },
  {
    "value": "CPA",
    "label": "Harper (CPA)"
  },
  {
    "value": "SNI",
    "label": "Greenville (SNI)"
  },
  {
    "value": "MLW",
    "label": "Monrovia (MLW)"
  },
  {
    "value": "ROB",
    "label": "Monrovia (ROB)"
  },
  {
    "value": "SAZ",
    "label": "Sasstown (SAZ)"
  },
  {
    "value": "THC",
    "label": "Tchien (THC)"
  },
  {
    "value": "VOI",
    "label": "Voinjama (VOI)"
  },
  {
    "value": "AGA",
    "label": "Agadir (AGA)"
  },
  {
    "value": "TTA",
    "label": "Tan Tan (TTA)"
  },
  {
    "value": "OZG",
    "label": "Zagora (OZG)"
  },
  {
    "value": "UAR",
    "label": "Bouarfa (UAR)"
  },
  {
    "value": "FEZ",
    "label": "Fes (FEZ)"
  },
  {
    "value": "ERH",
    "label": "Errachidia (ERH)"
  },
  {
    "value": "MEK",
    "label": "Meknes (MEK)"
  },
  {
    "value": "OUD",
    "label": "Oujda (OUD)"
  },
  {
    "value": "SMW",
    "label": "Smara (SMW)"
  },
  {
    "value": "GMD",
    "label": "Ben Slimane (GMD)"
  },
  {
    "value": "CAS",
    "label": "Casablanca (CAS)"
  },
  {
    "value": "RBA",
    "label": "Rabat (RBA)"
  },
  {
    "value": "SII",
    "label": "Sidi Ifni (SII)"
  },
  {
    "value": "VIL",
    "label": "Dakhla (VIL)"
  },
  {
    "value": "ESU",
    "label": "Essaouira (ESU)"
  },
  {
    "value": "EUN",
    "label": "El AaiÃºn (EUN)"
  },
  {
    "value": "CMN",
    "label": "Casablanca (CMN)"
  },
  {
    "value": "SFI",
    "label": "Safi (SFI)"
  },
  {
    "value": "NDR",
    "label": "Nador (NDR)"
  },
  {
    "value": "RAK",
    "label": "Marrakech (RAK)"
  },
  {
    "value": "NNA",
    "label": "Kenitra Airport (NNA)"
  },
  {
    "value": "OZZ",
    "label": "Ouarzazate (OZZ)"
  },
  {
    "value": "AHU",
    "label": "Al Hoceima (AHU)"
  },
  {
    "value": "TTU",
    "label": "Saniat Rmel Airport (TTU)"
  },
  {
    "value": "TNG",
    "label": "Tangier (TNG)"
  },
  {
    "value": "GNU",
    "label": "Goodnews (GNU)"
  },
  {
    "value": "KDA",
    "label": "Kolda (KDA)"
  },
  {
    "value": "ZIG",
    "label": "Ziguinchor (ZIG)"
  },
  {
    "value": "CSK",
    "label": "Cap Skirring (CSK)"
  },
  {
    "value": "KLC",
    "label": "Kaolack (KLC)"
  },
  {
    "value": "DKR",
    "label": "Dakar (DKR)"
  },
  {
    "value": "MAX",
    "label": "Matam (MAX)"
  },
  {
    "value": "POD",
    "label": "Podor (POD)"
  },
  {
    "value": "RDT",
    "label": "Richard Toll (RDT)"
  },
  {
    "value": "XLS",
    "label": "Saint Louis (XLS)"
  },
  {
    "value": "BXE",
    "label": "Bakel (BXE)"
  },
  {
    "value": "KGG",
    "label": "KÃ©dougou (KGG)"
  },
  {
    "value": "SMY",
    "label": "Simenti (SMY)"
  },
  {
    "value": "TUD",
    "label": "Tambacounda (TUD)"
  },
  {
    "value": "AEO",
    "label": "Aioun El Atrouss (AEO)"
  },
  {
    "value": "OTL",
    "label": "Boutilimit (OTL)"
  },
  {
    "value": "THI",
    "label": "Tichitt (THI)"
  },
  {
    "value": "TIY",
    "label": "Tidjikja (TIY)"
  },
  {
    "value": "BGH",
    "label": "Boghe (BGH)"
  },
  {
    "value": "KFA",
    "label": "Kiffa (KFA)"
  },
  {
    "value": "TMD",
    "label": "Timbedra (TMD)"
  },
  {
    "value": "EMN",
    "label": "NÃ©ma (EMN)"
  },
  {
    "value": "AJJ",
    "label": "Akjoujt (AJJ)"
  },
  {
    "value": "KED",
    "label": "KaÃ©di (KED)"
  },
  {
    "value": "MOM",
    "label": "Moudjeria (MOM)"
  },
  {
    "value": "NKC",
    "label": "Nouakchott (NKC)"
  },
  {
    "value": "SEY",
    "label": "SÃ©libaby (SEY)"
  },
  {
    "value": "THT",
    "label": "Tamchakett (THT)"
  },
  {
    "value": "ATR",
    "label": "Atar (ATR)"
  },
  {
    "value": "FGD",
    "label": "Fderik (FGD)"
  },
  {
    "value": "NDB",
    "label": "Nouadhibou (NDB)"
  },
  {
    "value": "OUZ",
    "label": "ZouÃ©rate (OUZ)"
  },
  {
    "value": "JSS",
    "label": "Spetsai (JSS)"
  },
  {
    "value": "CIQ",
    "label": "Chiquimula (CIQ)"
  },
  {
    "value": "DON",
    "label": "Dos Lagunas (DON)"
  },
  {
    "value": "ENJ",
    "label": "El Naranjo (ENJ)"
  },
  {
    "value": "PCG",
    "label": "Paso Caballos (PCG)"
  },
  {
    "value": "LCF",
    "label": "Rio Dulce (LCF)"
  },
  {
    "value": "TKM",
    "label": "Tikal (TKM)"
  },
  {
    "value": "UAX",
    "label": "Uaxactun (UAX)"
  },
  {
    "value": "PKJ",
    "label": "Playa Grande (PKJ)"
  },
  {
    "value": "GTZ",
    "label": "Grumeti Game Reserve (GTZ)"
  },
  {
    "value": "CKY",
    "label": "Conakry (CKY)"
  },
  {
    "value": "FIG",
    "label": "Fria Airport (FIG)"
  },
  {
    "value": "FAA",
    "label": "Faranah Airport (FAA)"
  },
  {
    "value": "KSI",
    "label": "Kissidougou (KSI)"
  },
  {
    "value": "LEK",
    "label": "Labe Airport (LEK)"
  },
  {
    "value": "MCA",
    "label": "Macenta (MCA)"
  },
  {
    "value": "NZE",
    "label": "Nzerekore (NZE)"
  },
  {
    "value": "BKJ",
    "label": "Boke (BKJ)"
  },
  {
    "value": "SBI",
    "label": "Koundara (SBI)"
  },
  {
    "value": "GII",
    "label": "Siguiri (GII)"
  },
  {
    "value": "KNN",
    "label": "Kankan (KNN)"
  },
  {
    "value": "SID",
    "label": "Espargos (SID)"
  },
  {
    "value": "NTO",
    "label": "Ponta do Sol (NTO)"
  },
  {
    "value": "BVC",
    "label": "Rabil (BVC)"
  },
  {
    "value": "MMO",
    "label": "Vila do Maio (MMO)"
  },
  {
    "value": "MTI",
    "label": "Vila do Mosteiros (MTI)"
  },
  {
    "value": "RAI",
    "label": "Praia (RAI)"
  },
  {
    "value": "SFL",
    "label": "SÃ£o Filipe (SFL)"
  },
  {
    "value": "SNE",
    "label": "PreguiÃ§a (SNE)"
  },
  {
    "value": "VXE",
    "label": "SÃ£o Pedro (VXE)"
  },
  {
    "value": "BCG",
    "label": "Bemichi (BCG)"
  },
  {
    "value": "BTO",
    "label": "Botopasi (BTO)"
  },
  {
    "value": "DOE",
    "label": "Djumu-Djomoe (DOE)"
  },
  {
    "value": "LDO",
    "label": "Ladouanie (LDO)"
  },
  {
    "value": "WSO",
    "label": "Washabo (WSO)"
  },
  {
    "value": "ADD",
    "label": "Addis Ababa (ADD)"
  },
  {
    "value": "AMH",
    "label": "Arba Minch Airport (AMH)"
  },
  {
    "value": "AXU",
    "label": "Axum Airport (AXU)"
  },
  {
    "value": "BCO",
    "label": "Baco (BCO)"
  },
  {
    "value": "BJR",
    "label": "Bahir Dar (BJR)"
  },
  {
    "value": "BEI",
    "label": "Beica (BEI)"
  },
  {
    "value": "DSE",
    "label": "Dessie (DSE)"
  },
  {
    "value": "DEM",
    "label": "Dembidollo (DEM)"
  },
  {
    "value": "DBM",
    "label": "Debra Marcos (DBM)"
  },
  {
    "value": "DIR",
    "label": "Dire Dawa (DIR)"
  },
  {
    "value": "DBT",
    "label": "Debre Tabor (DBT)"
  },
  {
    "value": "FNH",
    "label": "Fincha (FNH)"
  },
  {
    "value": "GOB",
    "label": "Goba (GOB)"
  },
  {
    "value": "GNN",
    "label": "Ghinnir (GNN)"
  },
  {
    "value": "GMB",
    "label": "Gambela (GMB)"
  },
  {
    "value": "GDQ",
    "label": "Gondar (GDQ)"
  },
  {
    "value": "GDE",
    "label": "Gode (GDE)"
  },
  {
    "value": "GOR",
    "label": "Gore (GOR)"
  },
  {
    "value": "QHR",
    "label": "Debre Zeyit (QHR)"
  },
  {
    "value": "HUE",
    "label": "Humera (HUE)"
  },
  {
    "value": "JIM",
    "label": "Jimma (JIM)"
  },
  {
    "value": "ABK",
    "label": "Kabri Dehar (ABK)"
  },
  {
    "value": "LFO",
    "label": "Kelafo (LFO)"
  },
  {
    "value": "AWA",
    "label": "Awassa (AWA)"
  },
  {
    "value": "LLI",
    "label": "Lalibela (LLI)"
  },
  {
    "value": "MQX",
    "label": "Mekele Airport (MQX)"
  },
  {
    "value": "NDM",
    "label": "Mendi (NDM)"
  },
  {
    "value": "MTF",
    "label": "Mizan Teferi (MTF)"
  },
  {
    "value": "NEJ",
    "label": "Nejjo (NEJ)"
  },
  {
    "value": "NEK",
    "label": "Nekemte (NEK)"
  },
  {
    "value": "SXU",
    "label": "Soddu (SXU)"
  },
  {
    "value": "ASO",
    "label": "Asosa (ASO)"
  },
  {
    "value": "TIE",
    "label": "Tippi (TIE)"
  },
  {
    "value": "WAC",
    "label": "Waca (WAC)"
  },
  {
    "value": "BJM",
    "label": "Bujumbura (BJM)"
  },
  {
    "value": "GID",
    "label": "Gitega (GID)"
  },
  {
    "value": "KRE",
    "label": "Kirundo (KRE)"
  },
  {
    "value": "ALU",
    "label": "Alula (ALU)"
  },
  {
    "value": "BIB",
    "label": "Baidoa (BIB)"
  },
  {
    "value": "CXN",
    "label": "Candala (CXN)"
  },
  {
    "value": "BSY",
    "label": "Bardera Airport (BSY)"
  },
  {
    "value": "HCM",
    "label": "Eil (HCM)"
  },
  {
    "value": "BSA",
    "label": "Bosaso (BSA)"
  },
  {
    "value": "GSR",
    "label": "Gardo (GSR)"
  },
  {
    "value": "HGA",
    "label": "Hargeisa (HGA)"
  },
  {
    "value": "BBO",
    "label": "Berbera (BBO)"
  },
  {
    "value": "KMU",
    "label": "Kisimayu Airport (KMU)"
  },
  {
    "value": "MGQ",
    "label": "Mogadishu (MGQ)"
  },
  {
    "value": "CMO",
    "label": "Obbia (CMO)"
  },
  {
    "value": "GLK",
    "label": "Galcaio (GLK)"
  },
  {
    "value": "CMS",
    "label": "Scusciuban (CMS)"
  },
  {
    "value": "ERA",
    "label": "Erigavo (ERA)"
  },
  {
    "value": "BUO",
    "label": "Burao (BUO)"
  },
  {
    "value": "JIB",
    "label": "Djibouti City (JIB)"
  },
  {
    "value": "AII",
    "label": "Ali-Sabieh (AII)"
  },
  {
    "value": "MHI",
    "label": "Moucha Island (MHI)"
  },
  {
    "value": "OBC",
    "label": "Obock (OBC)"
  },
  {
    "value": "TDJ",
    "label": "Tadjoura (TDJ)"
  },
  {
    "value": "SEW",
    "label": "Siwa (SEW)"
  },
  {
    "value": "DBB",
    "label": "El Alamein (DBB)"
  },
  {
    "value": "AAC",
    "label": "El Arish (AAC)"
  },
  {
    "value": "ATZ",
    "label": "Assiut (ATZ)"
  },
  {
    "value": "ALY",
    "label": "Alexandria (ALY)"
  },
  {
    "value": "HBE",
    "label": "Alexandria (HBE)"
  },
  {
    "value": "ABS",
    "label": "Abu Simbel (ABS)"
  },
  {
    "value": "CAI",
    "label": "Cairo (CAI)"
  },
  {
    "value": "CWE",
    "label": "El Cairo (CWE)"
  },
  {
    "value": "DAK",
    "label": "Dakhla Airport (DAK)"
  },
  {
    "value": "HRG",
    "label": "Hurghada (HRG)"
  },
  {
    "value": "EGH",
    "label": "El Gora Airport (EGH)"
  },
  {
    "value": "UVL",
    "label": "El Kharga Airport (UVL)"
  },
  {
    "value": "LXR",
    "label": "Luxor (LXR)"
  },
  {
    "value": "RMF",
    "label": "Marsa Alam (RMF)"
  },
  {
    "value": "HMB",
    "label": "Sohag (HMB)"
  },
  {
    "value": "MUH",
    "label": "Mersa Matruh (MUH)"
  },
  {
    "value": "HEO",
    "label": "Haelogo Airport (HEO)"
  },
  {
    "value": "GSQ",
    "label": "Shark El Oweinat International Airport (GSQ)"
  },
  {
    "value": "PSD",
    "label": "Port Said (PSD)"
  },
  {
    "value": "SKV",
    "label": "St Catherine International Airport (SKV)"
  },
  {
    "value": "SSH",
    "label": "Sharm el-Sheikh (SSH)"
  },
  {
    "value": "ASW",
    "label": "Aswan (ASW)"
  },
  {
    "value": "TCP",
    "label": "Taba (TCP)"
  },
  {
    "value": "ELT",
    "label": "El Tor Airport (ELT)"
  },
  {
    "value": "HEY",
    "label": "Fort Rucker Ozark (HEY)"
  },
  {
    "value": "HGI",
    "label": "Higleig (HGI)"
  },
  {
    "value": "ASM",
    "label": "Asmara (ASM)"
  },
  {
    "value": "MSW",
    "label": "Massawa (MSW)"
  },
  {
    "value": "ASA",
    "label": "Asab (ASA)"
  },
  {
    "value": "TES",
    "label": "Tessenei (TES)"
  },
  {
    "value": "HIA",
    "label": "Huai'an (HIA)"
  },
  {
    "value": "HIL",
    "label": "Shilavo (HIL)"
  },
  {
    "value": "ASV",
    "label": "Amboseli National Park (ASV)"
  },
  {
    "value": "EDL",
    "label": "Eldoret (EDL)"
  },
  {
    "value": "EYS",
    "label": "Eliye Springs (EYS)"
  },
  {
    "value": "KLK",
    "label": "Kalokol (KLK)"
  },
  {
    "value": "GAS",
    "label": "Garissa (GAS)"
  },
  {
    "value": "HOA",
    "label": "Hola (HOA)"
  },
  {
    "value": "NBO",
    "label": "Nairobi (NBO)"
  },
  {
    "value": "GGM",
    "label": "Kakamega (GGM)"
  },
  {
    "value": "KIS",
    "label": "Kisumu (KIS)"
  },
  {
    "value": "ILU",
    "label": "Kilaguni (ILU)"
  },
  {
    "value": "KEY",
    "label": "Kericho (KEY)"
  },
  {
    "value": "KTL",
    "label": "Kitale (KTL)"
  },
  {
    "value": "LKG",
    "label": "Lokichoggio (LKG)"
  },
  {
    "value": "LOK",
    "label": "Lodwar (LOK)"
  },
  {
    "value": "LAU",
    "label": "Lamu (LAU)"
  },
  {
    "value": "LOY",
    "label": "Loyengalani (LOY)"
  },
  {
    "value": "NDE",
    "label": "Mandera (NDE)"
  },
  {
    "value": "RBT",
    "label": "Marsabit (RBT)"
  },
  {
    "value": "MYD",
    "label": "Malindi (MYD)"
  },
  {
    "value": "MBA",
    "label": "Mombasa (MBA)"
  },
  {
    "value": "MRE",
    "label": "Masai Mara (MRE)"
  },
  {
    "value": "OYL",
    "label": "Moyale (Lower) (OYL)"
  },
  {
    "value": "NYE",
    "label": "Nyeri (NYE)"
  },
  {
    "value": "NUU",
    "label": "Nakuru (NUU)"
  },
  {
    "value": "WIL",
    "label": "Nairobi (WIL)"
  },
  {
    "value": "NYK",
    "label": "Nanyuki (NYK)"
  },
  {
    "value": "UAS",
    "label": "Samburu South (UAS)"
  },
  {
    "value": "UKA",
    "label": "Ukunda (UKA)"
  },
  {
    "value": "WJR",
    "label": "Wajir (WJR)"
  },
  {
    "value": "SRX",
    "label": "Sirt (SRX)"
  },
  {
    "value": "TOB",
    "label": "Tobruk (TOB)"
  },
  {
    "value": "GHT",
    "label": "Ghat (GHT)"
  },
  {
    "value": "AKF",
    "label": "Kufra (AKF)"
  },
  {
    "value": "BEN",
    "label": "Benghazi (BEN)"
  },
  {
    "value": "MJI",
    "label": "Tripoli (MJI)"
  },
  {
    "value": "LAQ",
    "label": "Al Bayda' (LAQ)"
  },
  {
    "value": "SEB",
    "label": "Sabha (SEB)"
  },
  {
    "value": "TIP",
    "label": "Tripoli (TIP)"
  },
  {
    "value": "LMQ",
    "label": "Marsa Brega Airport (LMQ)"
  },
  {
    "value": "HUQ",
    "label": "Hon Airport (HUQ)"
  },
  {
    "value": "LTD",
    "label": "Ghadames (LTD)"
  },
  {
    "value": "WAX",
    "label": "Zuwara (WAX)"
  },
  {
    "value": "GYI",
    "label": "Gisenyi (GYI)"
  },
  {
    "value": "BTQ",
    "label": "Butare (BTQ)"
  },
  {
    "value": "KGL",
    "label": "Kigali (KGL)"
  },
  {
    "value": "RHG",
    "label": "Ruhengeri (RHG)"
  },
  {
    "value": "KME",
    "label": "Kamembe (KME)"
  },
  {
    "value": "ATB",
    "label": "Atbara (ATB)"
  },
  {
    "value": "EDB",
    "label": "El Debba (EDB)"
  },
  {
    "value": "DOG",
    "label": "Dongola (DOG)"
  },
  {
    "value": "ELF",
    "label": "El Fasher (ELF)"
  },
  {
    "value": "GSU",
    "label": "Gedaref (GSU)"
  },
  {
    "value": "DNX",
    "label": "Dinder (DNX)"
  },
  {
    "value": "EGN",
    "label": "Geneina (EGN)"
  },
  {
    "value": "KSL",
    "label": "Kassala (KSL)"
  },
  {
    "value": "GBU",
    "label": "Khashm El Girba (GBU)"
  },
  {
    "value": "KST",
    "label": "Kosti (KST)"
  },
  {
    "value": "KDX",
    "label": "Kadugli (KDX)"
  },
  {
    "value": "MWE",
    "label": "Merowe (MWE)"
  },
  {
    "value": "NUD",
    "label": "En Nahud (NUD)"
  },
  {
    "value": "UYL",
    "label": "Nyala (UYL)"
  },
  {
    "value": "NHF",
    "label": "New Halfa (NHF)"
  },
  {
    "value": "EBD",
    "label": "Al-Ubayyid (EBD)"
  },
  {
    "value": "PZU",
    "label": "Port Sudan (PZU)"
  },
  {
    "value": "JUB",
    "label": "Juba (JUB)"
  },
  {
    "value": "MAK",
    "label": "Malakal (MAK)"
  },
  {
    "value": "KRT",
    "label": "Khartoum (KRT)"
  },
  {
    "value": "WHF",
    "label": "Wadi Halfa (WHF)"
  },
  {
    "value": "WUU",
    "label": "Wau (WUU)"
  },
  {
    "value": "ARK",
    "label": "Arusha (ARK)"
  },
  {
    "value": "BKZ",
    "label": "Bukoba (BKZ)"
  },
  {
    "value": "DAR",
    "label": "Dar es Salaam (DAR)"
  },
  {
    "value": "DOD",
    "label": "Dodoma (DOD)"
  },
  {
    "value": "IRI",
    "label": "Nduli (IRI)"
  },
  {
    "value": "TKQ",
    "label": "Kigoma (TKQ)"
  },
  {
    "value": "KIY",
    "label": "Kilwa Masoko (KIY)"
  },
  {
    "value": "JRO",
    "label": "Arusha (JRO)"
  },
  {
    "value": "LDI",
    "label": "Lindi (LDI)"
  },
  {
    "value": "LKY",
    "label": "Lake Manyara National Park (LKY)"
  },
  {
    "value": "MFA",
    "label": "Mafia Island (MFA)"
  },
  {
    "value": "MBI",
    "label": "Mbeya (MBI)"
  },
  {
    "value": "MWN",
    "label": "Mwadui (MWN)"
  },
  {
    "value": "XMI",
    "label": "Masasi (XMI)"
  },
  {
    "value": "QSI",
    "label": "Moshi (QSI)"
  },
  {
    "value": "MYW",
    "label": "Mtwara (MYW)"
  },
  {
    "value": "MUZ",
    "label": "Musoma (MUZ)"
  },
  {
    "value": "MWZ",
    "label": "Mwanza (MWZ)"
  },
  {
    "value": "NCH",
    "label": "Nachingwea (NCH)"
  },
  {
    "value": "JOM",
    "label": "Njombe (JOM)"
  },
  {
    "value": "PMA",
    "label": "Chake (PMA)"
  },
  {
    "value": "SEU",
    "label": "Seronera (SEU)"
  },
  {
    "value": "SGX",
    "label": "Songea (SGX)"
  },
  {
    "value": "SUT",
    "label": "Sumbawanga (SUT)"
  },
  {
    "value": "SHY",
    "label": "Shinyanga (SHY)"
  },
  {
    "value": "TBO",
    "label": "Tabora (TBO)"
  },
  {
    "value": "TGT",
    "label": "Tanga (TGT)"
  },
  {
    "value": "ZNZ",
    "label": "Kiembi Samaki (ZNZ)"
  },
  {
    "value": "RUA",
    "label": "Arua (RUA)"
  },
  {
    "value": "EBB",
    "label": "Kampala (EBB)"
  },
  {
    "value": "ULU",
    "label": "Gulu (ULU)"
  },
  {
    "value": "JIN",
    "label": "Jinja (JIN)"
  },
  {
    "value": "KBG",
    "label": "Kabalega Falls (KBG)"
  },
  {
    "value": "KSE",
    "label": "Kasese (KSE)"
  },
  {
    "value": "MBQ",
    "label": "Mbarara (MBQ)"
  },
  {
    "value": "KCU",
    "label": "Masindi (KCU)"
  },
  {
    "value": "PAF",
    "label": "Pakuba Airport (PAF)"
  },
  {
    "value": "SRT",
    "label": "Soroti (SRT)"
  },
  {
    "value": "TRY",
    "label": "Tororo (TRY)"
  },
  {
    "value": "HWA",
    "label": "Hawabango Airport (HWA)"
  },
  {
    "value": "IBL",
    "label": "Bazaruto Island (IBL)"
  },
  {
    "value": "PPJ",
    "label": "Tjipara-Java Island (PPJ)"
  },
  {
    "value": "LSE",
    "label": "Bandar Udara Lasondre (LSE)"
  },
  {
    "value": "AAS",
    "label": "Apalapsili-Papua Island (AAS)"
  },
  {
    "value": "AGD",
    "label": "Anggi-Papua Island (AGD)"
  },
  {
    "value": "AKQ",
    "label": "Astraksetra-Sumatra Island (AKQ)"
  },
  {
    "value": "AYW",
    "label": "Ayawasi-Papua Island (AYW)"
  },
  {
    "value": "BJG",
    "label": "Boalang-Celebes Island (BJG)"
  },
  {
    "value": "BXM",
    "label": "Batom-Papua Island (BXM)"
  },
  {
    "value": "DRH",
    "label": "Dabra-Papua Island (DRH)"
  },
  {
    "value": "ELR",
    "label": "Elelim-Papua Island (ELR)"
  },
  {
    "value": "EWE",
    "label": "Ewer-Papua Island (EWE)"
  },
  {
    "value": "FOO",
    "label": "Kornasoren-Numfoor Island (FOO)"
  },
  {
    "value": "GAV",
    "label": "Gag Island (GAV)"
  },
  {
    "value": "IUL",
    "label": "Ilu-Papua Island (IUL)"
  },
  {
    "value": "KBF",
    "label": "Karubaga-Papua Island (KBF)"
  },
  {
    "value": "KBX",
    "label": "Kambuaya-Papua Island (KBX)"
  },
  {
    "value": "KCD",
    "label": "Kamur-Papua Island (KCD)"
  },
  {
    "value": "KCI",
    "label": "Kon (KCI)"
  },
  {
    "value": "KEA",
    "label": "Keisah-Papua Island (KEA)"
  },
  {
    "value": "KMM",
    "label": "Kiman-Papua Island (KMM)"
  },
  {
    "value": "KOD",
    "label": "Kotabangun-Borneo Island (KOD)"
  },
  {
    "value": "KRC",
    "label": "Kerinici-Sumatra Island (KRC)"
  },
  {
    "value": "KWB",
    "label": "Karimunjawa-Karimunjawa Island (KWB)"
  },
  {
    "value": "LLN",
    "label": "Kelila-Papua Island (LLN)"
  },
  {
    "value": "LWE",
    "label": "Lewoleba-Lembata Island (LWE)"
  },
  {
    "value": "LYK",
    "label": "Lunyuk-Simbawa Island (LYK)"
  },
  {
    "value": "MJY",
    "label": "Mangungaya-Sumatra Island (MJY)"
  },
  {
    "value": "MPT",
    "label": "Maliana-Alor Island (MPT)"
  },
  {
    "value": "MSI",
    "label": "Masalembo Island (MSI)"
  },
  {
    "value": "MUF",
    "label": "Muting-Papua Island (MUF)"
  },
  {
    "value": "NAF",
    "label": "Banaina-Borneo Island (NAF)"
  },
  {
    "value": "NDA",
    "label": "Bandanaira-Naira Island (NDA)"
  },
  {
    "value": "OBD",
    "label": "Obano-Papua Island (OBD)"
  },
  {
    "value": "PUM",
    "label": "Tambea-Celebes Island (PUM)"
  },
  {
    "value": "PWL",
    "label": "Purwokerto-Java Island (PWL)"
  },
  {
    "value": "RAQ",
    "label": "Raha-Muna Island (RAQ)"
  },
  {
    "value": "RKI",
    "label": "Rokot-Sumatra Island (RKI)"
  },
  {
    "value": "RTI",
    "label": "Roti-Rote Island (RTI)"
  },
  {
    "value": "RUF",
    "label": "Yuruf-Papua Island (RUF)"
  },
  {
    "value": "RZS",
    "label": "Sawan-Bali Island (RZS)"
  },
  {
    "value": "SAE",
    "label": "Sangir-Simbawa Island (SAE)"
  },
  {
    "value": "TBM",
    "label": "Tumbang Samba-Borneo Island (TBM)"
  },
  {
    "value": "TMY",
    "label": "Tiom-Papua Island (TMY)"
  },
  {
    "value": "ZEG",
    "label": "Senggo-Papua Island (ZEG)"
  },
  {
    "value": "ZGP",
    "label": "Zugapa-Papua Island (ZGP)"
  },
  {
    "value": "CHE",
    "label": "Caherciveen (CHE)"
  },
  {
    "value": "VDY",
    "label": "Vijayanagar Aerodrome (JSW) (VDY)"
  },
  {
    "value": "JGB",
    "label": "Jagdalpur (JGB)"
  },
  {
    "value": "NVY",
    "label": "Neyveli Airport (NVY)"
  },
  {
    "value": "RJI",
    "label": "Rajouri (RJI)"
  },
  {
    "value": "TEI",
    "label": "Tezu (TEI)"
  },
  {
    "value": "KHA",
    "label": "Khaneh (KHA)"
  },
  {
    "value": "GSM",
    "label": "Gheshm (GSM)"
  },
  {
    "value": "TQR",
    "label": "Tremiti Islands (TQR)"
  },
  {
    "value": "JGD",
    "label": "Jiagedaqi (JGD)"
  },
  {
    "value": "JIC",
    "label": "Jinchang (JIC)"
  },
  {
    "value": "JIQ",
    "label": "Qianjiang (JIQ)"
  },
  {
    "value": "JMC",
    "label": "Sausalito (JMC)"
  },
  {
    "value": "JOP",
    "label": "Josephstaal Airport (JOP)"
  },
  {
    "value": "JRA",
    "label": "New York (JRA)"
  },
  {
    "value": "AMK",
    "label": "Durango (AMK)"
  },
  {
    "value": "BDX",
    "label": "Broadus (BDX)"
  },
  {
    "value": "RLA",
    "label": "Rolla (RLA)"
  },
  {
    "value": "FID",
    "label": "Fishers Island (FID)"
  },
  {
    "value": "AHD",
    "label": "Ardmore (AHD)"
  },
  {
    "value": "GCW",
    "label": "Peach Springs (GCW)"
  },
  {
    "value": "RKC",
    "label": "Montague (RKC)"
  },
  {
    "value": "GNF",
    "label": "Quincy (GNF)"
  },
  {
    "value": "AHF",
    "label": "Arapahoe (AHF)"
  },
  {
    "value": "GTP",
    "label": "Grants Pass (GTP)"
  },
  {
    "value": "GCD",
    "label": "Electric City (GCD)"
  },
  {
    "value": "FPY",
    "label": "Perry (FPY)"
  },
  {
    "value": "FHB",
    "label": "Fernandina Beach (FHB)"
  },
  {
    "value": "BLD",
    "label": "Boulder City (BLD)"
  },
  {
    "value": "FMU",
    "label": "Florence (FMU)"
  },
  {
    "value": "ATE",
    "label": "Antlers (ATE)"
  },
  {
    "value": "ASQ",
    "label": "Austin (ASQ)"
  },
  {
    "value": "AAF",
    "label": "Apalachicola (AAF)"
  },
  {
    "value": "ABE",
    "label": "Allentown (ABE)"
  },
  {
    "value": "ABI",
    "label": "Abilene (ABI)"
  },
  {
    "value": "ABQ",
    "label": "Albuquerque (ABQ)"
  },
  {
    "value": "ABR",
    "label": "Aberdeen (ABR)"
  },
  {
    "value": "ABY",
    "label": "Albany (ABY)"
  },
  {
    "value": "ACB",
    "label": "Bellaire (ACB)"
  },
  {
    "value": "ACK",
    "label": "Nantucket (ACK)"
  },
  {
    "value": "ACT",
    "label": "Waco (ACT)"
  },
  {
    "value": "ACV",
    "label": "Arcata/Eureka (ACV)"
  },
  {
    "value": "ACY",
    "label": "Atlantic City (ACY)"
  },
  {
    "value": "ADG",
    "label": "Adrian (ADG)"
  },
  {
    "value": "ADT",
    "label": "Ada (ADT)"
  },
  {
    "value": "ADM",
    "label": "Ardmore (ADM)"
  },
  {
    "value": "ADS",
    "label": "Dallas (ADS)"
  },
  {
    "value": "ADW",
    "label": "Camp Springs (ADW)"
  },
  {
    "value": "KAE",
    "label": "Kake (KAE)"
  },
  {
    "value": "AEL",
    "label": "Albert Lea (AEL)"
  },
  {
    "value": "AEX",
    "label": "Alexandria (AEX)"
  },
  {
    "value": "AFF",
    "label": "Colorado Springs (AFF)"
  },
  {
    "value": "WSG",
    "label": "Washington (WSG)"
  },
  {
    "value": "AFN",
    "label": "Jaffrey (AFN)"
  },
  {
    "value": "AFO",
    "label": "Afton (AFO)"
  },
  {
    "value": "AFW",
    "label": "Fort Worth (AFW)"
  },
  {
    "value": "AGC",
    "label": "Pittsburgh (AGC)"
  },
  {
    "value": "AGO",
    "label": "Magnolia (AGO)"
  },
  {
    "value": "AGS",
    "label": "Augusta (AGS)"
  },
  {
    "value": "AHC",
    "label": "Herlong (AHC)"
  },
  {
    "value": "AHH",
    "label": "Amery (AHH)"
  },
  {
    "value": "AHN",
    "label": "Athens (AHN)"
  },
  {
    "value": "AIA",
    "label": "Alliance (AIA)"
  },
  {
    "value": "AID",
    "label": "Anderson (AID)"
  },
  {
    "value": "AIK",
    "label": "Aiken (AIK)"
  },
  {
    "value": "AIO",
    "label": "Atlantic (AIO)"
  },
  {
    "value": "AIV",
    "label": "Aliceville (AIV)"
  },
  {
    "value": "AIZ",
    "label": "Kaiser Lake Ozark (AIZ)"
  },
  {
    "value": "AKO",
    "label": "Akron (AKO)"
  },
  {
    "value": "AKC",
    "label": "Akron (AKC)"
  },
  {
    "value": "ALB",
    "label": "Albany (ALB)"
  },
  {
    "value": "ALI",
    "label": "Alice (ALI)"
  },
  {
    "value": "ALM",
    "label": "Alamogordo (ALM)"
  },
  {
    "value": "ALN",
    "label": "Alton/St Louis (ALN)"
  },
  {
    "value": "ALO",
    "label": "Waterloo (ALO)"
  },
  {
    "value": "ALS",
    "label": "Alamosa (ALS)"
  },
  {
    "value": "ALW",
    "label": "Walla Walla (ALW)"
  },
  {
    "value": "ALX",
    "label": "Alexander City (ALX)"
  },
  {
    "value": "AMA",
    "label": "Amarillo (AMA)"
  },
  {
    "value": "AMN",
    "label": "Alma (AMN)"
  },
  {
    "value": "AMW",
    "label": "Ames (AMW)"
  },
  {
    "value": "ANB",
    "label": "Anniston (ANB)"
  },
  {
    "value": "AND",
    "label": "Anderson (AND)"
  },
  {
    "value": "ANP",
    "label": "Annapolis (ANP)"
  },
  {
    "value": "ANQ",
    "label": "Angola (ANQ)"
  },
  {
    "value": "ANW",
    "label": "Ainsworth (ANW)"
  },
  {
    "value": "ANY",
    "label": "Anthony (ANY)"
  },
  {
    "value": "AOH",
    "label": "Lima (AOH)"
  },
  {
    "value": "AOO",
    "label": "Altoona (AOO)"
  },
  {
    "value": "APA",
    "label": "Denver (APA)"
  },
  {
    "value": "APC",
    "label": "Napa (APC)"
  },
  {
    "value": "APF",
    "label": "Naples (APF)"
  },
  {
    "value": "APG",
    "label": "Aberdeen Proving Grounds(Aberdeen) (APG)"
  },
  {
    "value": "APH",
    "label": "Fort A. P. Hill (APH)"
  },
  {
    "value": "APN",
    "label": "Alpena (APN)"
  },
  {
    "value": "APT",
    "label": "Jasper (APT)"
  },
  {
    "value": "APV",
    "label": "Apple Valley (APV)"
  },
  {
    "value": "KAQ",
    "label": "Kamulai Mission (KAQ)"
  },
  {
    "value": "ARA",
    "label": "New Iberia (ARA)"
  },
  {
    "value": "ARB",
    "label": "Ann Arbor (ARB)"
  },
  {
    "value": "ARG",
    "label": "Walnut Ridge (ARG)"
  },
  {
    "value": "AUZ",
    "label": "Chicago/Aurora (AUZ)"
  },
  {
    "value": "ART",
    "label": "Watertown (ART)"
  },
  {
    "value": "ARV",
    "label": "Minocqua-Woodruff (ARV)"
  },
  {
    "value": "BFT",
    "label": "Beaufort (BFT)"
  },
  {
    "value": "ASE",
    "label": "Aspen (ASE)"
  },
  {
    "value": "ASH",
    "label": "Nashua (ASH)"
  },
  {
    "value": "ASL",
    "label": "Marshall (ASL)"
  },
  {
    "value": "ASN",
    "label": "Talladega (ASN)"
  },
  {
    "value": "AST",
    "label": "Astoria (AST)"
  },
  {
    "value": "ATL",
    "label": "Atlanta (ATL)"
  },
  {
    "value": "ATS",
    "label": "Artesia (ATS)"
  },
  {
    "value": "ATW",
    "label": "Appleton (ATW)"
  },
  {
    "value": "ATY",
    "label": "Watertown (ATY)"
  },
  {
    "value": "AUG",
    "label": "Augusta (AUG)"
  },
  {
    "value": "AUM",
    "label": "Austin (AUM)"
  },
  {
    "value": "AUN",
    "label": "Auburn (AUN)"
  },
  {
    "value": "AUS",
    "label": "Austin (AUS)"
  },
  {
    "value": "AVL",
    "label": "Asheville (AVL)"
  },
  {
    "value": "AVO",
    "label": "Avon Park (AVO)"
  },
  {
    "value": "AVP",
    "label": "Wilkes-Barre/Scranton (AVP)"
  },
  {
    "value": "AVW",
    "label": "Tucson (AVW)"
  },
  {
    "value": "AWM",
    "label": "West Memphis (AWM)"
  },
  {
    "value": "AXG",
    "label": "Algona (AXG)"
  },
  {
    "value": "AXN",
    "label": "Alexandria (AXN)"
  },
  {
    "value": "AXS",
    "label": "Altus (AXS)"
  },
  {
    "value": "AXV",
    "label": "Wapakoneta (AXV)"
  },
  {
    "value": "AXX",
    "label": "Angel Fire (AXX)"
  },
  {
    "value": "AYS",
    "label": "Waycross (AYS)"
  },
  {
    "value": "AZO",
    "label": "Kalamazoo (AZO)"
  },
  {
    "value": "BAB",
    "label": "Marysville (BAB)"
  },
  {
    "value": "BAD",
    "label": "Bossier City (BAD)"
  },
  {
    "value": "BAF",
    "label": "Westfield/Springfield (BAF)"
  },
  {
    "value": "BBB",
    "label": "Benson (BBB)"
  },
  {
    "value": "BBD",
    "label": "Brady (BBD)"
  },
  {
    "value": "BTN",
    "label": "Bennettsville (BTN)"
  },
  {
    "value": "BBW",
    "label": "Broken Bow (BBW)"
  },
  {
    "value": "BCB",
    "label": "Blacksburg (BCB)"
  },
  {
    "value": "BCE",
    "label": "Bryce Canyon (BCE)"
  },
  {
    "value": "BCT",
    "label": "Boca Raton (BCT)"
  },
  {
    "value": "BDE",
    "label": "Baudette (BDE)"
  },
  {
    "value": "BDL",
    "label": "Hartford (BDL)"
  },
  {
    "value": "BDR",
    "label": "Bridgeport (BDR)"
  },
  {
    "value": "BEC",
    "label": "Wichita (BEC)"
  },
  {
    "value": "BED",
    "label": "Bedford (BED)"
  },
  {
    "value": "BEH",
    "label": "Benton Harbor (BEH)"
  },
  {
    "value": "BFD",
    "label": "Bradford (BFD)"
  },
  {
    "value": "BFF",
    "label": "Scottsbluff (BFF)"
  },
  {
    "value": "BFI",
    "label": "Seattle (BFI)"
  },
  {
    "value": "BFL",
    "label": "Bakersfield (BFL)"
  },
  {
    "value": "BFM",
    "label": "Mobile (BFM)"
  },
  {
    "value": "BFR",
    "label": "Bedford (BFR)"
  },
  {
    "value": "BGD",
    "label": "Borger (BGD)"
  },
  {
    "value": "BGE",
    "label": "Bainbridge (BGE)"
  },
  {
    "value": "BGM",
    "label": "Binghamton (BGM)"
  },
  {
    "value": "BGR",
    "label": "Bangor (BGR)"
  },
  {
    "value": "BHB",
    "label": "Bar Harbor (BHB)"
  },
  {
    "value": "BHM",
    "label": "Birmingham (BHM)"
  },
  {
    "value": "BID",
    "label": "Block Island (BID)"
  },
  {
    "value": "BIE",
    "label": "Beatrice (BIE)"
  },
  {
    "value": "BIF",
    "label": "Fort Bliss/El Paso (BIF)"
  },
  {
    "value": "BIH",
    "label": "Bishop (BIH)"
  },
  {
    "value": "BIL",
    "label": "Billings (BIL)"
  },
  {
    "value": "BIS",
    "label": "Bismarck (BIS)"
  },
  {
    "value": "BIX",
    "label": "Biloxi (BIX)"
  },
  {
    "value": "BJC",
    "label": "Denver (BJC)"
  },
  {
    "value": "BKD",
    "label": "Breckenridge (BKD)"
  },
  {
    "value": "BKE",
    "label": "Baker City (BKE)"
  },
  {
    "value": "BFK",
    "label": "Aurora (BFK)"
  },
  {
    "value": "BKL",
    "label": "Cleveland (BKL)"
  },
  {
    "value": "BKT",
    "label": "Blackstone (BKT)"
  },
  {
    "value": "BKW",
    "label": "Beckley (BKW)"
  },
  {
    "value": "BKX",
    "label": "Brookings (BKX)"
  },
  {
    "value": "BLF",
    "label": "Bluefield (BLF)"
  },
  {
    "value": "BLH",
    "label": "Blythe (BLH)"
  },
  {
    "value": "BLI",
    "label": "Bellingham (BLI)"
  },
  {
    "value": "BLU",
    "label": "Emigrant Gap (BLU)"
  },
  {
    "value": "BLV",
    "label": "Belleville (BLV)"
  },
  {
    "value": "KBM",
    "label": "Kabwum (KBM)"
  },
  {
    "value": "BMC",
    "label": "Brigham City (BMC)"
  },
  {
    "value": "BMG",
    "label": "Bloomington (BMG)"
  },
  {
    "value": "BMI",
    "label": "Bloomington-Normal (BMI)"
  },
  {
    "value": "BML",
    "label": "Berlin (BML)"
  },
  {
    "value": "BMT",
    "label": "Beaumont (BMT)"
  },
  {
    "value": "BNA",
    "label": "Nashville (BNA)"
  },
  {
    "value": "BNG",
    "label": "Banning (BNG)"
  },
  {
    "value": "BNL",
    "label": "Barnwell (BNL)"
  },
  {
    "value": "BNO",
    "label": "Burns (BNO)"
  },
  {
    "value": "BNW",
    "label": "Boone (BNW)"
  },
  {
    "value": "BOI",
    "label": "Boise (BOI)"
  },
  {
    "value": "BOS",
    "label": "Boston (BOS)"
  },
  {
    "value": "BOW",
    "label": "Bartow (BOW)"
  },
  {
    "value": "BGS",
    "label": "Big Spring (BGS)"
  },
  {
    "value": "BPI",
    "label": "Big Piney (BPI)"
  },
  {
    "value": "WMH",
    "label": "Mountain Home (WMH)"
  },
  {
    "value": "BWM",
    "label": "Bowman (BWM)"
  },
  {
    "value": "BPT",
    "label": "Beaumont/Port Arthur (BPT)"
  },
  {
    "value": "BQK",
    "label": "Brunswick (BQK)"
  },
  {
    "value": "BRD",
    "label": "Brainerd (BRD)"
  },
  {
    "value": "BRL",
    "label": "Burlington (BRL)"
  },
  {
    "value": "BRO",
    "label": "Brownsville (BRO)"
  },
  {
    "value": "BRY",
    "label": "Bardstown (BRY)"
  },
  {
    "value": "BTF",
    "label": "Bountiful (BTF)"
  },
  {
    "value": "BTL",
    "label": "Battle Creek (BTL)"
  },
  {
    "value": "BTM",
    "label": "Butte (BTM)"
  },
  {
    "value": "BTR",
    "label": "Baton Rouge (BTR)"
  },
  {
    "value": "BTV",
    "label": "Burlington (BTV)"
  },
  {
    "value": "BTY",
    "label": "Beatty (BTY)"
  },
  {
    "value": "BUB",
    "label": "Burwell (BUB)"
  },
  {
    "value": "BUF",
    "label": "Buffalo (BUF)"
  },
  {
    "value": "BUM",
    "label": "Butler (BUM)"
  },
  {
    "value": "BUR",
    "label": "Burbank (BUR)"
  },
  {
    "value": "BFP",
    "label": "Beaver Falls (BFP)"
  },
  {
    "value": "BVO",
    "label": "Bartlesville (BVO)"
  },
  {
    "value": "BVX",
    "label": "Batesville (BVX)"
  },
  {
    "value": "BVY",
    "label": "Beverly (BVY)"
  },
  {
    "value": "BWC",
    "label": "Brawley (BWC)"
  },
  {
    "value": "BWD",
    "label": "Brownwood (BWD)"
  },
  {
    "value": "BWG",
    "label": "Bowling Green (BWG)"
  },
  {
    "value": "BWI",
    "label": "Baltimore (BWI)"
  },
  {
    "value": "BXA",
    "label": "Bogalusa (BXA)"
  },
  {
    "value": "BXK",
    "label": "Buckeye (BXK)"
  },
  {
    "value": "BYS",
    "label": "Fort Irwin/Barstow (BYS)"
  },
  {
    "value": "BBC",
    "label": "Bay City (BBC)"
  },
  {
    "value": "BZN",
    "label": "Bozeman (BZN)"
  },
  {
    "value": "CLG",
    "label": "Coalinga (CLG)"
  },
  {
    "value": "CAD",
    "label": "Cadillac (CAD)"
  },
  {
    "value": "CAE",
    "label": "Columbia (CAE)"
  },
  {
    "value": "CAK",
    "label": "Akron (CAK)"
  },
  {
    "value": "CAO",
    "label": "Clayton (CAO)"
  },
  {
    "value": "CBE",
    "label": "Cumberland (CBE)"
  },
  {
    "value": "CBF",
    "label": "Council Bluffs (CBF)"
  },
  {
    "value": "CBK",
    "label": "Colby (CBK)"
  },
  {
    "value": "CBM",
    "label": "Columbus (CBM)"
  },
  {
    "value": "CCB",
    "label": "Upland (CCB)"
  },
  {
    "value": "CCR",
    "label": "Concord (CCR)"
  },
  {
    "value": "CCY",
    "label": "Charles City (CCY)"
  },
  {
    "value": "CDC",
    "label": "Cedar City (CDC)"
  },
  {
    "value": "CDH",
    "label": "Camden (CDH)"
  },
  {
    "value": "CDN",
    "label": "Camden (CDN)"
  },
  {
    "value": "CDR",
    "label": "Chadron (CDR)"
  },
  {
    "value": "CDS",
    "label": "Childress (CDS)"
  },
  {
    "value": "CDW",
    "label": "Caldwell (CDW)"
  },
  {
    "value": "CEC",
    "label": "Crescent City (CEC)"
  },
  {
    "value": "CEF",
    "label": "Springfield/Chicopee (CEF)"
  },
  {
    "value": "CGI",
    "label": "Cape Girardeau (CGI)"
  },
  {
    "value": "CHA",
    "label": "Chattanooga (CHA)"
  },
  {
    "value": "CHO",
    "label": "Charlottesville (CHO)"
  },
  {
    "value": "CHS",
    "label": "Charleston (CHS)"
  },
  {
    "value": "CID",
    "label": "Cedar Rapids (CID)"
  },
  {
    "value": "CIU",
    "label": "Sault Ste Marie (CIU)"
  },
  {
    "value": "CKB",
    "label": "Clarksburg (CKB)"
  },
  {
    "value": "KCL",
    "label": "Chignik Lagoon (KCL)"
  },
  {
    "value": "CLE",
    "label": "Cleveland (CLE)"
  },
  {
    "value": "CLL",
    "label": "College Station (CLL)"
  },
  {
    "value": "CLM",
    "label": "Port Angeles (CLM)"
  },
  {
    "value": "CLT",
    "label": "Charlotte (CLT)"
  },
  {
    "value": "CMH",
    "label": "Columbus (CMH)"
  },
  {
    "value": "CMI",
    "label": "Champaign/Urbana (CMI)"
  },
  {
    "value": "CMX",
    "label": "Hancock (CMX)"
  },
  {
    "value": "CNM",
    "label": "Carlsbad (CNM)"
  },
  {
    "value": "COS",
    "label": "Colorado Springs (COS)"
  },
  {
    "value": "COU",
    "label": "Columbia (COU)"
  },
  {
    "value": "CPR",
    "label": "Casper (CPR)"
  },
  {
    "value": "CRO",
    "label": "Corcoran (CRO)"
  },
  {
    "value": "CRP",
    "label": "Corpus Christi (CRP)"
  },
  {
    "value": "CRW",
    "label": "Charleston (CRW)"
  },
  {
    "value": "CSG",
    "label": "Columbus (CSG)"
  },
  {
    "value": "CVG",
    "label": "Cincinnati (CVG)"
  },
  {
    "value": "KIP",
    "label": "Wichita Falls (KIP)"
  },
  {
    "value": "CWF",
    "label": "Lake Charles (CWF)"
  },
  {
    "value": "CYS",
    "label": "Cheyenne (CYS)"
  },
  {
    "value": "DAA",
    "label": "Fort Belvoir (DAA)"
  },
  {
    "value": "DAB",
    "label": "Daytona Beach (DAB)"
  },
  {
    "value": "DAG",
    "label": "Daggett (DAG)"
  },
  {
    "value": "DAL",
    "label": "Dallas (DAL)"
  },
  {
    "value": "DAN",
    "label": "Danville (DAN)"
  },
  {
    "value": "DAY",
    "label": "Dayton (DAY)"
  },
  {
    "value": "DBN",
    "label": "Dublin (DBN)"
  },
  {
    "value": "DBQ",
    "label": "Dubuque (DBQ)"
  },
  {
    "value": "DCA",
    "label": "Washington (DCA)"
  },
  {
    "value": "DCU",
    "label": "Decatur (DCU)"
  },
  {
    "value": "DDC",
    "label": "Dodge City (DDC)"
  },
  {
    "value": "DEC",
    "label": "Decatur (DEC)"
  },
  {
    "value": "DEH",
    "label": "Decorah (DEH)"
  },
  {
    "value": "DEN",
    "label": "Denver (DEN)"
  },
  {
    "value": "DET",
    "label": "Detroit (DET)"
  },
  {
    "value": "DFI",
    "label": "Defiance (DFI)"
  },
  {
    "value": "DFW",
    "label": "Dallas-Fort Worth (DFW)"
  },
  {
    "value": "DGL",
    "label": "Douglas (DGL)"
  },
  {
    "value": "DGW",
    "label": "Douglas (DGW)"
  },
  {
    "value": "DHN",
    "label": "Dothan (DHN)"
  },
  {
    "value": "DHT",
    "label": "Dalhart (DHT)"
  },
  {
    "value": "DIK",
    "label": "Dickinson (DIK)"
  },
  {
    "value": "DLH",
    "label": "Duluth (DLH)"
  },
  {
    "value": "DNL",
    "label": "Augusta (DNL)"
  },
  {
    "value": "KDP",
    "label": "Kandep (KDP)"
  },
  {
    "value": "DPA",
    "label": "Chicago/West Chicago (DPA)"
  },
  {
    "value": "DPG",
    "label": "Dugway Proving Ground (DPG)"
  },
  {
    "value": "DRO",
    "label": "Durango (DRO)"
  },
  {
    "value": "DRT",
    "label": "Del Rio (DRT)"
  },
  {
    "value": "DSM",
    "label": "Des Moines (DSM)"
  },
  {
    "value": "DSV",
    "label": "Dansville (DSV)"
  },
  {
    "value": "DTA",
    "label": "Delta (DTA)"
  },
  {
    "value": "DTL",
    "label": "Detroit Lakes (DTL)"
  },
  {
    "value": "DTN",
    "label": "Shreveport (DTN)"
  },
  {
    "value": "DSI",
    "label": "Destin (DSI)"
  },
  {
    "value": "DTW",
    "label": "Detroit (DTW)"
  },
  {
    "value": "DUA",
    "label": "Durant (DUA)"
  },
  {
    "value": "DUC",
    "label": "Duncan (DUC)"
  },
  {
    "value": "DUG",
    "label": "Douglas Bisbee (DUG)"
  },
  {
    "value": "DUJ",
    "label": "Dubois (DUJ)"
  },
  {
    "value": "DVL",
    "label": "Devils Lake (DVL)"
  },
  {
    "value": "DVN",
    "label": "Davenport (DVN)"
  },
  {
    "value": "DVT",
    "label": "Phoenix (DVT)"
  },
  {
    "value": "DWH",
    "label": "Houston (DWH)"
  },
  {
    "value": "DXR",
    "label": "Danbury (DXR)"
  },
  {
    "value": "DYL",
    "label": "Doylestown (DYL)"
  },
  {
    "value": "DYS",
    "label": "Abilene (DYS)"
  },
  {
    "value": "JJM",
    "label": "Meru-Kinna (JJM)"
  },
  {
    "value": "VPG",
    "label": "Vipingo Estate (VPG)"
  },
  {
    "value": "KRV",
    "label": "Kimwarer (KRV)"
  },
  {
    "value": "KIU",
    "label": "Kiunga (KIU)"
  },
  {
    "value": "LBK",
    "label": "Liboi (LBK)"
  },
  {
    "value": "LBN",
    "label": "Lake Baringo (LBN)"
  },
  {
    "value": "LKU",
    "label": "Lake Rudolf (LKU)"
  },
  {
    "value": "MUM",
    "label": "Mumias (MUM)"
  },
  {
    "value": "CCG",
    "label": "Crane (CCG)"
  },
  {
    "value": "BGQ",
    "label": "Big Lake (BGQ)"
  },
  {
    "value": "BGT",
    "label": "Bagdad (BGT)"
  },
  {
    "value": "EAR",
    "label": "Kearney (EAR)"
  },
  {
    "value": "EAU",
    "label": "Eau Claire (EAU)"
  },
  {
    "value": "EBS",
    "label": "Webster City (EBS)"
  },
  {
    "value": "ECG",
    "label": "Elizabeth City (ECG)"
  },
  {
    "value": "ECP",
    "label": "Panama City Beach (ECP)"
  },
  {
    "value": "EEN",
    "label": "Keene (EEN)"
  },
  {
    "value": "EGE",
    "label": "Eagle (EGE)"
  },
  {
    "value": "KEK",
    "label": "Ekwok (KEK)"
  },
  {
    "value": "EKO",
    "label": "Elko (EKO)"
  },
  {
    "value": "ELD",
    "label": "El Dorado (ELD)"
  },
  {
    "value": "ELM",
    "label": "Elmira/Corning (ELM)"
  },
  {
    "value": "ELP",
    "label": "El Paso (ELP)"
  },
  {
    "value": "END",
    "label": "Enid (END)"
  },
  {
    "value": "ERI",
    "label": "Erie (ERI)"
  },
  {
    "value": "EUG",
    "label": "Eugene (EUG)"
  },
  {
    "value": "EVV",
    "label": "Evansville (EVV)"
  },
  {
    "value": "EVW",
    "label": "Evanston (EVW)"
  },
  {
    "value": "EWB",
    "label": "New Bedford (EWB)"
  },
  {
    "value": "EWK",
    "label": "Newton (EWK)"
  },
  {
    "value": "EWN",
    "label": "New Bern (EWN)"
  },
  {
    "value": "EWR",
    "label": "Newark (EWR)"
  },
  {
    "value": "KEX",
    "label": "Kanabea Airport (KEX)"
  },
  {
    "value": "EYW",
    "label": "Key West (EYW)"
  },
  {
    "value": "FAR",
    "label": "Fargo (FAR)"
  },
  {
    "value": "FAT",
    "label": "Fresno (FAT)"
  },
  {
    "value": "FAY",
    "label": "Fayetteville (FAY)"
  },
  {
    "value": "FBG",
    "label": "Fort Bragg (FBG)"
  },
  {
    "value": "FCS",
    "label": "Fort Carson (FCS)"
  },
  {
    "value": "KFE",
    "label": "Cloudbreak Village (KFE)"
  },
  {
    "value": "FRD",
    "label": "Friday Harbor (FRD)"
  },
  {
    "value": "FHU",
    "label": "Fort Huachuca Sierra Vista (FHU)"
  },
  {
    "value": "FLG",
    "label": "Flagstaff (FLG)"
  },
  {
    "value": "FLL",
    "label": "Fort Lauderdale (FLL)"
  },
  {
    "value": "FLO",
    "label": "Florence (FLO)"
  },
  {
    "value": "FNT",
    "label": "Flint (FNT)"
  },
  {
    "value": "FOD",
    "label": "Fort Dodge (FOD)"
  },
  {
    "value": "FOE",
    "label": "Topeka (FOE)"
  },
  {
    "value": "FIL",
    "label": "Fillmore (FIL)"
  },
  {
    "value": "FPR",
    "label": "Fort Pierce (FPR)"
  },
  {
    "value": "FRH",
    "label": "French Lick (FRH)"
  },
  {
    "value": "FRI",
    "label": "Fort Riley(Junction City) (FRI)"
  },
  {
    "value": "FRM",
    "label": "Fairmont (FRM)"
  },
  {
    "value": "FSD",
    "label": "Sioux Falls (FSD)"
  },
  {
    "value": "FSM",
    "label": "Fort Smith (FSM)"
  },
  {
    "value": "FMS",
    "label": "Fort Madison (FMS)"
  },
  {
    "value": "FTW",
    "label": "Fort Worth (FTW)"
  },
  {
    "value": "FWA",
    "label": "Fort Wayne (FWA)"
  },
  {
    "value": "FYV",
    "label": "Fayetteville (FYV)"
  },
  {
    "value": "GAG",
    "label": "Gage (GAG)"
  },
  {
    "value": "GCK",
    "label": "Garden City (GCK)"
  },
  {
    "value": "GCN",
    "label": "Grand Canyon (GCN)"
  },
  {
    "value": "GEG",
    "label": "Spokane (GEG)"
  },
  {
    "value": "GFK",
    "label": "Grand Forks (GFK)"
  },
  {
    "value": "GGG",
    "label": "Longview (GGG)"
  },
  {
    "value": "GGW",
    "label": "Glasgow (GGW)"
  },
  {
    "value": "GJT",
    "label": "Grand Junction (GJT)"
  },
  {
    "value": "GLH",
    "label": "Greenville (GLH)"
  },
  {
    "value": "GLS",
    "label": "Galveston (GLS)"
  },
  {
    "value": "GNV",
    "label": "Gainesville (GNV)"
  },
  {
    "value": "GON",
    "label": "Groton (New London) (GON)"
  },
  {
    "value": "FCA",
    "label": "Kalispell (FCA)"
  },
  {
    "value": "GPT",
    "label": "Gulfport (GPT)"
  },
  {
    "value": "GRB",
    "label": "Green Bay (GRB)"
  },
  {
    "value": "GRI",
    "label": "Grand Island (GRI)"
  },
  {
    "value": "GRK",
    "label": "Fort Hood/Killeen (GRK)"
  },
  {
    "value": "GRR",
    "label": "Grand Rapids (GRR)"
  },
  {
    "value": "GSO",
    "label": "Greensboro (GSO)"
  },
  {
    "value": "GSP",
    "label": "Greenville (GSP)"
  },
  {
    "value": "GTF",
    "label": "Great Falls (GTF)"
  },
  {
    "value": "GUP",
    "label": "Gallup (GUP)"
  },
  {
    "value": "GVT",
    "label": "Greenville (GVT)"
  },
  {
    "value": "KGW",
    "label": "Kagi (KGW)"
  },
  {
    "value": "GYY",
    "label": "Gary (GYY)"
  },
  {
    "value": "HGR",
    "label": "Hagerstown (HGR)"
  },
  {
    "value": "HIB",
    "label": "Hibbing (HIB)"
  },
  {
    "value": "HKY",
    "label": "Hickory (HKY)"
  },
  {
    "value": "HLN",
    "label": "Helena (HLN)"
  },
  {
    "value": "HON",
    "label": "Huron (HON)"
  },
  {
    "value": "HOT",
    "label": "Hot Springs (HOT)"
  },
  {
    "value": "HOU",
    "label": "Houston (HOU)"
  },
  {
    "value": "HPN",
    "label": "White Plains (HPN)"
  },
  {
    "value": "HRL",
    "label": "Harlingen (HRL)"
  },
  {
    "value": "HRO",
    "label": "Harrison (HRO)"
  },
  {
    "value": "HNC",
    "label": "Hatteras (HNC)"
  },
  {
    "value": "HSV",
    "label": "Huntsville (HSV)"
  },
  {
    "value": "HTS",
    "label": "Huntington (HTS)"
  },
  {
    "value": "HUF",
    "label": "Terre Haute (HUF)"
  },
  {
    "value": "HVN",
    "label": "New Haven (HVN)"
  },
  {
    "value": "HYA",
    "label": "Hyannis (HYA)"
  },
  {
    "value": "IAB",
    "label": "Wichita (IAB)"
  },
  {
    "value": "IAD",
    "label": "Washington (IAD)"
  },
  {
    "value": "IAG",
    "label": "Niagara Falls (IAG)"
  },
  {
    "value": "IAH",
    "label": "Houston (IAH)"
  },
  {
    "value": "ICT",
    "label": "Wichita (ICT)"
  },
  {
    "value": "IDA",
    "label": "Idaho Falls (IDA)"
  },
  {
    "value": "XPR",
    "label": "Pine Ridge (XPR)"
  },
  {
    "value": "IFP",
    "label": "Bullhead City (IFP)"
  },
  {
    "value": "IGM",
    "label": "Kingman (IGM)"
  },
  {
    "value": "ILG",
    "label": "Wilmington (ILG)"
  },
  {
    "value": "ILM",
    "label": "Wilmington (ILM)"
  },
  {
    "value": "IND",
    "label": "Indianapolis (IND)"
  },
  {
    "value": "INL",
    "label": "International Falls (INL)"
  },
  {
    "value": "INT",
    "label": "Winston Salem (INT)"
  },
  {
    "value": "IPT",
    "label": "Williamsport (IPT)"
  },
  {
    "value": "KIQ",
    "label": "Kira Airport (KIQ)"
  },
  {
    "value": "IRK",
    "label": "Kirksville (IRK)"
  },
  {
    "value": "ISP",
    "label": "Islip (ISP)"
  },
  {
    "value": "ITH",
    "label": "Ithaca (ITH)"
  },
  {
    "value": "AZA",
    "label": "Phoenix (AZA)"
  },
  {
    "value": "JAC",
    "label": "Jackson (JAC)"
  },
  {
    "value": "JAN",
    "label": "Jackson (JAN)"
  },
  {
    "value": "JAX",
    "label": "Jacksonville (JAX)"
  },
  {
    "value": "JBR",
    "label": "Jonesboro (JBR)"
  },
  {
    "value": "JFK",
    "label": "New York (JFK)"
  },
  {
    "value": "JLN",
    "label": "Joplin (JLN)"
  },
  {
    "value": "JMS",
    "label": "Jamestown (JMS)"
  },
  {
    "value": "JST",
    "label": "Johnstown (JST)"
  },
  {
    "value": "BXS",
    "label": "Borrego Springs (BXS)"
  },
  {
    "value": "LAF",
    "label": "Lafayette (LAF)"
  },
  {
    "value": "LAN",
    "label": "Lansing (LAN)"
  },
  {
    "value": "LAR",
    "label": "Laramie (LAR)"
  },
  {
    "value": "LAS",
    "label": "Las Vegas (LAS)"
  },
  {
    "value": "LAX",
    "label": "Los Angeles (LAX)"
  },
  {
    "value": "LBB",
    "label": "Lubbock (LBB)"
  },
  {
    "value": "LBE",
    "label": "Latrobe (LBE)"
  },
  {
    "value": "LBF",
    "label": "North Platte (LBF)"
  },
  {
    "value": "LBL",
    "label": "Liberal (LBL)"
  },
  {
    "value": "LCH",
    "label": "Lake Charles (LCH)"
  },
  {
    "value": "LEB",
    "label": "Lebanon (LEB)"
  },
  {
    "value": "LEX",
    "label": "Lexington (LEX)"
  },
  {
    "value": "LFT",
    "label": "Lafayette (LFT)"
  },
  {
    "value": "LGA",
    "label": "New York (LGA)"
  },
  {
    "value": "LGB",
    "label": "Long Beach (LGB)"
  },
  {
    "value": "LIT",
    "label": "Little Rock (LIT)"
  },
  {
    "value": "LMT",
    "label": "Klamath Falls (LMT)"
  },
  {
    "value": "LNK",
    "label": "Lincoln (LNK)"
  },
  {
    "value": "LNS",
    "label": "Lancaster (LNS)"
  },
  {
    "value": "BBX",
    "label": "Philadelphia (BBX)"
  },
  {
    "value": "LRD",
    "label": "Laredo (LRD)"
  },
  {
    "value": "LRU",
    "label": "Las Cruces (LRU)"
  },
  {
    "value": "LUK",
    "label": "Cincinnati (LUK)"
  },
  {
    "value": "LWS",
    "label": "Lewiston (LWS)"
  },
  {
    "value": "LWT",
    "label": "Lewistown (LWT)"
  },
  {
    "value": "LYH",
    "label": "Lynchburg (LYH)"
  },
  {
    "value": "MAF",
    "label": "Midland (MAF)"
  },
  {
    "value": "KMB",
    "label": "Koinambe Airport (KMB)"
  },
  {
    "value": "MBS",
    "label": "Saginaw (MBS)"
  },
  {
    "value": "MCE",
    "label": "Merced (MCE)"
  },
  {
    "value": "MCI",
    "label": "Kansas City (MCI)"
  },
  {
    "value": "MCN",
    "label": "Macon (MCN)"
  },
  {
    "value": "MCO",
    "label": "Orlando (MCO)"
  },
  {
    "value": "MDH",
    "label": "Carbondale/Murphysboro (MDH)"
  },
  {
    "value": "MDT",
    "label": "Harrisburg (MDT)"
  },
  {
    "value": "MDW",
    "label": "Chicago (MDW)"
  },
  {
    "value": "MEI",
    "label": "Meridian (MEI)"
  },
  {
    "value": "MEM",
    "label": "Memphis (MEM)"
  },
  {
    "value": "KMF",
    "label": "Hoieti (KMF)"
  },
  {
    "value": "MFE",
    "label": "Mc Allen (MFE)"
  },
  {
    "value": "MFR",
    "label": "Medford (MFR)"
  },
  {
    "value": "MGM",
    "label": "Montgomery (MGM)"
  },
  {
    "value": "MGW",
    "label": "Morgantown (MGW)"
  },
  {
    "value": "MHK",
    "label": "Manhattan (MHK)"
  },
  {
    "value": "MHT",
    "label": "Manchester (MHT)"
  },
  {
    "value": "MIA",
    "label": "Miami (MIA)"
  },
  {
    "value": "MIE",
    "label": "Muncie (MIE)"
  },
  {
    "value": "MKC",
    "label": "Kansas City (MKC)"
  },
  {
    "value": "MKE",
    "label": "Milwaukee (MKE)"
  },
  {
    "value": "MKG",
    "label": "Muskegon (MKG)"
  },
  {
    "value": "MKL",
    "label": "Jackson (MKL)"
  },
  {
    "value": "MLB",
    "label": "Melbourne (MLB)"
  },
  {
    "value": "MLI",
    "label": "Moline (MLI)"
  },
  {
    "value": "MLS",
    "label": "Miles City (MLS)"
  },
  {
    "value": "MLU",
    "label": "Monroe (MLU)"
  },
  {
    "value": "MMU",
    "label": "Morristown (MMU)"
  },
  {
    "value": "MOB",
    "label": "Mobile (MOB)"
  },
  {
    "value": "MOD",
    "label": "Modesto (MOD)"
  },
  {
    "value": "MOT",
    "label": "Minot (MOT)"
  },
  {
    "value": "MRY",
    "label": "Monterey (MRY)"
  },
  {
    "value": "MSL",
    "label": "Muscle Shoals (MSL)"
  },
  {
    "value": "MSN",
    "label": "Madison (MSN)"
  },
  {
    "value": "MSO",
    "label": "Missoula (MSO)"
  },
  {
    "value": "MSP",
    "label": "Minneapolis (MSP)"
  },
  {
    "value": "MSS",
    "label": "Massena (MSS)"
  },
  {
    "value": "MSY",
    "label": "New Orleans (MSY)"
  },
  {
    "value": "MVY",
    "label": "Martha's Vineyard (MVY)"
  },
  {
    "value": "MYR",
    "label": "Myrtle Beach (MYR)"
  },
  {
    "value": "DGN",
    "label": "Dahlgren (DGN)"
  },
  {
    "value": "NEL",
    "label": "Lakehurst (NEL)"
  },
  {
    "value": "KNO",
    "label": "new york airport (KNO)"
  },
  {
    "value": "YUM",
    "label": "Yuma (YUM)"
  },
  {
    "value": "NVN",
    "label": "Beckwourth (NVN)"
  },
  {
    "value": "ODC",
    "label": "Oakdale (ODC)"
  },
  {
    "value": "EYR",
    "label": "Yerington (EYR)"
  },
  {
    "value": "OAK",
    "label": "Oakland (OAK)"
  },
  {
    "value": "OAR",
    "label": "Marina (OAR)"
  },
  {
    "value": "OKC",
    "label": "Oklahoma City (OKC)"
  },
  {
    "value": "OLD",
    "label": "Old Town (OLD)"
  },
  {
    "value": "OLM",
    "label": "Olympia (OLM)"
  },
  {
    "value": "OMA",
    "label": "Omaha (OMA)"
  },
  {
    "value": "ONT",
    "label": "Ontario (ONT)"
  },
  {
    "value": "KOR",
    "label": "Kakoro (KOR)"
  },
  {
    "value": "ORD",
    "label": "Chicago (ORD)"
  },
  {
    "value": "ORF",
    "label": "Norfolk (ORF)"
  },
  {
    "value": "ORH",
    "label": "Worcester (ORH)"
  },
  {
    "value": "OSH",
    "label": "Oshkosh (OSH)"
  },
  {
    "value": "OTH",
    "label": "North Bend (OTH)"
  },
  {
    "value": "OTM",
    "label": "Ottumwa (OTM)"
  },
  {
    "value": "OWB",
    "label": "Owensboro (OWB)"
  },
  {
    "value": "DSO",
    "label": "Sondok Airport (DSO)"
  },
  {
    "value": "BSQ",
    "label": "Bisbee (BSQ)"
  },
  {
    "value": "HBK",
    "label": "Holbrook (HBK)"
  },
  {
    "value": "CWX",
    "label": "Willcox (CWX)"
  },
  {
    "value": "PAE",
    "label": "Everett (PAE)"
  },
  {
    "value": "PAH",
    "label": "Paducah (PAH)"
  },
  {
    "value": "PBG",
    "label": "Plattsburgh (PBG)"
  },
  {
    "value": "PBI",
    "label": "West Palm Beach (PBI)"
  },
  {
    "value": "PCA",
    "label": "Picacho (PCA)"
  },
  {
    "value": "PDK",
    "label": "Atlanta (PDK)"
  },
  {
    "value": "PDX",
    "label": "Portland (PDX)"
  },
  {
    "value": "KPE",
    "label": "Yapsiei Airport (KPE)"
  },
  {
    "value": "PFN",
    "label": "Panama City (PFN)"
  },
  {
    "value": "PHF",
    "label": "Newport News (PHF)"
  },
  {
    "value": "ADR",
    "label": "Andrews (ADR)"
  },
  {
    "value": "PHL",
    "label": "Philadelphia (PHL)"
  },
  {
    "value": "PHX",
    "label": "Phoenix (PHX)"
  },
  {
    "value": "PIA",
    "label": "Peoria (PIA)"
  },
  {
    "value": "PIB",
    "label": "Hattiesburg/Laurel (PIB)"
  },
  {
    "value": "PIE",
    "label": "St Petersburg-Clearwater (PIE)"
  },
  {
    "value": "PIH",
    "label": "Pocatello (PIH)"
  },
  {
    "value": "PIR",
    "label": "Pierre (PIR)"
  },
  {
    "value": "PIT",
    "label": "Pittsburgh (PIT)"
  },
  {
    "value": "PKB",
    "label": "Parkersburg (PKB)"
  },
  {
    "value": "PLN",
    "label": "Pellston (PLN)"
  },
  {
    "value": "PMD",
    "label": "Palmdale (PMD)"
  },
  {
    "value": "PNS",
    "label": "Pensacola (PNS)"
  },
  {
    "value": "POU",
    "label": "Poughkeepsie (POU)"
  },
  {
    "value": "PQI",
    "label": "Presque Isle (PQI)"
  },
  {
    "value": "PRC",
    "label": "Prescott (PRC)"
  },
  {
    "value": "PSC",
    "label": "Pasco (PSC)"
  },
  {
    "value": "PSM",
    "label": "Portsmouth (PSM)"
  },
  {
    "value": "PSP",
    "label": "Palm Springs (PSP)"
  },
  {
    "value": "PUB",
    "label": "Pueblo (PUB)"
  },
  {
    "value": "PUW",
    "label": "Pullman/Moscow,Id (PUW)"
  },
  {
    "value": "PVD",
    "label": "Providence (PVD)"
  },
  {
    "value": "PWM",
    "label": "Portland (PWM)"
  },
  {
    "value": "PWT",
    "label": "Bremerton (PWT)"
  },
  {
    "value": "KQA",
    "label": "Akutan (KQA)"
  },
  {
    "value": "KQL",
    "label": "Kol Airport (KQL)"
  },
  {
    "value": "RAP",
    "label": "Rapid City (RAP)"
  },
  {
    "value": "RDD",
    "label": "Redding (RDD)"
  },
  {
    "value": "RDG",
    "label": "Reading (RDG)"
  },
  {
    "value": "RDM",
    "label": "Redmond (RDM)"
  },
  {
    "value": "RDU",
    "label": "Raleigh/Durham (RDU)"
  },
  {
    "value": "RFD",
    "label": "Chicago/Rockford (RFD)"
  },
  {
    "value": "RHI",
    "label": "Rhinelander (RHI)"
  },
  {
    "value": "RIC",
    "label": "Richmond (RIC)"
  },
  {
    "value": "KRJ",
    "label": "Karawari Airstrip (KRJ)"
  },
  {
    "value": "RKS",
    "label": "Rock Springs (RKS)"
  },
  {
    "value": "RNO",
    "label": "Reno (RNO)"
  },
  {
    "value": "ROA",
    "label": "Roanoke (ROA)"
  },
  {
    "value": "ROC",
    "label": "Rochester (ROC)"
  },
  {
    "value": "ROW",
    "label": "Roswell (ROW)"
  },
  {
    "value": "RQO",
    "label": "El Reno (RQO)"
  },
  {
    "value": "RST",
    "label": "Rochester (RST)"
  },
  {
    "value": "RSW",
    "label": "Fort Myers (RSW)"
  },
  {
    "value": "RUT",
    "label": "Rutland (RUT)"
  },
  {
    "value": "RWI",
    "label": "Rocky Mount (RWI)"
  },
  {
    "value": "AHM",
    "label": "Ashland (AHM)"
  },
  {
    "value": "BDY",
    "label": "Bandon (BDY)"
  },
  {
    "value": "SUO",
    "label": "Sunriver (SUO)"
  },
  {
    "value": "IDH",
    "label": "Grangeville (IDH)"
  },
  {
    "value": "VSK",
    "label": "Kennewick (VSK)"
  },
  {
    "value": "SAN",
    "label": "San Diego (SAN)"
  },
  {
    "value": "SAT",
    "label": "San Antonio (SAT)"
  },
  {
    "value": "SBA",
    "label": "Santa Barbara (SBA)"
  },
  {
    "value": "SBN",
    "label": "South Bend (SBN)"
  },
  {
    "value": "SBP",
    "label": "San Luis Obispo (SBP)"
  },
  {
    "value": "SBY",
    "label": "Salisbury (SBY)"
  },
  {
    "value": "SDF",
    "label": "Louisville (SDF)"
  },
  {
    "value": "SEA",
    "label": "Seattle (SEA)"
  },
  {
    "value": "SFB",
    "label": "Orlando (SFB)"
  },
  {
    "value": "SFO",
    "label": "San Francisco (SFO)"
  },
  {
    "value": "SGF",
    "label": "Springfield (SGF)"
  },
  {
    "value": "SHD",
    "label": "Staunton/Waynesboro/Harrisonburg (SHD)"
  },
  {
    "value": "SHR",
    "label": "Sheridan (SHR)"
  },
  {
    "value": "SHV",
    "label": "Shreveport (SHV)"
  },
  {
    "value": "SJC",
    "label": "San Jose (SJC)"
  },
  {
    "value": "SJT",
    "label": "San Angelo (SJT)"
  },
  {
    "value": "SLC",
    "label": "Salt Lake City (SLC)"
  },
  {
    "value": "SLK",
    "label": "Saranac Lake (SLK)"
  },
  {
    "value": "SLN",
    "label": "Salina (SLN)"
  },
  {
    "value": "SMF",
    "label": "Sacramento (SMF)"
  },
  {
    "value": "SMX",
    "label": "Santa Maria (SMX)"
  },
  {
    "value": "SNA",
    "label": "Santa Ana (SNA)"
  },
  {
    "value": "SPI",
    "label": "Springfield (SPI)"
  },
  {
    "value": "SPS",
    "label": "Wichita Falls (SPS)"
  },
  {
    "value": "SRQ",
    "label": "Sarasota/Bradenton (SRQ)"
  },
  {
    "value": "STC",
    "label": "St Cloud (STC)"
  },
  {
    "value": "STL",
    "label": "St Louis (STL)"
  },
  {
    "value": "STP",
    "label": "St Paul (STP)"
  },
  {
    "value": "SUN",
    "label": "Hailey (SUN)"
  },
  {
    "value": "SUX",
    "label": "Sioux City (SUX)"
  },
  {
    "value": "SVC",
    "label": "Silver City (SVC)"
  },
  {
    "value": "SWF",
    "label": "Newburgh (SWF)"
  },
  {
    "value": "SYR",
    "label": "Syracuse (SYR)"
  },
  {
    "value": "TBN",
    "label": "Fort Leonard Wood (TBN)"
  },
  {
    "value": "TCL",
    "label": "Tuscaloosa (TCL)"
  },
  {
    "value": "TLH",
    "label": "Tallahassee (TLH)"
  },
  {
    "value": "OTK",
    "label": "Tillamook (OTK)"
  },
  {
    "value": "TOL",
    "label": "Toledo (TOL)"
  },
  {
    "value": "TPA",
    "label": "Tampa (TPA)"
  },
  {
    "value": "TPL",
    "label": "Temple (TPL)"
  },
  {
    "value": "TRI",
    "label": "Bristol/Johnson/Kingsport (TRI)"
  },
  {
    "value": "TTN",
    "label": "Trenton (TTN)"
  },
  {
    "value": "TUL",
    "label": "Tulsa (TUL)"
  },
  {
    "value": "TUP",
    "label": "Tupelo (TUP)"
  },
  {
    "value": "TUS",
    "label": "Tucson (TUS)"
  },
  {
    "value": "TVC",
    "label": "Traverse City (TVC)"
  },
  {
    "value": "TVL",
    "label": "South Lake Tahoe (TVL)"
  },
  {
    "value": "TWF",
    "label": "Twin Falls (TWF)"
  },
  {
    "value": "TXK",
    "label": "Texarkana (TXK)"
  },
  {
    "value": "TYR",
    "label": "Tyler (TYR)"
  },
  {
    "value": "TYS",
    "label": "Knoxville (TYS)"
  },
  {
    "value": "BFG",
    "label": "Glen Canyon Natl Rec Area (BFG)"
  },
  {
    "value": "RVR",
    "label": "Green River (RVR)"
  },
  {
    "value": "ICS",
    "label": "Cascade (ICS)"
  },
  {
    "value": "UIN",
    "label": "Quincy (UIN)"
  },
  {
    "value": "ATO",
    "label": "Athens/Albany (ATO)"
  },
  {
    "value": "SCE",
    "label": "State College (SCE)"
  },
  {
    "value": "KUX",
    "label": "Kuyol Airport (KUX)"
  },
  {
    "value": "VCT",
    "label": "Victoria (VCT)"
  },
  {
    "value": "VLD",
    "label": "Valdosta (VLD)"
  },
  {
    "value": "VPS",
    "label": "Valparaiso (VPS)"
  },
  {
    "value": "VRB",
    "label": "Vero Beach (VRB)"
  },
  {
    "value": "WRI",
    "label": "Wrightstown (WRI)"
  },
  {
    "value": "WRL",
    "label": "Worland (WRL)"
  },
  {
    "value": "KWY",
    "label": "Kiwayu (KWY)"
  },
  {
    "value": "YIP",
    "label": "Detroit (YIP)"
  },
  {
    "value": "YKM",
    "label": "Yakima (YKM)"
  },
  {
    "value": "YNG",
    "label": "Youngstown/Warren (YNG)"
  },
  {
    "value": "DZN",
    "label": "Dzhezkazgan (DZN)"
  },
  {
    "value": "TDK",
    "label": "Taldy Kurgan (TDK)"
  },
  {
    "value": "ATX",
    "label": "Atbasar (ATX)"
  },
  {
    "value": "KZF",
    "label": "Kaintiba (KZF)"
  },
  {
    "value": "AVX",
    "label": "Avalon (AVX)"
  },
  {
    "value": "LAC",
    "label": "Spratley Islands (LAC)"
  },
  {
    "value": "TIA",
    "label": "Tirana (TIA)"
  },
  {
    "value": "BOJ",
    "label": "Burgas (BOJ)"
  },
  {
    "value": "GOZ",
    "label": "Gorna Oryahovitsa (GOZ)"
  },
  {
    "value": "PDV",
    "label": "Plovdiv (PDV)"
  },
  {
    "value": "PVN",
    "label": "Dolna Mitropoliya (PVN)"
  },
  {
    "value": "SOF",
    "label": "Sofia (SOF)"
  },
  {
    "value": "SLS",
    "label": "Silistra (SLS)"
  },
  {
    "value": "SZR",
    "label": "Stara Zagora (SZR)"
  },
  {
    "value": "VID",
    "label": "Vidin (VID)"
  },
  {
    "value": "VAR",
    "label": "Varna (VAR)"
  },
  {
    "value": "ECN",
    "label": "Nicosia (ECN)"
  },
  {
    "value": "LCA",
    "label": "Larnarca (LCA)"
  },
  {
    "value": "LCP",
    "label": "Loncopue (LCP)"
  },
  {
    "value": "PFO",
    "label": "Paphos (PFO)"
  },
  {
    "value": "AKT",
    "label": "RAF Akrotiri (AKT)"
  },
  {
    "value": "DBV",
    "label": "Dubrovnik (DBV)"
  },
  {
    "value": "LSZ",
    "label": "LoÅ¡inj (LSZ)"
  },
  {
    "value": "OSI",
    "label": "Osijek (OSI)"
  },
  {
    "value": "PUY",
    "label": "Pula (PUY)"
  },
  {
    "value": "RJK",
    "label": "Rijeka (RJK)"
  },
  {
    "value": "BWK",
    "label": "BraÄ Island (BWK)"
  },
  {
    "value": "SPU",
    "label": "Split (SPU)"
  },
  {
    "value": "ZAG",
    "label": "Zagreb (ZAG)"
  },
  {
    "value": "ZAD",
    "label": "Zadar (ZAD)"
  },
  {
    "value": "ABC",
    "label": "Albacete (ABC)"
  },
  {
    "value": "ALC",
    "label": "Alicante (ALC)"
  },
  {
    "value": "LEI",
    "label": "AlmerÃ­a (LEI)"
  },
  {
    "value": "OVD",
    "label": "RanÃ³n (OVD)"
  },
  {
    "value": "ODB",
    "label": "CÃ³rdoba (ODB)"
  },
  {
    "value": "BIO",
    "label": "Bilbao (BIO)"
  },
  {
    "value": "RGS",
    "label": "Burgos (RGS)"
  },
  {
    "value": "BCN",
    "label": "Barcelona (BCN)"
  },
  {
    "value": "BJZ",
    "label": "Badajoz (BJZ)"
  },
  {
    "value": "CDT",
    "label": "CastellÃ³n de La Plana (CDT)"
  },
  {
    "value": "LCG",
    "label": "Culleredo (LCG)"
  },
  {
    "value": "ECV",
    "label": "Madrid (ECV)"
  },
  {
    "value": "GRO",
    "label": "Girona (GRO)"
  },
  {
    "value": "GRX",
    "label": "Granada (GRX)"
  },
  {
    "value": "IBZ",
    "label": "Ibiza (IBZ)"
  },
  {
    "value": "XRY",
    "label": "Jerez de la Forntera (XRY)"
  },
  {
    "value": "MJV",
    "label": "San Javier (MJV)"
  },
  {
    "value": "QSA",
    "label": "Sabadell (QSA)"
  },
  {
    "value": "LEN",
    "label": "LeÃ³n (LEN)"
  },
  {
    "value": "RJL",
    "label": "LogroÃ±o (RJL)"
  },
  {
    "value": "MAD",
    "label": "Madrid (MAD)"
  },
  {
    "value": "HEV",
    "label": "GibraleÃ³n (HEV)"
  },
  {
    "value": "AGP",
    "label": "MÃ¡laga (AGP)"
  },
  {
    "value": "MAH",
    "label": "Menorca Island (MAH)"
  },
  {
    "value": "OZP",
    "label": "MorÃ³n (OZP)"
  },
  {
    "value": "PMI",
    "label": "Palma De Mallorca (PMI)"
  },
  {
    "value": "PNA",
    "label": "Pamplona (PNA)"
  },
  {
    "value": "REU",
    "label": "Reus (REU)"
  },
  {
    "value": "SLM",
    "label": "Salamanca (SLM)"
  },
  {
    "value": "EAS",
    "label": "Hondarribia (EAS)"
  },
  {
    "value": "SCQ",
    "label": "Santiago de Compostela (SCQ)"
  },
  {
    "value": "LEU",
    "label": "Montferrer / CastellbÃ² (LEU)"
  },
  {
    "value": "TOJ",
    "label": "Madrid (TOJ)"
  },
  {
    "value": "VLC",
    "label": "Valencia (VLC)"
  },
  {
    "value": "VLL",
    "label": "Valladolid (VLL)"
  },
  {
    "value": "VIT",
    "label": "Alava (VIT)"
  },
  {
    "value": "VGO",
    "label": "Vigo (VGO)"
  },
  {
    "value": "SDR",
    "label": "Santander (SDR)"
  },
  {
    "value": "ZAZ",
    "label": "Zaragoza (ZAZ)"
  },
  {
    "value": "SVQ",
    "label": "Sevilla (SVQ)"
  },
  {
    "value": "DPE",
    "label": "Dieppe (DPE)"
  },
  {
    "value": "CQF",
    "label": "Calais/Dunkerque (CQF)"
  },
  {
    "value": "XCP",
    "label": "Calais-Dunkerque (XCP)"
  },
  {
    "value": "XLN",
    "label": "Calais-Dunkerque (XLN)"
  },
  {
    "value": "XSJ",
    "label": "PÃ©ronne/Saint-Quentin (XSJ)"
  },
  {
    "value": "XDK",
    "label": "Calais-Dunkerque (XDK)"
  },
  {
    "value": "BYF",
    "label": "Albert/Bray (BYF)"
  },
  {
    "value": "LTQ",
    "label": "Le Touquet-Paris-Plage (LTQ)"
  },
  {
    "value": "XVS",
    "label": "Valenciennes/Denain (XVS)"
  },
  {
    "value": "QAM",
    "label": "Amiens/Glisy (QAM)"
  },
  {
    "value": "AGF",
    "label": "Agen/La Garenne (AGF)"
  },
  {
    "value": "BOD",
    "label": "Bordeaux/MÃ©rignac (BOD)"
  },
  {
    "value": "EGC",
    "label": "Bergerac/RoumaniÃ¨re (EGC)"
  },
  {
    "value": "CNG",
    "label": "Cognac/ChÃ¢teaubernard (CNG)"
  },
  {
    "value": "LRH",
    "label": "La Rochelle/ÃŽle de RÃ© (LRH)"
  },
  {
    "value": "PIS",
    "label": "Poitiers/Biard (PIS)"
  },
  {
    "value": "MCU",
    "label": "MontluÃ§on/GuÃ©ret (MCU)"
  },
  {
    "value": "LIG",
    "label": "Limoges/Bellegarde (LIG)"
  },
  {
    "value": "XMJ",
    "label": "Mont-de-Marsan (XMJ)"
  },
  {
    "value": "NIT",
    "label": "Niort/SouchÃ© (NIT)"
  },
  {
    "value": "TLS",
    "label": "Toulouse/Blagnac (TLS)"
  },
  {
    "value": "PUF",
    "label": "Pau/PyrÃ©nÃ©es (Uzein) (PUF)"
  },
  {
    "value": "LDE",
    "label": "Tarbes/Lourdes/PyrÃ©nÃ©es (LDE)"
  },
  {
    "value": "ANG",
    "label": "AngoulÃªme/Brie/Champniers (ANG)"
  },
  {
    "value": "BVE",
    "label": "Brive-la-Gaillarde (BVE)"
  },
  {
    "value": "PGX",
    "label": "PÃ©rigueux/Bassillac (PGX)"
  },
  {
    "value": "XDA",
    "label": "Perigueux (XDA)"
  },
  {
    "value": "BIQ",
    "label": "Biarritz/Anglet/Bayonne (BIQ)"
  },
  {
    "value": "XCX",
    "label": "Biarritz (XCX)"
  },
  {
    "value": "ZAO",
    "label": "Cahors/Lalbenque (ZAO)"
  },
  {
    "value": "XGT",
    "label": "Cahors (XGT)"
  },
  {
    "value": "XAC",
    "label": "Arcachon/La Teste-de-Buch (XAC)"
  },
  {
    "value": "LBI",
    "label": "Albi/Le SÃ©questre (LBI)"
  },
  {
    "value": "DCM",
    "label": "Castres/Mazamet (DCM)"
  },
  {
    "value": "RDZ",
    "label": "Rodez/Marcillac (RDZ)"
  },
  {
    "value": "RYN",
    "label": "Royan/MÃ©dis (RYN)"
  },
  {
    "value": "XMW",
    "label": "Montauban (XMW)"
  },
  {
    "value": "XLR",
    "label": "Libourne/Artigues-de-Lussac (XLR)"
  },
  {
    "value": "RCO",
    "label": "Rochefort/Saint-Agnant (RCO)"
  },
  {
    "value": "XSL",
    "label": "Rochefort (XSL)"
  },
  {
    "value": "XTB",
    "label": "Rochefort (XTB)"
  },
  {
    "value": "IDY",
    "label": "ÃŽle d'Yeu (IDY)"
  },
  {
    "value": "CMR",
    "label": "Colmar/Houssen (CMR)"
  },
  {
    "value": "XBV",
    "label": "Beaune/Challanges (XBV)"
  },
  {
    "value": "DLE",
    "label": "Dole/Tavaux (DLE)"
  },
  {
    "value": "XVN",
    "label": "Verdun/Le Rozelier (XVN)"
  },
  {
    "value": "MVV",
    "label": "Verdun (MVV)"
  },
  {
    "value": "OBS",
    "label": "Aubenas/ArdÃ¨che MÃ©ridional (OBS)"
  },
  {
    "value": "LPY",
    "label": "Le Puy/Loudes (LPY)"
  },
  {
    "value": "AHZ",
    "label": "Bourg (AHZ)"
  },
  {
    "value": "ETZ",
    "label": "Metz / Nancy (ETZ)"
  },
  {
    "value": "ANE",
    "label": "Angers/MarcÃ© (ANE)"
  },
  {
    "value": "BIA",
    "label": "Bastia/Poretta (BIA)"
  },
  {
    "value": "CLY",
    "label": "Calvi/Sainte-Catherine (CLY)"
  },
  {
    "value": "FSC",
    "label": "Figari Sud-Corse (FSC)"
  },
  {
    "value": "AJA",
    "label": "Ajaccio/NapolÃ©on Bonaparte (AJA)"
  },
  {
    "value": "PRP",
    "label": "Propriano (PRP)"
  },
  {
    "value": "SOZ",
    "label": "Solenzara (SOZ)"
  },
  {
    "value": "MFX",
    "label": "Ajaccio (MFX)"
  },
  {
    "value": "AUF",
    "label": "Auxerre/Branches (AUF)"
  },
  {
    "value": "CMF",
    "label": "ChambÃ©ry/Aix-les-Bains (CMF)"
  },
  {
    "value": "CFE",
    "label": "Clermont-Ferrand/Auvergne (CFE)"
  },
  {
    "value": "BOU",
    "label": "Bourges (BOU)"
  },
  {
    "value": "QNJ",
    "label": "Annemasse (QNJ)"
  },
  {
    "value": "CVF",
    "label": "Courcheval (CVF)"
  },
  {
    "value": "LYS",
    "label": "Lyon (LYS)"
  },
  {
    "value": "QNX",
    "label": "MÃ¢con/Charnay (QNX)"
  },
  {
    "value": "SYT",
    "label": "Saint-Yan (SYT)"
  },
  {
    "value": "RNE",
    "label": "Roanne/Renaison (RNE)"
  },
  {
    "value": "NCY",
    "label": "Annecy/Meythet (NCY)"
  },
  {
    "value": "XMK",
    "label": "Annecy (XMK)"
  },
  {
    "value": "GNB",
    "label": "Grenoble/Saint-Geoirs (GNB)"
  },
  {
    "value": "VAF",
    "label": "Valence/Chabeuil (VAF)"
  },
  {
    "value": "VHY",
    "label": "Vichy/Charmeil (VHY)"
  },
  {
    "value": "AUR",
    "label": "Aurillac (AUR)"
  },
  {
    "value": "CHR",
    "label": "ChÃ¢teauroux/DÃ©ols (CHR)"
  },
  {
    "value": "LYN",
    "label": "Lyon/Bron (LYN)"
  },
  {
    "value": "CEQ",
    "label": "Cannes/Mandelieu (CEQ)"
  },
  {
    "value": "EBU",
    "label": "Saint-Ã‰tienne/BouthÃ©on (EBU)"
  },
  {
    "value": "QIE",
    "label": "Istres/Le TubÃ© (QIE)"
  },
  {
    "value": "CCF",
    "label": "Carcassonne/Salvaza (CCF)"
  },
  {
    "value": "MRS",
    "label": "Marseille (MRS)"
  },
  {
    "value": "NCE",
    "label": "Nice (NCE)"
  },
  {
    "value": "XOG",
    "label": "Orange/Caritat (XOG)"
  },
  {
    "value": "PGF",
    "label": "Perpignan/Rivesaltes (PGF)"
  },
  {
    "value": "CTT",
    "label": "Le Castellet (CTT)"
  },
  {
    "value": "BAE",
    "label": "Le Castellet (BAE)"
  },
  {
    "value": "XAS",
    "label": "AlÃ¨s/Deaux (XAS)"
  },
  {
    "value": "MPL",
    "label": "Montpellier/MÃ©diterranÃ©e (MPL)"
  },
  {
    "value": "BZR",
    "label": "BÃ©ziers/Vias (BZR)"
  },
  {
    "value": "AVN",
    "label": "Avignon/Caumont (AVN)"
  },
  {
    "value": "GAT",
    "label": "Avignon (GAT)"
  },
  {
    "value": "MEN",
    "label": "Mende/BrÃ©noux (MEN)"
  },
  {
    "value": "SCP",
    "label": "Mende (SCP)"
  },
  {
    "value": "BVA",
    "label": "Beauvais/TillÃ© (BVA)"
  },
  {
    "value": "XSU",
    "label": "Saumur/Saint-Florent (XSU)"
  },
  {
    "value": "EVX",
    "label": "Ã‰vreux/Fauville (EVX)"
  },
  {
    "value": "XAN",
    "label": "Evreux (XAN)"
  },
  {
    "value": "LEH",
    "label": "Le Havre/Octeville (LEH)"
  },
  {
    "value": "XAB",
    "label": "Abbeville (Buigny/Saint-Maclou) (XAB)"
  },
  {
    "value": "ORE",
    "label": "OrlÃ©ans/Bricy (ORE)"
  },
  {
    "value": "XCR",
    "label": "ChÃ¢lons/Vatry (XCR)"
  },
  {
    "value": "LSO",
    "label": "Les Sables-d'Olonne (LSO)"
  },
  {
    "value": "URO",
    "label": "Rouen/VallÃ©e de Seine (URO)"
  },
  {
    "value": "XBQ",
    "label": "Blois/Le Breuil (XBQ)"
  },
  {
    "value": "QTJ",
    "label": "Blois (QTJ)"
  },
  {
    "value": "TUF",
    "label": "Tours/Val de Loire (Loire Valley) (TUF)"
  },
  {
    "value": "CET",
    "label": "Cholet/Le Pontreau (CET)"
  },
  {
    "value": "LVA",
    "label": "Laval/Entrammes (LVA)"
  },
  {
    "value": "LBG",
    "label": "Paris (LBG)"
  },
  {
    "value": "CSF",
    "label": "Creil (CSF)"
  },
  {
    "value": "CDG",
    "label": "Paris (CDG)"
  },
  {
    "value": "JDP",
    "label": "Issy-les-Moulineaux (JDP)"
  },
  {
    "value": "TNF",
    "label": "Toussus-le-Noble (TNF)"
  },
  {
    "value": "ORY",
    "label": "Paris (ORY)"
  },
  {
    "value": "POX",
    "label": "Pontoise (POX)"
  },
  {
    "value": "VIY",
    "label": "Villacoublay/VÃ©lizy (VIY)"
  },
  {
    "value": "QYR",
    "label": "Troyes/Barberey (QYR)"
  },
  {
    "value": "NVS",
    "label": "Nevers/Fourchambault (NVS)"
  },
  {
    "value": "XCB",
    "label": "Cambrai/Ã‰pinoy (XCB)"
  },
  {
    "value": "XME",
    "label": "Maubeuge/Ã‰lesmes (XME)"
  },
  {
    "value": "LIL",
    "label": "Lille/Lesquin (LIL)"
  },
  {
    "value": "HZB",
    "label": "Merville/Calonne (HZB)"
  },
  {
    "value": "XCZ",
    "label": "Charleville-MÃ©ziÃ¨res (XCZ)"
  },
  {
    "value": "XVO",
    "label": "Vesoul/Frotey (XVO)"
  },
  {
    "value": "BES",
    "label": "Brest/Guipavas (BES)"
  },
  {
    "value": "CER",
    "label": "Cherbourg/Maupertus (CER)"
  },
  {
    "value": "DNR",
    "label": "Dinard/Pleurtuit/Saint-Malo (DNR)"
  },
  {
    "value": "LBY",
    "label": "La Baule-Escoublac (LBY)"
  },
  {
    "value": "GFR",
    "label": "Granville (GFR)"
  },
  {
    "value": "DOL",
    "label": "Deauville (DOL)"
  },
  {
    "value": "LRT",
    "label": "Lorient/Lann/BihouÃ© (LRT)"
  },
  {
    "value": "EDM",
    "label": "La Roche-sur-Yon/Les Ajoncs (EDM)"
  },
  {
    "value": "LDV",
    "label": "Landivisiau (LDV)"
  },
  {
    "value": "CFR",
    "label": "Caen/Carpiquet (CFR)"
  },
  {
    "value": "LME",
    "label": "Le Mans/Arnage (LME)"
  },
  {
    "value": "RNS",
    "label": "Rennes/Saint-Jacques (RNS)"
  },
  {
    "value": "LAI",
    "label": "Lannion (LAI)"
  },
  {
    "value": "UIP",
    "label": "Quimper/Pluguffan (UIP)"
  },
  {
    "value": "NTE",
    "label": "Nantes (NTE)"
  },
  {
    "value": "SBK",
    "label": "Saint-Brieuc/Armor (SBK)"
  },
  {
    "value": "MXN",
    "label": "Morlaix/Ploujean (MXN)"
  },
  {
    "value": "VNE",
    "label": "Vannes/Meucon (VNE)"
  },
  {
    "value": "SNR",
    "label": "Saint-Nazaire/Montoir (SNR)"
  },
  {
    "value": "QBQ",
    "label": "St Nazaire (QBQ)"
  },
  {
    "value": "BSL",
    "label": "BÃ¢le/Mulhouse (BSL)"
  },
  {
    "value": "DIJ",
    "label": "Dijon/Longvic (DIJ)"
  },
  {
    "value": "MZM",
    "label": "Metz/Frescaty (MZM)"
  },
  {
    "value": "EPL",
    "label": "Ã‰pinal/Mirecourt (EPL)"
  },
  {
    "value": "XMF",
    "label": "MontbÃ©liard/Courcelles (XMF)"
  },
  {
    "value": "ENC",
    "label": "Nancy/Essey (ENC)"
  },
  {
    "value": "BOR",
    "label": "Belfort (BOR)"
  },
  {
    "value": "RHE",
    "label": "Reims/Champagne (RHE)"
  },
  {
    "value": "SXB",
    "label": "Strasbourg (SXB)"
  },
  {
    "value": "VTL",
    "label": "Luxeuil (VTL)"
  },
  {
    "value": "XHE",
    "label": "Toulon/HyÃ¨res/Le Palyvestre (XHE)"
  },
  {
    "value": "FNI",
    "label": "NÃ®mes/Garons (FNI)"
  },
  {
    "value": "LTT",
    "label": "La MÃ´le (LTT)"
  },
  {
    "value": "MQC",
    "label": "Miquelon (MQC)"
  },
  {
    "value": "FSP",
    "label": "Saint-Pierre (FSP)"
  },
  {
    "value": "PYR",
    "label": "Andravida (PYR)"
  },
  {
    "value": "AGQ",
    "label": "Agrinion (AGQ)"
  },
  {
    "value": "AXD",
    "label": "Alexandroupolis (AXD)"
  },
  {
    "value": "HEW",
    "label": "Athens (HEW)"
  },
  {
    "value": "ATH",
    "label": "Athens (ATH)"
  },
  {
    "value": "VOL",
    "label": "Nea Anchialos (VOL)"
  },
  {
    "value": "JKH",
    "label": "Chios Island (JKH)"
  },
  {
    "value": "PKH",
    "label": "Porto Cheli (PKH)"
  },
  {
    "value": "JIK",
    "label": "Ikaria Island (JIK)"
  },
  {
    "value": "IOA",
    "label": "Ioannina (IOA)"
  },
  {
    "value": "HER",
    "label": "Heraklion (HER)"
  },
  {
    "value": "KSO",
    "label": "Kastoria (KSO)"
  },
  {
    "value": "KIT",
    "label": "Kithira Island (KIT)"
  },
  {
    "value": "EFL",
    "label": "Kefallinia Island (EFL)"
  },
  {
    "value": "KZS",
    "label": "Kastelorizo Island (KZS)"
  },
  {
    "value": "KLX",
    "label": "Kalamata (KLX)"
  },
  {
    "value": "KGS",
    "label": "Kos Island (KGS)"
  },
  {
    "value": "AOK",
    "label": "Karpathos Island (AOK)"
  },
  {
    "value": "CFU",
    "label": "Kerkyra Island (CFU)"
  },
  {
    "value": "KSJ",
    "label": "Kasos Island (KSJ)"
  },
  {
    "value": "KVA",
    "label": "Kavala (KVA)"
  },
  {
    "value": "KZI",
    "label": "Kozani (KZI)"
  },
  {
    "value": "LRS",
    "label": "Leros Island (LRS)"
  },
  {
    "value": "LXS",
    "label": "Limnos Island (LXS)"
  },
  {
    "value": "LRA",
    "label": "Larisa (LRA)"
  },
  {
    "value": "JMK",
    "label": "Mykonos Island (JMK)"
  },
  {
    "value": "MLO",
    "label": "Milos Island (MLO)"
  },
  {
    "value": "MJT",
    "label": "Mytilene (MJT)"
  },
  {
    "value": "LGN",
    "label": "Linga Linga Airport (LGN)"
  },
  {
    "value": "JNX",
    "label": "Naxos Island (JNX)"
  },
  {
    "value": "PAS",
    "label": "Paros Island (PAS)"
  },
  {
    "value": "JTY",
    "label": "Astypalaia Island (JTY)"
  },
  {
    "value": "PVK",
    "label": "Preveza/Lefkada (PVK)"
  },
  {
    "value": "RHO",
    "label": "Rodes Island (RHO)"
  },
  {
    "value": "GPA",
    "label": "Patras (GPA)"
  },
  {
    "value": "CHQ",
    "label": "Souda (CHQ)"
  },
  {
    "value": "JSI",
    "label": "Skiathos (JSI)"
  },
  {
    "value": "SMI",
    "label": "Samos Island (SMI)"
  },
  {
    "value": "JSY",
    "label": "Syros Island (JSY)"
  },
  {
    "value": "SPJ",
    "label": "Sparti (SPJ)"
  },
  {
    "value": "JTR",
    "label": "Santorini Island (JTR)"
  },
  {
    "value": "JSH",
    "label": "Crete Island (JSH)"
  },
  {
    "value": "SKU",
    "label": "Skiros Island (SKU)"
  },
  {
    "value": "SKG",
    "label": "Thessaloniki (SKG)"
  },
  {
    "value": "ZTH",
    "label": "Zakynthos Island (ZTH)"
  },
  {
    "value": "BUD",
    "label": "Budapest (BUD)"
  },
  {
    "value": "DEB",
    "label": "Debrecen (DEB)"
  },
  {
    "value": "MCQ",
    "label": "Miskolc (MCQ)"
  },
  {
    "value": "PEV",
    "label": "PÃ©cs-PogÃ¡ny (PEV)"
  },
  {
    "value": "QGY",
    "label": "GyÅ‘r (QGY)"
  },
  {
    "value": "SOB",
    "label": "SÃ¡rmellÃ©k (SOB)"
  },
  {
    "value": "TZR",
    "label": "TaszÃ¡r (TZR)"
  },
  {
    "value": "QZD",
    "label": "Szeged (QZD)"
  },
  {
    "value": "CRV",
    "label": "Crotone (CRV)"
  },
  {
    "value": "BRI",
    "label": "Bari (BRI)"
  },
  {
    "value": "FOG",
    "label": "Foggia (FOG)"
  },
  {
    "value": "TAR",
    "label": "Grottaglie (TAR)"
  },
  {
    "value": "LCC",
    "label": "Lecce Airport (LCC)"
  },
  {
    "value": "PSR",
    "label": "Pescara (PSR)"
  },
  {
    "value": "BDS",
    "label": "Brindisi (BDS)"
  },
  {
    "value": "SUF",
    "label": "Lamezia Terme (SUF)"
  },
  {
    "value": "CIY",
    "label": "Comiso (CIY)"
  },
  {
    "value": "CTA",
    "label": "Catania (CTA)"
  },
  {
    "value": "LMP",
    "label": "Lampedusa (LMP)"
  },
  {
    "value": "PNL",
    "label": "Pantelleria (PNL)"
  },
  {
    "value": "PMO",
    "label": "Palermo (PMO)"
  },
  {
    "value": "REG",
    "label": "Reggio Calabria (REG)"
  },
  {
    "value": "TPS",
    "label": "Trapani (TPS)"
  },
  {
    "value": "NSY",
    "label": "Sigonella Airport (NSY)"
  },
  {
    "value": "BLX",
    "label": "Belluno (BLX)"
  },
  {
    "value": "CDF",
    "label": "Cortina D'Ampezzo (CDF)"
  },
  {
    "value": "RAN",
    "label": "Ravenna (RAN)"
  },
  {
    "value": "ZIA",
    "label": "Trento (ZIA)"
  },
  {
    "value": "AHO",
    "label": "Alghero (AHO)"
  },
  {
    "value": "DCI",
    "label": "Decimomannu (DCI)"
  },
  {
    "value": "CAG",
    "label": "Cagliari (CAG)"
  },
  {
    "value": "OLB",
    "label": "Olbia (OLB)"
  },
  {
    "value": "FNU",
    "label": "Oristano (FNU)"
  },
  {
    "value": "TTB",
    "label": "Arbatax (TTB)"
  },
  {
    "value": "QVA",
    "label": "Varese (QVA)"
  },
  {
    "value": "QMM",
    "label": "Marina Di Massa (QMM)"
  },
  {
    "value": "MXP",
    "label": "Milan (MXP)"
  },
  {
    "value": "BGY",
    "label": "Bergamo (BGY)"
  },
  {
    "value": "TRN",
    "label": "Torino (TRN)"
  },
  {
    "value": "ALL",
    "label": "Albenga (ALL)"
  },
  {
    "value": "GOA",
    "label": "Genova (GOA)"
  },
  {
    "value": "LIN",
    "label": "Milan (LIN)"
  },
  {
    "value": "PMF",
    "label": "Parma (PMF)"
  },
  {
    "value": "QPZ",
    "label": "Piacenza (QPZ)"
  },
  {
    "value": "AOT",
    "label": "Aosta (AOT)"
  },
  {
    "value": "CUF",
    "label": "Cuneo (CUF)"
  },
  {
    "value": "AVB",
    "label": "Aviano (AVB)"
  },
  {
    "value": "BZO",
    "label": "Bolzano (BZO)"
  },
  {
    "value": "UDN",
    "label": "Udine (UDN)"
  },
  {
    "value": "BLQ",
    "label": "Bologna (BLQ)"
  },
  {
    "value": "TSF",
    "label": "Treviso (TSF)"
  },
  {
    "value": "FRL",
    "label": "ForlÃ¬ (FRL)"
  },
  {
    "value": "VBS",
    "label": "Brescia (VBS)"
  },
  {
    "value": "TRS",
    "label": "Trieste (TRS)"
  },
  {
    "value": "RMI",
    "label": "Rimini (RMI)"
  },
  {
    "value": "VIC",
    "label": "Vicenza (VIC)"
  },
  {
    "value": "QPA",
    "label": "Padova (QPA)"
  },
  {
    "value": "VRN",
    "label": "Verona (VRN)"
  },
  {
    "value": "AOI",
    "label": "Ancona (AOI)"
  },
  {
    "value": "VCE",
    "label": "Venezia (VCE)"
  },
  {
    "value": "QZO",
    "label": "Arezzo (QZO)"
  },
  {
    "value": "LCV",
    "label": "Lucca (LCV)"
  },
  {
    "value": "QRT",
    "label": "Rieti (QRT)"
  },
  {
    "value": "SAY",
    "label": "Siena (SAY)"
  },
  {
    "value": "CIA",
    "label": "Roma (CIA)"
  },
  {
    "value": "FCO",
    "label": "Rome (FCO)"
  },
  {
    "value": "QFR",
    "label": "Frosinone (QFR)"
  },
  {
    "value": "QSR",
    "label": "Salerno (QSR)"
  },
  {
    "value": "EBA",
    "label": "Marina  Di Campo (EBA)"
  },
  {
    "value": "QLT",
    "label": "Latina (QLT)"
  },
  {
    "value": "NAP",
    "label": "NÃ¡poli (NAP)"
  },
  {
    "value": "PSA",
    "label": "Pisa (PSA)"
  },
  {
    "value": "FLR",
    "label": "Firenze (FLR)"
  },
  {
    "value": "GRS",
    "label": "Grosetto (GRS)"
  },
  {
    "value": "PEG",
    "label": "Perugia (PEG)"
  },
  {
    "value": "LJU",
    "label": "Ljubljana (LJU)"
  },
  {
    "value": "MBX",
    "label": "Maribor Airport (MBX)"
  },
  {
    "value": "POW",
    "label": "Portoroz (POW)"
  },
  {
    "value": "GTW",
    "label": "HoleÅ¡ov (GTW)"
  },
  {
    "value": "UHE",
    "label": "UherskÃ© HradiÅ¡tÄ› (UHE)"
  },
  {
    "value": "KLV",
    "label": "Karlovy Vary (KLV)"
  },
  {
    "value": "MKA",
    "label": "MariÃ¡nskÃ© LÃ¡znÄ› (MKA)"
  },
  {
    "value": "OSR",
    "label": "Ostrava (OSR)"
  },
  {
    "value": "PED",
    "label": "Pardubice (PED)"
  },
  {
    "value": "PRV",
    "label": "PÅ™erov (PRV)"
  },
  {
    "value": "PRG",
    "label": "Prague (PRG)"
  },
  {
    "value": "BRQ",
    "label": "Brno (BRQ)"
  },
  {
    "value": "ZBE",
    "label": "Zabreh (ZBE)"
  },
  {
    "value": "TLV",
    "label": "Tel Aviv (TLV)"
  },
  {
    "value": "BEV",
    "label": "Beersheva (BEV)"
  },
  {
    "value": "ETH",
    "label": "Eilat (ETH)"
  },
  {
    "value": "EIY",
    "label": "Sapir (EIY)"
  },
  {
    "value": "HFA",
    "label": "Haifa (HFA)"
  },
  {
    "value": "RPN",
    "label": "Rosh Pina (RPN)"
  },
  {
    "value": "KSW",
    "label": "Kiryat Shmona (KSW)"
  },
  {
    "value": "MTZ",
    "label": "Masada (MTZ)"
  },
  {
    "value": "VTM",
    "label": "Beersheba (VTM)"
  },
  {
    "value": "VDA",
    "label": "Eilat (VDA)"
  },
  {
    "value": "MIP",
    "label": "Beersheba (MIP)"
  },
  {
    "value": "SDV",
    "label": "Tel Aviv (SDV)"
  },
  {
    "value": "YOT",
    "label": "Yotvata (YOT)"
  },
  {
    "value": "GZM",
    "label": "Gozo (GZM)"
  },
  {
    "value": "MLA",
    "label": "Luqa (MLA)"
  },
  {
    "value": "LNC",
    "label": "Lengbati Airport (LNC)"
  },
  {
    "value": "LNM",
    "label": "Langimar Airport (LNM)"
  },
  {
    "value": "HOH",
    "label": "Hohenems / Dornbirn (HOH)"
  },
  {
    "value": "LOR",
    "label": "Fort Rucker Ozark (LOR)"
  },
  {
    "value": "GRZ",
    "label": "Graz (GRZ)"
  },
  {
    "value": "KLU",
    "label": "Klagenfurt am WÃ¶rthersee (KLU)"
  },
  {
    "value": "LNZ",
    "label": "Linz (LNZ)"
  },
  {
    "value": "SZG",
    "label": "Salzburg (SZG)"
  },
  {
    "value": "VIE",
    "label": "Vienna (VIE)"
  },
  {
    "value": "SMA",
    "label": "Vila do Porto (SMA)"
  },
  {
    "value": "BGC",
    "label": "Braganca Airport (BGC)"
  },
  {
    "value": "BYJ",
    "label": "Beja (BYJ)"
  },
  {
    "value": "BGZ",
    "label": "Braga (BGZ)"
  },
  {
    "value": "CHV",
    "label": "Chaves (CHV)"
  },
  {
    "value": "CBP",
    "label": "Coimbra Airport (CBP)"
  },
  {
    "value": "CVU",
    "label": "Corvo (CVU)"
  },
  {
    "value": "COV",
    "label": "Covilha Airport (COV)"
  },
  {
    "value": "FLW",
    "label": "Santa Cruz das Flores (FLW)"
  },
  {
    "value": "FAO",
    "label": "Faro (FAO)"
  },
  {
    "value": "GRW",
    "label": "Santa Cruz da Graciosa (GRW)"
  },
  {
    "value": "HOR",
    "label": "Horta (HOR)"
  },
  {
    "value": "TER",
    "label": "Lajes (TER)"
  },
  {
    "value": "FNC",
    "label": "Funchal (FNC)"
  },
  {
    "value": "PDL",
    "label": "Ponta Delgada (PDL)"
  },
  {
    "value": "PIX",
    "label": "Pico Island (PIX)"
  },
  {
    "value": "OPO",
    "label": "Porto (OPO)"
  },
  {
    "value": "PXO",
    "label": "Vila Baleira (PXO)"
  },
  {
    "value": "LIS",
    "label": "Lisbon (LIS)"
  },
  {
    "value": "SIE",
    "label": "Sines Airport (SIE)"
  },
  {
    "value": "SJZ",
    "label": "Velas (SJZ)"
  },
  {
    "value": "VRL",
    "label": "Vila Real Airport (VRL)"
  },
  {
    "value": "VSE",
    "label": "Viseu Airport (VSE)"
  },
  {
    "value": "BNX",
    "label": "Banja Luka (BNX)"
  },
  {
    "value": "OMO",
    "label": "Mostar (OMO)"
  },
  {
    "value": "SJJ",
    "label": "Sarajevo (SJJ)"
  },
  {
    "value": "TZL",
    "label": "Tuzla (TZL)"
  },
  {
    "value": "ARW",
    "label": "Arad (ARW)"
  },
  {
    "value": "BCM",
    "label": "BacÄƒu (BCM)"
  },
  {
    "value": "BAY",
    "label": "Baia Mare (BAY)"
  },
  {
    "value": "BBU",
    "label": "Bucharest (BBU)"
  },
  {
    "value": "CND",
    "label": "ConstanÅ£a (CND)"
  },
  {
    "value": "CLJ",
    "label": "Cluj-Napoca (CLJ)"
  },
  {
    "value": "CSB",
    "label": "CaransebeÅŸ (CSB)"
  },
  {
    "value": "CRA",
    "label": "Craiova (CRA)"
  },
  {
    "value": "IAS",
    "label": "IaÅŸi (IAS)"
  },
  {
    "value": "OMR",
    "label": "Oradea (OMR)"
  },
  {
    "value": "OTP",
    "label": "Bucharest (OTP)"
  },
  {
    "value": "SBZ",
    "label": "Sibiu (SBZ)"
  },
  {
    "value": "SUJ",
    "label": "Satu Mare (SUJ)"
  },
  {
    "value": "SCV",
    "label": "Suceava (SCV)"
  },
  {
    "value": "TCE",
    "label": "Tulcea (TCE)"
  },
  {
    "value": "TGM",
    "label": "TÃ¢rgu MureÅŸ (TGM)"
  },
  {
    "value": "TSR",
    "label": "TimiÅŸoara (TSR)"
  },
  {
    "value": "GVA",
    "label": "Geneva (GVA)"
  },
  {
    "value": "QNC",
    "label": "Neuchatel Airport (QNC)"
  },
  {
    "value": "SIR",
    "label": "Sion (SIR)"
  },
  {
    "value": "ZIN",
    "label": "Interlaken Air Base (ZIN)"
  },
  {
    "value": "LUG",
    "label": "Lugano (LUG)"
  },
  {
    "value": "BRN",
    "label": "Bern (BRN)"
  },
  {
    "value": "BXO",
    "label": "Buochs (BXO)"
  },
  {
    "value": "ZHI",
    "label": "Grenchen Airport (ZHI)"
  },
  {
    "value": "ZRH",
    "label": "Zurich (ZRH)"
  },
  {
    "value": "ZJI",
    "label": "Locarno Airport (ZJI)"
  },
  {
    "value": "ACH",
    "label": "Altenrhein (ACH)"
  },
  {
    "value": "SMV",
    "label": "Samedan Airport (SMV)"
  },
  {
    "value": "GKD",
    "label": "GÃ¶kÃ§eada (GKD)"
  },
  {
    "value": "ESB",
    "label": "Ankara (ESB)"
  },
  {
    "value": "ANK",
    "label": "Ankara (ANK)"
  },
  {
    "value": "ADA",
    "label": "Adana (ADA)"
  },
  {
    "value": "UAB",
    "label": "Adana (UAB)"
  },
  {
    "value": "AFY",
    "label": "Afyonkarahisar (AFY)"
  },
  {
    "value": "AYT",
    "label": "Antalya (AYT)"
  },
  {
    "value": "GZT",
    "label": "Gaziantep (GZT)"
  },
  {
    "value": "ISK",
    "label": "Ä°skenderun (ISK)"
  },
  {
    "value": "KFS",
    "label": "Kastamonu (KFS)"
  },
  {
    "value": "KYA",
    "label": "Konya (KYA)"
  },
  {
    "value": "MZH",
    "label": "Amasya (MZH)"
  },
  {
    "value": "SSX",
    "label": "Samsun (SSX)"
  },
  {
    "value": "VAS",
    "label": "Sivas (VAS)"
  },
  {
    "value": "ONQ",
    "label": "Zonguldak (ONQ)"
  },
  {
    "value": "MLX",
    "label": "Malatya (MLX)"
  },
  {
    "value": "ASR",
    "label": "Kayseri (ASR)"
  },
  {
    "value": "TJK",
    "label": "Tokat (TJK)"
  },
  {
    "value": "DNZ",
    "label": "Denizli (DNZ)"
  },
  {
    "value": "NAV",
    "label": "NevÅŸehir (NAV)"
  },
  {
    "value": "IST",
    "label": "Istanbul (IST)"
  },
  {
    "value": "BTZ",
    "label": "Bursa (BTZ)"
  },
  {
    "value": "BZI",
    "label": "BalÄ±kesir Merkez Airport (BZI)"
  },
  {
    "value": "BDM",
    "label": "BandÄ±rma Airport (BDM)"
  },
  {
    "value": "CKZ",
    "label": "Ã‡anakkale (CKZ)"
  },
  {
    "value": "ESK",
    "label": "EskiÅŸehir Air Base (ESK)"
  },
  {
    "value": "ADB",
    "label": "Ä°zmir (ADB)"
  },
  {
    "value": "IGL",
    "label": "Ã‡iÄŸli Airport (IGL)"
  },
  {
    "value": "USQ",
    "label": "UÅŸak (USQ)"
  },
  {
    "value": "KCO",
    "label": "Cengiz Topel Airport (KCO)"
  },
  {
    "value": "YEI",
    "label": "Bursa (YEI)"
  },
  {
    "value": "DLM",
    "label": "Dalaman (DLM)"
  },
  {
    "value": "TEQ",
    "label": "Ã‡orlu (TEQ)"
  },
  {
    "value": "BXN",
    "label": "ImsÄ±k Airport (BXN)"
  },
  {
    "value": "AOE",
    "label": "EskiÅŸehir (AOE)"
  },
  {
    "value": "EZS",
    "label": "ElazÄ±ÄŸ (EZS)"
  },
  {
    "value": "DIY",
    "label": "Diyarbakir (DIY)"
  },
  {
    "value": "ERC",
    "label": "Erzincan (ERC)"
  },
  {
    "value": "ERZ",
    "label": "Erzurum (ERZ)"
  },
  {
    "value": "KSY",
    "label": "Kars (KSY)"
  },
  {
    "value": "TZX",
    "label": "Trabzon (TZX)"
  },
  {
    "value": "SFQ",
    "label": "ÅžanlÄ±urfa (SFQ)"
  },
  {
    "value": "VAN",
    "label": "Van (VAN)"
  },
  {
    "value": "BAL",
    "label": "Batman (BAL)"
  },
  {
    "value": "MSR",
    "label": "MuÅŸ (MSR)"
  },
  {
    "value": "SXZ",
    "label": "Siirt (SXZ)"
  },
  {
    "value": "SIC",
    "label": "Sinop (SIC)"
  },
  {
    "value": "KCM",
    "label": "KahramanmaraÅŸ (KCM)"
  },
  {
    "value": "AJI",
    "label": "AÄŸrÄ± Airport (AJI)"
  },
  {
    "value": "ADF",
    "label": "AdÄ±yaman (ADF)"
  },
  {
    "value": "MQM",
    "label": "Mardin (MQM)"
  },
  {
    "value": "GNY",
    "label": "ÅžanlÄ±urfa (GNY)"
  },
  {
    "value": "HTY",
    "label": "Hatay (HTY)"
  },
  {
    "value": "ISE",
    "label": "Isparta (ISE)"
  },
  {
    "value": "EDO",
    "label": "Edremit (EDO)"
  },
  {
    "value": "BJV",
    "label": "Bodrum (BJV)"
  },
  {
    "value": "SZF",
    "label": "Samsun (SZF)"
  },
  {
    "value": "SAW",
    "label": "Istanbul (SAW)"
  },
  {
    "value": "GZP",
    "label": "GazipaÅŸa (GZP)"
  },
  {
    "value": "BZY",
    "label": "Strymba (BZY)"
  },
  {
    "value": "KIV",
    "label": "ChiÅŸinÄƒu (KIV)"
  },
  {
    "value": "OHD",
    "label": "Ohrid (OHD)"
  },
  {
    "value": "SKP",
    "label": "Skopje (SKP)"
  },
  {
    "value": "GIB",
    "label": "Gibraltar (GIB)"
  },
  {
    "value": "BCQ",
    "label": "Brack (BCQ)"
  },
  {
    "value": "DNF",
    "label": "Derna (DNF)"
  },
  {
    "value": "MRA",
    "label": "Misratah (MRA)"
  },
  {
    "value": "QUB",
    "label": "Ubari (QUB)"
  },
  {
    "value": "UZC",
    "label": "Ponikve Airport (UZC)"
  },
  {
    "value": "BEG",
    "label": "Belgrad (BEG)"
  },
  {
    "value": "LJB",
    "label": "Airport Lisicji Jarak (LJB)"
  },
  {
    "value": "IVG",
    "label": "Berane (IVG)"
  },
  {
    "value": "BJY",
    "label": "Batajnica (BJY)"
  },
  {
    "value": "GJA",
    "label": "GjakovÃ« (GJA)"
  },
  {
    "value": "INI",
    "label": "Nis (INI)"
  },
  {
    "value": "QND",
    "label": "Novi Sad (QND)"
  },
  {
    "value": "TGD",
    "label": "Podgorica (TGD)"
  },
  {
    "value": "TIV",
    "label": "Tivat (TIV)"
  },
  {
    "value": "ZRE",
    "label": "Zrenjanin (ZRE)"
  },
  {
    "value": "BTS",
    "label": "Bratislava (BTS)"
  },
  {
    "value": "KSC",
    "label": "KoÅ¡ice (KSC)"
  },
  {
    "value": "LUE",
    "label": "LuÄenec (LUE)"
  },
  {
    "value": "PZY",
    "label": "PieÅ¡Å¥any (PZY)"
  },
  {
    "value": "POV",
    "label": "PreÅ¡ov (POV)"
  },
  {
    "value": "SLD",
    "label": "SliaÄ (SLD)"
  },
  {
    "value": "ILZ",
    "label": "Å½ilina (ILZ)"
  },
  {
    "value": "DRU",
    "label": "Drummond (DRU)"
  },
  {
    "value": "GLN",
    "label": "Goulimime (GLN)"
  },
  {
    "value": "MAP",
    "label": "Mamai (MAP)"
  },
  {
    "value": "GDT",
    "label": "Cockburn Town (GDT)"
  },
  {
    "value": "MDS",
    "label": "Middle Caicos (MDS)"
  },
  {
    "value": "NCA",
    "label": "North Caicos Airport (NCA)"
  },
  {
    "value": "PIC",
    "label": "Pine Cay (PIC)"
  },
  {
    "value": "PLS",
    "label": "Providenciales Island (PLS)"
  },
  {
    "value": "XSC",
    "label": "South Caicos Airport (XSC)"
  },
  {
    "value": "SLX",
    "label": "Salt Cay (SLX)"
  },
  {
    "value": "EPS",
    "label": "Arroyo Barril (EPS)"
  },
  {
    "value": "BRX",
    "label": "Barahona (BRX)"
  },
  {
    "value": "CBJ",
    "label": "Cabo Rojo (CBJ)"
  },
  {
    "value": "AZS",
    "label": "Samana (AZS)"
  },
  {
    "value": "COZ",
    "label": "Costanza (COZ)"
  },
  {
    "value": "JBQ",
    "label": "La Isabela (JBQ)"
  },
  {
    "value": "LRM",
    "label": "La Romana (LRM)"
  },
  {
    "value": "PUJ",
    "label": "Punta Cana (PUJ)"
  },
  {
    "value": "POP",
    "label": "Puerto Plata (POP)"
  },
  {
    "value": "MDR",
    "label": "Medra (MDR)"
  },
  {
    "value": "SNX",
    "label": "Sabana de Mar (SNX)"
  },
  {
    "value": "SDQ",
    "label": "Santo Domingo (SDQ)"
  },
  {
    "value": "DOA",
    "label": "Doany (DOA)"
  },
  {
    "value": "CBV",
    "label": "Coban (CBV)"
  },
  {
    "value": "CMM",
    "label": "Carmelita (CMM)"
  },
  {
    "value": "CTF",
    "label": "Coatepeque (CTF)"
  },
  {
    "value": "GUA",
    "label": "Guatemala City (GUA)"
  },
  {
    "value": "HUG",
    "label": "Huehuetenango (HUG)"
  },
  {
    "value": "MCR",
    "label": "Melchor de Mencos (MCR)"
  },
  {
    "value": "PBR",
    "label": "Puerto Barrios (PBR)"
  },
  {
    "value": "PON",
    "label": "PoptÃºn (PON)"
  },
  {
    "value": "AQB",
    "label": "Santa Cruz del Quiche (AQB)"
  },
  {
    "value": "AAZ",
    "label": "Quezaltenango (AAZ)"
  },
  {
    "value": "RUV",
    "label": "Rubelsanto (RUV)"
  },
  {
    "value": "RER",
    "label": "Retalhuleu (RER)"
  },
  {
    "value": "GSJ",
    "label": "Puerto San JosÃ© (GSJ)"
  },
  {
    "value": "FRS",
    "label": "San Benito (FRS)"
  },
  {
    "value": "AIM",
    "label": "Ailuk Island (AIM)"
  },
  {
    "value": "AUL",
    "label": "Aur Atoll (AUL)"
  },
  {
    "value": "BII",
    "label": "Bikini Atoll (BII)"
  },
  {
    "value": "EBN",
    "label": "Ebadon Island (EBN)"
  },
  {
    "value": "JAT",
    "label": "Ailinglapalap Atoll (JAT)"
  },
  {
    "value": "JEJ",
    "label": "Ailinglapalap Atoll (JEJ)"
  },
  {
    "value": "KBT",
    "label": "Kaben (KBT)"
  },
  {
    "value": "LIK",
    "label": "Likiep Island (LIK)"
  },
  {
    "value": "LML",
    "label": "Lae Island (LML)"
  },
  {
    "value": "MAV",
    "label": "Maloelap Island (MAV)"
  },
  {
    "value": "MJB",
    "label": "Mejit Atoll (MJB)"
  },
  {
    "value": "MJE",
    "label": "Majkin (MJE)"
  },
  {
    "value": "NDK",
    "label": "Namorik Atoll (NDK)"
  },
  {
    "value": "RNP",
    "label": "Rongelap Island (RNP)"
  },
  {
    "value": "TIC",
    "label": "Arno Atoll (TIC)"
  },
  {
    "value": "UIT",
    "label": "Jabor Jaluit Atoll (UIT)"
  },
  {
    "value": "WJA",
    "label": "Woja (WJA)"
  },
  {
    "value": "WTE",
    "label": "Wotje Atoll (WTE)"
  },
  {
    "value": "WTO",
    "label": "Wotho Island (WTO)"
  },
  {
    "value": "AHS",
    "label": "Ahuas (AHS)"
  },
  {
    "value": "BHG",
    "label": "Brus Laguna (BHG)"
  },
  {
    "value": "CAA",
    "label": "Catacamas (CAA)"
  },
  {
    "value": "CDD",
    "label": "Cauquira (CDD)"
  },
  {
    "value": "JUT",
    "label": "Jutigalpa (JUT)"
  },
  {
    "value": "LCE",
    "label": "La Ceiba (LCE)"
  },
  {
    "value": "LEZ",
    "label": "La Esperanza (LEZ)"
  },
  {
    "value": "SAP",
    "label": "La Mesa (SAP)"
  },
  {
    "value": "PEU",
    "label": "Puerto Lempira (PEU)"
  },
  {
    "value": "RTB",
    "label": "Roatan Island (RTB)"
  },
  {
    "value": "SDH",
    "label": "Santa Rosa de CopÃ¡n (SDH)"
  },
  {
    "value": "RUY",
    "label": "Ruinas de Copan (RUY)"
  },
  {
    "value": "XPL",
    "label": "Comayagua (XPL)"
  },
  {
    "value": "TEA",
    "label": "Tela (TEA)"
  },
  {
    "value": "TGU",
    "label": "Tegucigalpa (TGU)"
  },
  {
    "value": "TJI",
    "label": "Trujillo (TJI)"
  },
  {
    "value": "SCD",
    "label": "Sulaco (SCD)"
  },
  {
    "value": "UII",
    "label": "Utila Island (UII)"
  },
  {
    "value": "MHY",
    "label": "Morehead (MHY)"
  },
  {
    "value": "MJG",
    "label": "Areopuerto Internacional Michael Gonzalez (MJG)"
  },
  {
    "value": "OCJ",
    "label": "Ocho Rios (OCJ)"
  },
  {
    "value": "KIN",
    "label": "Kingston (KIN)"
  },
  {
    "value": "MBJ",
    "label": "Montego Bay (MBJ)"
  },
  {
    "value": "POT",
    "label": "Ken Jones (POT)"
  },
  {
    "value": "MKN",
    "label": "Babase Island (MKN)"
  },
  {
    "value": "NEG",
    "label": "Negril (NEG)"
  },
  {
    "value": "KTP",
    "label": "Tinson Pen (KTP)"
  },
  {
    "value": "MIJ",
    "label": "Mili Island (MIJ)"
  },
  {
    "value": "MLQ",
    "label": "Malalaua Airport (MLQ)"
  },
  {
    "value": "HEB",
    "label": "Henzada (HEB)"
  },
  {
    "value": "ACA",
    "label": "Acapulco (ACA)"
  },
  {
    "value": "NTR",
    "label": "Del Norte International Airport (NTR)"
  },
  {
    "value": "AGU",
    "label": "Aguascalientes (AGU)"
  },
  {
    "value": "HUX",
    "label": "Huatulco (HUX)"
  },
  {
    "value": "CNA",
    "label": "Cananea Airport (CNA)"
  },
  {
    "value": "CVJ",
    "label": "General Mariano Matamoros Airport (CVJ)"
  },
  {
    "value": "ACN",
    "label": "Ciudad AcuÃ±a (ACN)"
  },
  {
    "value": "CME",
    "label": "Ciudad del Carmen (CME)"
  },
  {
    "value": "NCG",
    "label": "Nuevo Casas Grandes Airport (NCG)"
  },
  {
    "value": "CUL",
    "label": "CuliacÃ¡n (CUL)"
  },
  {
    "value": "CTM",
    "label": "Chetumal (CTM)"
  },
  {
    "value": "CEN",
    "label": "Ciudad ObregÃ³n (CEN)"
  },
  {
    "value": "CJT",
    "label": "Comitan Airport (CJT)"
  },
  {
    "value": "CPE",
    "label": "Campeche (CPE)"
  },
  {
    "value": "CJS",
    "label": "Ciudad JuÃ¡rez (CJS)"
  },
  {
    "value": "CZA",
    "label": "Chichen Itza International Airport (CZA)"
  },
  {
    "value": "CUU",
    "label": "Chihuahua (CUU)"
  },
  {
    "value": "CVM",
    "label": "Ciudad Victoria (CVM)"
  },
  {
    "value": "CYW",
    "label": "Celaya (CYW)"
  },
  {
    "value": "CZM",
    "label": "Cozumel (CZM)"
  },
  {
    "value": "CUA",
    "label": "Ciudad ConstituciÃ³n (CUA)"
  },
  {
    "value": "MMC",
    "label": "Ciudad Mante (MMC)"
  },
  {
    "value": "DGO",
    "label": "Durango (DGO)"
  },
  {
    "value": "TPQ",
    "label": "Tepic (TPQ)"
  },
  {
    "value": "ESE",
    "label": "Ensenada Airport (ESE)"
  },
  {
    "value": "GDL",
    "label": "Guadalajara (GDL)"
  },
  {
    "value": "GYM",
    "label": "Guaymas (GYM)"
  },
  {
    "value": "GUB",
    "label": "Guerrero Negro (GUB)"
  },
  {
    "value": "TCN",
    "label": "Tehuacan Airport (TCN)"
  },
  {
    "value": "HMO",
    "label": "Hermosillo (HMO)"
  },
  {
    "value": "CLQ",
    "label": "Colima (CLQ)"
  },
  {
    "value": "ISJ",
    "label": "Isla Mujeres Airport (ISJ)"
  },
  {
    "value": "SLW",
    "label": "Saltillo (SLW)"
  },
  {
    "value": "IZT",
    "label": "Ixtepec Airport (IZT)"
  },
  {
    "value": "JAL",
    "label": "Xalapa (JAL)"
  },
  {
    "value": "AZP",
    "label": "Atizapan De Zaragoza Airport (AZP)"
  },
  {
    "value": "LZC",
    "label": "LÃ¡zaro CÃ¡rdenas (LZC)"
  },
  {
    "value": "LMM",
    "label": "Los Mochis (LMM)"
  },
  {
    "value": "BJX",
    "label": "Silao (BJX)"
  },
  {
    "value": "LAP",
    "label": "La Paz (LAP)"
  },
  {
    "value": "LTO",
    "label": "Loreto (LTO)"
  },
  {
    "value": "MAM",
    "label": "Matamoros (MAM)"
  },
  {
    "value": "MID",
    "label": "MÃ©rida (MID)"
  },
  {
    "value": "MUG",
    "label": "Mulege (MUG)"
  },
  {
    "value": "MXL",
    "label": "Mexicali (MXL)"
  },
  {
    "value": "MLM",
    "label": "Morelia (MLM)"
  },
  {
    "value": "MTT",
    "label": "MinatitlÃ¡n (MTT)"
  },
  {
    "value": "LOV",
    "label": "Monclova International Airport (LOV)"
  },
  {
    "value": "MEX",
    "label": "Mexico City (MEX)"
  },
  {
    "value": "MTY",
    "label": "Monterrey (MTY)"
  },
  {
    "value": "MZT",
    "label": "MazatlÃ¡n (MZT)"
  },
  {
    "value": "NOG",
    "label": "Nogales International Airport (NOG)"
  },
  {
    "value": "NLD",
    "label": "Nuevo Laredo (NLD)"
  },
  {
    "value": "OAX",
    "label": "Oaxaca (OAX)"
  },
  {
    "value": "PAZ",
    "label": "Poza Rica (PAZ)"
  },
  {
    "value": "PBC",
    "label": "Puebla (PBC)"
  },
  {
    "value": "PDS",
    "label": "Piedras Negras International Airport (PDS)"
  },
  {
    "value": "UPN",
    "label": "Licenciado y General Ignacio Lopez Rayon Airport (UPN)"
  },
  {
    "value": "PQM",
    "label": "Palenque International Airport (PQM)"
  },
  {
    "value": "PVR",
    "label": "Puerto Vallarta (PVR)"
  },
  {
    "value": "PXM",
    "label": "Puerto Escondido (PXM)"
  },
  {
    "value": "QRO",
    "label": "QuerÃ©taro (QRO)"
  },
  {
    "value": "REX",
    "label": "Reynosa (REX)"
  },
  {
    "value": "SZT",
    "label": "San Cristobal De Las Casas Airport (SZT)"
  },
  {
    "value": "SJD",
    "label": "San JosÃ© del Cabo (SJD)"
  },
  {
    "value": "SFH",
    "label": "San Felipe International Airport (SFH)"
  },
  {
    "value": "SLP",
    "label": "San Luis PotosÃ­ (SLP)"
  },
  {
    "value": "TRC",
    "label": "TorreÃ³n (TRC)"
  },
  {
    "value": "TIJ",
    "label": "Tijuana (TIJ)"
  },
  {
    "value": "TAM",
    "label": "Tampico (TAM)"
  },
  {
    "value": "TSL",
    "label": "Tamuin Airport (TSL)"
  },
  {
    "value": "TLC",
    "label": "Toluca (TLC)"
  },
  {
    "value": "TAP",
    "label": "Tapachula (TAP)"
  },
  {
    "value": "WIX",
    "label": "Tuxpan Airport (WIX)"
  },
  {
    "value": "CUN",
    "label": "CancÃºn (CUN)"
  },
  {
    "value": "MMV",
    "label": "Mal Island (MMV)"
  },
  {
    "value": "VSA",
    "label": "Villahermosa (VSA)"
  },
  {
    "value": "VER",
    "label": "Veracruz (VER)"
  },
  {
    "value": "ZCL",
    "label": "Zacatecas (ZCL)"
  },
  {
    "value": "ZIH",
    "label": "Ixtapa (ZIH)"
  },
  {
    "value": "ZMM",
    "label": "Zamora Airport (ZMM)"
  },
  {
    "value": "ZLO",
    "label": "Manzanillo (ZLO)"
  },
  {
    "value": "MXW",
    "label": "Mandalgobi (MXW)"
  },
  {
    "value": "ULG",
    "label": "Ã–lgii (ULG)"
  },
  {
    "value": "ULZ",
    "label": "Uliastai (ULZ)"
  },
  {
    "value": "BEF",
    "label": "Bluefileds (BEF)"
  },
  {
    "value": "BZA",
    "label": "Bonanza (BZA)"
  },
  {
    "value": "RNI",
    "label": "Corn Island (RNI)"
  },
  {
    "value": "MGA",
    "label": "Managua (MGA)"
  },
  {
    "value": "NVG",
    "label": "Nueva Guinea (NVG)"
  },
  {
    "value": "PUZ",
    "label": "Puerto Cabezas (PUZ)"
  },
  {
    "value": "RFS",
    "label": "La Rosita (RFS)"
  },
  {
    "value": "NCR",
    "label": "San Carlos (NCR)"
  },
  {
    "value": "SIU",
    "label": "Siuna (SIU)"
  },
  {
    "value": "WSP",
    "label": "Waspam (WSP)"
  },
  {
    "value": "BOC",
    "label": "Isla ColÃ³n (BOC)"
  },
  {
    "value": "CTD",
    "label": "ChitrÃ© (CTD)"
  },
  {
    "value": "CHX",
    "label": "Changuinola (CHX)"
  },
  {
    "value": "DAV",
    "label": "David (DAV)"
  },
  {
    "value": "ONX",
    "label": "ColÃ³n (ONX)"
  },
  {
    "value": "MPG",
    "label": "Makini Airport (MPG)"
  },
  {
    "value": "BLB",
    "label": "PanamÃ¡ City (BLB)"
  },
  {
    "value": "JQE",
    "label": "JaquÃ© (JQE)"
  },
  {
    "value": "PLP",
    "label": "La Palma (PLP)"
  },
  {
    "value": "PAC",
    "label": "Albrook (PAC)"
  },
  {
    "value": "SYP",
    "label": "Santiago (SYP)"
  },
  {
    "value": "PTY",
    "label": "Tocumen (PTY)"
  },
  {
    "value": "MPU",
    "label": "Tatau Island (MPU)"
  },
  {
    "value": "NBL",
    "label": "Wannukandi (NBL)"
  },
  {
    "value": "MPX",
    "label": "Miyanmin Airport (MPX)"
  },
  {
    "value": "MQO",
    "label": "Malam (MQO)"
  },
  {
    "value": "FON",
    "label": "La Fortuna/San Carlos (FON)"
  },
  {
    "value": "TTQ",
    "label": "Roxana (TTQ)"
  },
  {
    "value": "BAI",
    "label": "Punta Arenas (BAI)"
  },
  {
    "value": "BCL",
    "label": "Pococi (BCL)"
  },
  {
    "value": "CSC",
    "label": "Guapiles (CSC)"
  },
  {
    "value": "OTR",
    "label": "Corredores (OTR)"
  },
  {
    "value": "RIK",
    "label": "Nicoya (RIK)"
  },
  {
    "value": "TNO",
    "label": "Nicoya (TNO)"
  },
  {
    "value": "DRK",
    "label": "Puntarenas (DRK)"
  },
  {
    "value": "FMG",
    "label": "Brasilito (FMG)"
  },
  {
    "value": "GLF",
    "label": "Golfito (GLF)"
  },
  {
    "value": "GPL",
    "label": "Pococi (GPL)"
  },
  {
    "value": "PBP",
    "label": "Nandayure (PBP)"
  },
  {
    "value": "LIR",
    "label": "Liberia (LIR)"
  },
  {
    "value": "LSL",
    "label": "Los Chiles (LSL)"
  },
  {
    "value": "LIO",
    "label": "Puerto Limon (LIO)"
  },
  {
    "value": "NCT",
    "label": "Nicoya/Guanacate (NCT)"
  },
  {
    "value": "NOM",
    "label": "Nicoya (NOM)"
  },
  {
    "value": "SJO",
    "label": "San Jose (SJO)"
  },
  {
    "value": "PJM",
    "label": "Puerto Jimenez (PJM)"
  },
  {
    "value": "PMZ",
    "label": "Palmar Sur (PMZ)"
  },
  {
    "value": "SYQ",
    "label": "San Jose (SYQ)"
  },
  {
    "value": "XQP",
    "label": "Quepos (XQP)"
  },
  {
    "value": "RFR",
    "label": "Rio Frio / Progreso (RFR)"
  },
  {
    "value": "PLD",
    "label": "Playa Samara (PLD)"
  },
  {
    "value": "TOO",
    "label": "Coto Brus (TOO)"
  },
  {
    "value": "TMU",
    "label": "Nicoya (TMU)"
  },
  {
    "value": "UPL",
    "label": "Upala (UPL)"
  },
  {
    "value": "SAL",
    "label": "Santa Clara (SAL)"
  },
  {
    "value": "CYA",
    "label": "Les Cayes (CYA)"
  },
  {
    "value": "CAP",
    "label": "Cap Haitien (CAP)"
  },
  {
    "value": "JAK",
    "label": "Jacmel (JAK)"
  },
  {
    "value": "JEE",
    "label": "Jeremie (JEE)"
  },
  {
    "value": "PAP",
    "label": "Port-au-Prince (PAP)"
  },
  {
    "value": "PAX",
    "label": "Port-de-Paix (PAX)"
  },
  {
    "value": "MTU",
    "label": "Montepuez (MTU)"
  },
  {
    "value": "BCA",
    "label": "Baracoa (BCA)"
  },
  {
    "value": "BWW",
    "label": "Cayo Santa Maria (BWW)"
  },
  {
    "value": "BYM",
    "label": "Bayamo (BYM)"
  },
  {
    "value": "AVI",
    "label": "Ciego de Avila (AVI)"
  },
  {
    "value": "CCC",
    "label": "Cayo Coco (CCC)"
  },
  {
    "value": "CFG",
    "label": "Cienfuegos (CFG)"
  },
  {
    "value": "CYO",
    "label": "Cayo Largo del Sur (CYO)"
  },
  {
    "value": "CMW",
    "label": "Camaguey (CMW)"
  },
  {
    "value": "QCO",
    "label": "ColÃ³n (QCO)"
  },
  {
    "value": "SCU",
    "label": "Santiago (SCU)"
  },
  {
    "value": "NBW",
    "label": "Guantanamo Bay Naval Station (NBW)"
  },
  {
    "value": "GAO",
    "label": "GuantÃ¡namo (GAO)"
  },
  {
    "value": "HAV",
    "label": "Havana (HAV)"
  },
  {
    "value": "HOG",
    "label": "Holguin (HOG)"
  },
  {
    "value": "VRO",
    "label": "Matanzas (VRO)"
  },
  {
    "value": "LCL",
    "label": "Pinar del Rio (LCL)"
  },
  {
    "value": "UMA",
    "label": "Maisi (UMA)"
  },
  {
    "value": "MOA",
    "label": "Moa (MOA)"
  },
  {
    "value": "MZO",
    "label": "Manzanillo (MZO)"
  },
  {
    "value": "QSN",
    "label": "San NicolÃ¡s (QSN)"
  },
  {
    "value": "ICR",
    "label": "Nicaro (ICR)"
  },
  {
    "value": "GER",
    "label": "Nueva Gerona (GER)"
  },
  {
    "value": "UPB",
    "label": "Havana (UPB)"
  },
  {
    "value": "QPD",
    "label": "Pinar del Rio (QPD)"
  },
  {
    "value": "SNU",
    "label": "Santa Clara (SNU)"
  },
  {
    "value": "SNJ",
    "label": "Pinar Del Rio (SNJ)"
  },
  {
    "value": "SZJ",
    "label": "Isla de la Juventud (SZJ)"
  },
  {
    "value": "USS",
    "label": "Sancti Spiritus (USS)"
  },
  {
    "value": "TND",
    "label": "Trinidad (TND)"
  },
  {
    "value": "VRA",
    "label": "Varadero (VRA)"
  },
  {
    "value": "VTU",
    "label": "Las Tunas (VTU)"
  },
  {
    "value": "CYB",
    "label": "Cayman Brac (CYB)"
  },
  {
    "value": "LYB",
    "label": "Little Cayman (LYB)"
  },
  {
    "value": "GCM",
    "label": "Georgetown (GCM)"
  },
  {
    "value": "AJS",
    "label": "Abreojos (AJS)"
  },
  {
    "value": "AZG",
    "label": "ApatzingÃ¡n (AZG)"
  },
  {
    "value": "NVJ",
    "label": "Navojoa (NVJ)"
  },
  {
    "value": "PCM",
    "label": "Playa del Carmen (PCM)"
  },
  {
    "value": "PCV",
    "label": "Punta Chivato (PCV)"
  },
  {
    "value": "PNO",
    "label": "Pinotepa (PNO)"
  },
  {
    "value": "SCX",
    "label": "Salina Cruz (SCX)"
  },
  {
    "value": "SGM",
    "label": "San Ignacio (SGM)"
  },
  {
    "value": "TUY",
    "label": "Tulum (TUY)"
  },
  {
    "value": "UAC",
    "label": "San Luis RÃ­o Colorado (UAC)"
  },
  {
    "value": "XAL",
    "label": "Ãlamos (XAL)"
  },
  {
    "value": "MXK",
    "label": "Mindik (MXK)"
  },
  {
    "value": "GTB",
    "label": "Genting (GTB)"
  },
  {
    "value": "GTK",
    "label": "Sungei Tekai (GTK)"
  },
  {
    "value": "LBP",
    "label": "Long Banga (LBP)"
  },
  {
    "value": "LLM",
    "label": "Long Lama (LLM)"
  },
  {
    "value": "MZS",
    "label": "Mostyn (MZS)"
  },
  {
    "value": "SPT",
    "label": "Sipitang (SPT)"
  },
  {
    "value": "MAY",
    "label": "Mangrove Cay (MAY)"
  },
  {
    "value": "ASD",
    "label": "Andros Town Airport (ASD)"
  },
  {
    "value": "COX",
    "label": "Andros (COX)"
  },
  {
    "value": "MHH",
    "label": "Marsh Harbour (MHH)"
  },
  {
    "value": "SAQ",
    "label": "Andros Island (SAQ)"
  },
  {
    "value": "AXP",
    "label": "Spring Point (AXP)"
  },
  {
    "value": "TCB",
    "label": "Treasure Cay (TCB)"
  },
  {
    "value": "WKR",
    "label": "Abaco I Walker C Airport (WKR)"
  },
  {
    "value": "CCZ",
    "label": "Chub Cay Airport (CCZ)"
  },
  {
    "value": "GHC",
    "label": "Great Harbour Cay Airport (GHC)"
  },
  {
    "value": "BIM",
    "label": "South Bimini (BIM)"
  },
  {
    "value": "ATC",
    "label": "Arthur's Town (ATC)"
  },
  {
    "value": "CAT",
    "label": "Cat Island (CAT)"
  },
  {
    "value": "CXY",
    "label": "Cat Cay (CXY)"
  },
  {
    "value": "CRI",
    "label": "Colonel Hill (CRI)"
  },
  {
    "value": "PWN",
    "label": "Pitts Town (PWN)"
  },
  {
    "value": "GGT",
    "label": "George Town (GGT)"
  },
  {
    "value": "ELH",
    "label": "North Eleuthera (ELH)"
  },
  {
    "value": "GHB",
    "label": "Governor's Harbour (GHB)"
  },
  {
    "value": "NMC",
    "label": "Normans Cay Airport (NMC)"
  },
  {
    "value": "RSD",
    "label": "Rock Sound (RSD)"
  },
  {
    "value": "TYM",
    "label": "Staniel Cay Airport (TYM)"
  },
  {
    "value": "FPO",
    "label": "Freeport (FPO)"
  },
  {
    "value": "WTD",
    "label": "West End (WTD)"
  },
  {
    "value": "IGA",
    "label": "Matthew Town (IGA)"
  },
  {
    "value": "LGI",
    "label": "Deadman's Cay (LGI)"
  },
  {
    "value": "SML",
    "label": "Stella Maris (SML)"
  },
  {
    "value": "MYG",
    "label": "Mayaguana (MYG)"
  },
  {
    "value": "NAS",
    "label": "Nassau (NAS)"
  },
  {
    "value": "PID",
    "label": "Nassau (PID)"
  },
  {
    "value": "DCT",
    "label": "Duncan Town Airport (DCT)"
  },
  {
    "value": "RCY",
    "label": "Rum Cay Airport (RCY)"
  },
  {
    "value": "ZSA",
    "label": "San Salvador (ZSA)"
  },
  {
    "value": "MYX",
    "label": "Menyamya (MYX)"
  },
  {
    "value": "TGS",
    "label": "ChokwÃ© (TGS)"
  },
  {
    "value": "BZE",
    "label": "Belize City (BZE)"
  },
  {
    "value": "BQI",
    "label": "Bagani (BQI)"
  },
  {
    "value": "NBS",
    "label": "Baishan (NBS)"
  },
  {
    "value": "AIT",
    "label": "Aitutaki (AIT)"
  },
  {
    "value": "AIU",
    "label": "Atiu Island (AIU)"
  },
  {
    "value": "MGS",
    "label": "Mangaia Island (MGS)"
  },
  {
    "value": "MHX",
    "label": "Manihiki Island (MHX)"
  },
  {
    "value": "MUK",
    "label": "Mauke Island (MUK)"
  },
  {
    "value": "MOI",
    "label": "Mitiaro Island (MOI)"
  },
  {
    "value": "PYE",
    "label": "Penrhyn Island (PYE)"
  },
  {
    "value": "RAR",
    "label": "Avarua (RAR)"
  },
  {
    "value": "NDI",
    "label": "Namudi Airport (NDI)"
  },
  {
    "value": "NDN",
    "label": "Nadunumu Airport (NDN)"
  },
  {
    "value": "ICI",
    "label": "Cicia (ICI)"
  },
  {
    "value": "BFJ",
    "label": "Ba Airport (BFJ)"
  },
  {
    "value": "NAN",
    "label": "Nadi (NAN)"
  },
  {
    "value": "PTF",
    "label": "Malolo Lailai Island (PTF)"
  },
  {
    "value": "KDV",
    "label": "Vunisea (KDV)"
  },
  {
    "value": "MNF",
    "label": "Mana Island (MNF)"
  },
  {
    "value": "MFJ",
    "label": "Moala (MFJ)"
  },
  {
    "value": "SUV",
    "label": "Nausori (SUV)"
  },
  {
    "value": "LEV",
    "label": "Bureta (LEV)"
  },
  {
    "value": "NGI",
    "label": "Ngau (NGI)"
  },
  {
    "value": "LUC",
    "label": "Laucala Island (LUC)"
  },
  {
    "value": "LKB",
    "label": "Lakeba Island (LKB)"
  },
  {
    "value": "LBS",
    "label": "Labasa Airport (LBS)"
  },
  {
    "value": "TVU",
    "label": "Matei (TVU)"
  },
  {
    "value": "KXF",
    "label": "Koro Island (KXF)"
  },
  {
    "value": "RTA",
    "label": "Rotuma (RTA)"
  },
  {
    "value": "SVU",
    "label": "Savusavu (SVU)"
  },
  {
    "value": "VAU",
    "label": "Vatukoula (VAU)"
  },
  {
    "value": "KAY",
    "label": "Wakaya Island (KAY)"
  },
  {
    "value": "ONU",
    "label": "Ono-I-Lau (ONU)"
  },
  {
    "value": "YAS",
    "label": "Yasawa Island (YAS)"
  },
  {
    "value": "EUA",
    "label": "Eua Island (EUA)"
  },
  {
    "value": "TBU",
    "label": "Nuku'alofa (TBU)"
  },
  {
    "value": "HPA",
    "label": "Lifuka (HPA)"
  },
  {
    "value": "NFO",
    "label": "Angaha, Niuafo'ou Island (NFO)"
  },
  {
    "value": "NTT",
    "label": "Niuatoputapu (NTT)"
  },
  {
    "value": "VAV",
    "label": "Vava'u Island (VAV)"
  },
  {
    "value": "VBV",
    "label": "Vanua Balavu (VBV)"
  },
  {
    "value": "VTF",
    "label": "Vatulele (VTF)"
  },
  {
    "value": "GMO",
    "label": "Gombe (GMO)"
  },
  {
    "value": "PHG",
    "label": "Port Harcourt (PHG)"
  },
  {
    "value": "BCU",
    "label": "Bauchi (BCU)"
  },
  {
    "value": "QRW",
    "label": "Warri (QRW)"
  },
  {
    "value": "ABF",
    "label": "Abaiang (ABF)"
  },
  {
    "value": "BEZ",
    "label": "Beru (BEZ)"
  },
  {
    "value": "FUN",
    "label": "Funafuti (FUN)"
  },
  {
    "value": "KUC",
    "label": "Kuria (KUC)"
  },
  {
    "value": "MNK",
    "label": "Maiana (MNK)"
  },
  {
    "value": "MZK",
    "label": "Marakei (MZK)"
  },
  {
    "value": "MTK",
    "label": "Makin Island (MTK)"
  },
  {
    "value": "NIG",
    "label": "Nikunau (NIG)"
  },
  {
    "value": "OOT",
    "label": "Onotoa (OOT)"
  },
  {
    "value": "TRW",
    "label": "Tarawa (TRW)"
  },
  {
    "value": "AEA",
    "label": "Abemama Atoll (AEA)"
  },
  {
    "value": "TBF",
    "label": "Tabiteuea North Airport (TBF)"
  },
  {
    "value": "TMN",
    "label": "Tamana Island (TMN)"
  },
  {
    "value": "NON",
    "label": "Nonouti (NON)"
  },
  {
    "value": "AIS",
    "label": "Arorae Island (AIS)"
  },
  {
    "value": "TSU",
    "label": "Tabiteuea South (TSU)"
  },
  {
    "value": "BBG",
    "label": "Butaritari Atoll (BBG)"
  },
  {
    "value": "AAK",
    "label": "Buariki (AAK)"
  },
  {
    "value": "IUE",
    "label": "Alofi (IUE)"
  },
  {
    "value": "FUT",
    "label": "Futuna Island (FUT)"
  },
  {
    "value": "WLS",
    "label": "Wallis Island (WLS)"
  },
  {
    "value": "MWP",
    "label": "Mountain (MWP)"
  },
  {
    "value": "TPJ",
    "label": "Taplejung (TPJ)"
  },
  {
    "value": "OFU",
    "label": "Ofu Village (OFU)"
  },
  {
    "value": "AAU",
    "label": "Asau (AAU)"
  },
  {
    "value": "APW",
    "label": "Apia (APW)"
  },
  {
    "value": "FGI",
    "label": "Apia (FGI)"
  },
  {
    "value": "MXS",
    "label": "Maota (MXS)"
  },
  {
    "value": "PPG",
    "label": "Pago Pago (PPG)"
  },
  {
    "value": "PPT",
    "label": "Papeete (PPT)"
  },
  {
    "value": "RUR",
    "label": "Rurutu Airport (RUR)"
  },
  {
    "value": "TUB",
    "label": "Tubuai Airport (TUB)"
  },
  {
    "value": "AAA",
    "label": "Anaa Airport (AAA)"
  },
  {
    "value": "FGU",
    "label": "Fangatau Airport (FGU)"
  },
  {
    "value": "TIH",
    "label": "Tikehau Airport (TIH)"
  },
  {
    "value": "APK",
    "label": "Apataki (APK)"
  },
  {
    "value": "REA",
    "label": "Reao Airport (REA)"
  },
  {
    "value": "FAV",
    "label": "Fakarava Airport (FAV)"
  },
  {
    "value": "HHZ",
    "label": "Hikueru Atoll (HHZ)"
  },
  {
    "value": "XMH",
    "label": "Manihi Airport (XMH)"
  },
  {
    "value": "GMR",
    "label": "Totegegie Airport (GMR)"
  },
  {
    "value": "KKR",
    "label": "Kaukura Airport (KKR)"
  },
  {
    "value": "MKP",
    "label": "Makemo Airport (MKP)"
  },
  {
    "value": "NAU",
    "label": "Napuka Island (NAU)"
  },
  {
    "value": "TKV",
    "label": "Tatakoto (TKV)"
  },
  {
    "value": "PKP",
    "label": "Puka Puka Airport (PKP)"
  },
  {
    "value": "PUK",
    "label": "Pukarua (PUK)"
  },
  {
    "value": "TKP",
    "label": "Takapoto Airport (TKP)"
  },
  {
    "value": "AXR",
    "label": "Arutua Airport (AXR)"
  },
  {
    "value": "MVT",
    "label": "Mataiva Airport (MVT)"
  },
  {
    "value": "NUK",
    "label": "Nukutavake (NUK)"
  },
  {
    "value": "ZTA",
    "label": "Tureia Airport (ZTA)"
  },
  {
    "value": "AHE",
    "label": "Ahe Atoll (AHE)"
  },
  {
    "value": "KHZ",
    "label": "Kauehi (KHZ)"
  },
  {
    "value": "FAC",
    "label": "Faaite Airport (FAC)"
  },
  {
    "value": "FHZ",
    "label": "Fakahina (FHZ)"
  },
  {
    "value": "TKX",
    "label": "Takaroa Airport (TKX)"
  },
  {
    "value": "NHV",
    "label": "Nuku Hiva Airport (NHV)"
  },
  {
    "value": "AUQ",
    "label": "Hiva Oa-Atuona Airport (AUQ)"
  },
  {
    "value": "UAP",
    "label": "Ua Pou (UAP)"
  },
  {
    "value": "UAH",
    "label": "Ua Huka (UAH)"
  },
  {
    "value": "BOB",
    "label": "Motu Mute (BOB)"
  },
  {
    "value": "TTI",
    "label": "Tetiaroa (TTI)"
  },
  {
    "value": "RGI",
    "label": "Rangiroa Airport (RGI)"
  },
  {
    "value": "HUH",
    "label": "Fare (HUH)"
  },
  {
    "value": "MOZ",
    "label": "Moorea Airport (MOZ)"
  },
  {
    "value": "HOI",
    "label": "Hao Airport (HOI)"
  },
  {
    "value": "MAU",
    "label": "Maupiti Airport (MAU)"
  },
  {
    "value": "RFP",
    "label": "Uturoa (RFP)"
  },
  {
    "value": "VHZ",
    "label": "Vahitahi (VHZ)"
  },
  {
    "value": "MTV",
    "label": "Ablow (MTV)"
  },
  {
    "value": "SLH",
    "label": "Sola (SLH)"
  },
  {
    "value": "TOH",
    "label": "Loh/Linua (TOH)"
  },
  {
    "value": "EAE",
    "label": "Sangafa (EAE)"
  },
  {
    "value": "CCV",
    "label": "Craig Cove (CCV)"
  },
  {
    "value": "LOD",
    "label": "Longana (LOD)"
  },
  {
    "value": "SSR",
    "label": "Pentecost Island (SSR)"
  },
  {
    "value": "PBJ",
    "label": "Paama Island (PBJ)"
  },
  {
    "value": "LPM",
    "label": "Lamap (LPM)"
  },
  {
    "value": "LNB",
    "label": "Lamen Bay (LNB)"
  },
  {
    "value": "MWF",
    "label": "Maewo Island (MWF)"
  },
  {
    "value": "LNE",
    "label": "Lonorore (LNE)"
  },
  {
    "value": "ZGU",
    "label": "Gaua Island (ZGU)"
  },
  {
    "value": "RCL",
    "label": "Redcliffe (RCL)"
  },
  {
    "value": "SON",
    "label": "Luganville (SON)"
  },
  {
    "value": "TGH",
    "label": "Tongoa Island (TGH)"
  },
  {
    "value": "ULB",
    "label": "Ambryn Island (ULB)"
  },
  {
    "value": "VLS",
    "label": "Valesdir (VLS)"
  },
  {
    "value": "WLH",
    "label": "Walaha (WLH)"
  },
  {
    "value": "SWJ",
    "label": "Malekula Island (SWJ)"
  },
  {
    "value": "OLJ",
    "label": "Olpoi (OLJ)"
  },
  {
    "value": "AUY",
    "label": "Anelghowhat (AUY)"
  },
  {
    "value": "AWD",
    "label": "Aniwa (AWD)"
  },
  {
    "value": "DLY",
    "label": "Dillon's Bay (DLY)"
  },
  {
    "value": "FTA",
    "label": "Futuna Island (FTA)"
  },
  {
    "value": "IPA",
    "label": "Ipota (IPA)"
  },
  {
    "value": "UIQ",
    "label": "Quion Hill (UIQ)"
  },
  {
    "value": "VLI",
    "label": "Port Vila (VLI)"
  },
  {
    "value": "TAH",
    "label": "Tanna Airport (TAH)"
  },
  {
    "value": "NWT",
    "label": "Nowata Airport (NWT)"
  },
  {
    "value": "TGJ",
    "label": "Tiga (TGJ)"
  },
  {
    "value": "BMY",
    "label": "Waala (BMY)"
  },
  {
    "value": "KNQ",
    "label": "KonÃ© (KNQ)"
  },
  {
    "value": "ILP",
    "label": "ÃŽle des Pins (ILP)"
  },
  {
    "value": "HLU",
    "label": "Houailou (HLU)"
  },
  {
    "value": "KOC",
    "label": "Koumac (KOC)"
  },
  {
    "value": "LIF",
    "label": "Lifou (LIF)"
  },
  {
    "value": "GEA",
    "label": "NoumÃ©a (GEA)"
  },
  {
    "value": "IOU",
    "label": "ÃŽle Ouen (IOU)"
  },
  {
    "value": "PUV",
    "label": "Poum (PUV)"
  },
  {
    "value": "PDC",
    "label": "Mueo (PDC)"
  },
  {
    "value": "MEE",
    "label": "MarÃ© (MEE)"
  },
  {
    "value": "TOU",
    "label": "Touho (TOU)"
  },
  {
    "value": "UVE",
    "label": "OuvÃ©a (UVE)"
  },
  {
    "value": "NOU",
    "label": "NoumÃ©a (NOU)"
  },
  {
    "value": "AKL",
    "label": "Auckland (AKL)"
  },
  {
    "value": "TUO",
    "label": "Taupo (TUO)"
  },
  {
    "value": "AMZ",
    "label": "Manurewa (AMZ)"
  },
  {
    "value": "ASG",
    "label": "Ashburton Aerodrome (ASG)"
  },
  {
    "value": "CHC",
    "label": "Christchurch (CHC)"
  },
  {
    "value": "CHT",
    "label": "Waitangi (CHT)"
  },
  {
    "value": "CMV",
    "label": "Coromandel Aerodrome (CMV)"
  },
  {
    "value": "DGR",
    "label": "Dargaville Aerodrome (DGR)"
  },
  {
    "value": "DUD",
    "label": "Dunedin (DUD)"
  },
  {
    "value": "FGL",
    "label": "Fox (FGL)"
  },
  {
    "value": "WHO",
    "label": "Franz Josef Aerodrome (WHO)"
  },
  {
    "value": "GBZ",
    "label": "Claris (GBZ)"
  },
  {
    "value": "GMN",
    "label": "Greymouth Airport (GMN)"
  },
  {
    "value": "GIS",
    "label": "Gisborne (GIS)"
  },
  {
    "value": "GTN",
    "label": "Glentanner Station (GTN)"
  },
  {
    "value": "HKK",
    "label": "Hokitika Airfield (HKK)"
  },
  {
    "value": "HLZ",
    "label": "Hamilton (HLZ)"
  },
  {
    "value": "WIK",
    "label": "Waiheke Reeve Airport (WIK)"
  },
  {
    "value": "KBZ",
    "label": "Kaikoura Airport (KBZ)"
  },
  {
    "value": "KKE",
    "label": "Kerikeri (KKE)"
  },
  {
    "value": "KKO",
    "label": "Kaikohe Airport (KKO)"
  },
  {
    "value": "KAT",
    "label": "Kaitaia (KAT)"
  },
  {
    "value": "ALR",
    "label": "Alexandra (ALR)"
  },
  {
    "value": "MTA",
    "label": "Matamata Glider Airport (MTA)"
  },
  {
    "value": "MON",
    "label": "Mount Cook Airport (MON)"
  },
  {
    "value": "MFN",
    "label": "Milford Sound Airport (MFN)"
  },
  {
    "value": "MZP",
    "label": "Motueka Airport (MZP)"
  },
  {
    "value": "TEU",
    "label": "Manapouri Airport (TEU)"
  },
  {
    "value": "MRO",
    "label": "Masterton (MRO)"
  },
  {
    "value": "NPL",
    "label": "New Plymouth (NPL)"
  },
  {
    "value": "NPE",
    "label": "Napier Airport (NPE)"
  },
  {
    "value": "NSN",
    "label": "Nelson (NSN)"
  },
  {
    "value": "IVC",
    "label": "Invercargill (IVC)"
  },
  {
    "value": "OHA",
    "label": "RNZAF Base Ohakea (OHA)"
  },
  {
    "value": "OAM",
    "label": "Oamaru Airport (OAM)"
  },
  {
    "value": "PMR",
    "label": "Palmerston North Airport (PMR)"
  },
  {
    "value": "PCN",
    "label": "Picton (PCN)"
  },
  {
    "value": "PPQ",
    "label": "Paraparaumu Airport (PPQ)"
  },
  {
    "value": "ZQN",
    "label": "Queenstown (ZQN)"
  },
  {
    "value": "RAG",
    "label": "Raglan Airfield (RAG)"
  },
  {
    "value": "SZS",
    "label": "Oban (SZS)"
  },
  {
    "value": "ROT",
    "label": "Rotorua (ROT)"
  },
  {
    "value": "TRG",
    "label": "Tauranga (TRG)"
  },
  {
    "value": "TMZ",
    "label": "Thames Aerodrome (TMZ)"
  },
  {
    "value": "KTF",
    "label": "Takaka Airport (KTF)"
  },
  {
    "value": "TKZ",
    "label": "Tokoroa (TKZ)"
  },
  {
    "value": "THH",
    "label": "Taharoa (THH)"
  },
  {
    "value": "TIU",
    "label": "Timaru Airport (TIU)"
  },
  {
    "value": "TWZ",
    "label": "Twitzel (TWZ)"
  },
  {
    "value": "BHE",
    "label": "Blenheim (BHE)"
  },
  {
    "value": "WKA",
    "label": "Wanaka Airport (WKA)"
  },
  {
    "value": "WHK",
    "label": "Whakatane Airport (WHK)"
  },
  {
    "value": "WLG",
    "label": "Wellington (WLG)"
  },
  {
    "value": "WIR",
    "label": "Wairoa (WIR)"
  },
  {
    "value": "WRE",
    "label": "Whangarei Airport (WRE)"
  },
  {
    "value": "WSZ",
    "label": "Westport Airport (WSZ)"
  },
  {
    "value": "WTZ",
    "label": "Whitianga Airport (WTZ)"
  },
  {
    "value": "WAG",
    "label": "Wanganui (WAG)"
  },
  {
    "value": "BZF",
    "label": "Redding (BZF)"
  },
  {
    "value": "OAA",
    "label": "Shank Air Base (OAA)"
  },
  {
    "value": "BIN",
    "label": "Bamiyan (BIN)"
  },
  {
    "value": "BST",
    "label": "Bost (BST)"
  },
  {
    "value": "CCN",
    "label": "Chakcharan (CCN)"
  },
  {
    "value": "DAZ",
    "label": "Darwaz (DAZ)"
  },
  {
    "value": "FAH",
    "label": "Farah (FAH)"
  },
  {
    "value": "FBD",
    "label": "Faizabad (FBD)"
  },
  {
    "value": "KWH",
    "label": "Khwahan (KWH)"
  },
  {
    "value": "HEA",
    "label": "Herat Airport (HEA)"
  },
  {
    "value": "OAI",
    "label": "Bagram (OAI)"
  },
  {
    "value": "JAA",
    "label": "Jalalabad Airport (JAA)"
  },
  {
    "value": "KBL",
    "label": "Kabul (KBL)"
  },
  {
    "value": "KDH",
    "label": "Kandahar Airport (KDH)"
  },
  {
    "value": "KHT",
    "label": "Khost (KHT)"
  },
  {
    "value": "MMZ",
    "label": "Maimana Airport (MMZ)"
  },
  {
    "value": "MZR",
    "label": "Mazar I Sharif Airport (MZR)"
  },
  {
    "value": "LQN",
    "label": "Qala-I-Naw (LQN)"
  },
  {
    "value": "OAS",
    "label": "Sharana (OAS)"
  },
  {
    "value": "OAH",
    "label": "Shindand Airport (OAH)"
  },
  {
    "value": "SGA",
    "label": "Sheghnan (SGA)"
  },
  {
    "value": "TII",
    "label": "Tarin Kowt (TII)"
  },
  {
    "value": "UND",
    "label": "Konduz Airport (UND)"
  },
  {
    "value": "OAZ",
    "label": "Camp Bastion Airport (OAZ)"
  },
  {
    "value": "ZAJ",
    "label": "Zaranj (ZAJ)"
  },
  {
    "value": "BAH",
    "label": "Manama (BAH)"
  },
  {
    "value": "AHB",
    "label": "Abha (AHB)"
  },
  {
    "value": "HOF",
    "label": "Al Ahsa Airport (HOF)"
  },
  {
    "value": "ABT",
    "label": "Al Baha Airport (ABT)"
  },
  {
    "value": "BHH",
    "label": "Bisha Airport (BHH)"
  },
  {
    "value": "DMM",
    "label": "Ad Dammam (DMM)"
  },
  {
    "value": "DHA",
    "label": "King Abdulaziz Air Base (DHA)"
  },
  {
    "value": "DWD",
    "label": "Dawadmi (DWD)"
  },
  {
    "value": "GIZ",
    "label": "Jizan (GIZ)"
  },
  {
    "value": "ELQ",
    "label": "Gassim Airport (ELQ)"
  },
  {
    "value": "URY",
    "label": "Guriat Domestic Airport (URY)"
  },
  {
    "value": "HAS",
    "label": "Hail Airport (HAS)"
  },
  {
    "value": "QJB",
    "label": "Jubail (QJB)"
  },
  {
    "value": "JED",
    "label": "Jeddah (JED)"
  },
  {
    "value": "HBT",
    "label": "King Khaled Military City (HBT)"
  },
  {
    "value": "KMX",
    "label": "King Khaled Air Base (KMX)"
  },
  {
    "value": "MED",
    "label": "Medina (MED)"
  },
  {
    "value": "EAM",
    "label": "Nejran Airport (EAM)"
  },
  {
    "value": "AQI",
    "label": "Qaisumah (AQI)"
  },
  {
    "value": "AKH",
    "label": "Prince Sultan Air Base (AKH)"
  },
  {
    "value": "RAH",
    "label": "Rafha (RAH)"
  },
  {
    "value": "RUH",
    "label": "Riyadh (RUH)"
  },
  {
    "value": "RAE",
    "label": "Arar (RAE)"
  },
  {
    "value": "XXN",
    "label": "Riyadh (XXN)"
  },
  {
    "value": "SHW",
    "label": "Sharurah Airport (SHW)"
  },
  {
    "value": "AJF",
    "label": "Al-Jawf (AJF)"
  },
  {
    "value": "SLF",
    "label": "Sulayel Airport (SLF)"
  },
  {
    "value": "TUU",
    "label": "Tabuk Airport (TUU)"
  },
  {
    "value": "TIF",
    "label": "Taif Airport (TIF)"
  },
  {
    "value": "TUI",
    "label": "Turaif Domestic Airport (TUI)"
  },
  {
    "value": "EWD",
    "label": "Wadi Al Dawasir Airport (EWD)"
  },
  {
    "value": "EJH",
    "label": "Al Wajh (EJH)"
  },
  {
    "value": "YNB",
    "label": "Yenbo Airport (YNB)"
  },
  {
    "value": "ZUL",
    "label": "Zilfi (ZUL)"
  },
  {
    "value": "OGE",
    "label": "Ogeranang Airport (OGE)"
  },
  {
    "value": "ABD",
    "label": "Abadan (ABD)"
  },
  {
    "value": "DEF",
    "label": "Dezful Airport (DEF)"
  },
  {
    "value": "OMI",
    "label": "Omidiyeh (OMI)"
  },
  {
    "value": "MRX",
    "label": "Mahshahr Airport (MRX)"
  },
  {
    "value": "AWZ",
    "label": "Ahwaz (AWZ)"
  },
  {
    "value": "AEU",
    "label": "Abumusa Island Airport (AEU)"
  },
  {
    "value": "BUZ",
    "label": "Bushehr (BUZ)"
  },
  {
    "value": "AOY",
    "label": "Asaloyeh (AOY)"
  },
  {
    "value": "KNR",
    "label": "Kangan (KNR)"
  },
  {
    "value": "KIH",
    "label": "Kish Island (KIH)"
  },
  {
    "value": "BDH",
    "label": "Bandar Lengeh (BDH)"
  },
  {
    "value": "YEH",
    "label": "Asalouyeh (YEH)"
  },
  {
    "value": "KHK",
    "label": "Khark Island Airport (KHK)"
  },
  {
    "value": "SXI",
    "label": "Sirri Island Airport (SXI)"
  },
  {
    "value": "LVP",
    "label": "Lavan Island Airport (LVP)"
  },
  {
    "value": "KSH",
    "label": "Kermanshah (KSH)"
  },
  {
    "value": "IIL",
    "label": "Ilam (IIL)"
  },
  {
    "value": "KHD",
    "label": "Khoram Abad Airport (KHD)"
  },
  {
    "value": "SDG",
    "label": "Sanandaj Airport (SDG)"
  },
  {
    "value": "IFH",
    "label": "Hesa (IFH)"
  },
  {
    "value": "IFN",
    "label": "Isfahan (IFN)"
  },
  {
    "value": "CQD",
    "label": "Shahrekord (CQD)"
  },
  {
    "value": "RAS",
    "label": "Rasht (RAS)"
  },
  {
    "value": "HDM",
    "label": "Hamadan (HDM)"
  },
  {
    "value": "AJK",
    "label": "Araak (AJK)"
  },
  {
    "value": "IKA",
    "label": "Tehran (IKA)"
  },
  {
    "value": "THR",
    "label": "Tehran (THR)"
  },
  {
    "value": "BND",
    "label": "Bandar Abbas (BND)"
  },
  {
    "value": "KER",
    "label": "Kerman (KER)"
  },
  {
    "value": "BXR",
    "label": "Bam Airport (BXR)"
  },
  {
    "value": "HDR",
    "label": "Havadarya (HDR)"
  },
  {
    "value": "RJN",
    "label": "Rafsanjan Airport (RJN)"
  },
  {
    "value": "SYJ",
    "label": "Sirjan Airport (SYJ)"
  },
  {
    "value": "XBJ",
    "label": "Birjand (XBJ)"
  },
  {
    "value": "CKT",
    "label": "Sarakhs (CKT)"
  },
  {
    "value": "MHD",
    "label": "Mashhad (MHD)"
  },
  {
    "value": "BJB",
    "label": "Bojnord (BJB)"
  },
  {
    "value": "AFZ",
    "label": "Sabzevar (AFZ)"
  },
  {
    "value": "TCX",
    "label": "Tabas (TCX)"
  },
  {
    "value": "BBL",
    "label": "Babolsar (BBL)"
  },
  {
    "value": "GBT",
    "label": "Gorgan (GBT)"
  },
  {
    "value": "BSM",
    "label": "Amol (BSM)"
  },
  {
    "value": "NSH",
    "label": "Noshahr Airport (NSH)"
  },
  {
    "value": "RZR",
    "label": "Ramsar Airport (RZR)"
  },
  {
    "value": "SRY",
    "label": "Sari (SRY)"
  },
  {
    "value": "FAZ",
    "label": "Fasa (FAZ)"
  },
  {
    "value": "LRR",
    "label": "Lar (LRR)"
  },
  {
    "value": "SYZ",
    "label": "Shiraz (SYZ)"
  },
  {
    "value": "KHY",
    "label": "Khoy (KHY)"
  },
  {
    "value": "ADU",
    "label": "Ardabil (ADU)"
  },
  {
    "value": "ACP",
    "label": "Maragheh (ACP)"
  },
  {
    "value": "PFQ",
    "label": "Parsabad (PFQ)"
  },
  {
    "value": "OMH",
    "label": "Urmia (OMH)"
  },
  {
    "value": "TBZ",
    "label": "Tabriz (TBZ)"
  },
  {
    "value": "AZD",
    "label": "Yazd (AZD)"
  },
  {
    "value": "ACZ",
    "label": "Zabol Airport (ACZ)"
  },
  {
    "value": "ZBR",
    "label": "Chabahar (ZBR)"
  },
  {
    "value": "ZAH",
    "label": "Zahedan (ZAH)"
  },
  {
    "value": "AMM",
    "label": "Amman (AMM)"
  },
  {
    "value": "ADJ",
    "label": "Amman (ADJ)"
  },
  {
    "value": "AQJ",
    "label": "Aqaba (AQJ)"
  },
  {
    "value": "OMF",
    "label": "Mafraq (OMF)"
  },
  {
    "value": "DWN",
    "label": "Oklahoma City (DWN)"
  },
  {
    "value": "KWI",
    "label": "Kuwait City (KWI)"
  },
  {
    "value": "OKV",
    "label": "Okao Airport (OKV)"
  },
  {
    "value": "BEY",
    "label": "Beirut (BEY)"
  },
  {
    "value": "KYE",
    "label": "Tripoli (KYE)"
  },
  {
    "value": "OLQ",
    "label": "Olsobip (OLQ)"
  },
  {
    "value": "BYB",
    "label": "Dibba Al-Baya (BYB)"
  },
  {
    "value": "AOM",
    "label": "Adam (AOM)"
  },
  {
    "value": "AUH",
    "label": "Abu Dhabi (AUH)"
  },
  {
    "value": "AZI",
    "label": "Bateen Airport (AZI)"
  },
  {
    "value": "AAN",
    "label": "Al Ain (AAN)"
  },
  {
    "value": "DHF",
    "label": "Al Dhafra Air Base (DHF)"
  },
  {
    "value": "DXB",
    "label": "Dubai (DXB)"
  },
  {
    "value": "NHD",
    "label": "Dubai (NHD)"
  },
  {
    "value": "DWC",
    "label": "Jebel Ali (DWC)"
  },
  {
    "value": "FJR",
    "label": "Fujairah International Airport (FJR)"
  },
  {
    "value": "RKT",
    "label": "Ras Al Khaimah (RKT)"
  },
  {
    "value": "SHJ",
    "label": "Sharjah (SHJ)"
  },
  {
    "value": "ONB",
    "label": "Onange Mission (ONB)"
  },
  {
    "value": "RMB",
    "label": "Buraimi (RMB)"
  },
  {
    "value": "KHS",
    "label": "Khasab (KHS)"
  },
  {
    "value": "MSH",
    "label": "Masirah (MSH)"
  },
  {
    "value": "MCT",
    "label": "Muscat (MCT)"
  },
  {
    "value": "OMM",
    "label": "Marmul (OMM)"
  },
  {
    "value": "SLL",
    "label": "Salalah (SLL)"
  },
  {
    "value": "SUH",
    "label": "Sur (SUH)"
  },
  {
    "value": "TTH",
    "label": "Thumrait (TTH)"
  },
  {
    "value": "DDU",
    "label": "Dadu (DDU)"
  },
  {
    "value": "AAW",
    "label": "Abbottabad (AAW)"
  },
  {
    "value": "BHW",
    "label": "Bhagatanwala (BHW)"
  },
  {
    "value": "BNP",
    "label": "Bannu (BNP)"
  },
  {
    "value": "WGB",
    "label": "Bahawalnagar (WGB)"
  },
  {
    "value": "BHV",
    "label": "Bahawalpur (BHV)"
  },
  {
    "value": "CJL",
    "label": "Chitral (CJL)"
  },
  {
    "value": "CHB",
    "label": "Chilas (CHB)"
  },
  {
    "value": "DBA",
    "label": "Dalbandin (DBA)"
  },
  {
    "value": "DEA",
    "label": "Dera Ghazi Khan (DEA)"
  },
  {
    "value": "DSK",
    "label": "Dera Ismael Khan (DSK)"
  },
  {
    "value": "LYP",
    "label": "Faisalabad (LYP)"
  },
  {
    "value": "GWD",
    "label": "Gwadar (GWD)"
  },
  {
    "value": "GIL",
    "label": "Gilgit (GIL)"
  },
  {
    "value": "JAG",
    "label": "Jacobabad (JAG)"
  },
  {
    "value": "JIW",
    "label": "Jiwani (JIW)"
  },
  {
    "value": "KHI",
    "label": "Karachi (KHI)"
  },
  {
    "value": "HDD",
    "label": "Hyderabad (HDD)"
  },
  {
    "value": "KDD",
    "label": "Khuzdar (KDD)"
  },
  {
    "value": "KBH",
    "label": "Kalat (KBH)"
  },
  {
    "value": "OHT",
    "label": "Kohat (OHT)"
  },
  {
    "value": "LHE",
    "label": "Lahore (LHE)"
  },
  {
    "value": "LRG",
    "label": "Loralai (LRG)"
  },
  {
    "value": "XJM",
    "label": "Mangla (XJM)"
  },
  {
    "value": "MFG",
    "label": "Muzaffarabad (MFG)"
  },
  {
    "value": "MWD",
    "label": "Mianwali (MWD)"
  },
  {
    "value": "MJD",
    "label": "Moenjodaro (MJD)"
  },
  {
    "value": "MPD",
    "label": "Mirpur Khas (MPD)"
  },
  {
    "value": "MUX",
    "label": "Multan (MUX)"
  },
  {
    "value": "WNS",
    "label": "Nawabash (WNS)"
  },
  {
    "value": "NHS",
    "label": "Nushki (NHS)"
  },
  {
    "value": "ORW",
    "label": "Ormara Raik (ORW)"
  },
  {
    "value": "PAJ",
    "label": "Parachinar (PAJ)"
  },
  {
    "value": "PJG",
    "label": "Panjgur (PJG)"
  },
  {
    "value": "PSI",
    "label": "Pasni (PSI)"
  },
  {
    "value": "PEW",
    "label": "Peshawar (PEW)"
  },
  {
    "value": "UET",
    "label": "Quetta (UET)"
  },
  {
    "value": "RYK",
    "label": "Rahim Yar Khan (RYK)"
  },
  {
    "value": "ISB",
    "label": "Islamabad (ISB)"
  },
  {
    "value": "RAZ",
    "label": "Rawalakot (RAZ)"
  },
  {
    "value": "SBQ",
    "label": "Sibi (SBQ)"
  },
  {
    "value": "KDU",
    "label": "Skardu (KDU)"
  },
  {
    "value": "SKZ",
    "label": "Mirpur Khas (SKZ)"
  },
  {
    "value": "SYW",
    "label": "Sehwan Sharif (SYW)"
  },
  {
    "value": "SGI",
    "label": "Sargodha (SGI)"
  },
  {
    "value": "SDT",
    "label": "Saidu Sharif (SDT)"
  },
  {
    "value": "SKT",
    "label": "Sialkot (SKT)"
  },
  {
    "value": "SUL",
    "label": "Sui (SUL)"
  },
  {
    "value": "SWN",
    "label": "Sahiwal (SWN)"
  },
  {
    "value": "TLB",
    "label": "Tarbela (TLB)"
  },
  {
    "value": "BDN",
    "label": "Badin (BDN)"
  },
  {
    "value": "TFT",
    "label": "Taftan (TFT)"
  },
  {
    "value": "TUK",
    "label": "Turbat (TUK)"
  },
  {
    "value": "WAF",
    "label": "Waana (WAF)"
  },
  {
    "value": "PZH",
    "label": "Fort Sandeman (PZH)"
  },
  {
    "value": "IQA",
    "label": "HÄ«t (IQA)"
  },
  {
    "value": "BMN",
    "label": "Bamarni (BMN)"
  },
  {
    "value": "BGW",
    "label": "Baghdad (BGW)"
  },
  {
    "value": "OSB",
    "label": "Mosul (OSB)"
  },
  {
    "value": "EBL",
    "label": "Arbil (EBL)"
  },
  {
    "value": "KIK",
    "label": "Kirkuk (KIK)"
  },
  {
    "value": "BSR",
    "label": "Basrah (BSR)"
  },
  {
    "value": "OSO",
    "label": "Sulaymaniyah (OSO)"
  },
  {
    "value": "ALP",
    "label": "Aleppo (ALP)"
  },
  {
    "value": "DAM",
    "label": "Damascus (DAM)"
  },
  {
    "value": "DEZ",
    "label": "Deir ez-Zor (DEZ)"
  },
  {
    "value": "OSE",
    "label": "Omora Airport (OSE)"
  },
  {
    "value": "OSG",
    "label": "Ossima (OSG)"
  },
  {
    "value": "KAC",
    "label": "Kamishly (KAC)"
  },
  {
    "value": "LTK",
    "label": "Latakia (LTK)"
  },
  {
    "value": "PMS",
    "label": "Palmyra Airport (PMS)"
  },
  {
    "value": "DOH",
    "label": "Doha (DOH)"
  },
  {
    "value": "IUD",
    "label": "Ar Rayyan (IUD)"
  },
  {
    "value": "OTT",
    "label": "CotriguaÃ§u (OTT)"
  },
  {
    "value": "ADE",
    "label": "Aden (ADE)"
  },
  {
    "value": "EAB",
    "label": "Abbse (EAB)"
  },
  {
    "value": "AXK",
    "label": "Ataq Airport (AXK)"
  },
  {
    "value": "BHN",
    "label": "Beihan Airport (BHN)"
  },
  {
    "value": "AAY",
    "label": "Al Ghaidah International Airport (AAY)"
  },
  {
    "value": "HOD",
    "label": "Hodeida (HOD)"
  },
  {
    "value": "MYN",
    "label": "Mareb (MYN)"
  },
  {
    "value": "IHN",
    "label": "Qishn (IHN)"
  },
  {
    "value": "RIY",
    "label": "Riyan (RIY)"
  },
  {
    "value": "SYE",
    "label": "Sadah (SYE)"
  },
  {
    "value": "SAH",
    "label": "Sana'a (SAH)"
  },
  {
    "value": "SCT",
    "label": "Socotra Islands (SCT)"
  },
  {
    "value": "GXF",
    "label": "Sayun (GXF)"
  },
  {
    "value": "TAI",
    "label": "Ta'izz (TAI)"
  },
  {
    "value": "ACU",
    "label": "Achutupo (ACU)"
  },
  {
    "value": "AIL",
    "label": "Alligandi (AIL)"
  },
  {
    "value": "AML",
    "label": "Puerto Armuelles (AML)"
  },
  {
    "value": "BFQ",
    "label": "Bahia PiÃ±a (BFQ)"
  },
  {
    "value": "ELE",
    "label": "El Real (ELE)"
  },
  {
    "value": "OTD",
    "label": "Contadora Island (OTD)"
  },
  {
    "value": "SAX",
    "label": "Boca de SÃ¡balo (SAX)"
  },
  {
    "value": "AKB",
    "label": "Atka (AKB)"
  },
  {
    "value": "PTD",
    "label": "Port Alexander (PTD)"
  },
  {
    "value": "PAQ",
    "label": "Palmer (PAQ)"
  },
  {
    "value": "BTI",
    "label": "Barter Island Lrrs (BTI)"
  },
  {
    "value": "BET",
    "label": "Bethel (BET)"
  },
  {
    "value": "BVU",
    "label": "Beluga (BVU)"
  },
  {
    "value": "BIG",
    "label": "Delta Junction Ft Greely (BIG)"
  },
  {
    "value": "BKC",
    "label": "Buckland (BKC)"
  },
  {
    "value": "BMX",
    "label": "Big Mountain (BMX)"
  },
  {
    "value": "BRW",
    "label": "Barrow (BRW)"
  },
  {
    "value": "BTT",
    "label": "Bettles (BTT)"
  },
  {
    "value": "CDB",
    "label": "Cold Bay (CDB)"
  },
  {
    "value": "CDV",
    "label": "Cordova (CDV)"
  },
  {
    "value": "CZF",
    "label": "Cape Romanzof (CZF)"
  },
  {
    "value": "DRG",
    "label": "Deering (DRG)"
  },
  {
    "value": "ADK",
    "label": "Adak Island (ADK)"
  },
  {
    "value": "DLG",
    "label": "Dillingham (DLG)"
  },
  {
    "value": "ADQ",
    "label": "Kodiak (ADQ)"
  },
  {
    "value": "DUT",
    "label": "Unalaska (DUT)"
  },
  {
    "value": "EDF",
    "label": "Anchorage (EDF)"
  },
  {
    "value": "EEK",
    "label": "Eek (EEK)"
  },
  {
    "value": "EHM",
    "label": "Cape Newenham (EHM)"
  },
  {
    "value": "EIL",
    "label": "Fairbanks (EIL)"
  },
  {
    "value": "EMK",
    "label": "Emmonak (EMK)"
  },
  {
    "value": "ENA",
    "label": "Kenai (ENA)"
  },
  {
    "value": "FAI",
    "label": "Fairbanks (FAI)"
  },
  {
    "value": "FBK",
    "label": "Fairbanks/Ft Wainwright (FBK)"
  },
  {
    "value": "AFE",
    "label": "Kake (AFE)"
  },
  {
    "value": "ABL",
    "label": "Ambler (ABL)"
  },
  {
    "value": "FRN",
    "label": "Fort Richardson(Anchorage) (FRN)"
  },
  {
    "value": "FMC",
    "label": "Five Mile (FMC)"
  },
  {
    "value": "GAL",
    "label": "Galena (GAL)"
  },
  {
    "value": "GKN",
    "label": "Gulkana (GKN)"
  },
  {
    "value": "GAM",
    "label": "Gambell (GAM)"
  },
  {
    "value": "AGN",
    "label": "Angoon (AGN)"
  },
  {
    "value": "GST",
    "label": "Gustavus (GST)"
  },
  {
    "value": "SGY",
    "label": "Skagway (SGY)"
  },
  {
    "value": "HCR",
    "label": "Holy Cross (HCR)"
  },
  {
    "value": "HNS",
    "label": "Haines (HNS)"
  },
  {
    "value": "HOM",
    "label": "Homer (HOM)"
  },
  {
    "value": "HPB",
    "label": "Hooper Bay (HPB)"
  },
  {
    "value": "HYG",
    "label": "Hydaburg (HYG)"
  },
  {
    "value": "IGG",
    "label": "Igiugig (IGG)"
  },
  {
    "value": "EGX",
    "label": "Egegik (EGX)"
  },
  {
    "value": "IAN",
    "label": "Kiana (IAN)"
  },
  {
    "value": "ILI",
    "label": "Iliamna (ILI)"
  },
  {
    "value": "UTO",
    "label": "Utopia Creek (UTO)"
  },
  {
    "value": "JNU",
    "label": "Juneau (JNU)"
  },
  {
    "value": "KFP",
    "label": "False Pass (KFP)"
  },
  {
    "value": "AKK",
    "label": "Akhiok (AKK)"
  },
  {
    "value": "AKN",
    "label": "King Salmon (AKN)"
  },
  {
    "value": "IKO",
    "label": "Nikolski (IKO)"
  },
  {
    "value": "AKP",
    "label": "Anaktuvuk Pass (AKP)"
  },
  {
    "value": "KTN",
    "label": "Ketchikan (KTN)"
  },
  {
    "value": "KAL",
    "label": "Kaltag (KAL)"
  },
  {
    "value": "AKW",
    "label": "Klawock (AKW)"
  },
  {
    "value": "KLG",
    "label": "Kalskag (KLG)"
  },
  {
    "value": "LUR",
    "label": "Cape Lisburne (LUR)"
  },
  {
    "value": "MCG",
    "label": "McGrath (MCG)"
  },
  {
    "value": "MOU",
    "label": "Mountain Village (MOU)"
  },
  {
    "value": "MRI",
    "label": "Anchorage (MRI)"
  },
  {
    "value": "MYU",
    "label": "Mekoryuk (MYU)"
  },
  {
    "value": "WNA",
    "label": "Napakiak (WNA)"
  },
  {
    "value": "ANC",
    "label": "Anchorage (ANC)"
  },
  {
    "value": "ANI",
    "label": "Aniak (ANI)"
  },
  {
    "value": "ENN",
    "label": "Nenana (ENN)"
  },
  {
    "value": "ANN",
    "label": "Annette (ANN)"
  },
  {
    "value": "ANV",
    "label": "Anvik (ANV)"
  },
  {
    "value": "KNW",
    "label": "New Stuyahok (KNW)"
  },
  {
    "value": "HNH",
    "label": "Hoonah (HNH)"
  },
  {
    "value": "OME",
    "label": "Nome (OME)"
  },
  {
    "value": "ORT",
    "label": "Northway (ORT)"
  },
  {
    "value": "OTZ",
    "label": "Kotzebue (OTZ)"
  },
  {
    "value": "PBV",
    "label": "St George (PBV)"
  },
  {
    "value": "KPC",
    "label": "Port Clarence (KPC)"
  },
  {
    "value": "PSG",
    "label": "Petersburg (PSG)"
  },
  {
    "value": "PTH",
    "label": "Port Heiden (PTH)"
  },
  {
    "value": "PTU",
    "label": "Platinum (PTU)"
  },
  {
    "value": "PHO",
    "label": "Point Hope (PHO)"
  },
  {
    "value": "NUI",
    "label": "Nuiqsut (NUI)"
  },
  {
    "value": "ARC",
    "label": "Arctic Village (ARC)"
  },
  {
    "value": "RBY",
    "label": "Ruby (RBY)"
  },
  {
    "value": "SVA",
    "label": "Savoonga (SVA)"
  },
  {
    "value": "SCC",
    "label": "Deadhorse (SCC)"
  },
  {
    "value": "SDP",
    "label": "Sand Point (SDP)"
  },
  {
    "value": "SHH",
    "label": "Shishmaref (SHH)"
  },
  {
    "value": "SIT",
    "label": "Sitka (SIT)"
  },
  {
    "value": "KSM",
    "label": "St Mary's (KSM)"
  },
  {
    "value": "SNP",
    "label": "St Paul Island (SNP)"
  },
  {
    "value": "SVW",
    "label": "Sparrevohn (SVW)"
  },
  {
    "value": "SXQ",
    "label": "Soldotna (SXQ)"
  },
  {
    "value": "SYA",
    "label": "Shemya (SYA)"
  },
  {
    "value": "TOG",
    "label": "Togiak Village (TOG)"
  },
  {
    "value": "TKJ",
    "label": "Tok (TKJ)"
  },
  {
    "value": "TLJ",
    "label": "Takotna (TLJ)"
  },
  {
    "value": "ATK",
    "label": "Atqasuk (ATK)"
  },
  {
    "value": "AUK",
    "label": "Alakanuk (AUK)"
  },
  {
    "value": "VAK",
    "label": "Chevak (VAK)"
  },
  {
    "value": "KVC",
    "label": "King Cove (KVC)"
  },
  {
    "value": "VDZ",
    "label": "Valdez (VDZ)"
  },
  {
    "value": "KVL",
    "label": "Kivalina (KVL)"
  },
  {
    "value": "SWD",
    "label": "Seward (SWD)"
  },
  {
    "value": "WRG",
    "label": "Wrangell (WRG)"
  },
  {
    "value": "AIN",
    "label": "Wainwright (AIN)"
  },
  {
    "value": "WTK",
    "label": "Noatak (WTK)"
  },
  {
    "value": "IYS",
    "label": "Wasilla (IYS)"
  },
  {
    "value": "CIS",
    "label": "Abariringa (CIS)"
  },
  {
    "value": "PCQ",
    "label": "Phongsaly (PCQ)"
  },
  {
    "value": "PDI",
    "label": "Pindiu (PDI)"
  },
  {
    "value": "MFT",
    "label": "Machu Pichu (MFT)"
  },
  {
    "value": "AKI",
    "label": "Akiak (AKI)"
  },
  {
    "value": "AET",
    "label": "Allakaket (AET)"
  },
  {
    "value": "PFC",
    "label": "Pacific City (PFC)"
  },
  {
    "value": "FYU",
    "label": "Fort Yukon (FYU)"
  },
  {
    "value": "ERE",
    "label": "Erave (ERE)"
  },
  {
    "value": "ESA",
    "label": "Esa'ala (ESA)"
  },
  {
    "value": "BPD",
    "label": "Bapi Airstrip (BPD)"
  },
  {
    "value": "BPK",
    "label": "Biangabip Airport (BPK)"
  },
  {
    "value": "AKG",
    "label": "Anguganak (AKG)"
  },
  {
    "value": "TAJ",
    "label": "Aitape (TAJ)"
  },
  {
    "value": "AWB",
    "label": "Awaba (AWB)"
  },
  {
    "value": "BAA",
    "label": "Bialla, Matalilu, Ewase (BAA)"
  },
  {
    "value": "CVB",
    "label": "Chungribu Airport (CVB)"
  },
  {
    "value": "GMI",
    "label": "Gasmata Island (GMI)"
  },
  {
    "value": "GVI",
    "label": "Green River (GVI)"
  },
  {
    "value": "HYF",
    "label": "Bainyik (HYF)"
  },
  {
    "value": "IHU",
    "label": "Ihu (IHU)"
  },
  {
    "value": "IIS",
    "label": "Nissan Island (IIS)"
  },
  {
    "value": "JAQ",
    "label": "Jacquinot Bay (JAQ)"
  },
  {
    "value": "KDR",
    "label": "Kandrian (KDR)"
  },
  {
    "value": "KKD",
    "label": "Kokoda (KKD)"
  },
  {
    "value": "KUY",
    "label": "Kamusi (KUY)"
  },
  {
    "value": "KWO",
    "label": "Kawito (KWO)"
  },
  {
    "value": "KXR",
    "label": "Buka Island (KXR)"
  },
  {
    "value": "LMI",
    "label": "Lumi (LMI)"
  },
  {
    "value": "LMY",
    "label": "Lake Murray (LMY)"
  },
  {
    "value": "OBX",
    "label": "Obo (OBX)"
  },
  {
    "value": "OPU",
    "label": "Balimo (OPU)"
  },
  {
    "value": "SKC",
    "label": "Suki (SKC)"
  },
  {
    "value": "TFI",
    "label": "Tufi (TFI)"
  },
  {
    "value": "TFM",
    "label": "Telefomin (TFM)"
  },
  {
    "value": "TLO",
    "label": "Tol (TLO)"
  },
  {
    "value": "UKU",
    "label": "Nuku (UKU)"
  },
  {
    "value": "ULE",
    "label": "Sule (ULE)"
  },
  {
    "value": "VMU",
    "label": "Baimuru (VMU)"
  },
  {
    "value": "WPM",
    "label": "Wipim (WPM)"
  },
  {
    "value": "PGE",
    "label": "Yegepa Airport (PGE)"
  },
  {
    "value": "ROP",
    "label": "Rota Island (ROP)"
  },
  {
    "value": "SPN",
    "label": "Saipan Island (SPN)"
  },
  {
    "value": "UAM",
    "label": "Andersen,Mariana Island (UAM)"
  },
  {
    "value": "GUM",
    "label": "HagÃ¥tÃ±a, Guam International Airport (GUM)"
  },
  {
    "value": "TIQ",
    "label": "Tinian Island (TIQ)"
  },
  {
    "value": "ENI",
    "label": "El Nido (ENI)"
  },
  {
    "value": "BKH",
    "label": "Kekaha (BKH)"
  },
  {
    "value": "HDH",
    "label": "Mokuleia (HDH)"
  },
  {
    "value": "HHI",
    "label": "Wahiawa (HHI)"
  },
  {
    "value": "HNM",
    "label": "Hana (HNM)"
  },
  {
    "value": "JHM",
    "label": "Lahaina (JHM)"
  },
  {
    "value": "JRF",
    "label": "Kapolei (JRF)"
  },
  {
    "value": "KOA",
    "label": "Kailua/Kona (KOA)"
  },
  {
    "value": "LIH",
    "label": "Lihue (LIH)"
  },
  {
    "value": "LUP",
    "label": "Kalaupapa (LUP)"
  },
  {
    "value": "MKK",
    "label": "Kaunakakai (MKK)"
  },
  {
    "value": "MUE",
    "label": "Kamuela (MUE)"
  },
  {
    "value": "HNL",
    "label": "Honolulu (HNL)"
  },
  {
    "value": "LNY",
    "label": "Lanai City (LNY)"
  },
  {
    "value": "OGG",
    "label": "Kahului (OGG)"
  },
  {
    "value": "BSF",
    "label": "Camp Pohakuloa (BSF)"
  },
  {
    "value": "ITO",
    "label": "Hilo (ITO)"
  },
  {
    "value": "UPP",
    "label": "Hawi (UPP)"
  },
  {
    "value": "JON",
    "label": "Johnston Atoll (JON)"
  },
  {
    "value": "BHC",
    "label": "Bhurban (BHC)"
  },
  {
    "value": "CWP",
    "label": "Campbellpore (CWP)"
  },
  {
    "value": "GRT",
    "label": "Gujrat (GRT)"
  },
  {
    "value": "HRA",
    "label": "Mansehra (HRA)"
  },
  {
    "value": "KCF",
    "label": "Kadanwari (KCF)"
  },
  {
    "value": "REQ",
    "label": "Chagai (REQ)"
  },
  {
    "value": "ENT",
    "label": "Eniwetok Atoll (ENT)"
  },
  {
    "value": "MAJ",
    "label": "Majuro Atoll (MAJ)"
  },
  {
    "value": "KIA",
    "label": "Kaieteur Falls (KIA)"
  },
  {
    "value": "KWA",
    "label": "Kwajalein (KWA)"
  },
  {
    "value": "CXI",
    "label": "Banana (CXI)"
  },
  {
    "value": "PLE",
    "label": "Paiela Airport (PLE)"
  },
  {
    "value": "TNV",
    "label": "Tabuaeran Island (TNV)"
  },
  {
    "value": "MDY",
    "label": "Sand Island (MDY)"
  },
  {
    "value": "PMP",
    "label": "Pimaga Airport (PMP)"
  },
  {
    "value": "PIZ",
    "label": "Point Lay (PIZ)"
  },
  {
    "value": "PQD",
    "label": "Batticaloa (PQD)"
  },
  {
    "value": "DDP",
    "label": "Dorado (DDP)"
  },
  {
    "value": "HUC",
    "label": "Humacao (HUC)"
  },
  {
    "value": "PPD",
    "label": "Palmas del Mar (PPD)"
  },
  {
    "value": "TKK",
    "label": "Weno Island (TKK)"
  },
  {
    "value": "PNI",
    "label": "Pohnpei Island (PNI)"
  },
  {
    "value": "ROR",
    "label": "Babelthuap Island (ROR)"
  },
  {
    "value": "KSA",
    "label": "Okat (KSA)"
  },
  {
    "value": "YAP",
    "label": "Yap Island (YAP)"
  },
  {
    "value": "AWK",
    "label": "Wake Island (AWK)"
  },
  {
    "value": "BFA",
    "label": "BahÃ­a Negra (BFA)"
  },
  {
    "value": "OLK",
    "label": "Fuerte Olimpo (OLK)"
  },
  {
    "value": "PBT",
    "label": "Puerto Leda (PBT)"
  },
  {
    "value": "PCJ",
    "label": "Puerto La Victoria (PCJ)"
  },
  {
    "value": "KIO",
    "label": "Kili Island (KIO)"
  },
  {
    "value": "QFX",
    "label": "Igaliku (QFX)"
  },
  {
    "value": "RAW",
    "label": "Arawa (RAW)"
  },
  {
    "value": "RAX",
    "label": "Oram Airport (RAX)"
  },
  {
    "value": "RBP",
    "label": "Rabaraba (RBP)"
  },
  {
    "value": "KNH",
    "label": "Shang-I (KNH)"
  },
  {
    "value": "LZN",
    "label": "Nangang Island (LZN)"
  },
  {
    "value": "TTT",
    "label": "Taitung City (TTT)"
  },
  {
    "value": "GNI",
    "label": "Lyudao (GNI)"
  },
  {
    "value": "KHH",
    "label": "Kaohsiung City (KHH)"
  },
  {
    "value": "CYI",
    "label": "Chiayi City (CYI)"
  },
  {
    "value": "HCN",
    "label": "Hengchung (HCN)"
  },
  {
    "value": "TXG",
    "label": "Taichung City (TXG)"
  },
  {
    "value": "KYD",
    "label": "Orchid Island (KYD)"
  },
  {
    "value": "RMQ",
    "label": "Taichung City (RMQ)"
  },
  {
    "value": "MFK",
    "label": "Beigan Island (MFK)"
  },
  {
    "value": "TNN",
    "label": "Tainan City (TNN)"
  },
  {
    "value": "MZG",
    "label": "Makung City (MZG)"
  },
  {
    "value": "PIF",
    "label": "Pingtung (PIF)"
  },
  {
    "value": "TSA",
    "label": "Taipei City (TSA)"
  },
  {
    "value": "TPE",
    "label": "Taipei (TPE)"
  },
  {
    "value": "WOT",
    "label": "Wang-an (WOT)"
  },
  {
    "value": "HUN",
    "label": "Hualien City (HUN)"
  },
  {
    "value": "NRT",
    "label": "Tokyo (NRT)"
  },
  {
    "value": "MMJ",
    "label": "Matsumoto (MMJ)"
  },
  {
    "value": "IBR",
    "label": "Omitama (IBR)"
  },
  {
    "value": "MUS",
    "label": "Minami Torishima Airport (MUS)"
  },
  {
    "value": "IWO",
    "label": "Iwo Jima Airport (IWO)"
  },
  {
    "value": "KIX",
    "label": "Osaka (KIX)"
  },
  {
    "value": "SHM",
    "label": "Shirahama (SHM)"
  },
  {
    "value": "UKB",
    "label": "Kobe (UKB)"
  },
  {
    "value": "HIW",
    "label": "Hiroshimanishi Airport (HIW)"
  },
  {
    "value": "TJH",
    "label": "Tajima (TJH)"
  },
  {
    "value": "OBO",
    "label": "Obihiro (OBO)"
  },
  {
    "value": "CTS",
    "label": "Chitose / Tomakomai (CTS)"
  },
  {
    "value": "HKD",
    "label": "Hakodate (HKD)"
  },
  {
    "value": "KUH",
    "label": "Kushiro (KUH)"
  },
  {
    "value": "MMB",
    "label": "ÅŒzora (MMB)"
  },
  {
    "value": "SHB",
    "label": "Nakashibetsu (SHB)"
  },
  {
    "value": "OKD",
    "label": "Sapporo (OKD)"
  },
  {
    "value": "RBJ",
    "label": "Rebun Airport Airport (RBJ)"
  },
  {
    "value": "WKJ",
    "label": "Wakkanai (WKJ)"
  },
  {
    "value": "IKI",
    "label": "Iki (IKI)"
  },
  {
    "value": "UBJ",
    "label": "Ube (UBJ)"
  },
  {
    "value": "TSJ",
    "label": "Tsushima (TSJ)"
  },
  {
    "value": "MBE",
    "label": "Monbetsu (MBE)"
  },
  {
    "value": "AKJ",
    "label": "Asahikawa / HokkaidÅ (AKJ)"
  },
  {
    "value": "OIR",
    "label": "Okushiri Airport (OIR)"
  },
  {
    "value": "RIS",
    "label": "Rishiri (RIS)"
  },
  {
    "value": "KUM",
    "label": "Yakushima Airport (KUM)"
  },
  {
    "value": "FUJ",
    "label": "Goto (FUJ)"
  },
  {
    "value": "FUK",
    "label": "Fukuoka (FUK)"
  },
  {
    "value": "TNE",
    "label": "New Tanegashima Airport (TNE)"
  },
  {
    "value": "KOJ",
    "label": "Kagoshima (KOJ)"
  },
  {
    "value": "KMI",
    "label": "Miyazaki (KMI)"
  },
  {
    "value": "OIT",
    "label": "Oita (OIT)"
  },
  {
    "value": "KKJ",
    "label": "KitakyÅ«shÅ« (KKJ)"
  },
  {
    "value": "HSG",
    "label": "Saga (HSG)"
  },
  {
    "value": "KMJ",
    "label": "Kumamoto (KMJ)"
  },
  {
    "value": "NGS",
    "label": "Nagasaki (NGS)"
  },
  {
    "value": "NGO",
    "label": "Nagoya (NGO)"
  },
  {
    "value": "ASJ",
    "label": "Amami (ASJ)"
  },
  {
    "value": "OKE",
    "label": "Okierabu Airport (OKE)"
  },
  {
    "value": "KKX",
    "label": "Kikai Airport (KKX)"
  },
  {
    "value": "TKN",
    "label": "Tokunoshima (TKN)"
  },
  {
    "value": "NKM",
    "label": "Nagoya (NKM)"
  },
  {
    "value": "FKJ",
    "label": "Fukui Airport (FKJ)"
  },
  {
    "value": "QGU",
    "label": "Gifu (QGU)"
  },
  {
    "value": "KMQ",
    "label": "Kanazawa (KMQ)"
  },
  {
    "value": "OKI",
    "label": "Okinoshima (OKI)"
  },
  {
    "value": "TOY",
    "label": "Toyama (TOY)"
  },
  {
    "value": "NTQ",
    "label": "Wajima (NTQ)"
  },
  {
    "value": "HIJ",
    "label": "Hiroshima (HIJ)"
  },
  {
    "value": "OKJ",
    "label": "Okayama City (OKJ)"
  },
  {
    "value": "IZO",
    "label": "Izumo (IZO)"
  },
  {
    "value": "YGJ",
    "label": "Yonago (YGJ)"
  },
  {
    "value": "KCZ",
    "label": "Nankoku (KCZ)"
  },
  {
    "value": "MYJ",
    "label": "Matsuyama (MYJ)"
  },
  {
    "value": "ITM",
    "label": "Osaka (ITM)"
  },
  {
    "value": "TTJ",
    "label": "Tottori (TTJ)"
  },
  {
    "value": "TKS",
    "label": "Tokushima (TKS)"
  },
  {
    "value": "TAK",
    "label": "Takamatsu (TAK)"
  },
  {
    "value": "IWJ",
    "label": "Masuda (IWJ)"
  },
  {
    "value": "AOJ",
    "label": "Aomori (AOJ)"
  },
  {
    "value": "GAJ",
    "label": "Yamagata (GAJ)"
  },
  {
    "value": "SDS",
    "label": "Sado Airport (SDS)"
  },
  {
    "value": "FKS",
    "label": "Sukagawa (FKS)"
  },
  {
    "value": "HHE",
    "label": "Hachinohe Airport (HHE)"
  },
  {
    "value": "HNA",
    "label": "Hanamaki Airport (HNA)"
  },
  {
    "value": "AXT",
    "label": "Akita (AXT)"
  },
  {
    "value": "MSJ",
    "label": "Misawa (MSJ)"
  },
  {
    "value": "KIJ",
    "label": "Niigata (KIJ)"
  },
  {
    "value": "ONJ",
    "label": "Odate (ONJ)"
  },
  {
    "value": "SDJ",
    "label": "Sendai (SDJ)"
  },
  {
    "value": "SYO",
    "label": "Shonai (SYO)"
  },
  {
    "value": "NJA",
    "label": "Atsugi Naval Air Facility (NJA)"
  },
  {
    "value": "HAC",
    "label": "Hachijojima (HAC)"
  },
  {
    "value": "OIM",
    "label": "Izu Oshima (OIM)"
  },
  {
    "value": "MYE",
    "label": "Miyakejima (MYE)"
  },
  {
    "value": "HND",
    "label": "Tokyo (HND)"
  },
  {
    "value": "QUT",
    "label": "Utsunomiya Airport (QUT)"
  },
  {
    "value": "OKO",
    "label": "Fussa (OKO)"
  },
  {
    "value": "MWX",
    "label": "Muan International Airport (MWX)"
  },
  {
    "value": "KWJ",
    "label": "Gwangju (KWJ)"
  },
  {
    "value": "KUV",
    "label": "Kunsan (KUV)"
  },
  {
    "value": "CHN",
    "label": "Jeon Ju (CHN)"
  },
  {
    "value": "RSU",
    "label": "Yeosu (RSU)"
  },
  {
    "value": "QUN",
    "label": "Chun Chon City (QUN)"
  },
  {
    "value": "SHO",
    "label": "Sokcho Airport (SHO)"
  },
  {
    "value": "KAG",
    "label": "Gangneung Airport (KAG)"
  },
  {
    "value": "WJU",
    "label": "Wonju (WJU)"
  },
  {
    "value": "YNY",
    "label": "Sokcho / Gangneung (YNY)"
  },
  {
    "value": "CJU",
    "label": "Jeju City (CJU)"
  },
  {
    "value": "CHF",
    "label": "Jinhae (CHF)"
  },
  {
    "value": "PUS",
    "label": "Busan (PUS)"
  },
  {
    "value": "HIN",
    "label": "Sacheon (HIN)"
  },
  {
    "value": "USN",
    "label": "Ulsan (USN)"
  },
  {
    "value": "ICN",
    "label": "Seoul (ICN)"
  },
  {
    "value": "SSN",
    "label": "Seoul Air Base (SSN)"
  },
  {
    "value": "OSN",
    "label": "Osan Air Base (OSN)"
  },
  {
    "value": "GMP",
    "label": "Seoul (GMP)"
  },
  {
    "value": "SWU",
    "label": "Suwon Airport (SWU)"
  },
  {
    "value": "KPO",
    "label": "Pohang (KPO)"
  },
  {
    "value": "TAE",
    "label": "Daegu (TAE)"
  },
  {
    "value": "CJJ",
    "label": "Cheongju (CJJ)"
  },
  {
    "value": "YEC",
    "label": "Yecheon Airport (YEC)"
  },
  {
    "value": "RKU",
    "label": "Yule Island (RKU)"
  },
  {
    "value": "OKA",
    "label": "Naha (OKA)"
  },
  {
    "value": "DNA",
    "label": "Kadena Air Base (DNA)"
  },
  {
    "value": "UEO",
    "label": "Kumejima Airport (UEO)"
  },
  {
    "value": "KJP",
    "label": "Kerama (KJP)"
  },
  {
    "value": "MMD",
    "label": "Minami Daito Airport (MMD)"
  },
  {
    "value": "MMY",
    "label": "Miyako City (MMY)"
  },
  {
    "value": "AGJ",
    "label": "Aguni (AGJ)"
  },
  {
    "value": "IEJ",
    "label": "Ie Jima Airport (IEJ)"
  },
  {
    "value": "HTR",
    "label": "Hateruma (HTR)"
  },
  {
    "value": "KTD",
    "label": "Kitadaito Airport (KTD)"
  },
  {
    "value": "SHI",
    "label": "Shimojishima Airport (SHI)"
  },
  {
    "value": "TRA",
    "label": "Tarama Airport (TRA)"
  },
  {
    "value": "RNJ",
    "label": "Yoron Airport (RNJ)"
  },
  {
    "value": "OGN",
    "label": "Yonaguni Airport (OGN)"
  },
  {
    "value": "SFS",
    "label": "Olongapo City (SFS)"
  },
  {
    "value": "CRK",
    "label": "Angeles City (CRK)"
  },
  {
    "value": "LAO",
    "label": "Laoag City (LAO)"
  },
  {
    "value": "MNL",
    "label": "Manila (MNL)"
  },
  {
    "value": "CYU",
    "label": "Cuyo (CYU)"
  },
  {
    "value": "LGP",
    "label": "Legazpi City (LGP)"
  },
  {
    "value": "NSP",
    "label": "Cavite City (NSP)"
  },
  {
    "value": "LBX",
    "label": "Lubang Airport (LBX)"
  },
  {
    "value": "AAV",
    "label": "Surallah (AAV)"
  },
  {
    "value": "GES",
    "label": "General Santos City (GES)"
  },
  {
    "value": "CBO",
    "label": "Cotabato City (CBO)"
  },
  {
    "value": "DVO",
    "label": "Davao City (DVO)"
  },
  {
    "value": "BXU",
    "label": "Butuan City (BXU)"
  },
  {
    "value": "BPH",
    "label": "Bislig Airport (BPH)"
  },
  {
    "value": "DPL",
    "label": "Dipolog City (DPL)"
  },
  {
    "value": "CGM",
    "label": "Camiguin Airport (CGM)"
  },
  {
    "value": "IGN",
    "label": "Iligan Airport (IGN)"
  },
  {
    "value": "JOL",
    "label": "Jolo Airport (JOL)"
  },
  {
    "value": "CGY",
    "label": "Cagayan De Oro City (CGY)"
  },
  {
    "value": "MLP",
    "label": "Malabang (MLP)"
  },
  {
    "value": "SGS",
    "label": "Sanga Sanga Airport (SGS)"
  },
  {
    "value": "OZC",
    "label": "Ozamiz City (OZC)"
  },
  {
    "value": "PAG",
    "label": "Pagadian City (PAG)"
  },
  {
    "value": "MXI",
    "label": "Mati National Airport (MXI)"
  },
  {
    "value": "SUG",
    "label": "Surigao City (SUG)"
  },
  {
    "value": "CDY",
    "label": "Mapun (CDY)"
  },
  {
    "value": "IPE",
    "label": "Ipil (IPE)"
  },
  {
    "value": "TDG",
    "label": "Tandag Airport (TDG)"
  },
  {
    "value": "ZAM",
    "label": "Zamboanga City (ZAM)"
  },
  {
    "value": "IAO",
    "label": "Del Carmen (IAO)"
  },
  {
    "value": "BAG",
    "label": "Baguio City (BAG)"
  },
  {
    "value": "DTE",
    "label": "Daet (DTE)"
  },
  {
    "value": "SJI",
    "label": "San Jose (SJI)"
  },
  {
    "value": "MBO",
    "label": "Mamburao Airport (MBO)"
  },
  {
    "value": "WNP",
    "label": "Naga (WNP)"
  },
  {
    "value": "BSO",
    "label": "Basco (BSO)"
  },
  {
    "value": "BQA",
    "label": "Baler (BQA)"
  },
  {
    "value": "SFE",
    "label": "San Fernando Airport (SFE)"
  },
  {
    "value": "TUG",
    "label": "Tuguegarao City (TUG)"
  },
  {
    "value": "VRC",
    "label": "Virac (VRC)"
  },
  {
    "value": "MRQ",
    "label": "Gasan (MRQ)"
  },
  {
    "value": "CYZ",
    "label": "Cauayan City (CYZ)"
  },
  {
    "value": "TAC",
    "label": "Tacloban City (TAC)"
  },
  {
    "value": "BCD",
    "label": "Bacolod City (BCD)"
  },
  {
    "value": "CYP",
    "label": "Calbayog City (CYP)"
  },
  {
    "value": "DGT",
    "label": "Dumaguete City (DGT)"
  },
  {
    "value": "MPH",
    "label": "Malay (MPH)"
  },
  {
    "value": "CRM",
    "label": "Catarman (CRM)"
  },
  {
    "value": "GUI",
    "label": "Guiuan (GUI)"
  },
  {
    "value": "ILO",
    "label": "Iloilo City (ILO)"
  },
  {
    "value": "MBT",
    "label": "Masbate (MBT)"
  },
  {
    "value": "KLO",
    "label": "Kalibo (KLO)"
  },
  {
    "value": "CEB",
    "label": "Lapu-Lapu City (CEB)"
  },
  {
    "value": "OMC",
    "label": "Ormoc City (OMC)"
  },
  {
    "value": "PPS",
    "label": "Puerto Princesa City (PPS)"
  },
  {
    "value": "RXS",
    "label": "Roxas City (RXS)"
  },
  {
    "value": "EUQ",
    "label": "San Jose (EUQ)"
  },
  {
    "value": "TAG",
    "label": "Tagbilaran City (TAG)"
  },
  {
    "value": "TBH",
    "label": "Romblon (TBH)"
  },
  {
    "value": "USU",
    "label": "Coron (USU)"
  },
  {
    "value": "BPR",
    "label": "Borongan City (BPR)"
  },
  {
    "value": "NGK",
    "label": "Nogliki-Sakhalin Island (NGK)"
  },
  {
    "value": "GRV",
    "label": "Grozny (GRV)"
  },
  {
    "value": "LNX",
    "label": "Smolensk (LNX)"
  },
  {
    "value": "VUS",
    "label": "Velikiy Ustyug (VUS)"
  },
  {
    "value": "RUU",
    "label": "Kawbenaberi (RUU)"
  },
  {
    "value": "LPS",
    "label": "Lopez (LPS)"
  },
  {
    "value": "MJR",
    "label": "Miramar (MJR)"
  },
  {
    "value": "CCT",
    "label": "Colonia Catriel (CCT)"
  },
  {
    "value": "COC",
    "label": "Concordia (COC)"
  },
  {
    "value": "GHU",
    "label": "Gualeguaychu (GHU)"
  },
  {
    "value": "JNI",
    "label": "Junin (JNI)"
  },
  {
    "value": "PRA",
    "label": "Parana (PRA)"
  },
  {
    "value": "ROS",
    "label": "Rosario (ROS)"
  },
  {
    "value": "SFN",
    "label": "Santa Fe (SFN)"
  },
  {
    "value": "AEP",
    "label": "Buenos Aires (AEP)"
  },
  {
    "value": "LCM",
    "label": "La Cumbre (LCM)"
  },
  {
    "value": "COR",
    "label": "Cordoba (COR)"
  },
  {
    "value": "FDO",
    "label": "San Fernando (FDO)"
  },
  {
    "value": "LPG",
    "label": "La Plata (LPG)"
  },
  {
    "value": "EPA",
    "label": "El Palomar (EPA)"
  },
  {
    "value": "EZE",
    "label": "Ezeiza (EZE)"
  },
  {
    "value": "HOS",
    "label": "Chos Malal (HOS)"
  },
  {
    "value": "CVH",
    "label": "Lafontaine (CVH)"
  },
  {
    "value": "GNR",
    "label": "General Roca (GNR)"
  },
  {
    "value": "RDS",
    "label": "Rincon de los Sauces (RDS)"
  },
  {
    "value": "APZ",
    "label": "Zapala (APZ)"
  },
  {
    "value": "MDZ",
    "label": "Mendoza (MDZ)"
  },
  {
    "value": "LGS",
    "label": "Malargue (LGS)"
  },
  {
    "value": "AFA",
    "label": "San Rafael (AFA)"
  },
  {
    "value": "CTC",
    "label": "Catamarca (CTC)"
  },
  {
    "value": "SDE",
    "label": "Santiago del Estero (SDE)"
  },
  {
    "value": "RHD",
    "label": "Rio Hondo (RHD)"
  },
  {
    "value": "IRJ",
    "label": "La Rioja (IRJ)"
  },
  {
    "value": "TUC",
    "label": "San Miguel de Tucuman (TUC)"
  },
  {
    "value": "UAQ",
    "label": "San Juan (UAQ)"
  },
  {
    "value": "CRR",
    "label": "Ceres (CRR)"
  },
  {
    "value": "RCU",
    "label": "Rio Cuarto (RCU)"
  },
  {
    "value": "VDR",
    "label": "Villa Dolores (VDR)"
  },
  {
    "value": "RLO",
    "label": "Merlo (RLO)"
  },
  {
    "value": "LUQ",
    "label": "San Luis (LUQ)"
  },
  {
    "value": "CNQ",
    "label": "Corrientes (CNQ)"
  },
  {
    "value": "RES",
    "label": "Resistencia (RES)"
  },
  {
    "value": "FMA",
    "label": "Formosa (FMA)"
  },
  {
    "value": "IGR",
    "label": "Puerto Iguazu (IGR)"
  },
  {
    "value": "AOL",
    "label": "Paso de los Libres (AOL)"
  },
  {
    "value": "MCS",
    "label": "Monte Caseros (MCS)"
  },
  {
    "value": "PSS",
    "label": "Posadas (PSS)"
  },
  {
    "value": "SAS",
    "label": "Salton City (SAS)"
  },
  {
    "value": "SLA",
    "label": "Salta (SLA)"
  },
  {
    "value": "JUJ",
    "label": "San Salvador de Jujuy (JUJ)"
  },
  {
    "value": "ORA",
    "label": "OrÃ¡n (ORA)"
  },
  {
    "value": "TTG",
    "label": "Tartagal (TTG)"
  },
  {
    "value": "CLX",
    "label": "Clorinda (CLX)"
  },
  {
    "value": "ELO",
    "label": "El Dorado (ELO)"
  },
  {
    "value": "OYA",
    "label": "Goya (OYA)"
  },
  {
    "value": "LLS",
    "label": "Las Lomitas (LLS)"
  },
  {
    "value": "MDX",
    "label": "Mercedes (MDX)"
  },
  {
    "value": "RCQ",
    "label": "Reconquista (RCQ)"
  },
  {
    "value": "UZU",
    "label": "Curuzu Cuatia (UZU)"
  },
  {
    "value": "EHL",
    "label": "El Bolson (EHL)"
  },
  {
    "value": "CRD",
    "label": "Comodoro Rivadavia (CRD)"
  },
  {
    "value": "EMX",
    "label": "El Maiten (EMX)"
  },
  {
    "value": "EQS",
    "label": "Esquel (EQS)"
  },
  {
    "value": "LHS",
    "label": "Las Heras (LHS)"
  },
  {
    "value": "IGB",
    "label": "Ingeniero Jacobacci (IGB)"
  },
  {
    "value": "OES",
    "label": "San Antonio Oeste (OES)"
  },
  {
    "value": "MQD",
    "label": "Maquinchao (MQD)"
  },
  {
    "value": "ARR",
    "label": "Alto Rio Senguerr (ARR)"
  },
  {
    "value": "SGV",
    "label": "Sierra Grande (SGV)"
  },
  {
    "value": "REL",
    "label": "Rawson (REL)"
  },
  {
    "value": "VDM",
    "label": "Viedma / Carmen de Patagones (VDM)"
  },
  {
    "value": "PMY",
    "label": "Puerto Madryn (PMY)"
  },
  {
    "value": "ING",
    "label": "El Calafate (ING)"
  },
  {
    "value": "FTE",
    "label": "El Calafate (FTE)"
  },
  {
    "value": "PUD",
    "label": "Puerto Deseado (PUD)"
  },
  {
    "value": "RGA",
    "label": "Rio Grande (RGA)"
  },
  {
    "value": "RGL",
    "label": "Rio Gallegos (RGL)"
  },
  {
    "value": "USH",
    "label": "Ushuahia (USH)"
  },
  {
    "value": "ULA",
    "label": "San Julian (ULA)"
  },
  {
    "value": "ROY",
    "label": "Rio Mayo (ROY)"
  },
  {
    "value": "PMQ",
    "label": "Perito Moreno (PMQ)"
  },
  {
    "value": "GGS",
    "label": "Gobernador Gregores (GGS)"
  },
  {
    "value": "JSM",
    "label": "Chubut (JSM)"
  },
  {
    "value": "RYO",
    "label": "El Turbio (RYO)"
  },
  {
    "value": "RZA",
    "label": "Santa Cruz (RZA)"
  },
  {
    "value": "BHI",
    "label": "Bahia Blanca (BHI)"
  },
  {
    "value": "OVR",
    "label": "Olavarria (OVR)"
  },
  {
    "value": "GPO",
    "label": "General Pico (GPO)"
  },
  {
    "value": "OYO",
    "label": "Tres Arroyos (OYO)"
  },
  {
    "value": "SST",
    "label": "Santa Teresita (SST)"
  },
  {
    "value": "MDQ",
    "label": "Mar del Plata (MDQ)"
  },
  {
    "value": "NQN",
    "label": "Neuquen (NQN)"
  },
  {
    "value": "NEC",
    "label": "Necochea (NEC)"
  },
  {
    "value": "PEH",
    "label": "PehuajÃ³ (PEH)"
  },
  {
    "value": "RSA",
    "label": "Santa Rosa (RSA)"
  },
  {
    "value": "BRC",
    "label": "San Carlos de Bariloche (BRC)"
  },
  {
    "value": "TDL",
    "label": "Tandil (TDL)"
  },
  {
    "value": "VLG",
    "label": "Villa Gesell (VLG)"
  },
  {
    "value": "CUT",
    "label": "Cutral-Co (CUT)"
  },
  {
    "value": "CPC",
    "label": "Chapelco/San Martin de los Andes (CPC)"
  },
  {
    "value": "VIU",
    "label": "Viru (VIU)"
  },
  {
    "value": "CDJ",
    "label": "ConceiÃ§Ã£o Do Araguaia (CDJ)"
  },
  {
    "value": "AQA",
    "label": "Araraquara (AQA)"
  },
  {
    "value": "AJU",
    "label": "Aracaju (AJU)"
  },
  {
    "value": "AFL",
    "label": "Alta Floresta (AFL)"
  },
  {
    "value": "ARU",
    "label": "AraÃ§atuba (ARU)"
  },
  {
    "value": "AAX",
    "label": "AraxÃ¡ (AAX)"
  },
  {
    "value": "BEL",
    "label": "BelÃ©m (BEL)"
  },
  {
    "value": "BGX",
    "label": "BagÃ© (BGX)"
  },
  {
    "value": "PLU",
    "label": "Belo Horizonte (PLU)"
  },
  {
    "value": "BFH",
    "label": "Curitiba (BFH)"
  },
  {
    "value": "BJP",
    "label": "BraganÃ§a Paulista (BJP)"
  },
  {
    "value": "QAK",
    "label": "Barbacena (QAK)"
  },
  {
    "value": "BSB",
    "label": "Brasilia (BSB)"
  },
  {
    "value": "BAT",
    "label": "Barretos (BAT)"
  },
  {
    "value": "BAU",
    "label": "Bauru (BAU)"
  },
  {
    "value": "BVB",
    "label": "Boa Vista (BVB)"
  },
  {
    "value": "BPG",
    "label": "Barra Do GarÃ§as (BPG)"
  },
  {
    "value": "BZC",
    "label": "Cabo Frio (BZC)"
  },
  {
    "value": "CAC",
    "label": "Cascavel (CAC)"
  },
  {
    "value": "CFB",
    "label": "Cabo Frio (CFB)"
  },
  {
    "value": "ITB",
    "label": "Novo Progresso (ITB)"
  },
  {
    "value": "CNF",
    "label": "Belo Horizonte (CNF)"
  },
  {
    "value": "CGR",
    "label": "Campo Grande (CGR)"
  },
  {
    "value": "XAP",
    "label": "ChapecÃ³ (XAP)"
  },
  {
    "value": "CLN",
    "label": "Carolina (CLN)"
  },
  {
    "value": "CKS",
    "label": "CarajÃ¡s (CKS)"
  },
  {
    "value": "CCM",
    "label": "CriciÃºma (CCM)"
  },
  {
    "value": "CLV",
    "label": "Caldas Novas (CLV)"
  },
  {
    "value": "QNS",
    "label": "Porto Alegre (QNS)"
  },
  {
    "value": "CAW",
    "label": "Campos Dos Goytacazes (CAW)"
  },
  {
    "value": "CMG",
    "label": "CorumbÃ¡ (CMG)"
  },
  {
    "value": "CWB",
    "label": "Curitiba (CWB)"
  },
  {
    "value": "CRQ",
    "label": "Caravelas (CRQ)"
  },
  {
    "value": "CXJ",
    "label": "Caxias Do Sul (CXJ)"
  },
  {
    "value": "CGB",
    "label": "CuiabÃ¡ (CGB)"
  },
  {
    "value": "CZS",
    "label": "Cruzeiro Do Sul (CZS)"
  },
  {
    "value": "PPB",
    "label": "Presidente Prudente (PPB)"
  },
  {
    "value": "MAO",
    "label": "Manaus (MAO)"
  },
  {
    "value": "JCR",
    "label": "Jacareacanga (JCR)"
  },
  {
    "value": "ESI",
    "label": "Espinosa (ESI)"
  },
  {
    "value": "IGU",
    "label": "Foz Do IguaÃ§u (IGU)"
  },
  {
    "value": "FLN",
    "label": "FlorianÃ³polis (FLN)"
  },
  {
    "value": "FEN",
    "label": "Fernando De Noronha (FEN)"
  },
  {
    "value": "FOR",
    "label": "Fortaleza (FOR)"
  },
  {
    "value": "GIG",
    "label": "Rio De Janeiro (GIG)"
  },
  {
    "value": "GJM",
    "label": "GuajarÃ¡-Mirim (GJM)"
  },
  {
    "value": "GYN",
    "label": "GoiÃ¢nia (GYN)"
  },
  {
    "value": "GRU",
    "label": "SÃ£o Paulo (GRU)"
  },
  {
    "value": "GPB",
    "label": "Guarapuava (GPB)"
  },
  {
    "value": "GVR",
    "label": "Governador Valadares (GVR)"
  },
  {
    "value": "GUJ",
    "label": "GuaratinguetÃ¡ (GUJ)"
  },
  {
    "value": "ATM",
    "label": "Altamira (ATM)"
  },
  {
    "value": "ITA",
    "label": "Itacoatiara (ITA)"
  },
  {
    "value": "IOS",
    "label": "IlhÃ©us (IOS)"
  },
  {
    "value": "IPN",
    "label": "Ipatinga (IPN)"
  },
  {
    "value": "IMP",
    "label": "Imperatriz (IMP)"
  },
  {
    "value": "JDF",
    "label": "Juiz De Fora (JDF)"
  },
  {
    "value": "JPA",
    "label": "JoÃ£o Pessoa (JPA)"
  },
  {
    "value": "JDO",
    "label": "Juazeiro Do Norte (JDO)"
  },
  {
    "value": "JOI",
    "label": "Joinville (JOI)"
  },
  {
    "value": "CPV",
    "label": "Campina Grande (CPV)"
  },
  {
    "value": "VCP",
    "label": "Campinas (VCP)"
  },
  {
    "value": "LEC",
    "label": "LenÃ§Ã³is (LEC)"
  },
  {
    "value": "LAJ",
    "label": "Lages (LAJ)"
  },
  {
    "value": "LIP",
    "label": "Lins (LIP)"
  },
  {
    "value": "LDB",
    "label": "Londrina (LDB)"
  },
  {
    "value": "LAZ",
    "label": "Bom Jesus Da Lapa (LAZ)"
  },
  {
    "value": "MAB",
    "label": "MarabÃ¡ (MAB)"
  },
  {
    "value": "MQH",
    "label": "MinaÃ§u (MQH)"
  },
  {
    "value": "MEU",
    "label": "Almeirim (MEU)"
  },
  {
    "value": "MEA",
    "label": "MacaÃ© (MEA)"
  },
  {
    "value": "MGF",
    "label": "MaringÃ¡ (MGF)"
  },
  {
    "value": "MOC",
    "label": "Montes Claros (MOC)"
  },
  {
    "value": "MII",
    "label": "MarÃ­lia (MII)"
  },
  {
    "value": "PLL",
    "label": "Manaus (PLL)"
  },
  {
    "value": "MCZ",
    "label": "MaceiÃ³ (MCZ)"
  },
  {
    "value": "MCP",
    "label": "MacapÃ¡ (MCP)"
  },
  {
    "value": "MVF",
    "label": "MossorÃ³ (MVF)"
  },
  {
    "value": "SAO",
    "label": "SÃ£o Paulo (SAO)"
  },
  {
    "value": "MNX",
    "label": "ManicorÃ© (MNX)"
  },
  {
    "value": "NVT",
    "label": "Navegantes (NVT)"
  },
  {
    "value": "GEL",
    "label": "Santo Ã‚ngelo (GEL)"
  },
  {
    "value": "NAT",
    "label": "Natal (NAT)"
  },
  {
    "value": "OYK",
    "label": "Oiapoque (OYK)"
  },
  {
    "value": "POA",
    "label": "Porto Alegre (POA)"
  },
  {
    "value": "PBB",
    "label": "ParnaÃ­ba (PBB)"
  },
  {
    "value": "POO",
    "label": "PoÃ§os De Caldas (POO)"
  },
  {
    "value": "PFB",
    "label": "Passo Fundo (PFB)"
  },
  {
    "value": "PMW",
    "label": "Palmas (PMW)"
  },
  {
    "value": "PET",
    "label": "Pelotas (PET)"
  },
  {
    "value": "PNZ",
    "label": "Petrolina (PNZ)"
  },
  {
    "value": "PNB",
    "label": "Porto Nacional (PNB)"
  },
  {
    "value": "PMG",
    "label": "Ponta PorÃ£ (PMG)"
  },
  {
    "value": "BPS",
    "label": "Porto Seguro (BPS)"
  },
  {
    "value": "PVH",
    "label": "Porto Velho (PVH)"
  },
  {
    "value": "VDC",
    "label": "VitÃ³ria Da Conquista (VDC)"
  },
  {
    "value": "RBR",
    "label": "Rio Branco (RBR)"
  },
  {
    "value": "REC",
    "label": "Recife (REC)"
  },
  {
    "value": "SDU",
    "label": "Rio De Janeiro (SDU)"
  },
  {
    "value": "RAO",
    "label": "RibeirÃ£o Preto (RAO)"
  },
  {
    "value": "BRB",
    "label": "Barreirinhas Airport (BRB)"
  },
  {
    "value": "SNZ",
    "label": "Rio De Janeiro (SNZ)"
  },
  {
    "value": "SJK",
    "label": "SÃ£o JosÃ© Dos Campos (SJK)"
  },
  {
    "value": "SLZ",
    "label": "SÃ£o LuÃ­s (SLZ)"
  },
  {
    "value": "RIA",
    "label": "Santa Maria (RIA)"
  },
  {
    "value": "STM",
    "label": "SantarÃ©m (STM)"
  },
  {
    "value": "CGH",
    "label": "SÃ£o Paulo (CGH)"
  },
  {
    "value": "SJP",
    "label": "SÃ£o JosÃ© Do Rio Preto (SJP)"
  },
  {
    "value": "SSZ",
    "label": "GuarujÃ¡ (SSZ)"
  },
  {
    "value": "SSA",
    "label": "Salvador (SSA)"
  },
  {
    "value": "QHP",
    "label": "TaubatÃ© (QHP)"
  },
  {
    "value": "TMT",
    "label": "OriximinÃ¡ (TMT)"
  },
  {
    "value": "UNA",
    "label": "Una (UNA)"
  },
  {
    "value": "TOW",
    "label": "Toledo (TOW)"
  },
  {
    "value": "THE",
    "label": "Teresina (THE)"
  },
  {
    "value": "TFF",
    "label": "TefÃ© (TFF)"
  },
  {
    "value": "TRQ",
    "label": "TarauacÃ¡ (TRQ)"
  },
  {
    "value": "TEC",
    "label": "TelÃªmaco Borba (TEC)"
  },
  {
    "value": "OBI",
    "label": "Ã“bidos (OBI)"
  },
  {
    "value": "TBT",
    "label": "Tabatinga (TBT)"
  },
  {
    "value": "TUR",
    "label": "TucuruÃ­ (TUR)"
  },
  {
    "value": "SJL",
    "label": "SÃ£o Gabriel Da Cachoeira (SJL)"
  },
  {
    "value": "PAV",
    "label": "Paulo Afonso (PAV)"
  },
  {
    "value": "URG",
    "label": "Uruguaiana (URG)"
  },
  {
    "value": "UDI",
    "label": "UberlÃ¢ndia (UDI)"
  },
  {
    "value": "UBA",
    "label": "Uberaba (UBA)"
  },
  {
    "value": "VAG",
    "label": "Varginha (VAG)"
  },
  {
    "value": "BVH",
    "label": "Vilhena (BVH)"
  },
  {
    "value": "VIX",
    "label": "VitÃ³ria (VIX)"
  },
  {
    "value": "QPS",
    "label": "Pirassununga (QPS)"
  },
  {
    "value": "ZUD",
    "label": "Ancud (ZUD)"
  },
  {
    "value": "LOB",
    "label": "Los Andes (LOB)"
  },
  {
    "value": "WAP",
    "label": "Alto Palena (WAP)"
  },
  {
    "value": "ARI",
    "label": "Arica (ARI)"
  },
  {
    "value": "WPA",
    "label": "Puerto Aysen (WPA)"
  },
  {
    "value": "CPO",
    "label": "Copiapo (CPO)"
  },
  {
    "value": "BBA",
    "label": "Balmaceda (BBA)"
  },
  {
    "value": "TOQ",
    "label": "Tocopilla (TOQ)"
  },
  {
    "value": "CCH",
    "label": "Chile Chico (CCH)"
  },
  {
    "value": "CJC",
    "label": "Calama (CJC)"
  },
  {
    "value": "YAI",
    "label": "Chillan (YAI)"
  },
  {
    "value": "PUQ",
    "label": "Punta Arenas (PUQ)"
  },
  {
    "value": "GXQ",
    "label": "Coyhaique (GXQ)"
  },
  {
    "value": "IQQ",
    "label": "Iquique (IQQ)"
  },
  {
    "value": "SCL",
    "label": "Santiago (SCL)"
  },
  {
    "value": "ESR",
    "label": "El Salvador (ESR)"
  },
  {
    "value": "FRT",
    "label": "Frutillar (FRT)"
  },
  {
    "value": "ANF",
    "label": "Antofagasta (ANF)"
  },
  {
    "value": "WPR",
    "label": "Porvenir (WPR)"
  },
  {
    "value": "FFU",
    "label": "Futaleufu (FFU)"
  },
  {
    "value": "LSQ",
    "label": "Los Angeles (LSQ)"
  },
  {
    "value": "WPU",
    "label": "Puerto Williams (WPU)"
  },
  {
    "value": "LGR",
    "label": "Cochrane (LGR)"
  },
  {
    "value": "CCP",
    "label": "Concepcion (CCP)"
  },
  {
    "value": "IPC",
    "label": "Isla De Pascua (IPC)"
  },
  {
    "value": "ZOS",
    "label": "Osorno (ZOS)"
  },
  {
    "value": "VLR",
    "label": "Vallenar (VLR)"
  },
  {
    "value": "ZLR",
    "label": "Linares (ZLR)"
  },
  {
    "value": "PNT",
    "label": "Puerto Natales (PNT)"
  },
  {
    "value": "OVL",
    "label": "Ovalle (OVL)"
  },
  {
    "value": "ZPC",
    "label": "Pucon (ZPC)"
  },
  {
    "value": "PUX",
    "label": "Puerto Varas (PUX)"
  },
  {
    "value": "CNR",
    "label": "ChaÃ±aral (CNR)"
  },
  {
    "value": "VAP",
    "label": "ViÃ±a Del Mar (VAP)"
  },
  {
    "value": "QRC",
    "label": "Rancagua (QRC)"
  },
  {
    "value": "SMB",
    "label": "Cerro Sombrero (SMB)"
  },
  {
    "value": "LSC",
    "label": "La Serena-Coquimbo (LSC)"
  },
  {
    "value": "SSD",
    "label": "San Felipe (SSD)"
  },
  {
    "value": "WCA",
    "label": "Castro (WCA)"
  },
  {
    "value": "ZCO",
    "label": "Temuco (ZCO)"
  },
  {
    "value": "PMC",
    "label": "Puerto Montt (PMC)"
  },
  {
    "value": "TLX",
    "label": "Talca (TLX)"
  },
  {
    "value": "WCH",
    "label": "Chaiten (WCH)"
  },
  {
    "value": "ZIC",
    "label": "Victoria (ZIC)"
  },
  {
    "value": "TTC",
    "label": "Taltal (TTC)"
  },
  {
    "value": "ZAL",
    "label": "Valdivia (ZAL)"
  },
  {
    "value": "KNA",
    "label": "ViÃ±a Del Mar (KNA)"
  },
  {
    "value": "CPQ",
    "label": "Campinas (CPQ)"
  },
  {
    "value": "QCJ",
    "label": "Botucatu (QCJ)"
  },
  {
    "value": "OLC",
    "label": "SÃ£o Paulo De OlivenÃ§a (OLC)"
  },
  {
    "value": "SOD",
    "label": "Sorocaba (SOD)"
  },
  {
    "value": "QDC",
    "label": "Dracena (QDC)"
  },
  {
    "value": "SDI",
    "label": "Saidor Airport (SDI)"
  },
  {
    "value": "JLS",
    "label": "Jales (JLS)"
  },
  {
    "value": "QOA",
    "label": "Mococa (QOA)"
  },
  {
    "value": "QGC",
    "label": "LenÃ§Ã³is Paulista (QGC)"
  },
  {
    "value": "QNV",
    "label": "Nova IguaÃ§u (QNV)"
  },
  {
    "value": "OUS",
    "label": "Ourinhos (OUS)"
  },
  {
    "value": "QHB",
    "label": "Piracicaba (QHB)"
  },
  {
    "value": "QIQ",
    "label": "Rio Claro (QIQ)"
  },
  {
    "value": "QVP",
    "label": "AvarÃ© (QVP)"
  },
  {
    "value": "QRZ",
    "label": "Resende (QRZ)"
  },
  {
    "value": "QSC",
    "label": "SÃ£o Carlos (QSC)"
  },
  {
    "value": "UBT",
    "label": "Ubatuba (UBT)"
  },
  {
    "value": "QGS",
    "label": "Alagoinhas (QGS)"
  },
  {
    "value": "VOT",
    "label": "Votuporanga (VOT)"
  },
  {
    "value": "QGB",
    "label": "Limeira (QGB)"
  },
  {
    "value": "IZA",
    "label": "Juiz De Fora (IZA)"
  },
  {
    "value": "ATF",
    "label": "Ambato (ATF)"
  },
  {
    "value": "OCC",
    "label": "Coca (OCC)"
  },
  {
    "value": "CUE",
    "label": "Cuenca (CUE)"
  },
  {
    "value": "GPS",
    "label": "Baltra (GPS)"
  },
  {
    "value": "GYE",
    "label": "Guayaquil (GYE)"
  },
  {
    "value": "IBB",
    "label": "Isabela (IBB)"
  },
  {
    "value": "JIP",
    "label": "Jipijapa (JIP)"
  },
  {
    "value": "LTX",
    "label": "Latacunga (LTX)"
  },
  {
    "value": "MRR",
    "label": "MacarÃ¡ (MRR)"
  },
  {
    "value": "XMS",
    "label": "Macas (XMS)"
  },
  {
    "value": "MCH",
    "label": "Machala (MCH)"
  },
  {
    "value": "MEC",
    "label": "Manta (MEC)"
  },
  {
    "value": "LGQ",
    "label": "Lago Agrio (LGQ)"
  },
  {
    "value": "PYO",
    "label": "Puerto Putumayo (PYO)"
  },
  {
    "value": "PVO",
    "label": "Portoviejo (PVO)"
  },
  {
    "value": "UIO",
    "label": "Quito (UIO)"
  },
  {
    "value": "ETR",
    "label": "Santa Rosa (ETR)"
  },
  {
    "value": "SNC",
    "label": "Salinas (SNC)"
  },
  {
    "value": "SUQ",
    "label": "Sucua (SUQ)"
  },
  {
    "value": "PTZ",
    "label": "Shell Mera (PTZ)"
  },
  {
    "value": "SCY",
    "label": "San CristÃ³bal (SCY)"
  },
  {
    "value": "BHA",
    "label": "BahÃ­a de Caraquez (BHA)"
  },
  {
    "value": "TSC",
    "label": "Taisha (TSC)"
  },
  {
    "value": "TPN",
    "label": "Tiputini (TPN)"
  },
  {
    "value": "LOH",
    "label": "La Toma (Catamayo) (LOH)"
  },
  {
    "value": "ESM",
    "label": "Tachina (ESM)"
  },
  {
    "value": "TPC",
    "label": "Tarapoa (TPC)"
  },
  {
    "value": "TUA",
    "label": "TulcÃ¡n (TUA)"
  },
  {
    "value": "PSY",
    "label": "Stanley (PSY)"
  },
  {
    "value": "SFU",
    "label": "Safia (SFU)"
  },
  {
    "value": "ASU",
    "label": "AsunciÃ³n (ASU)"
  },
  {
    "value": "AYO",
    "label": "Ayolas (AYO)"
  },
  {
    "value": "CIO",
    "label": "ConcepciÃ³n (CIO)"
  },
  {
    "value": "ENO",
    "label": "EncarnaciÃ³n (ENO)"
  },
  {
    "value": "AGT",
    "label": "Ciudad del Este (AGT)"
  },
  {
    "value": "FLM",
    "label": "Filadelfia (FLM)"
  },
  {
    "value": "ESG",
    "label": "Mariscal Estigarribia (ESG)"
  },
  {
    "value": "PIL",
    "label": "Pilar (PIL)"
  },
  {
    "value": "PJC",
    "label": "Pedro Juan Caballero (PJC)"
  },
  {
    "value": "LVR",
    "label": "Lucas do Rio Verde (LVR)"
  },
  {
    "value": "FRC",
    "label": "Franca (FRC)"
  },
  {
    "value": "SIZ",
    "label": "Sissano (SIZ)"
  },
  {
    "value": "CFO",
    "label": "Confresa (CFO)"
  },
  {
    "value": "RIG",
    "label": "Rio Grande (RIG)"
  },
  {
    "value": "JTC",
    "label": "Bauru (JTC)"
  },
  {
    "value": "ARS",
    "label": "Santa Cruz CabrÃ¡lia (ARS)"
  },
  {
    "value": "ACM",
    "label": "Arica (ACM)"
  },
  {
    "value": "ECO",
    "label": "El Encanto (ECO)"
  },
  {
    "value": "ARO",
    "label": "Arboletes (ARO)"
  },
  {
    "value": "AYI",
    "label": "Yari (AYI)"
  },
  {
    "value": "ACL",
    "label": "Aguaclara (ACL)"
  },
  {
    "value": "AYC",
    "label": "Ayacucho (AYC)"
  },
  {
    "value": "BHF",
    "label": "BahÃ­a Cupica (BHF)"
  },
  {
    "value": "AYA",
    "label": "Ayapel (AYA)"
  },
  {
    "value": "NBB",
    "label": "Barranco Minas (NBB)"
  },
  {
    "value": "BAC",
    "label": "Barranca De Upia (BAC)"
  },
  {
    "value": "ECR",
    "label": "El Charco (ECR)"
  },
  {
    "value": "AZT",
    "label": "Zapatoca (AZT)"
  },
  {
    "value": "SQB",
    "label": "Piedras (SQB)"
  },
  {
    "value": "ARF",
    "label": "Acaricuara (ARF)"
  },
  {
    "value": "ACR",
    "label": "Araracuara (ACR)"
  },
  {
    "value": "ACD",
    "label": "AcandÃ­ (ACD)"
  },
  {
    "value": "AFI",
    "label": "Amalfi (AFI)"
  },
  {
    "value": "ADN",
    "label": "Andes (ADN)"
  },
  {
    "value": "AXM",
    "label": "Armenia (AXM)"
  },
  {
    "value": "PUU",
    "label": "Puerto AsÃ­s (PUU)"
  },
  {
    "value": "ELB",
    "label": "El Banco (ELB)"
  },
  {
    "value": "BGA",
    "label": "Bucaramanga (BGA)"
  },
  {
    "value": "BOG",
    "label": "Bogota (BOG)"
  },
  {
    "value": "BAQ",
    "label": "Barranquilla (BAQ)"
  },
  {
    "value": "BSC",
    "label": "BahÃ­a Solano (BSC)"
  },
  {
    "value": "BUN",
    "label": "Buenaventura (BUN)"
  },
  {
    "value": "CPB",
    "label": "CapurganÃ¡ (CPB)"
  },
  {
    "value": "CUC",
    "label": "CÃºcuta (CUC)"
  },
  {
    "value": "COG",
    "label": "Condoto (COG)"
  },
  {
    "value": "CTG",
    "label": "Cartagena (CTG)"
  },
  {
    "value": "CCO",
    "label": "Puerto LÃ³pez (CCO)"
  },
  {
    "value": "CLO",
    "label": "Cali (CLO)"
  },
  {
    "value": "CIM",
    "label": "Cimitarra (CIM)"
  },
  {
    "value": "RAV",
    "label": "Cravo Norte (RAV)"
  },
  {
    "value": "TCO",
    "label": "Tumaco (TCO)"
  },
  {
    "value": "CUO",
    "label": "CarurÃº (CUO)"
  },
  {
    "value": "CAQ",
    "label": "Caucasia (CAQ)"
  },
  {
    "value": "CVE",
    "label": "CoveÃ±as (CVE)"
  },
  {
    "value": "CZU",
    "label": "Corozal (CZU)"
  },
  {
    "value": "EBG",
    "label": "El Bagre (EBG)"
  },
  {
    "value": "EJA",
    "label": "Barrancabermeja (EJA)"
  },
  {
    "value": "FLA",
    "label": "Florencia (FLA)"
  },
  {
    "value": "FDA",
    "label": "FundaciÃ³n (FDA)"
  },
  {
    "value": "GIR",
    "label": "Girardot (GIR)"
  },
  {
    "value": "CRC",
    "label": "Cartago (CRC)"
  },
  {
    "value": "GPI",
    "label": "Guapi (GPI)"
  },
  {
    "value": "GLJ",
    "label": "GarzÃ³n (GLJ)"
  },
  {
    "value": "CPL",
    "label": "Chaparral (CPL)"
  },
  {
    "value": "HTZ",
    "label": "Hato Corozal (HTZ)"
  },
  {
    "value": "IBE",
    "label": "IbaguÃ© (IBE)"
  },
  {
    "value": "IGO",
    "label": "ChigorodÃ³ (IGO)"
  },
  {
    "value": "MMP",
    "label": "LimÃ³n (MMP)"
  },
  {
    "value": "IPI",
    "label": "Ipiales (IPI)"
  },
  {
    "value": "LQM",
    "label": "Puerto LeguÃ­zamo (LQM)"
  },
  {
    "value": "MCJ",
    "label": "La Mina-Maicao (MCJ)"
  },
  {
    "value": "LPD",
    "label": "La Pedrera (LPD)"
  },
  {
    "value": "LET",
    "label": "Leticia (LET)"
  },
  {
    "value": "EOH",
    "label": "MedellÃ­n (EOH)"
  },
  {
    "value": "MFS",
    "label": "Miraflores (MFS)"
  },
  {
    "value": "MGN",
    "label": "MaganguÃ© (MGN)"
  },
  {
    "value": "MTB",
    "label": "MontelÃ­bano (MTB)"
  },
  {
    "value": "MTR",
    "label": "MonterÃ­a (MTR)"
  },
  {
    "value": "MVP",
    "label": "MitÃº (MVP)"
  },
  {
    "value": "MZL",
    "label": "Manizales (MZL)"
  },
  {
    "value": "NCI",
    "label": "Necocli (NCI)"
  },
  {
    "value": "NQU",
    "label": "NuquÃ­ (NQU)"
  },
  {
    "value": "NVA",
    "label": "Neiva (NVA)"
  },
  {
    "value": "OCV",
    "label": "OcaÃ±a (OCV)"
  },
  {
    "value": "ORC",
    "label": "Orocue (ORC)"
  },
  {
    "value": "PCR",
    "label": "Puerto CarreÃ±o (PCR)"
  },
  {
    "value": "PDA",
    "label": "Puerto InÃ­rida (PDA)"
  },
  {
    "value": "PEI",
    "label": "Pereira (PEI)"
  },
  {
    "value": "PTX",
    "label": "Pitalito (PTX)"
  },
  {
    "value": "PLT",
    "label": "Plato (PLT)"
  },
  {
    "value": "NAR",
    "label": "Armenia (NAR)"
  },
  {
    "value": "PPN",
    "label": "PopayÃ¡n (PPN)"
  },
  {
    "value": "PQE",
    "label": "La Dorada (PQE)"
  },
  {
    "value": "PBE",
    "label": "Puerto Berrio (PBE)"
  },
  {
    "value": "PSO",
    "label": "Pasto (PSO)"
  },
  {
    "value": "PVA",
    "label": "Providencia (PVA)"
  },
  {
    "value": "PZA",
    "label": "Paz De Ariporo (PZA)"
  },
  {
    "value": "MQU",
    "label": "Mariquita (MQU)"
  },
  {
    "value": "MDE",
    "label": "Rionegro (MDE)"
  },
  {
    "value": "RCH",
    "label": "Riohacha (RCH)"
  },
  {
    "value": "SJE",
    "label": "San JosÃ© Del Guaviare (SJE)"
  },
  {
    "value": "SMR",
    "label": "Santa Marta (SMR)"
  },
  {
    "value": "SOX",
    "label": "Sogamoso (SOX)"
  },
  {
    "value": "ADZ",
    "label": "San AndrÃ©s (ADZ)"
  },
  {
    "value": "SVI",
    "label": "San Vicente Del CaguÃ¡n (SVI)"
  },
  {
    "value": "TDA",
    "label": "Trinidad (TDA)"
  },
  {
    "value": "TLU",
    "label": "TolÃº (TLU)"
  },
  {
    "value": "TME",
    "label": "Tame (TME)"
  },
  {
    "value": "TQS",
    "label": "Tres Esquinas (TQS)"
  },
  {
    "value": "TRB",
    "label": "Turbo (TRB)"
  },
  {
    "value": "MQZ",
    "label": "MarandÃºa (MQZ)"
  },
  {
    "value": "AUC",
    "label": "Arauca (AUC)"
  },
  {
    "value": "UIB",
    "label": "QuibdÃ³ (UIB)"
  },
  {
    "value": "ULQ",
    "label": "TuluÃ¡ (ULQ)"
  },
  {
    "value": "URR",
    "label": "Urrao (URR)"
  },
  {
    "value": "VUP",
    "label": "Valledupar (VUP)"
  },
  {
    "value": "VVC",
    "label": "Villavicencio (VVC)"
  },
  {
    "value": "AYG",
    "label": "San Vicente Del CaguÃ¡n (AYG)"
  },
  {
    "value": "EYP",
    "label": "El Yopal (EYP)"
  },
  {
    "value": "MHW",
    "label": "El BaÃ±ado (MHW)"
  },
  {
    "value": "APB",
    "label": "Apolo (APB)"
  },
  {
    "value": "ASC",
    "label": "AscensiÃ³n de Guarayos (ASC)"
  },
  {
    "value": "BJO",
    "label": "Bermejo (BJO)"
  },
  {
    "value": "CAM",
    "label": "Camiri (CAM)"
  },
  {
    "value": "CBB",
    "label": "Cochabamba (CBB)"
  },
  {
    "value": "CIJ",
    "label": "Cobija (CIJ)"
  },
  {
    "value": "CEP",
    "label": "ConcepciÃ³n (CEP)"
  },
  {
    "value": "SRZ",
    "label": "Santa Cruz (SRZ)"
  },
  {
    "value": "GYA",
    "label": "GuayaramerÃ­n (GYA)"
  },
  {
    "value": "BVK",
    "label": "Itenes (BVK)"
  },
  {
    "value": "SJS",
    "label": "San JosÃ© de Chiquitos (SJS)"
  },
  {
    "value": "SJB",
    "label": "San JoaquÃ­n (SJB)"
  },
  {
    "value": "SJV",
    "label": "San Javier (SJV)"
  },
  {
    "value": "LPB",
    "label": "La Paz / El Alto (LPB)"
  },
  {
    "value": "MGD",
    "label": "Magdalena (MGD)"
  },
  {
    "value": "ORU",
    "label": "Oruro (ORU)"
  },
  {
    "value": "POI",
    "label": "PotosÃ­ (POI)"
  },
  {
    "value": "PUR",
    "label": "Puerto Rico/Manuripi (PUR)"
  },
  {
    "value": "PSZ",
    "label": "Puerto SuÃ¡rez (PSZ)"
  },
  {
    "value": "SRD",
    "label": "San RamÃ³n / MamorÃ© (SRD)"
  },
  {
    "value": "RBO",
    "label": "RoborÃ© (RBO)"
  },
  {
    "value": "RIB",
    "label": "Riberalta (RIB)"
  },
  {
    "value": "REY",
    "label": "Reyes (REY)"
  },
  {
    "value": "SBL",
    "label": "Santa Ana del Yacuma (SBL)"
  },
  {
    "value": "SRJ",
    "label": "San Borja (SRJ)"
  },
  {
    "value": "SNG",
    "label": "San Ignacio de Velasco (SNG)"
  },
  {
    "value": "SNM",
    "label": "San Ignacio de Moxos (SNM)"
  },
  {
    "value": "SRB",
    "label": "Santa Rosa (SRB)"
  },
  {
    "value": "SRE",
    "label": "Sucre (SRE)"
  },
  {
    "value": "MQK",
    "label": "San MatÃ­as (MQK)"
  },
  {
    "value": "TJA",
    "label": "Tarija (TJA)"
  },
  {
    "value": "TDD",
    "label": "Trinidad (TDD)"
  },
  {
    "value": "UYU",
    "label": "Quijarro (UYU)"
  },
  {
    "value": "VAH",
    "label": "Vallegrande (VAH)"
  },
  {
    "value": "VLM",
    "label": "Villamontes (VLM)"
  },
  {
    "value": "VVI",
    "label": "Santa Cruz (VVI)"
  },
  {
    "value": "BYC",
    "label": "YacuÃ­ba (BYC)"
  },
  {
    "value": "ABN",
    "label": "Albina (ABN)"
  },
  {
    "value": "TOT",
    "label": "Totness (TOT)"
  },
  {
    "value": "DRJ",
    "label": "Drietabbetje (DRJ)"
  },
  {
    "value": "SMH",
    "label": "Sapmanga (SMH)"
  },
  {
    "value": "PBM",
    "label": "Zandery (PBM)"
  },
  {
    "value": "ICK",
    "label": "Nieuw Nickerie (ICK)"
  },
  {
    "value": "OEM",
    "label": "Paloemeu (OEM)"
  },
  {
    "value": "SMZ",
    "label": "Stoelmanseiland (SMZ)"
  },
  {
    "value": "AGI",
    "label": "Wageningen Airport (AGI)"
  },
  {
    "value": "ORG",
    "label": "Paramaribo (ORG)"
  },
  {
    "value": "APY",
    "label": "Alto ParnaÃ­ba (APY)"
  },
  {
    "value": "APQ",
    "label": "Arapiraca (APQ)"
  },
  {
    "value": "AMJ",
    "label": "Almenara (AMJ)"
  },
  {
    "value": "AIF",
    "label": "Assis (AIF)"
  },
  {
    "value": "BDC",
    "label": "Barra Do Corda (BDC)"
  },
  {
    "value": "BVM",
    "label": "Belmonte (BVM)"
  },
  {
    "value": "BRA",
    "label": "Barreiras (BRA)"
  },
  {
    "value": "BSS",
    "label": "Balsas (BSS)"
  },
  {
    "value": "BMS",
    "label": "Brumado (BMS)"
  },
  {
    "value": "BQQ",
    "label": "Barra (BQQ)"
  },
  {
    "value": "CTP",
    "label": "Carutapera (CTP)"
  },
  {
    "value": "CPU",
    "label": "Cururupu (CPU)"
  },
  {
    "value": "QCH",
    "label": "Colatina (QCH)"
  },
  {
    "value": "RDC",
    "label": "RedenÃ§Ã£o (RDC)"
  },
  {
    "value": "LEP",
    "label": "Leopoldina (LEP)"
  },
  {
    "value": "DTI",
    "label": "Diamantina (DTI)"
  },
  {
    "value": "DIQ",
    "label": "DivinÃ³polis (DIQ)"
  },
  {
    "value": "CNV",
    "label": "Canavieiras (CNV)"
  },
  {
    "value": "SXX",
    "label": "SÃ£o FÃ©lix Do Xingu (SXX)"
  },
  {
    "value": "GUZ",
    "label": "Guarapari (GUZ)"
  },
  {
    "value": "GDP",
    "label": "Guadalupe (GDP)"
  },
  {
    "value": "GNM",
    "label": "Guanambi (GNM)"
  },
  {
    "value": "GMS",
    "label": "UberlÃ¢ndia (GMS)"
  },
  {
    "value": "QGP",
    "label": "Garanhuns (QGP)"
  },
  {
    "value": "IRE",
    "label": "IrecÃª (IRE)"
  },
  {
    "value": "QIG",
    "label": "Iguatu (QIG)"
  },
  {
    "value": "QIT",
    "label": "Itapetinga (QIT)"
  },
  {
    "value": "IPU",
    "label": "IpiaÃº (IPU)"
  },
  {
    "value": "JCM",
    "label": "Jacobina (JCM)"
  },
  {
    "value": "FEC",
    "label": "Feira De Santana (FEC)"
  },
  {
    "value": "JEQ",
    "label": "JequiÃ© (JEQ)"
  },
  {
    "value": "JNA",
    "label": "JanuÃ¡ria (JNA)"
  },
  {
    "value": "JDR",
    "label": "SÃ£o JoÃ£o Del Rei (JDR)"
  },
  {
    "value": "CMP",
    "label": "Santana Do Araguaia (CMP)"
  },
  {
    "value": "QDF",
    "label": "Conselheiro Lafaiete (QDF)"
  },
  {
    "value": "CDI",
    "label": "Cachoeiro Do Itapemirim (CDI)"
  },
  {
    "value": "QCP",
    "label": "Currais Novos (QCP)"
  },
  {
    "value": "LVB",
    "label": "Livramento Do Brumado (LVB)"
  },
  {
    "value": "SSO",
    "label": "SÃ£o LourenÃ§o (SSO)"
  },
  {
    "value": "MTE",
    "label": "Monte Alegre (MTE)"
  },
  {
    "value": "MVS",
    "label": "Mucuri (MVS)"
  },
  {
    "value": "SBJ",
    "label": "SÃ£o Mateus (SBJ)"
  },
  {
    "value": "PTQ",
    "label": "Porto De Moz (PTQ)"
  },
  {
    "value": "NNU",
    "label": "Nanuque (NNU)"
  },
  {
    "value": "QBX",
    "label": "Sobral (QBX)"
  },
  {
    "value": "PSW",
    "label": "Passos (PSW)"
  },
  {
    "value": "ORX",
    "label": "OriximinÃ¡ (ORX)"
  },
  {
    "value": "PCS",
    "label": "Picos (PCS)"
  },
  {
    "value": "POJ",
    "label": "Patos De Minas (POJ)"
  },
  {
    "value": "PIV",
    "label": "Pirapora (PIV)"
  },
  {
    "value": "FLB",
    "label": "Floriano (FLB)"
  },
  {
    "value": "PDF",
    "label": "Prado (PDF)"
  },
  {
    "value": "CAU",
    "label": "Caruaru (CAU)"
  },
  {
    "value": "SFK",
    "label": "Soure (SFK)"
  },
  {
    "value": "TFL",
    "label": "TeÃ³filo Otoni (TFL)"
  },
  {
    "value": "VAL",
    "label": "ValenÃ§a (VAL)"
  },
  {
    "value": "QID",
    "label": "TrÃªs CoraÃ§Ãµes (QID)"
  },
  {
    "value": "BVS",
    "label": "Breves (BVS)"
  },
  {
    "value": "CMC",
    "label": "Camocim (CMC)"
  },
  {
    "value": "QXC",
    "label": "Barra De Santo Antonio (QXC)"
  },
  {
    "value": "PHI",
    "label": "Pinheiro (PHI)"
  },
  {
    "value": "ITI",
    "label": "Cumaru Do Norte (ITI)"
  },
  {
    "value": "PPY",
    "label": "Pouso Alegre (PPY)"
  },
  {
    "value": "BXX",
    "label": "Boorama (BXX)"
  },
  {
    "value": "GTA",
    "label": "Gatokae (GTA)"
  },
  {
    "value": "CAY",
    "label": "Cayenne / Rochambeau (CAY)"
  },
  {
    "value": "MPY",
    "label": "Maripasoula (MPY)"
  },
  {
    "value": "OXP",
    "label": "Saint-Georges-de-l'Oyapock Airport (OXP)"
  },
  {
    "value": "LDX",
    "label": "Saint-Laurent-du-Maroni (LDX)"
  },
  {
    "value": "REI",
    "label": "Regina (REI)"
  },
  {
    "value": "XAU",
    "label": "SaÃºl (XAU)"
  },
  {
    "value": "APE",
    "label": "San Juan Aposento (APE)"
  },
  {
    "value": "ALD",
    "label": "Fortaleza (ALD)"
  },
  {
    "value": "AOP",
    "label": "Andoas (AOP)"
  },
  {
    "value": "ATG",
    "label": "Atalaya (ATG)"
  },
  {
    "value": "MBP",
    "label": "Moyobamba (MBP)"
  },
  {
    "value": "LHC",
    "label": "Caballococha (LHC)"
  },
  {
    "value": "BLP",
    "label": "Bellavista (BLP)"
  },
  {
    "value": "IBP",
    "label": "Iberia (IBP)"
  },
  {
    "value": "TCG",
    "label": "Tocache (TCG)"
  },
  {
    "value": "PCL",
    "label": "Pucallpa (PCL)"
  },
  {
    "value": "CHM",
    "label": "Chimbote (CHM)"
  },
  {
    "value": "TGI",
    "label": "Tingo Maria (TGI)"
  },
  {
    "value": "CIX",
    "label": "Chiclayo (CIX)"
  },
  {
    "value": "AYP",
    "label": "Ayacucho (AYP)"
  },
  {
    "value": "ANS",
    "label": "Andahuaylas (ANS)"
  },
  {
    "value": "ATA",
    "label": "Anta (ATA)"
  },
  {
    "value": "UMI",
    "label": "Quince Mil (UMI)"
  },
  {
    "value": "LIM",
    "label": "Lima (LIM)"
  },
  {
    "value": "UCZ",
    "label": "Uchiza (UCZ)"
  },
  {
    "value": "RIJ",
    "label": "Rioja (RIJ)"
  },
  {
    "value": "JJI",
    "label": "JuanjuÃ­ (JJI)"
  },
  {
    "value": "JAU",
    "label": "Jauja (JAU)"
  },
  {
    "value": "JUL",
    "label": "Juliaca (JUL)"
  },
  {
    "value": "SJA",
    "label": "San Juan de Marcona (SJA)"
  },
  {
    "value": "CJA",
    "label": "Cajamarca (CJA)"
  },
  {
    "value": "RIM",
    "label": "Rodriguez de Mendoza (RIM)"
  },
  {
    "value": "ILQ",
    "label": "Ilo (ILQ)"
  },
  {
    "value": "TBP",
    "label": "Tumbes (TBP)"
  },
  {
    "value": "YMS",
    "label": "Yurimaguas (YMS)"
  },
  {
    "value": "HUU",
    "label": "HuÃ¡nuco (HUU)"
  },
  {
    "value": "SQU",
    "label": "Plaza Saposoa (SQU)"
  },
  {
    "value": "SYC",
    "label": "Leon Velarde (SYC)"
  },
  {
    "value": "CHH",
    "label": "Chachapoyas (CHH)"
  },
  {
    "value": "IQT",
    "label": "Iquitos (IQT)"
  },
  {
    "value": "AQP",
    "label": "Arequipa (AQP)"
  },
  {
    "value": "TRU",
    "label": "Trujillo (TRU)"
  },
  {
    "value": "SQD",
    "label": "San Francisco de Yeso (SQD)"
  },
  {
    "value": "PIO",
    "label": "Pisco (PIO)"
  },
  {
    "value": "TPP",
    "label": "Tarapoto (TPP)"
  },
  {
    "value": "TCQ",
    "label": "Tacna (TCQ)"
  },
  {
    "value": "PEM",
    "label": "Puerto Maldonado (PEM)"
  },
  {
    "value": "PIU",
    "label": "Piura (PIU)"
  },
  {
    "value": "TYL",
    "label": "Capitan Montes Airport (TYL)"
  },
  {
    "value": "NZA",
    "label": "Maria Reiche Neuman Airport (NZA)"
  },
  {
    "value": "CUZ",
    "label": "Cusco (CUZ)"
  },
  {
    "value": "SQT",
    "label": "Samarai Island (SQT)"
  },
  {
    "value": "AAJ",
    "label": "Awaradam (AAJ)"
  },
  {
    "value": "KCB",
    "label": "Kasikasima (KCB)"
  },
  {
    "value": "APU",
    "label": "Apucarana (APU)"
  },
  {
    "value": "BGV",
    "label": "Bento GonÃ§alves (BGV)"
  },
  {
    "value": "BNU",
    "label": "Blumenau (BNU)"
  },
  {
    "value": "CCI",
    "label": "ConcÃ³rdia (CCI)"
  },
  {
    "value": "QCN",
    "label": "Canela (QCN)"
  },
  {
    "value": "CKO",
    "label": "CornÃ©lio ProcÃ³pio (CKO)"
  },
  {
    "value": "DOU",
    "label": "Dourados (DOU)"
  },
  {
    "value": "ERM",
    "label": "Erechim (ERM)"
  },
  {
    "value": "FBE",
    "label": "Francisco BeltrÃ£o (FBE)"
  },
  {
    "value": "QGA",
    "label": "GuaÃ­ra (QGA)"
  },
  {
    "value": "IJU",
    "label": "IjuÃ­ (IJU)"
  },
  {
    "value": "ITQ",
    "label": "Itaqui (ITQ)"
  },
  {
    "value": "JCB",
    "label": "JoaÃ§aba (JCB)"
  },
  {
    "value": "CBW",
    "label": "Campo MourÃ£o (CBW)"
  },
  {
    "value": "QDB",
    "label": "Cachoeira Do Sul (QDB)"
  },
  {
    "value": "QCR",
    "label": "Curitibanos (QCR)"
  },
  {
    "value": "QRE",
    "label": "Carazinho (QRE)"
  },
  {
    "value": "ALQ",
    "label": "Alegrete (ALQ)"
  },
  {
    "value": "QMF",
    "label": "Mafra (QMF)"
  },
  {
    "value": "QGF",
    "label": "Montenegro (QGF)"
  },
  {
    "value": "QHV",
    "label": "Novo Hamburgo (QHV)"
  },
  {
    "value": "SQX",
    "label": "SÃ£o Miguel Do Oeste (SQX)"
  },
  {
    "value": "APX",
    "label": "Arapongas (APX)"
  },
  {
    "value": "PTO",
    "label": "Pato Branco (PTO)"
  },
  {
    "value": "PNG",
    "label": "ParanaguÃ¡ (PNG)"
  },
  {
    "value": "PVI",
    "label": "ParanavaÃ­ (PVI)"
  },
  {
    "value": "QAC",
    "label": "Castro (QAC)"
  },
  {
    "value": "SQY",
    "label": "SÃ£o LourenÃ§o Do Sul (SQY)"
  },
  {
    "value": "QOJ",
    "label": "SÃ£o Borja (QOJ)"
  },
  {
    "value": "CSU",
    "label": "Santa Cruz Do Sul (CSU)"
  },
  {
    "value": "UMU",
    "label": "Umuarama (UMU)"
  },
  {
    "value": "QVB",
    "label": "UniÃ£o Da VitÃ³ria (QVB)"
  },
  {
    "value": "VIA",
    "label": "Videira (VIA)"
  },
  {
    "value": "CTQ",
    "label": "Santa VitÃ³ria Do Palmar (CTQ)"
  },
  {
    "value": "AXE",
    "label": "XanxerÃª (AXE)"
  },
  {
    "value": "AAG",
    "label": "Arapoti (AAG)"
  },
  {
    "value": "SRA",
    "label": "Santa Rosa (SRA)"
  },
  {
    "value": "PGZ",
    "label": "Ponta Grossa (PGZ)"
  },
  {
    "value": "ATI",
    "label": "Artigas (ATI)"
  },
  {
    "value": "BUV",
    "label": "Bella Union (BUV)"
  },
  {
    "value": "CYR",
    "label": "Colonia (CYR)"
  },
  {
    "value": "CAR",
    "label": "Carmelo (CAR)"
  },
  {
    "value": "DZO",
    "label": "Durazno (DZO)"
  },
  {
    "value": "PDP",
    "label": "Punta del Este (PDP)"
  },
  {
    "value": "MER",
    "label": "Mercedes (MER)"
  },
  {
    "value": "MLZ",
    "label": "Melo (MLZ)"
  },
  {
    "value": "MVD",
    "label": "Montevideo (MVD)"
  },
  {
    "value": "MDO",
    "label": "Maldonado (MDO)"
  },
  {
    "value": "PDU",
    "label": "Paysandu (PDU)"
  },
  {
    "value": "RVY",
    "label": "Rivera (RVY)"
  },
  {
    "value": "STY",
    "label": "Salto (STY)"
  },
  {
    "value": "TAW",
    "label": "Tacuarembo (TAW)"
  },
  {
    "value": "TYT",
    "label": "Treinta y Tres (TYT)"
  },
  {
    "value": "VCH",
    "label": "Vichadero (VCH)"
  },
  {
    "value": "AGV",
    "label": "Acarigua (AGV)"
  },
  {
    "value": "AAO",
    "label": "Anaco (AAO)"
  },
  {
    "value": "LPJ",
    "label": "Guayabal (LPJ)"
  },
  {
    "value": "BLA",
    "label": "Barcelona (BLA)"
  },
  {
    "value": "BNS",
    "label": "Barinas (BNS)"
  },
  {
    "value": "BRM",
    "label": "Barquisimeto (BRM)"
  },
  {
    "value": "MYC",
    "label": "Maracay (MYC)"
  },
  {
    "value": "CBL",
    "label": "Ciudad BolÃ­var Airport (CBL)"
  },
  {
    "value": "CXA",
    "label": "Caicara del Orinoco Airport (CXA)"
  },
  {
    "value": "CUV",
    "label": "Casigua El Cubo (CUV)"
  },
  {
    "value": "CLZ",
    "label": "Guarico (CLZ)"
  },
  {
    "value": "CAJ",
    "label": "Canaima (CAJ)"
  },
  {
    "value": "VCR",
    "label": "Carora (VCR)"
  },
  {
    "value": "CUP",
    "label": "CarÃºpano (CUP)"
  },
  {
    "value": "CZE",
    "label": "Coro (CZE)"
  },
  {
    "value": "CUM",
    "label": "CumanÃ¡ (Antonio JosÃ© de Sucre) Airport (CUM)"
  },
  {
    "value": "isl",
    "label": "Isla La Tortuga (isl)"
  },
  {
    "value": "EOR",
    "label": "Bolivar (EOR)"
  },
  {
    "value": "EOZ",
    "label": "Elorza Airport (EOZ)"
  },
  {
    "value": "GDO",
    "label": "Guasdalito Airport (GDO)"
  },
  {
    "value": "GUQ",
    "label": "Guanare (GUQ)"
  },
  {
    "value": "ICA",
    "label": "IcabarÃº Airport (ICA)"
  },
  {
    "value": "LSP",
    "label": "ParaguanÃ¡ (LSP)"
  },
  {
    "value": "KAV",
    "label": "Kavanayen Airport (KAV)"
  },
  {
    "value": "LFR",
    "label": "La Fria Airport (LFR)"
  },
  {
    "value": "MAR",
    "label": "Maracaibo (MAR)"
  },
  {
    "value": "MRD",
    "label": "MÃ©rida (MRD)"
  },
  {
    "value": "PMV",
    "label": "Isla Margarita (PMV)"
  },
  {
    "value": "CCS",
    "label": "Caracas (CCS)"
  },
  {
    "value": "MUN",
    "label": "MaturÃ­n Airport (MUN)"
  },
  {
    "value": "CBS",
    "label": "Cabimas (CBS)"
  },
  {
    "value": "PYH",
    "label": "Cacique Aramare Airport (PYH)"
  },
  {
    "value": "PBL",
    "label": "General Bartolome Salom International Airport (PBL)"
  },
  {
    "value": "PDZ",
    "label": "Pedernales Airport (PDZ)"
  },
  {
    "value": "PPH",
    "label": "Perai Tepuy Airport (PPH)"
  },
  {
    "value": "SCI",
    "label": "Paramillo Airport (SCI)"
  },
  {
    "value": "PZO",
    "label": "Puerto Ordaz-Ciudad Guayana (PZO)"
  },
  {
    "value": "PTM",
    "label": "Palmarito (PTM)"
  },
  {
    "value": "LRV",
    "label": "Los Roques (LRV)"
  },
  {
    "value": "SVZ",
    "label": "San Antonio Del Tachira Airport (SVZ)"
  },
  {
    "value": "SBB",
    "label": "Santa BÃ¡rbara (SBB)"
  },
  {
    "value": "SNV",
    "label": "Santa Elena de Uairen Airport (SNV)"
  },
  {
    "value": "STD",
    "label": "Santo Domingo (STD)"
  },
  {
    "value": "SNF",
    "label": "San Felipe (SNF)"
  },
  {
    "value": "SFD",
    "label": "Inglaterra (SFD)"
  },
  {
    "value": "SOM",
    "label": "San Tome Airport (SOM)"
  },
  {
    "value": "STB",
    "label": "Santa BÃ¡rbara del Zulia Airport (STB)"
  },
  {
    "value": "TUV",
    "label": "Tucupita (TUV)"
  },
  {
    "value": "TMO",
    "label": "Tumeremo Airport (TMO)"
  },
  {
    "value": "URM",
    "label": "Uriman Airport (URM)"
  },
  {
    "value": "VLN",
    "label": "Valencia (VLN)"
  },
  {
    "value": "VIG",
    "label": "El VigÃ­a (VIG)"
  },
  {
    "value": "VLV",
    "label": "Valera (VLV)"
  },
  {
    "value": "BAZ",
    "label": "Barcelos (BAZ)"
  },
  {
    "value": "RBB",
    "label": "Borba (RBB)"
  },
  {
    "value": "CAF",
    "label": "Carauari (CAF)"
  },
  {
    "value": "CQS",
    "label": "Costa Marques (CQS)"
  },
  {
    "value": "DMT",
    "label": "Diamantino (DMT)"
  },
  {
    "value": "DNO",
    "label": "DianÃ³polis (DNO)"
  },
  {
    "value": "SWE",
    "label": "Siwea Airport (SWE)"
  },
  {
    "value": "ERN",
    "label": "EirunepÃ© (ERN)"
  },
  {
    "value": "CQA",
    "label": "Canarana (CQA)"
  },
  {
    "value": "FEJ",
    "label": "FeijÃ³ (FEJ)"
  },
  {
    "value": "SXO",
    "label": "SÃ£o FÃ©lix Do Araguaia (SXO)"
  },
  {
    "value": "SWG",
    "label": "Satwag Airport (SWG)"
  },
  {
    "value": "GRP",
    "label": "Gurupi (GRP)"
  },
  {
    "value": "AUX",
    "label": "AraguaÃ­na (AUX)"
  },
  {
    "value": "IPG",
    "label": "Santo AntÃ´nio Do IÃ§Ã¡ (IPG)"
  },
  {
    "value": "IDO",
    "label": "CristalÃ¢ndia (IDO)"
  },
  {
    "value": "JPR",
    "label": "Ji-ParanÃ¡ (JPR)"
  },
  {
    "value": "JIA",
    "label": "JuÃ­na (JIA)"
  },
  {
    "value": "JRN",
    "label": "Juruena (JRN)"
  },
  {
    "value": "CCX",
    "label": "CÃ¡ceres (CCX)"
  },
  {
    "value": "CIZ",
    "label": "Coari (CIZ)"
  },
  {
    "value": "TLZ",
    "label": "CatalÃ£o (TLZ)"
  },
  {
    "value": "LBR",
    "label": "LÃ¡brea (LBR)"
  },
  {
    "value": "RVD",
    "label": "Rio Verde (RVD)"
  },
  {
    "value": "MBZ",
    "label": "MauÃ©s (MBZ)"
  },
  {
    "value": "NVP",
    "label": "Novo AripuanÃ£ (NVP)"
  },
  {
    "value": "AQM",
    "label": "Ariquemes (AQM)"
  },
  {
    "value": "BCR",
    "label": "Boca Do Acre (BCR)"
  },
  {
    "value": "NQL",
    "label": "NiquelÃ¢ndia (NQL)"
  },
  {
    "value": "APS",
    "label": "AnÃ¡polis (APS)"
  },
  {
    "value": "FBA",
    "label": "Fonte Boa (FBA)"
  },
  {
    "value": "PIN",
    "label": "Parintins (PIN)"
  },
  {
    "value": "PBQ",
    "label": "Pimenta Bueno (PBQ)"
  },
  {
    "value": "AAI",
    "label": "Arraias (AAI)"
  },
  {
    "value": "ROO",
    "label": "RondonÃ³polis (ROO)"
  },
  {
    "value": "AIR",
    "label": "AripuanÃ£ (AIR)"
  },
  {
    "value": "OPS",
    "label": "Sinop (OPS)"
  },
  {
    "value": "STZ",
    "label": "Santa Terezinha (STZ)"
  },
  {
    "value": "IRZ",
    "label": "Santa Isabel Do Rio Negro (IRZ)"
  },
  {
    "value": "TGQ",
    "label": "TangarÃ¡ Da Serra (TGQ)"
  },
  {
    "value": "AZL",
    "label": "Sapezal (AZL)"
  },
  {
    "value": "QHN",
    "label": "Taguatinga (QHN)"
  },
  {
    "value": "SQM",
    "label": "SÃ£o Miguel Do Araguaia (SQM)"
  },
  {
    "value": "VLP",
    "label": "Vila Rica (VLP)"
  },
  {
    "value": "MBK",
    "label": "MatupÃ¡ (MBK)"
  },
  {
    "value": "NOK",
    "label": "Nova Xavantina (NOK)"
  },
  {
    "value": "SXH",
    "label": "Sehulea (SXH)"
  },
  {
    "value": "AHL",
    "label": "Aishalton (AHL)"
  },
  {
    "value": "NAI",
    "label": "Annai (NAI)"
  },
  {
    "value": "BMJ",
    "label": "Baramita (BMJ)"
  },
  {
    "value": "GFO",
    "label": "Bartica (GFO)"
  },
  {
    "value": "GEO",
    "label": "Georgetown (GEO)"
  },
  {
    "value": "OGL",
    "label": "Ogle (OGL)"
  },
  {
    "value": "IMB",
    "label": "Imbaimadai (IMB)"
  },
  {
    "value": "KAR",
    "label": "Kamarang (KAR)"
  },
  {
    "value": "KRM",
    "label": "Karanambo (KRM)"
  },
  {
    "value": "KRG",
    "label": "Karasabai (KRG)"
  },
  {
    "value": "KTO",
    "label": "Kato (KTO)"
  },
  {
    "value": "SYL",
    "label": "Camp Roberts/San Miguel (SYL)"
  },
  {
    "value": "LUB",
    "label": "Lumid Pau (LUB)"
  },
  {
    "value": "LTM",
    "label": "Lethem (LTM)"
  },
  {
    "value": "USI",
    "label": "Mabaruma (USI)"
  },
  {
    "value": "MHA",
    "label": "Mahdia (MHA)"
  },
  {
    "value": "MYM",
    "label": "Monkey Mountain (MYM)"
  },
  {
    "value": "SYN",
    "label": "Stanton (SYN)"
  },
  {
    "value": "QSX",
    "label": "New Amsterdam (QSX)"
  },
  {
    "value": "ORJ",
    "label": "Orinduik (ORJ)"
  },
  {
    "value": "PRR",
    "label": "Paruma (PRR)"
  },
  {
    "value": "SZN",
    "label": "Santa Barbara (SZN)"
  },
  {
    "value": "SZP",
    "label": "Santa Paula (SZP)"
  },
  {
    "value": "ANU",
    "label": "St. George (ANU)"
  },
  {
    "value": "BBQ",
    "label": "Codrington (BBQ)"
  },
  {
    "value": "BGI",
    "label": "Bridgetown (BGI)"
  },
  {
    "value": "TBQ",
    "label": "Tarabo (TBQ)"
  },
  {
    "value": "DCF",
    "label": "Canefield (DCF)"
  },
  {
    "value": "DOM",
    "label": "Marigot (DOM)"
  },
  {
    "value": "TEO",
    "label": "Terapo Mission (TEO)"
  },
  {
    "value": "DSD",
    "label": "Grande Anse (DSD)"
  },
  {
    "value": "BBR",
    "label": "Basse Terre (BBR)"
  },
  {
    "value": "SFC",
    "label": "St-FranÃ§ois (SFC)"
  },
  {
    "value": "FDF",
    "label": "Fort-de-France (FDF)"
  },
  {
    "value": "SFG",
    "label": "Grand Case (SFG)"
  },
  {
    "value": "SBH",
    "label": "Gustavia (SBH)"
  },
  {
    "value": "GBJ",
    "label": "Grand Bourg (GBJ)"
  },
  {
    "value": "PTP",
    "label": "Pointe-Ã -Pitre Le Raizet (PTP)"
  },
  {
    "value": "LSS",
    "label": "Les Saintes (LSS)"
  },
  {
    "value": "TGL",
    "label": "Sudest Island (TGL)"
  },
  {
    "value": "GND",
    "label": "Saint George's (GND)"
  },
  {
    "value": "CRU",
    "label": "Carriacou Island (CRU)"
  },
  {
    "value": "STT",
    "label": "Charlotte Amalie, Harry S. Truman Airport (STT)"
  },
  {
    "value": "STX",
    "label": "Christiansted (STX)"
  },
  {
    "value": "ARE",
    "label": "Arecibo (ARE)"
  },
  {
    "value": "BQN",
    "label": "Aguadilla (BQN)"
  },
  {
    "value": "VQS",
    "label": "Vieques Island (VQS)"
  },
  {
    "value": "CPX",
    "label": "Culebra Island (CPX)"
  },
  {
    "value": "FAJ",
    "label": "Fajardo (FAJ)"
  },
  {
    "value": "SIG",
    "label": "San Juan (SIG)"
  },
  {
    "value": "MAZ",
    "label": "Mayaguez (MAZ)"
  },
  {
    "value": "PSE",
    "label": "Ponce (PSE)"
  },
  {
    "value": "SJU",
    "label": "San Juan (SJU)"
  },
  {
    "value": "SKB",
    "label": "Basseterre (SKB)"
  },
  {
    "value": "NEV",
    "label": "Charlestown (NEV)"
  },
  {
    "value": "TLP",
    "label": "Tumolbil Airport (TLP)"
  },
  {
    "value": "SLU",
    "label": "Castries (SLU)"
  },
  {
    "value": "UVF",
    "label": "Vieux Fort (UVF)"
  },
  {
    "value": "NBE",
    "label": "Enfidha (NBE)"
  },
  {
    "value": "AUA",
    "label": "Oranjestad (AUA)"
  },
  {
    "value": "BON",
    "label": "Kralendijk (BON)"
  },
  {
    "value": "CUR",
    "label": "Willemstad (CUR)"
  },
  {
    "value": "EUX",
    "label": "Sint Eustatius (EUX)"
  },
  {
    "value": "SXM",
    "label": "Saint Martin (SXM)"
  },
  {
    "value": "SAB",
    "label": "Saba (SAB)"
  },
  {
    "value": "PTA",
    "label": "Port Alsworth (PTA)"
  },
  {
    "value": "AXA",
    "label": "The Valley (AXA)"
  },
  {
    "value": "MNI",
    "label": "Gerald's Park (MNI)"
  },
  {
    "value": "TAB",
    "label": "Scarborough (TAB)"
  },
  {
    "value": "POS",
    "label": "Port of Spain (POS)"
  },
  {
    "value": "NGD",
    "label": "Anegada (NGD)"
  },
  {
    "value": "EIS",
    "label": "Road Town (EIS)"
  },
  {
    "value": "VIJ",
    "label": "Spanish Town (VIJ)"
  },
  {
    "value": "BQU",
    "label": "Bequia (BQU)"
  },
  {
    "value": "CIW",
    "label": "Canouan (CIW)"
  },
  {
    "value": "MQS",
    "label": "Mustique Island (MQS)"
  },
  {
    "value": "UNI",
    "label": "Union Island (UNI)"
  },
  {
    "value": "SVD",
    "label": "Kingstown (SVD)"
  },
  {
    "value": "CMJ",
    "label": "Chi Mei (CMJ)"
  },
  {
    "value": "TWH",
    "label": "Two Harbors (TWH)"
  },
  {
    "value": "BDA",
    "label": "Hamilton (BDA)"
  },
  {
    "value": "GIT",
    "label": "Geita (GIT)"
  },
  {
    "value": "LUY",
    "label": "Lushoto (LUY)"
  },
  {
    "value": "DBS",
    "label": "Dubois (DBS)"
  },
  {
    "value": "ALA",
    "label": "Almaty (ALA)"
  },
  {
    "value": "BXH",
    "label": "Balkhash (BXH)"
  },
  {
    "value": "BXJ",
    "label": "Aima Ata (BXJ)"
  },
  {
    "value": "TSE",
    "label": "Astana (TSE)"
  },
  {
    "value": "KOV",
    "label": "Kokshetau (KOV)"
  },
  {
    "value": "PPK",
    "label": "Petropavlosk (PPK)"
  },
  {
    "value": "DMB",
    "label": "Taraz (DMB)"
  },
  {
    "value": "UAE",
    "label": "Mount Aue Airport (UAE)"
  },
  {
    "value": "FRU",
    "label": "Bishkek (FRU)"
  },
  {
    "value": "OSS",
    "label": "Osh (OSS)"
  },
  {
    "value": "CIT",
    "label": "Shymkent (CIT)"
  },
  {
    "value": "KGF",
    "label": "Karaganda (KGF)"
  },
  {
    "value": "KZO",
    "label": "Kzyl-Orda (KZO)"
  },
  {
    "value": "URA",
    "label": "Uralsk (URA)"
  },
  {
    "value": "EKB",
    "label": "Ekibastuz (EKB)"
  },
  {
    "value": "PWQ",
    "label": "Pavlodar (PWQ)"
  },
  {
    "value": "DLX",
    "label": "Semey (DLX)"
  },
  {
    "value": "SCO",
    "label": "Aktau (SCO)"
  },
  {
    "value": "GUW",
    "label": "Atyrau (GUW)"
  },
  {
    "value": "AKX",
    "label": "Aktyuinsk (AKX)"
  },
  {
    "value": "AYK",
    "label": "Arkalyk (AYK)"
  },
  {
    "value": "KSN",
    "label": "Kostanay (KSN)"
  },
  {
    "value": "GYD",
    "label": "Baku (GYD)"
  },
  {
    "value": "KVD",
    "label": "Ganja (KVD)"
  },
  {
    "value": "NAJ",
    "label": "Nakhchivan (NAJ)"
  },
  {
    "value": "GBB",
    "label": "Gabala (GBB)"
  },
  {
    "value": "ZTU",
    "label": "Zaqatala (ZTU)"
  },
  {
    "value": "UBI",
    "label": "Buin (UBI)"
  },
  {
    "value": "LWN",
    "label": "Gyumri (LWN)"
  },
  {
    "value": "EVN",
    "label": "Yerevan (EVN)"
  },
  {
    "value": "ADH",
    "label": "Aldan (ADH)"
  },
  {
    "value": "YKS",
    "label": "Yakutsk (YKS)"
  },
  {
    "value": "CNN",
    "label": "Chulman (CNN)"
  },
  {
    "value": "ULK",
    "label": "Lensk (ULK)"
  },
  {
    "value": "PYJ",
    "label": "Yakutia (PYJ)"
  },
  {
    "value": "MJZ",
    "label": "Mirny (MJZ)"
  },
  {
    "value": "CKH",
    "label": "Chokurdah (CKH)"
  },
  {
    "value": "CYX",
    "label": "Cherskiy (CYX)"
  },
  {
    "value": "IKS",
    "label": "Tiksi (IKS)"
  },
  {
    "value": "OYG",
    "label": "Moyo (OYG)"
  },
  {
    "value": "UGB",
    "label": "Pilot Point (UGB)"
  },
  {
    "value": "KUT",
    "label": "Kutaisi (KUT)"
  },
  {
    "value": "BUS",
    "label": "Batumi (BUS)"
  },
  {
    "value": "SUI",
    "label": "Sukhumi (SUI)"
  },
  {
    "value": "TBS",
    "label": "Tbilisi (TBS)"
  },
  {
    "value": "BQS",
    "label": "Blagoveschensk (BQS)"
  },
  {
    "value": "GDG",
    "label": "Magdagachi (GDG)"
  },
  {
    "value": "TYD",
    "label": "Tynda (TYD)"
  },
  {
    "value": "KHV",
    "label": "Khabarovsk (KHV)"
  },
  {
    "value": "KXK",
    "label": "Komsomolsk-on-Amur (KXK)"
  },
  {
    "value": "GVN",
    "label": "Sovetskaya Gavan (GVN)"
  },
  {
    "value": "DYR",
    "label": "Anadyr (DYR)"
  },
  {
    "value": "PVS",
    "label": "Chukotka (PVS)"
  },
  {
    "value": "GDX",
    "label": "Magadan (GDX)"
  },
  {
    "value": "PWE",
    "label": "Pevek (PWE)"
  },
  {
    "value": "BQG",
    "label": "Bogorodskoye (BQG)"
  },
  {
    "value": "OHO",
    "label": "Okhotsk (OHO)"
  },
  {
    "value": "PKC",
    "label": "Petropavlovsk-Kamchatsky (PKC)"
  },
  {
    "value": "OHH",
    "label": "Okha (OHH)"
  },
  {
    "value": "EKS",
    "label": "Shakhtersk (EKS)"
  },
  {
    "value": "DEE",
    "label": "Kunashir Island (DEE)"
  },
  {
    "value": "ZZO",
    "label": "Tymovskoye (ZZO)"
  },
  {
    "value": "UUS",
    "label": "Yuzhno-Sakhalinsk (UUS)"
  },
  {
    "value": "VVO",
    "label": "Vladivostok (VVO)"
  },
  {
    "value": "HTA",
    "label": "Chita (HTA)"
  },
  {
    "value": "BTK",
    "label": "Bratsk (BTK)"
  },
  {
    "value": "UIK",
    "label": "Ust-Ilimsk (UIK)"
  },
  {
    "value": "IKT",
    "label": "Irkutsk (IKT)"
  },
  {
    "value": "ODO",
    "label": "Bodaybo (ODO)"
  },
  {
    "value": "ERG",
    "label": "Erbogachen (ERG)"
  },
  {
    "value": "UKX",
    "label": "Ust-Kut (UKX)"
  },
  {
    "value": "UUD",
    "label": "Ulan Ude (UUD)"
  },
  {
    "value": "UJE",
    "label": "Ujae Atoll (UJE)"
  },
  {
    "value": "UJN",
    "label": "Uljin (UJN)"
  },
  {
    "value": "KBP",
    "label": "Kiev (KBP)"
  },
  {
    "value": "DOK",
    "label": "Donetsk (DOK)"
  },
  {
    "value": "KRQ",
    "label": "Kramatorsk (KRQ)"
  },
  {
    "value": "MPW",
    "label": "Mariupol (MPW)"
  },
  {
    "value": "SEV",
    "label": "Sievierodonetsk (SEV)"
  },
  {
    "value": "VSG",
    "label": "Luhansk (VSG)"
  },
  {
    "value": "ERD",
    "label": "Berdyansk (ERD)"
  },
  {
    "value": "DNK",
    "label": "Dnipropetrovsk (DNK)"
  },
  {
    "value": "OZH",
    "label": "Zaporizhia (OZH)"
  },
  {
    "value": "KWG",
    "label": "Kryvyi Rih (KWG)"
  },
  {
    "value": "UKS",
    "label": "Sevastopol (UKS)"
  },
  {
    "value": "SIP",
    "label": "Simferopol (SIP)"
  },
  {
    "value": "KHC",
    "label": "Kerch (KHC)"
  },
  {
    "value": "UKH",
    "label": "Mukhaizna Oil Field (UKH)"
  },
  {
    "value": "HRK",
    "label": "Kharkiv (HRK)"
  },
  {
    "value": "PLV",
    "label": "Poltava (PLV)"
  },
  {
    "value": "UMY",
    "label": "Sumy (UMY)"
  },
  {
    "value": "CKC",
    "label": "Cherkasy (CKC)"
  },
  {
    "value": "KGO",
    "label": "Kirovograd (KGO)"
  },
  {
    "value": "IEV",
    "label": "Kiev (IEV)"
  },
  {
    "value": "GML",
    "label": "Kiev (GML)"
  },
  {
    "value": "ZTR",
    "label": "Zhytomyr Airport (ZTR)"
  },
  {
    "value": "UCK",
    "label": "Lutsk (UCK)"
  },
  {
    "value": "HMJ",
    "label": "Khmelnytskyi (HMJ)"
  },
  {
    "value": "IFO",
    "label": "Ivano-Frankivsk (IFO)"
  },
  {
    "value": "LWO",
    "label": "Lviv (LWO)"
  },
  {
    "value": "CWC",
    "label": "Chernivtsi (CWC)"
  },
  {
    "value": "RWN",
    "label": "Rivne (RWN)"
  },
  {
    "value": "TNL",
    "label": "Ternopil (TNL)"
  },
  {
    "value": "UDJ",
    "label": "Uzhhorod (UDJ)"
  },
  {
    "value": "KHE",
    "label": "Kherson (KHE)"
  },
  {
    "value": "NLV",
    "label": "Nikolayev (NLV)"
  },
  {
    "value": "ODS",
    "label": "Odessa (ODS)"
  },
  {
    "value": "VIN",
    "label": "Vinnitsa (VIN)"
  },
  {
    "value": "ARH",
    "label": "Archangelsk (ARH)"
  },
  {
    "value": "NNM",
    "label": "Naryan Mar (NNM)"
  },
  {
    "value": "CSH",
    "label": "Solovetsky Islands (CSH)"
  },
  {
    "value": "CEE",
    "label": "Cherepovets (CEE)"
  },
  {
    "value": "AMV",
    "label": "Amderma (AMV)"
  },
  {
    "value": "ULH",
    "label": "Al Ula (ULH)"
  },
  {
    "value": "KSZ",
    "label": "Kotlas (KSZ)"
  },
  {
    "value": "LED",
    "label": "St. Petersburg (LED)"
  },
  {
    "value": "KVK",
    "label": "Apatity (KVK)"
  },
  {
    "value": "MMK",
    "label": "Murmansk (MMK)"
  },
  {
    "value": "VLU",
    "label": "Velikiye Luki (VLU)"
  },
  {
    "value": "PKV",
    "label": "Pskov (PKV)"
  },
  {
    "value": "PES",
    "label": "Petrozavodsk (PES)"
  },
  {
    "value": "VGD",
    "label": "Vologda (VGD)"
  },
  {
    "value": "BQT",
    "label": "Brest (BQT)"
  },
  {
    "value": "GME",
    "label": "Gomel (GME)"
  },
  {
    "value": "VTB",
    "label": "Vitebsk (VTB)"
  },
  {
    "value": "KGD",
    "label": "Kaliningrad (KGD)"
  },
  {
    "value": "GNA",
    "label": "Hrodna (GNA)"
  },
  {
    "value": "MHP",
    "label": "Minsk (MHP)"
  },
  {
    "value": "MSQ",
    "label": "Minsk (MSQ)"
  },
  {
    "value": "MVQ",
    "label": "Mogilev (MVQ)"
  },
  {
    "value": "ABA",
    "label": "Abakan (ABA)"
  },
  {
    "value": "BAX",
    "label": "Barnaul (BAX)"
  },
  {
    "value": "KEJ",
    "label": "Kemerovo (KEJ)"
  },
  {
    "value": "EIE",
    "label": "Yeniseysk (EIE)"
  },
  {
    "value": "KJA",
    "label": "Krasnoyarsk (KJA)"
  },
  {
    "value": "ACS",
    "label": "Achinsk (ACS)"
  },
  {
    "value": "KYZ",
    "label": "Kyzyl (KYZ)"
  },
  {
    "value": "OVB",
    "label": "Novosibirsk (OVB)"
  },
  {
    "value": "OMS",
    "label": "Omsk (OMS)"
  },
  {
    "value": "TOF",
    "label": "Tomsk (TOF)"
  },
  {
    "value": "NOZ",
    "label": "Novokuznetsk (NOZ)"
  },
  {
    "value": "DKS",
    "label": "Dikson (DKS)"
  },
  {
    "value": "HTG",
    "label": "Khatanga (HTG)"
  },
  {
    "value": "IAA",
    "label": "Igarka (IAA)"
  },
  {
    "value": "NSK",
    "label": "Norilsk (NSK)"
  },
  {
    "value": "AAQ",
    "label": "Anapa (AAQ)"
  },
  {
    "value": "EIK",
    "label": "Yeysk (EIK)"
  },
  {
    "value": "GDZ",
    "label": "Gelendzhik (GDZ)"
  },
  {
    "value": "KRR",
    "label": "Krasnodar (KRR)"
  },
  {
    "value": "MCX",
    "label": "Makhachkala (MCX)"
  },
  {
    "value": "MRV",
    "label": "Mineralnyye Vody (MRV)"
  },
  {
    "value": "NAL",
    "label": "Nalchik (NAL)"
  },
  {
    "value": "OGZ",
    "label": "Beslan (OGZ)"
  },
  {
    "value": "IGT",
    "label": "Magas (IGT)"
  },
  {
    "value": "STW",
    "label": "Stavropol (STW)"
  },
  {
    "value": "ROV",
    "label": "Rostov-on-Don (ROV)"
  },
  {
    "value": "VLK",
    "label": "Volgodonsk Airport (VLK)"
  },
  {
    "value": "AER",
    "label": "Sochi (AER)"
  },
  {
    "value": "ASF",
    "label": "Astrakhan (ASF)"
  },
  {
    "value": "ESL",
    "label": "Elista (ESL)"
  },
  {
    "value": "VOG",
    "label": "Volgograd (VOG)"
  },
  {
    "value": "ALE",
    "label": "newark International Airport (ALE)"
  },
  {
    "value": "WQ",
    "label": "allentown International Airport (WQ)"
  },
  {
    "value": "CEK",
    "label": "Chelyabinsk (CEK)"
  },
  {
    "value": "MQF",
    "label": "Magnitogorsk (MQF)"
  },
  {
    "value": "SLY",
    "label": "Salekhard (SLY)"
  },
  {
    "value": "YMK",
    "label": "Mys Kamennyi (YMK)"
  },
  {
    "value": "UEN",
    "label": "Urengoy (UEN)"
  },
  {
    "value": "EZV",
    "label": "Berezovo Airport (EZV)"
  },
  {
    "value": "HMA",
    "label": "Khanty-Mansiysk (HMA)"
  },
  {
    "value": "IRM",
    "label": "Igrim Airport (IRM)"
  },
  {
    "value": "NYA",
    "label": "Nyagan (NYA)"
  },
  {
    "value": "OVS",
    "label": "Sovetskiy (OVS)"
  },
  {
    "value": "URJ",
    "label": "Uray (URJ)"
  },
  {
    "value": "EYK",
    "label": "Beloyarskiy Airport (EYK)"
  },
  {
    "value": "IJK",
    "label": "Izhevsk (IJK)"
  },
  {
    "value": "KVX",
    "label": "Kirov (KVX)"
  },
  {
    "value": "NYM",
    "label": "Nadym (NYM)"
  },
  {
    "value": "NUX",
    "label": "Novy Urengoy (NUX)"
  },
  {
    "value": "NJC",
    "label": "Nizhnevartovsk (NJC)"
  },
  {
    "value": "PEE",
    "label": "Perm (PEE)"
  },
  {
    "value": "KGP",
    "label": "Kogalym (KGP)"
  },
  {
    "value": "NFG",
    "label": "Nefteyugansk (NFG)"
  },
  {
    "value": "NOJ",
    "label": "Noyabrsk (NOJ)"
  },
  {
    "value": "SGC",
    "label": "Surgut (SGC)"
  },
  {
    "value": "SVX",
    "label": "Yekaterinburg (SVX)"
  },
  {
    "value": "TOX",
    "label": "Tobolsk (TOX)"
  },
  {
    "value": "TJM",
    "label": "Tyumen (TJM)"
  },
  {
    "value": "KRO",
    "label": "Kurgan (KRO)"
  },
  {
    "value": "ASB",
    "label": "Ashgabat (ASB)"
  },
  {
    "value": "KRW",
    "label": "Krasnovodsk (KRW)"
  },
  {
    "value": "MYP",
    "label": "Mary (MYP)"
  },
  {
    "value": "TAZ",
    "label": "DaÅŸoguz (TAZ)"
  },
  {
    "value": "CRZ",
    "label": "TÃ¼rkmenabat (CRZ)"
  },
  {
    "value": "DYU",
    "label": "Dushanbe (DYU)"
  },
  {
    "value": "TJU",
    "label": "Kulyab (TJU)"
  },
  {
    "value": "LBD",
    "label": "Khudzhand (LBD)"
  },
  {
    "value": "KQT",
    "label": "Kurgan-Tyube (KQT)"
  },
  {
    "value": "AZN",
    "label": "Andizhan (AZN)"
  },
  {
    "value": "FEG",
    "label": "Fergana (FEG)"
  },
  {
    "value": "NMA",
    "label": "Namangan (NMA)"
  },
  {
    "value": "NCU",
    "label": "Nukus (NCU)"
  },
  {
    "value": "UGC",
    "label": "Urgench (UGC)"
  },
  {
    "value": "NVI",
    "label": "Navoi (NVI)"
  },
  {
    "value": "BHK",
    "label": "Bukhara (BHK)"
  },
  {
    "value": "KSQ",
    "label": "Khanabad (KSQ)"
  },
  {
    "value": "AFS",
    "label": "Zarafshan (AFS)"
  },
  {
    "value": "SKD",
    "label": "Samarkand (SKD)"
  },
  {
    "value": "TMJ",
    "label": "Termez (TMJ)"
  },
  {
    "value": "TAS",
    "label": "Tashkent (TAS)"
  },
  {
    "value": "KMW",
    "label": "Kostroma (KMW)"
  },
  {
    "value": "BKA",
    "label": "Moscow (BKA)"
  },
  {
    "value": "IWA",
    "label": "Ivanovo (IWA)"
  },
  {
    "value": "RYB",
    "label": "Rybinsk (RYB)"
  },
  {
    "value": "BZK",
    "label": "Bryansk (BZK)"
  },
  {
    "value": "DME",
    "label": "Moscow (DME)"
  },
  {
    "value": "IAR",
    "label": "Tunoshna Airport (IAR)"
  },
  {
    "value": "SVO",
    "label": "Moscow (SVO)"
  },
  {
    "value": "KLD",
    "label": "Tver (KLD)"
  },
  {
    "value": "EGO",
    "label": "Belgorod (EGO)"
  },
  {
    "value": "URS",
    "label": "Kursk (URS)"
  },
  {
    "value": "LPK",
    "label": "Lipetsk (LPK)"
  },
  {
    "value": "VOZ",
    "label": "Voronezh (VOZ)"
  },
  {
    "value": "OEL",
    "label": "Orel (OEL)"
  },
  {
    "value": "TBW",
    "label": "Tambov (TBW)"
  },
  {
    "value": "RZN",
    "label": "Ryazan (RZN)"
  },
  {
    "value": "VKO",
    "label": "Moscow (VKO)"
  },
  {
    "value": "UCT",
    "label": "Ukhta (UCT)"
  },
  {
    "value": "INA",
    "label": "Inta (INA)"
  },
  {
    "value": "PEX",
    "label": "Pechora (PEX)"
  },
  {
    "value": "USK",
    "label": "Usinsk (USK)"
  },
  {
    "value": "VKT",
    "label": "Vorkuta (VKT)"
  },
  {
    "value": "UTS",
    "label": "Ust-Tsylma (UTS)"
  },
  {
    "value": "SCW",
    "label": "Syktyvkar (SCW)"
  },
  {
    "value": "GOJ",
    "label": "Nizhny Novgorod (GOJ)"
  },
  {
    "value": "UUA",
    "label": "Bugulma (UUA)"
  },
  {
    "value": "KZN",
    "label": "Kazan (KZN)"
  },
  {
    "value": "NBC",
    "label": "Nizhnekamsk (NBC)"
  },
  {
    "value": "JOK",
    "label": "Yoshkar-Ola (JOK)"
  },
  {
    "value": "CSY",
    "label": "Cheboksary (CSY)"
  },
  {
    "value": "ULV",
    "label": "Ulyanovsk (ULV)"
  },
  {
    "value": "ULY",
    "label": "Ulyanovsk (ULY)"
  },
  {
    "value": "REN",
    "label": "Orenburg (REN)"
  },
  {
    "value": "OSW",
    "label": "Orsk (OSW)"
  },
  {
    "value": "PEZ",
    "label": "Penza (PEZ)"
  },
  {
    "value": "SKX",
    "label": "Saransk (SKX)"
  },
  {
    "value": "BWO",
    "label": "Balakovo (BWO)"
  },
  {
    "value": "RTW",
    "label": "Saratov (RTW)"
  },
  {
    "value": "BCX",
    "label": "Beloretsk (BCX)"
  },
  {
    "value": "NEF",
    "label": "Neftekamsk (NEF)"
  },
  {
    "value": "OKT",
    "label": "Kzyl-Yar (OKT)"
  },
  {
    "value": "UFA",
    "label": "Ufa (UFA)"
  },
  {
    "value": "KUF",
    "label": "Samara (KUF)"
  },
  {
    "value": "FZB",
    "label": "Fray Bentos (FZB)"
  },
  {
    "value": "DIU",
    "label": "Diu (DIU)"
  },
  {
    "value": "AMD",
    "label": "Ahmedabad (AMD)"
  },
  {
    "value": "AKD",
    "label": "Akola Airport (AKD)"
  },
  {
    "value": "IXU",
    "label": "Aurangabad (IXU)"
  },
  {
    "value": "BOM",
    "label": "Mumbai (BOM)"
  },
  {
    "value": "PAB",
    "label": "Bilaspur Airport (PAB)"
  },
  {
    "value": "BHJ",
    "label": "Bhuj (BHJ)"
  },
  {
    "value": "IXG",
    "label": "Belgaum Airport (IXG)"
  },
  {
    "value": "BDQ",
    "label": "Vadodara (BDQ)"
  },
  {
    "value": "BHO",
    "label": "Bhopal (BHO)"
  },
  {
    "value": "BHU",
    "label": "Bhavnagar (BHU)"
  },
  {
    "value": "NMB",
    "label": "Daman Airport (NMB)"
  },
  {
    "value": "GUX",
    "label": "Guna Airport (GUX)"
  },
  {
    "value": "GOI",
    "label": "Vasco da Gama (GOI)"
  },
  {
    "value": "HBX",
    "label": "Hubli (HBX)"
  },
  {
    "value": "IDR",
    "label": "Indore (IDR)"
  },
  {
    "value": "JLR",
    "label": "Jabalpur Airport (JLR)"
  },
  {
    "value": "JGA",
    "label": "Jamnagar (JGA)"
  },
  {
    "value": "IXY",
    "label": "Kandla (IXY)"
  },
  {
    "value": "HJR",
    "label": "Khajuraho (HJR)"
  },
  {
    "value": "KLH",
    "label": "Kolhapur Airport (KLH)"
  },
  {
    "value": "IXK",
    "label": "Keshod Airport (IXK)"
  },
  {
    "value": "NDC",
    "label": "Nanded (NDC)"
  },
  {
    "value": "NAG",
    "label": "Naqpur (NAG)"
  },
  {
    "value": "PNQ",
    "label": "Pune (PNQ)"
  },
  {
    "value": "PBD",
    "label": "Porbandar (PBD)"
  },
  {
    "value": "RTC",
    "label": "Ratnagiri Airport (RTC)"
  },
  {
    "value": "RAJ",
    "label": "Rajkot (RAJ)"
  },
  {
    "value": "RPR",
    "label": "Raipur (RPR)"
  },
  {
    "value": "SSE",
    "label": "Solapur (SSE)"
  },
  {
    "value": "STV",
    "label": "Surat Airport (STV)"
  },
  {
    "value": "UDR",
    "label": "Udaipur (UDR)"
  },
  {
    "value": "CMB",
    "label": "Colombo (CMB)"
  },
  {
    "value": "ACJ",
    "label": "Anuradhapura (ACJ)"
  },
  {
    "value": "BTC",
    "label": "Batticaloa (BTC)"
  },
  {
    "value": "RML",
    "label": "Colombo (RML)"
  },
  {
    "value": "GOY",
    "label": "Amparai (GOY)"
  },
  {
    "value": "MNH",
    "label": "Polonnaruwa Town (MNH)"
  },
  {
    "value": "JAF",
    "label": "Jaffna (JAF)"
  },
  {
    "value": "KCT",
    "label": "Galle (KCT)"
  },
  {
    "value": "GIU",
    "label": "Sigiriya (GIU)"
  },
  {
    "value": "TRR",
    "label": "Trincomalee (TRR)"
  },
  {
    "value": "WRZ",
    "label": "Weerawila (WRZ)"
  },
  {
    "value": "BBM",
    "label": "Battambang (BBM)"
  },
  {
    "value": "KZC",
    "label": "Kampong Chhnang Airport (KZC)"
  },
  {
    "value": "KKZ",
    "label": "Kaoh Kong (KKZ)"
  },
  {
    "value": "KTI",
    "label": "Kratie (KTI)"
  },
  {
    "value": "PNH",
    "label": "Phnom Penh (PNH)"
  },
  {
    "value": "RBE",
    "label": "Ratanakiri (RBE)"
  },
  {
    "value": "SAI",
    "label": "Siem Reap (SAI)"
  },
  {
    "value": "TNX",
    "label": "Stung Treng (TNX)"
  },
  {
    "value": "KOS",
    "label": "Sihanukville (KOS)"
  },
  {
    "value": "ELX",
    "label": "Isla de Tigre (ELX)"
  },
  {
    "value": "LGY",
    "label": "Lagunillas (LGY)"
  },
  {
    "value": "KTV",
    "label": "Kamarata (KTV)"
  },
  {
    "value": "LAG",
    "label": "La Guaira (LAG)"
  },
  {
    "value": "SFX",
    "label": "Ciudad Guayana (SFX)"
  },
  {
    "value": "SVV",
    "label": "San Salvador de Paul (SVV)"
  },
  {
    "value": "WOK",
    "label": "Wonken (WOK)"
  },
  {
    "value": "IXV",
    "label": "Along Airport (IXV)"
  },
  {
    "value": "IXA",
    "label": "Agartala (IXA)"
  },
  {
    "value": "IXB",
    "label": "Siliguri (IXB)"
  },
  {
    "value": "RGH",
    "label": "Balurghat (RGH)"
  },
  {
    "value": "SHL",
    "label": "Shillong (SHL)"
  },
  {
    "value": "BBI",
    "label": "Bhubaneswar (BBI)"
  },
  {
    "value": "CCU",
    "label": "Kolkata (CCU)"
  },
  {
    "value": "COH",
    "label": "Cooch Behar Airport (COH)"
  },
  {
    "value": "DBD",
    "label": "Dhanbad Airport (DBD)"
  },
  {
    "value": "DAE",
    "label": "Daporijo Airport (DAE)"
  },
  {
    "value": "GOP",
    "label": "Gorakhpur (GOP)"
  },
  {
    "value": "GAU",
    "label": "Guwahati (GAU)"
  },
  {
    "value": "GAY",
    "label": "Gaya Airport (GAY)"
  },
  {
    "value": "IMF",
    "label": "Imphal (IMF)"
  },
  {
    "value": "PYB",
    "label": "Jeypore (PYB)"
  },
  {
    "value": "IXW",
    "label": "Jamshedpur Airport (IXW)"
  },
  {
    "value": "JRH",
    "label": "Jorhat (JRH)"
  },
  {
    "value": "IXQ",
    "label": "Kamalpur Airport (IXQ)"
  },
  {
    "value": "IXH",
    "label": "Kailashahar Airport (IXH)"
  },
  {
    "value": "IXS",
    "label": "Silchar (IXS)"
  },
  {
    "value": "IXN",
    "label": "Khowai (IXN)"
  },
  {
    "value": "AJL",
    "label": "Aizawl (AJL)"
  },
  {
    "value": "IXI",
    "label": "Lilabari (IXI)"
  },
  {
    "value": "LDA",
    "label": "Malda (LDA)"
  },
  {
    "value": "DIB",
    "label": "Dibrugarh (DIB)"
  },
  {
    "value": "DMU",
    "label": "Dimapur (DMU)"
  },
  {
    "value": "MZU",
    "label": "Muzaffarpur Airport (MZU)"
  },
  {
    "value": "IXT",
    "label": "Pasighat (IXT)"
  },
  {
    "value": "PAT",
    "label": "Patna (PAT)"
  },
  {
    "value": "IXR",
    "label": "Ranchi (IXR)"
  },
  {
    "value": "RRK",
    "label": "Rourkela Airport (RRK)"
  },
  {
    "value": "RUP",
    "label": "Rupsi India Airport (RUP)"
  },
  {
    "value": "TEZ",
    "label": "Tezpur Airport (TEZ)"
  },
  {
    "value": "VTZ",
    "label": "Visakhapatnam (VTZ)"
  },
  {
    "value": "ZER",
    "label": "Zero Airport (ZER)"
  },
  {
    "value": "BZL",
    "label": "Barisal (BZL)"
  },
  {
    "value": "CXB",
    "label": "Cox's Bazar (CXB)"
  },
  {
    "value": "CLA",
    "label": "Comilla (CLA)"
  },
  {
    "value": "CGP",
    "label": "Chittagong (CGP)"
  },
  {
    "value": "IRD",
    "label": "Ishurdi (IRD)"
  },
  {
    "value": "JSR",
    "label": "Jashahor (JSR)"
  },
  {
    "value": "LLJ",
    "label": "Lalmonirhat (LLJ)"
  },
  {
    "value": "RJH",
    "label": "Rajshahi (RJH)"
  },
  {
    "value": "SPD",
    "label": "Saidpur (SPD)"
  },
  {
    "value": "TKR",
    "label": "Thakurgaon (TKR)"
  },
  {
    "value": "ZHM",
    "label": "Shamshernagar (ZHM)"
  },
  {
    "value": "ZYL",
    "label": "Sylhet (ZYL)"
  },
  {
    "value": "DAC",
    "label": "Dhaka (DAC)"
  },
  {
    "value": "HKG",
    "label": "Hong Kong (HKG)"
  },
  {
    "value": "HHP",
    "label": "Hong Kong (HHP)"
  },
  {
    "value": "SPB",
    "label": "Charlotte Amalie St Thomas (SPB)"
  },
  {
    "value": "SSB",
    "label": "Christiansted St Croix (SSB)"
  },
  {
    "value": "AGR",
    "label": "Agra Airport (AGR)"
  },
  {
    "value": "IXD",
    "label": "Allahabad (IXD)"
  },
  {
    "value": "ATQ",
    "label": "Amritsar (ATQ)"
  },
  {
    "value": "BKB",
    "label": "Bikaner (BKB)"
  },
  {
    "value": "VNS",
    "label": "Varanasi (VNS)"
  },
  {
    "value": "KUU",
    "label": "Kullu Manali Airport (KUU)"
  },
  {
    "value": "BUP",
    "label": "Bhatinda Air Force Station (BUP)"
  },
  {
    "value": "IXC",
    "label": "Chandigarh (IXC)"
  },
  {
    "value": "DED",
    "label": "Dehradun (DED)"
  },
  {
    "value": "DEL",
    "label": "New Delhi (DEL)"
  },
  {
    "value": "DHM",
    "label": "Kangra Airport (DHM)"
  },
  {
    "value": "GWL",
    "label": "Gwalior (GWL)"
  },
  {
    "value": "HSS",
    "label": "Hissar Airport (HSS)"
  },
  {
    "value": "JDH",
    "label": "Jodhpur (JDH)"
  },
  {
    "value": "JAI",
    "label": "Jaipur (JAI)"
  },
  {
    "value": "JSA",
    "label": "Jaisalmer Airport (JSA)"
  },
  {
    "value": "IXJ",
    "label": "Jammu (IXJ)"
  },
  {
    "value": "KNU",
    "label": "Kanpur Airport (KNU)"
  },
  {
    "value": "KTU",
    "label": "Kota Airport (KTU)"
  },
  {
    "value": "LUH",
    "label": "Ludhiana Airport (LUH)"
  },
  {
    "value": "IXL",
    "label": "Leh (IXL)"
  },
  {
    "value": "LKO",
    "label": "Lucknow (LKO)"
  },
  {
    "value": "IXP",
    "label": "Pathankot Air Force Station (IXP)"
  },
  {
    "value": "PGH",
    "label": "Pantnagar (PGH)"
  },
  {
    "value": "SLV",
    "label": "Shimla Airport (SLV)"
  },
  {
    "value": "SXR",
    "label": "Srinagar (SXR)"
  },
  {
    "value": "TNI",
    "label": "Satna Airport (TNI)"
  },
  {
    "value": "VIV",
    "label": "Vivigani (VIV)"
  },
  {
    "value": "VKX",
    "label": "Friendly (VKX)"
  },
  {
    "value": "AOU",
    "label": "Attopeu (AOU)"
  },
  {
    "value": "OUI",
    "label": "Ban Huoeisay Airport (OUI)"
  },
  {
    "value": "LPQ",
    "label": "Luang Phabang (LPQ)"
  },
  {
    "value": "LXG",
    "label": "Luang Namtha (LXG)"
  },
  {
    "value": "ODY",
    "label": "Oudomsay (ODY)"
  },
  {
    "value": "PKZ",
    "label": "Pakse (PKZ)"
  },
  {
    "value": "ZBY",
    "label": "Sayaboury (ZBY)"
  },
  {
    "value": "ZVK",
    "label": "Savannakhet Airport (ZVK)"
  },
  {
    "value": "NEU",
    "label": "Sam Neua Airport (NEU)"
  },
  {
    "value": "VNA",
    "label": "Saravane (VNA)"
  },
  {
    "value": "THK",
    "label": "Thakhek (THK)"
  },
  {
    "value": "VTE",
    "label": "Vientiane (VTE)"
  },
  {
    "value": "XKH",
    "label": "Xieng Khouang (XKH)"
  },
  {
    "value": "VMI",
    "label": "Puerto Vallemi (VMI)"
  },
  {
    "value": "MFM",
    "label": "Taipa (MFM)"
  },
  {
    "value": "VDH",
    "label": "Dong Hoi (VDH)"
  },
  {
    "value": "KON",
    "label": "Kontum (KON)"
  },
  {
    "value": "BJH",
    "label": "Bajhang (BJH)"
  },
  {
    "value": "BHP",
    "label": "Bhojpur (BHP)"
  },
  {
    "value": "BGL",
    "label": "Baglung (BGL)"
  },
  {
    "value": "BHR",
    "label": "Bharatpur (BHR)"
  },
  {
    "value": "BJU",
    "label": "Bajura (BJU)"
  },
  {
    "value": "BIT",
    "label": "Baitadi (BIT)"
  },
  {
    "value": "BWA",
    "label": "Bhairawa (BWA)"
  },
  {
    "value": "BDP",
    "label": "Bhadrapur (BDP)"
  },
  {
    "value": "DNP",
    "label": "Dang (DNP)"
  },
  {
    "value": "DHI",
    "label": "Dhangarhi (DHI)"
  },
  {
    "value": "DAP",
    "label": "Darchula (DAP)"
  },
  {
    "value": "DOP",
    "label": "Dolpa (DOP)"
  },
  {
    "value": "SIH",
    "label": "Silgadi Doti (SIH)"
  },
  {
    "value": "GKH",
    "label": "Gorkha (GKH)"
  },
  {
    "value": "JIR",
    "label": "Jiri (JIR)"
  },
  {
    "value": "JUM",
    "label": "Jumla (JUM)"
  },
  {
    "value": "JKR",
    "label": "Janakpur (JKR)"
  },
  {
    "value": "KTM",
    "label": "Kathmandu (KTM)"
  },
  {
    "value": "LDN",
    "label": "Lamidanda (LDN)"
  },
  {
    "value": "LUA",
    "label": "Lukla (LUA)"
  },
  {
    "value": "LTG",
    "label": "Langtang (LTG)"
  },
  {
    "value": "NGX",
    "label": "Ngawal (NGX)"
  },
  {
    "value": "MEY",
    "label": "Meghauli (MEY)"
  },
  {
    "value": "XMG",
    "label": "Mahendranagar (XMG)"
  },
  {
    "value": "KEP",
    "label": "Nepalgunj (KEP)"
  },
  {
    "value": "PKR",
    "label": "Pokhara (PKR)"
  },
  {
    "value": "PPL",
    "label": "Phaplu (PPL)"
  },
  {
    "value": "RJB",
    "label": "Rajbiraj (RJB)"
  },
  {
    "value": "RHP",
    "label": "Ramechhap (RHP)"
  },
  {
    "value": "RUK",
    "label": "Rukumkot (RUK)"
  },
  {
    "value": "RUM",
    "label": "Rumjatar (RUM)"
  },
  {
    "value": "SIF",
    "label": "Simara (SIF)"
  },
  {
    "value": "SKH",
    "label": "Surkhet (SKH)"
  },
  {
    "value": "FEB",
    "label": "Sanfebagar (FEB)"
  },
  {
    "value": "IMK",
    "label": "Simikot (IMK)"
  },
  {
    "value": "TMI",
    "label": "Tumling Tar (TMI)"
  },
  {
    "value": "BIR",
    "label": "Biratnagar (BIR)"
  },
  {
    "value": "LTU",
    "label": "Latur (LTU)"
  },
  {
    "value": "AGX",
    "label": "Agatti Airport (AGX)"
  },
  {
    "value": "BEP",
    "label": "Bellary (BEP)"
  },
  {
    "value": "BLR",
    "label": "Bangalore (BLR)"
  },
  {
    "value": "VGA",
    "label": "Vijayawada Airport (VGA)"
  },
  {
    "value": "CJB",
    "label": "Coimbatore (CJB)"
  },
  {
    "value": "COK",
    "label": "Cochin (COK)"
  },
  {
    "value": "CCJ",
    "label": "Calicut (CCJ)"
  },
  {
    "value": "CDP",
    "label": "Cuddapah Airport (CDP)"
  },
  {
    "value": "CBD",
    "label": "Car Nicobar Air Force Station (CBD)"
  },
  {
    "value": "HYD",
    "label": "Hyderabad (HYD)"
  },
  {
    "value": "BPM",
    "label": "Hyderabad (BPM)"
  },
  {
    "value": "IXM",
    "label": "Madurai (IXM)"
  },
  {
    "value": "IXE",
    "label": "Mangalore (IXE)"
  },
  {
    "value": "MAA",
    "label": "Chennai (MAA)"
  },
  {
    "value": "MYQ",
    "label": "Mysore (MYQ)"
  },
  {
    "value": "IXZ",
    "label": "Port Blair (IXZ)"
  },
  {
    "value": "PNY",
    "label": "Pondicherry Airport (PNY)"
  },
  {
    "value": "RJA",
    "label": "Rajahmundry (RJA)"
  },
  {
    "value": "SXV",
    "label": "Salem Airport (SXV)"
  },
  {
    "value": "TJV",
    "label": "Thanjavur (TJV)"
  },
  {
    "value": "TIR",
    "label": "Tirupati (TIR)"
  },
  {
    "value": "TRZ",
    "label": "Tiruchirappally (TRZ)"
  },
  {
    "value": "TRV",
    "label": "Trivandrum (TRV)"
  },
  {
    "value": "WGC",
    "label": "Warrangal (WGC)"
  },
  {
    "value": "PBH",
    "label": "Paro (PBH)"
  },
  {
    "value": "FVM",
    "label": "Fuvahmulah Island (FVM)"
  },
  {
    "value": "GAN",
    "label": "Gan (GAN)"
  },
  {
    "value": "HAQ",
    "label": "Haa Dhaalu Atoll (HAQ)"
  },
  {
    "value": "KDO",
    "label": "Kadhdhoo (KDO)"
  },
  {
    "value": "MLE",
    "label": "MalÃ© (MLE)"
  },
  {
    "value": "KDM",
    "label": "Huvadhu Atoll (KDM)"
  },
  {
    "value": "VAM",
    "label": "Maamigili (VAM)"
  },
  {
    "value": "DMK",
    "label": "Bangkok (DMK)"
  },
  {
    "value": "KKM",
    "label": "Sa Pran Nak Airport (KKM)"
  },
  {
    "value": "TDX",
    "label": "Trat Airport (TDX)"
  },
  {
    "value": "BKK",
    "label": "Bangkok (BKK)"
  },
  {
    "value": "UTP",
    "label": "Rayong (UTP)"
  },
  {
    "value": "CNX",
    "label": "Chiang Mai (CNX)"
  },
  {
    "value": "HGN",
    "label": "Mae Hong Son Airport (HGN)"
  },
  {
    "value": "PYY",
    "label": "Mae Hong Son (PYY)"
  },
  {
    "value": "LPT",
    "label": "Lampang Airport (LPT)"
  },
  {
    "value": "NNT",
    "label": "Nan Airport (NNT)"
  },
  {
    "value": "PRH",
    "label": "Phrae Airport (PRH)"
  },
  {
    "value": "CEI",
    "label": "Chiang Rai (CEI)"
  },
  {
    "value": "BAO",
    "label": "Ban Mak Khaen (BAO)"
  },
  {
    "value": "PHY",
    "label": "Phetchabun Airport (PHY)"
  },
  {
    "value": "HHQ",
    "label": "Hua Hin (HHQ)"
  },
  {
    "value": "TKH",
    "label": "Takhli Airport (TKH)"
  },
  {
    "value": "MAQ",
    "label": "Mae Sot Airport (MAQ)"
  },
  {
    "value": "THS",
    "label": "Sukhothai Airport (THS)"
  },
  {
    "value": "PHS",
    "label": "Phitsanulok Airport (PHS)"
  },
  {
    "value": "TKT",
    "label": "Tak Airport (TKT)"
  },
  {
    "value": "UTR",
    "label": "Uttaradit (UTR)"
  },
  {
    "value": "URT",
    "label": "Surat Thani (URT)"
  },
  {
    "value": "NAW",
    "label": "Narathiwat Airport (NAW)"
  },
  {
    "value": "CJM",
    "label": "Chumphon Airport (CJM)"
  },
  {
    "value": "NST",
    "label": "Nakhon Si Thammarat (NST)"
  },
  {
    "value": "KBV",
    "label": "Krabi (KBV)"
  },
  {
    "value": "SGZ",
    "label": "Songkhla Airport (SGZ)"
  },
  {
    "value": "PAN",
    "label": "Pattani Airport (PAN)"
  },
  {
    "value": "USM",
    "label": "Na Thon (Ko Samui Island) (USM)"
  },
  {
    "value": "HKT",
    "label": "Phuket (HKT)"
  },
  {
    "value": "UNN",
    "label": "Ranong Airport (UNN)"
  },
  {
    "value": "HDY",
    "label": "Hat Yai (HDY)"
  },
  {
    "value": "TST",
    "label": "Trang Airport (TST)"
  },
  {
    "value": "UTH",
    "label": "Udon Thani (UTH)"
  },
  {
    "value": "SNO",
    "label": "Sakon Nakhon Airport (SNO)"
  },
  {
    "value": "KKC",
    "label": "Khon Kaen (KKC)"
  },
  {
    "value": "LOE",
    "label": "Loei Airport (LOE)"
  },
  {
    "value": "BFV",
    "label": "Buri Ram Airport (BFV)"
  },
  {
    "value": "NAK",
    "label": "Nakhon Ratchasima Airport (NAK)"
  },
  {
    "value": "UBP",
    "label": "Ubon Ratchathani (UBP)"
  },
  {
    "value": "ROI",
    "label": "Roi Et Airport (ROI)"
  },
  {
    "value": "KOP",
    "label": "Nakhon Phanom Airport (KOP)"
  },
  {
    "value": "VUU",
    "label": "Liwonde National Park (VUU)"
  },
  {
    "value": "BMV",
    "label": "Buon Ma Thuot (BMV)"
  },
  {
    "value": "VCL",
    "label": "Chu Lai (VCL)"
  },
  {
    "value": "HPH",
    "label": "Haiphong (HPH)"
  },
  {
    "value": "CAH",
    "label": "Ca Mau City (CAH)"
  },
  {
    "value": "CXR",
    "label": "Nha Trang (CXR)"
  },
  {
    "value": "VCS",
    "label": "Con Dao (VCS)"
  },
  {
    "value": "VCA",
    "label": "Can Tho (VCA)"
  },
  {
    "value": "DIN",
    "label": "Dien Bien Phu (DIN)"
  },
  {
    "value": "DLI",
    "label": "Dalat (DLI)"
  },
  {
    "value": "DAD",
    "label": "Da Nang (DAD)"
  },
  {
    "value": "VVN",
    "label": "Malvinas Gas Plant (VVN)"
  },
  {
    "value": "HAN",
    "label": "Ha Noi (HAN)"
  },
  {
    "value": "SQH",
    "label": "Son-La (SQH)"
  },
  {
    "value": "NHA",
    "label": "Nha Trang (NHA)"
  },
  {
    "value": "HUI",
    "label": "Hue (HUI)"
  },
  {
    "value": "UIH",
    "label": "Quy Nhon (UIH)"
  },
  {
    "value": "PXU",
    "label": "Pleiku (PXU)"
  },
  {
    "value": "PQC",
    "label": "Phu Quoc (PQC)"
  },
  {
    "value": "PHA",
    "label": "Phan Rang (PHA)"
  },
  {
    "value": "PHH",
    "label": "Phan Thiet (PHH)"
  },
  {
    "value": "VKG",
    "label": "Rach Gia (VKG)"
  },
  {
    "value": "TBB",
    "label": "Tuy Hoa (TBB)"
  },
  {
    "value": "SGN",
    "label": "Ho Chi Minh City (SGN)"
  },
  {
    "value": "VII",
    "label": "Vinh (VII)"
  },
  {
    "value": "VTG",
    "label": "Vung Tau (VTG)"
  },
  {
    "value": "NYU",
    "label": "Nyaung U (NYU)"
  },
  {
    "value": "BMO",
    "label": "Banmaw (BMO)"
  },
  {
    "value": "TVY",
    "label": "Dawei (TVY)"
  },
  {
    "value": "NYT",
    "label": "Pyinmana (NYT)"
  },
  {
    "value": "GAW",
    "label": "Gangaw (GAW)"
  },
  {
    "value": "GWA",
    "label": "Gwa (GWA)"
  },
  {
    "value": "HEH",
    "label": "Heho (HEH)"
  },
  {
    "value": "HOX",
    "label": "Hommalinn (HOX)"
  },
  {
    "value": "TIO",
    "label": "Tilin (TIO)"
  },
  {
    "value": "KET",
    "label": "Kengtung (KET)"
  },
  {
    "value": "KHM",
    "label": "Kanti (KHM)"
  },
  {
    "value": "KMV",
    "label": "Kalemyo (KMV)"
  },
  {
    "value": "KYP",
    "label": "Kyaukpyu (KYP)"
  },
  {
    "value": "KAW",
    "label": "Kawthoung (KAW)"
  },
  {
    "value": "KYT",
    "label": "Kyauktu (KYT)"
  },
  {
    "value": "LIW",
    "label": "Loikaw (LIW)"
  },
  {
    "value": "LSH",
    "label": "Lashio (LSH)"
  },
  {
    "value": "MDL",
    "label": "Mandalay (MDL)"
  },
  {
    "value": "MGZ",
    "label": "Mkeik (MGZ)"
  },
  {
    "value": "MYT",
    "label": "Myitkyina (MYT)"
  },
  {
    "value": "MNU",
    "label": "Mawlamyine (MNU)"
  },
  {
    "value": "MGU",
    "label": "Manaung (MGU)"
  },
  {
    "value": "MOE",
    "label": "Momeik Airport (MOE)"
  },
  {
    "value": "MOG",
    "label": "Mong Hsat (MOG)"
  },
  {
    "value": "MGK",
    "label": "Mong Tong (MGK)"
  },
  {
    "value": "MWQ",
    "label": "Magway (MWQ)"
  },
  {
    "value": "NMS",
    "label": "Namsang (NMS)"
  },
  {
    "value": "NMT",
    "label": "Namtu (NMT)"
  },
  {
    "value": "PAA",
    "label": "Hpa-N (PAA)"
  },
  {
    "value": "PAU",
    "label": "Pauk (PAU)"
  },
  {
    "value": "BSX",
    "label": "Pathein (BSX)"
  },
  {
    "value": "PPU",
    "label": "Pa Pun (PPU)"
  },
  {
    "value": "PBU",
    "label": "Putao (PBU)"
  },
  {
    "value": "PKK",
    "label": "Pakhokku (PKK)"
  },
  {
    "value": "PRU",
    "label": "Pye (PRU)"
  },
  {
    "value": "AKY",
    "label": "Sittwe (AKY)"
  },
  {
    "value": "SNW",
    "label": "Thandwe (SNW)"
  },
  {
    "value": "THL",
    "label": "Tachileik (THL)"
  },
  {
    "value": "XYE",
    "label": "Ye (XYE)"
  },
  {
    "value": "RGN",
    "label": "Yangon (RGN)"
  },
  {
    "value": "FBS",
    "label": "Friday Harbor (FBS)"
  },
  {
    "value": "UPG",
    "label": "Ujung Pandang-Celebes Island (UPG)"
  },
  {
    "value": "MJU",
    "label": "Mamuju-Celebes Island (MJU)"
  },
  {
    "value": "BIK",
    "label": "Biak-Supiori Island (BIK)"
  },
  {
    "value": "ONI",
    "label": "Moanamani-Papua Island (ONI)"
  },
  {
    "value": "WET",
    "label": "Wagethe-Papua Island (WET)"
  },
  {
    "value": "NBX",
    "label": "Nabire-Papua Island (NBX)"
  },
  {
    "value": "ILA",
    "label": "Illaga-Papua Island (ILA)"
  },
  {
    "value": "KOX",
    "label": "Kokonau-Papua Island (KOX)"
  },
  {
    "value": "ZRI",
    "label": "Serui-Japen Island (ZRI)"
  },
  {
    "value": "TIM",
    "label": "Timika-Papua Island (TIM)"
  },
  {
    "value": "EWI",
    "label": "Enarotali-Papua Island (EWI)"
  },
  {
    "value": "AMI",
    "label": "Mataram-Lombok Island (AMI)"
  },
  {
    "value": "BMU",
    "label": "Bima-Sumbawa Island (BMU)"
  },
  {
    "value": "DPS",
    "label": "Denpasar-Bali Island (DPS)"
  },
  {
    "value": "LOP",
    "label": "Mataram (LOP)"
  },
  {
    "value": "SWQ",
    "label": "Sumbawa Island (SWQ)"
  },
  {
    "value": "TMC",
    "label": "Waikabubak-Sumba Island (TMC)"
  },
  {
    "value": "WGP",
    "label": "Waingapu-Sumba Island (WGP)"
  },
  {
    "value": "ARJ",
    "label": "Arso-Papua Island (ARJ)"
  },
  {
    "value": "BUI",
    "label": "Bokondini-Papua Island (BUI)"
  },
  {
    "value": "ZRM",
    "label": "Sarmi-Papua Island (ZRM)"
  },
  {
    "value": "DJJ",
    "label": "Jayapura-Papua Island (DJJ)"
  },
  {
    "value": "LHI",
    "label": "Lereh-Papua Island (LHI)"
  },
  {
    "value": "LII",
    "label": "Mulia-Papua Island (LII)"
  },
  {
    "value": "OKL",
    "label": "Oksibil-Papua Island (OKL)"
  },
  {
    "value": "WAR",
    "label": "Waris-Papua Island (WAR)"
  },
  {
    "value": "SEH",
    "label": "Senggeh-Papua Island (SEH)"
  },
  {
    "value": "UBR",
    "label": "Ubrub-Papua Island (UBR)"
  },
  {
    "value": "WMX",
    "label": "Wamena-Papua Island (WMX)"
  },
  {
    "value": "MDP",
    "label": "Mindiptana-Papua Island (MDP)"
  },
  {
    "value": "BXD",
    "label": "Bade-Papua Island (BXD)"
  },
  {
    "value": "MKQ",
    "label": "Merauke-Papua Island (MKQ)"
  },
  {
    "value": "OKQ",
    "label": "Okaba-Papua Island (OKQ)"
  },
  {
    "value": "KEI",
    "label": "Kepi-Papua Island (KEI)"
  },
  {
    "value": "TMH",
    "label": "Tanah Merah-Papua Island (TMH)"
  },
  {
    "value": "TJS",
    "label": "Tanjung Selor-Borneo Island (TJS)"
  },
  {
    "value": "DTD",
    "label": "Datadawai-Borneo Island (DTD)"
  },
  {
    "value": "BEJ",
    "label": "Tanjung Redep-Borneo Island (BEJ)"
  },
  {
    "value": "BPN",
    "label": "Balikpapan-Borneo Island (BPN)"
  },
  {
    "value": "TRK",
    "label": "Tarakan Island (TRK)"
  },
  {
    "value": "SRI",
    "label": "Samarinda-Borneo Island (SRI)"
  },
  {
    "value": "TSX",
    "label": "Santan-Borneo Island (TSX)"
  },
  {
    "value": "BYQ",
    "label": "Bunju Island (BYQ)"
  },
  {
    "value": "GLX",
    "label": "Galela-Celebes Island (GLX)"
  },
  {
    "value": "GTO",
    "label": "Gorontalo-Celebes Island (GTO)"
  },
  {
    "value": "NAH",
    "label": "Tahuna-Sangihe Island (NAH)"
  },
  {
    "value": "TLI",
    "label": "Toli Toli-Celebes Island (TLI)"
  },
  {
    "value": "GEB",
    "label": "Gebe Island (GEB)"
  },
  {
    "value": "KAZ",
    "label": "Kao-Celebes Island (KAZ)"
  },
  {
    "value": "PLW",
    "label": "Palu-Celebes Island (PLW)"
  },
  {
    "value": "MDC",
    "label": "Manado-Celebes Island (MDC)"
  },
  {
    "value": "MNA",
    "label": "Karakelong Island (MNA)"
  },
  {
    "value": "PSJ",
    "label": "Poso-Celebes Island (PSJ)"
  },
  {
    "value": "OTI",
    "label": "Gotalalamo-Morotai Island (OTI)"
  },
  {
    "value": "TTE",
    "label": "Sango-Ternate Island (TTE)"
  },
  {
    "value": "LUW",
    "label": "Luwok-Celebes Island (LUW)"
  },
  {
    "value": "UOL",
    "label": "Buol-Celebes Island (UOL)"
  },
  {
    "value": "BTW",
    "label": "Batu Licin-Borneo Island (BTW)"
  },
  {
    "value": "PKN",
    "label": "Pangkalanbun-Borneo Island (PKN)"
  },
  {
    "value": "KBU",
    "label": "Laut Island (KBU)"
  },
  {
    "value": "MTW",
    "label": "Murateweh-Borneo Island (MTW)"
  },
  {
    "value": "TJG",
    "label": "Tanta-Tabalong-Borneo Island (TJG)"
  },
  {
    "value": "BDJ",
    "label": "Banjarmasin-Borneo Island (BDJ)"
  },
  {
    "value": "PKY",
    "label": "Palangkaraya-Kalimantan Tengah (PKY)"
  },
  {
    "value": "SMQ",
    "label": "Sampit-Borneo Island (SMQ)"
  },
  {
    "value": "AHI",
    "label": "Amahai-Seram Island (AHI)"
  },
  {
    "value": "DOB",
    "label": "Dobo-Kobror Island (DOB)"
  },
  {
    "value": "MAL",
    "label": "Mangole Island (MAL)"
  },
  {
    "value": "NRE",
    "label": "Namrole-Buru Island (NRE)"
  },
  {
    "value": "LAH",
    "label": "Labuha-Halmahera Island (LAH)"
  },
  {
    "value": "SXK",
    "label": "Saumlaki-Yamdena Island (SXK)"
  },
  {
    "value": "BJK",
    "label": "Maikoor Island (BJK)"
  },
  {
    "value": "LUV",
    "label": "Langgur-Seram Island (LUV)"
  },
  {
    "value": "SQN",
    "label": "Sanana-Seram Island (SQN)"
  },
  {
    "value": "AMQ",
    "label": "Ambon (AMQ)"
  },
  {
    "value": "NAM",
    "label": "Namlea-Buru Island (NAM)"
  },
  {
    "value": "TAX",
    "label": "Tikong-Taliabu Island (TAX)"
  },
  {
    "value": "MLG",
    "label": "Malang-Java Island (MLG)"
  },
  {
    "value": "CPF",
    "label": "Tjepu-Java Island (CPF)"
  },
  {
    "value": "JOG",
    "label": "Yogyakarta-Java Island (JOG)"
  },
  {
    "value": "SOC",
    "label": "Sukarata(Solo)-Java Island (SOC)"
  },
  {
    "value": "SUB",
    "label": "Surabaya (SUB)"
  },
  {
    "value": "SRG",
    "label": "Semarang-Java Island (SRG)"
  },
  {
    "value": "SUP",
    "label": "Sumenep-Madura Island (SUP)"
  },
  {
    "value": "NTI",
    "label": "Bintuni-Papua Island (NTI)"
  },
  {
    "value": "RSK",
    "label": "Ransiki-Papua Island (RSK)"
  },
  {
    "value": "KEQ",
    "label": "Kebar-Papua Island (KEQ)"
  },
  {
    "value": "FKQ",
    "label": "Fakfak-Papua Island (FKQ)"
  },
  {
    "value": "INX",
    "label": "Inanwatan Airport-Papua Island (INX)"
  },
  {
    "value": "KNG",
    "label": "Kaimana-Papua Island (KNG)"
  },
  {
    "value": "RDE",
    "label": "Merdei-Papua Island (RDE)"
  },
  {
    "value": "BXB",
    "label": "Babo-Papua Island (BXB)"
  },
  {
    "value": "MKW",
    "label": "Manokwari-Papua Island (MKW)"
  },
  {
    "value": "SOQ",
    "label": "Sorong-Papua Island (SOQ)"
  },
  {
    "value": "TXM",
    "label": "Atinjoe-Papua Island (TXM)"
  },
  {
    "value": "WSR",
    "label": "Wasior-Papua Island (WSR)"
  },
  {
    "value": "BJW",
    "label": "Bajawa (BJW)"
  },
  {
    "value": "MOF",
    "label": "Maumere-Flores Island (MOF)"
  },
  {
    "value": "ENE",
    "label": "Ende-Flores Island (ENE)"
  },
  {
    "value": "RTG",
    "label": "Satar Tacik-Flores Island (RTG)"
  },
  {
    "value": "ARD",
    "label": "Alor Island (ARD)"
  },
  {
    "value": "LBJ",
    "label": "Labuan Bajo-Flores Island (LBJ)"
  },
  {
    "value": "KOE",
    "label": "Kupang-Timor Island (KOE)"
  },
  {
    "value": "BUW",
    "label": "Bau Bau-Butung Island (BUW)"
  },
  {
    "value": "MXB",
    "label": "Masamba-Celebes Island (MXB)"
  },
  {
    "value": "SQR",
    "label": "Soroako-Celebes Island (SQR)"
  },
  {
    "value": "TTR",
    "label": "Tanah Toraja-Celebes Island (TTR)"
  },
  {
    "value": "KDI",
    "label": "Kendari-Celebes Island (KDI)"
  },
  {
    "value": "BTU",
    "label": "Bintulu (BTU)"
  },
  {
    "value": "BLG",
    "label": "Belaga (BLG)"
  },
  {
    "value": "LSM",
    "label": "Long Semado (LSM)"
  },
  {
    "value": "LGL",
    "label": "Long Datih (LGL)"
  },
  {
    "value": "KCH",
    "label": "Kuching (KCH)"
  },
  {
    "value": "ODN",
    "label": "Long Seridan (ODN)"
  },
  {
    "value": "LMN",
    "label": "Limbang (LMN)"
  },
  {
    "value": "MKM",
    "label": "Mukah (MKM)"
  },
  {
    "value": "LKH",
    "label": "Long Akah (LKH)"
  },
  {
    "value": "MUR",
    "label": "Marudi (MUR)"
  },
  {
    "value": "BSE",
    "label": "Sematan (BSE)"
  },
  {
    "value": "KPI",
    "label": "Kapit (KPI)"
  },
  {
    "value": "BKM",
    "label": "Bakalalan (BKM)"
  },
  {
    "value": "MYY",
    "label": "Miri (MYY)"
  },
  {
    "value": "SBW",
    "label": "Sibu (SBW)"
  },
  {
    "value": "TGC",
    "label": "Tanjung Manis (TGC)"
  },
  {
    "value": "LSU",
    "label": "Long Sukang (LSU)"
  },
  {
    "value": "LWY",
    "label": "Lawas (LWY)"
  },
  {
    "value": "SGG",
    "label": "Simanggang (SGG)"
  },
  {
    "value": "BBN",
    "label": "Bario (BBN)"
  },
  {
    "value": "SMM",
    "label": "Semporna (SMM)"
  },
  {
    "value": "LDU",
    "label": "Lahad Datu (LDU)"
  },
  {
    "value": "TEL",
    "label": "Telupid (TEL)"
  },
  {
    "value": "KGU",
    "label": "Keningau (KGU)"
  },
  {
    "value": "SXS",
    "label": "Sahabat (SXS)"
  },
  {
    "value": "BKI",
    "label": "Kota Kinabalu (BKI)"
  },
  {
    "value": "LBU",
    "label": "Labuan (LBU)"
  },
  {
    "value": "TMG",
    "label": "Tomanggong (TMG)"
  },
  {
    "value": "GSA",
    "label": "Long Miau (GSA)"
  },
  {
    "value": "SPE",
    "label": "Sepulot (SPE)"
  },
  {
    "value": "PAY",
    "label": "Pamol (PAY)"
  },
  {
    "value": "RNU",
    "label": "Ranau (RNU)"
  },
  {
    "value": "SDK",
    "label": "Sandakan (SDK)"
  },
  {
    "value": "KUD",
    "label": "Kudat (KUD)"
  },
  {
    "value": "TWU",
    "label": "Tawau (TWU)"
  },
  {
    "value": "MZV",
    "label": "Mulu (MZV)"
  },
  {
    "value": "BWN",
    "label": "Bandar Seri Begawan (BWN)"
  },
  {
    "value": "TKG",
    "label": "Bandar Lampung-Sumatra Island (TKG)"
  },
  {
    "value": "PKU",
    "label": "Pekanbaru-Sumatra Island (PKU)"
  },
  {
    "value": "DUM",
    "label": "Dumai-Sumatra Island (DUM)"
  },
  {
    "value": "RKO",
    "label": "Sipora Island (RKO)"
  },
  {
    "value": "SEQ",
    "label": "Bengkalis-Sumatra Island (SEQ)"
  },
  {
    "value": "TJB",
    "label": "Karinmunbesar Island (TJB)"
  },
  {
    "value": "BDO",
    "label": "Bandung-Java Island (BDO)"
  },
  {
    "value": "CBN",
    "label": "Cirebon-Java Island (CBN)"
  },
  {
    "value": "TSY",
    "label": "Tasikmalaya-Java Island (TSY)"
  },
  {
    "value": "BTH",
    "label": "Batam Island (BTH)"
  },
  {
    "value": "PPR",
    "label": "Pasir Pengarayan-Sumatra Island (PPR)"
  },
  {
    "value": "TNJ",
    "label": "Tanjung Pinang-Bintan Island (TNJ)"
  },
  {
    "value": "SIQ",
    "label": "Pasirkuning-Singkep Island (SIQ)"
  },
  {
    "value": "HLP",
    "label": "Jakarta (HLP)"
  },
  {
    "value": "CXP",
    "label": "Cilacap-Java Island (CXP)"
  },
  {
    "value": "PCB",
    "label": "Jakarta (PCB)"
  },
  {
    "value": "CGK",
    "label": "Jakarta (CGK)"
  },
  {
    "value": "LLG",
    "label": "Lubuk Linggau-Sumatra Island (LLG)"
  },
  {
    "value": "GNS",
    "label": "Gunung Sitoli-Nias Island (GNS)"
  },
  {
    "value": "AEG",
    "label": "Padang Sidempuan-Sumatra Island (AEG)"
  },
  {
    "value": "PDG",
    "label": "Padang-Sumatra Island (PDG)"
  },
  {
    "value": "MES",
    "label": "Medan-Sumatra Island (MES)"
  },
  {
    "value": "TJQ",
    "label": "Tanjung Pandan-Belitung Island (TJQ)"
  },
  {
    "value": "NPO",
    "label": "Nanga Pinoh-Borneo Island (NPO)"
  },
  {
    "value": "KTG",
    "label": "Ketapang-Borneo Island (KTG)"
  },
  {
    "value": "MWK",
    "label": "Matak Island (MWK)"
  },
  {
    "value": "NTX",
    "label": "Ranai-Natuna Besar Island (NTX)"
  },
  {
    "value": "PNK",
    "label": "Pontianak-Borneo Island (PNK)"
  },
  {
    "value": "PSU",
    "label": "Putussibau-Borneo Island (PSU)"
  },
  {
    "value": "SQG",
    "label": "Sintang-Borneo Island (SQG)"
  },
  {
    "value": "DJB",
    "label": "Jambi-Sumatra Island (DJB)"
  },
  {
    "value": "PGK",
    "label": "Pangkal Pinang-Palaubangka Island (PGK)"
  },
  {
    "value": "BKS",
    "label": "Bengkulu-Sumatra Island (BKS)"
  },
  {
    "value": "PLM",
    "label": "Palembang-Sumatra Island (PLM)"
  },
  {
    "value": "PDO",
    "label": "Talang Gudang-Sumatra Island (PDO)"
  },
  {
    "value": "RGT",
    "label": "Rengat-Sumatra Island (RGT)"
  },
  {
    "value": "MPC",
    "label": "Muko Muko-Sumatra Island (MPC)"
  },
  {
    "value": "TPK",
    "label": "Tapak Tuan-Sumatra Island (TPK)"
  },
  {
    "value": "SBG",
    "label": "Sabang-We Island (SBG)"
  },
  {
    "value": "MEQ",
    "label": "Peureumeue-Sumatra Island (MEQ)"
  },
  {
    "value": "LSX",
    "label": "Lhok Sukon-Sumatra Island (LSX)"
  },
  {
    "value": "LSW",
    "label": "Lhok Seumawe-Sumatra Island (LSW)"
  },
  {
    "value": "BTJ",
    "label": "Banda Aceh-Sumatra Island (BTJ)"
  },
  {
    "value": "SXT",
    "label": "Taman Negara (SXT)"
  },
  {
    "value": "MEP",
    "label": "Mersing (MEP)"
  },
  {
    "value": "SWY",
    "label": "Sitiawan (SWY)"
  },
  {
    "value": "TPG",
    "label": "Taiping (TPG)"
  },
  {
    "value": "TOD",
    "label": "Pulau Tioman (TOD)"
  },
  {
    "value": "AOR",
    "label": "Alor Satar (AOR)"
  },
  {
    "value": "BWH",
    "label": "Butterworth (BWH)"
  },
  {
    "value": "KBR",
    "label": "Kota Baharu (KBR)"
  },
  {
    "value": "KUA",
    "label": "Kuantan (KUA)"
  },
  {
    "value": "KTE",
    "label": "Kerteh (KTE)"
  },
  {
    "value": "IPH",
    "label": "Ipoh (IPH)"
  },
  {
    "value": "JHB",
    "label": "Senai (JHB)"
  },
  {
    "value": "KUL",
    "label": "Kuala Lumpur (KUL)"
  },
  {
    "value": "LGK",
    "label": "Langkawi (LGK)"
  },
  {
    "value": "MKZ",
    "label": "Malacca (MKZ)"
  },
  {
    "value": "TGG",
    "label": "Kuala Terengganu (TGG)"
  },
  {
    "value": "PEN",
    "label": "Penang (PEN)"
  },
  {
    "value": "PKG",
    "label": "Pangkor Island (PKG)"
  },
  {
    "value": "RDN",
    "label": "Redang (RDN)"
  },
  {
    "value": "SZB",
    "label": "Subang (SZB)"
  },
  {
    "value": "DTR",
    "label": "Decatur (DTR)"
  },
  {
    "value": "AUT",
    "label": "Atauro (AUT)"
  },
  {
    "value": "UAI",
    "label": "Suai (UAI)"
  },
  {
    "value": "DIC",
    "label": "Dili (DIC)"
  },
  {
    "value": "DIL",
    "label": "Dili (DIL)"
  },
  {
    "value": "BCH",
    "label": "Baucau (BCH)"
  },
  {
    "value": "OEC",
    "label": "Oecussi-Ambeno (OEC)"
  },
  {
    "value": "VIQ",
    "label": "Viqueque (VIQ)"
  },
  {
    "value": "ABU",
    "label": "Atambua-Timor Island (ABU)"
  },
  {
    "value": "LKA",
    "label": "Larantuka-Flores Island (LKA)"
  },
  {
    "value": "SAU",
    "label": "Sawu-Sawu Island (SAU)"
  },
  {
    "value": "SGQ",
    "label": "Sanggata-Timor Island (SGQ)"
  },
  {
    "value": "LBW",
    "label": "Long Bawan-Borneo Island (LBW)"
  },
  {
    "value": "BXT",
    "label": "Bontang-Borneo Island (BXT)"
  },
  {
    "value": "NNX",
    "label": "Nunukan-Nunukan Island (NNX)"
  },
  {
    "value": "TNB",
    "label": "Tanah Grogot-Borneo Island (TNB)"
  },
  {
    "value": "LPU",
    "label": "Long Apung-Borneo Island (LPU)"
  },
  {
    "value": "SZH",
    "label": "Senipah-Borneo Island (SZH)"
  },
  {
    "value": "QPG",
    "label": "Paya Lebar Air Base (QPG)"
  },
  {
    "value": "TGA",
    "label": "Tengah Air Base (TGA)"
  },
  {
    "value": "XSP",
    "label": "Seletar (XSP)"
  },
  {
    "value": "SIN",
    "label": "Singapore (SIN)"
  },
  {
    "value": "WTT",
    "label": "Wantoat Airport (WTT)"
  },
  {
    "value": "WUV",
    "label": "Wuvulu Island (WUV)"
  },
  {
    "value": "WWT",
    "label": "Newtok (WWT)"
  },
  {
    "value": "XBN",
    "label": "Biniguni Airport (XBN)"
  },
  {
    "value": "SKL",
    "label": "Broadford (SKL)"
  },
  {
    "value": "ALH",
    "label": "Albany (ALH)"
  },
  {
    "value": "ABG",
    "label": "Abingdon Downs Airport (ABG)"
  },
  {
    "value": "AWN",
    "label": "Alton Downs Airport (AWN)"
  },
  {
    "value": "AUD",
    "label": "Augustus Downs Airport (AUD)"
  },
  {
    "value": "MRP",
    "label": "Marla Airport (MRP)"
  },
  {
    "value": "AXL",
    "label": "Alexandria Homestead Airport (AXL)"
  },
  {
    "value": "AXC",
    "label": "Aramac Airport (AXC)"
  },
  {
    "value": "ADO",
    "label": "Andamooka Airport (ADO)"
  },
  {
    "value": "AMX",
    "label": "Ammaroo Airport (AMX)"
  },
  {
    "value": "AMT",
    "label": "Amata Airport (AMT)"
  },
  {
    "value": "AYL",
    "label": "Anthony Lagoon Airport (AYL)"
  },
  {
    "value": "ABH",
    "label": "Alpha Airport (ABH)"
  },
  {
    "value": "ARY",
    "label": "Ararat Airport (ARY)"
  },
  {
    "value": "GYL",
    "label": "Argyle Airport (GYL)"
  },
  {
    "value": "ARM",
    "label": "Armidale (ARM)"
  },
  {
    "value": "AAB",
    "label": "Arrabury Airport (AAB)"
  },
  {
    "value": "AUU",
    "label": "Aurukun Airport (AUU)"
  },
  {
    "value": "AWP",
    "label": "Austral Downs Airport (AWP)"
  },
  {
    "value": "AVG",
    "label": "Auvergne Airport (AVG)"
  },
  {
    "value": "AYQ",
    "label": "Ayers Rock (AYQ)"
  },
  {
    "value": "AYR",
    "label": "Ayr Airport (AYR)"
  },
  {
    "value": "ACF",
    "label": "Brisbane (ACF)"
  },
  {
    "value": "ABM",
    "label": "Bamaga Injinoo Airport (ABM)"
  },
  {
    "value": "BCI",
    "label": "Barcaldine (BCI)"
  },
  {
    "value": "ASP",
    "label": "Alice Springs (ASP)"
  },
  {
    "value": "BDD",
    "label": "Badu Island Airport (BDD)"
  },
  {
    "value": "BKP",
    "label": "Barkly Downs Airport (BKP)"
  },
  {
    "value": "BBE",
    "label": "Big Bell (BBE)"
  },
  {
    "value": "BNE",
    "label": "Brisbane (BNE)"
  },
  {
    "value": "OOL",
    "label": "Gold Coast (OOL)"
  },
  {
    "value": "BKQ",
    "label": "Blackall (BKQ)"
  },
  {
    "value": "CNS",
    "label": "Cairns (CNS)"
  },
  {
    "value": "CTL",
    "label": "Charleville (CTL)"
  },
  {
    "value": "BDW",
    "label": "Bedford Downs Airport (BDW)"
  },
  {
    "value": "BXG",
    "label": "Bendigo Airport (BXG)"
  },
  {
    "value": "BVI",
    "label": "Birdsville Airport (BVI)"
  },
  {
    "value": "BTX",
    "label": "Betoota Airport (BTX)"
  },
  {
    "value": "BQW",
    "label": "Balgo Hill Airport (BQW)"
  },
  {
    "value": "BHQ",
    "label": "Broken Hill (BHQ)"
  },
  {
    "value": "HTI",
    "label": "Hamilton Island (HTI)"
  },
  {
    "value": "BEU",
    "label": "Bedourie Airport (BEU)"
  },
  {
    "value": "BIW",
    "label": "Billiluna Airport (BIW)"
  },
  {
    "value": "BZP",
    "label": "Lakefield National Park (BZP)"
  },
  {
    "value": "BRK",
    "label": "Bourke Airport (BRK)"
  },
  {
    "value": "BUC",
    "label": "Burketown Airport (BUC)"
  },
  {
    "value": "BLN",
    "label": "Benalla Airport (BLN)"
  },
  {
    "value": "LCN",
    "label": "Balcanoona Airport (LCN)"
  },
  {
    "value": "BLS",
    "label": "Bollon Airport (BLS)"
  },
  {
    "value": "BQB",
    "label": "Busselton Regional Airport (BQB)"
  },
  {
    "value": "ISA",
    "label": "Mount Isa (ISA)"
  },
  {
    "value": "MCY",
    "label": "Maroochydore (MCY)"
  },
  {
    "value": "MKY",
    "label": "Mackay (MKY)"
  },
  {
    "value": "BNK",
    "label": "Ballina (BNK)"
  },
  {
    "value": "BSJ",
    "label": "Bairnsdale Airport (BSJ)"
  },
  {
    "value": "GIC",
    "label": "Boigu Airport (GIC)"
  },
  {
    "value": "OKY",
    "label": "Oakey Airport (OKY)"
  },
  {
    "value": "BQL",
    "label": "Boulia Airport (BQL)"
  },
  {
    "value": "BMP",
    "label": "Brampton Island Airport (BMP)"
  },
  {
    "value": "PPP",
    "label": "Proserpine (PPP)"
  },
  {
    "value": "ROK",
    "label": "Rockhampton (ROK)"
  },
  {
    "value": "BOX",
    "label": "Borroloola Airport (BOX)"
  },
  {
    "value": "BME",
    "label": "Broome (BME)"
  },
  {
    "value": "BZD",
    "label": "Balranald Airport (BZD)"
  },
  {
    "value": "BTD",
    "label": "Brunette Downs Airport (BTD)"
  },
  {
    "value": "BWQ",
    "label": "Brewarrina Airport (BWQ)"
  },
  {
    "value": "BHS",
    "label": "Bathurst (BHS)"
  },
  {
    "value": "BRT",
    "label": "Bathurst Island Airport (BRT)"
  },
  {
    "value": "TSV",
    "label": "Townsville (TSV)"
  },
  {
    "value": "BLT",
    "label": "Blackwater Airport (BLT)"
  },
  {
    "value": "BDB",
    "label": "Bundaberg (BDB)"
  },
  {
    "value": "BUY",
    "label": "Bunbury Airport (BUY)"
  },
  {
    "value": "BIP",
    "label": "Bulimba Airport (BIP)"
  },
  {
    "value": "ZBO",
    "label": "Bowen Airport (ZBO)"
  },
  {
    "value": "WEI",
    "label": "Weipa (WEI)"
  },
  {
    "value": "BWB",
    "label": "Barrow Island Airport (BWB)"
  },
  {
    "value": "BVZ",
    "label": "Beverley Springs Airport (BVZ)"
  },
  {
    "value": "CGV",
    "label": "Caiguna Airport (CGV)"
  },
  {
    "value": "CLH",
    "label": "Coolah Airport (CLH)"
  },
  {
    "value": "CVQ",
    "label": "Carnarvon Airport (CVQ)"
  },
  {
    "value": "CSI",
    "label": "Casino Airport (CSI)"
  },
  {
    "value": "CAZ",
    "label": "Cobar Airport (CAZ)"
  },
  {
    "value": "COJ",
    "label": "Coonabarabran Airport (COJ)"
  },
  {
    "value": "CBY",
    "label": "Canobie (CBY)"
  },
  {
    "value": "CBI",
    "label": "Cape Barren Island Airport (CBI)"
  },
  {
    "value": "CPD",
    "label": "Coober Pedy Airport (CPD)"
  },
  {
    "value": "CRB",
    "label": "Collarenebri Airport (CRB)"
  },
  {
    "value": "CCL",
    "label": "Chinchilla Airport (CCL)"
  },
  {
    "value": "CNC",
    "label": "Coconut Island Airport (CNC)"
  },
  {
    "value": "CNJ",
    "label": "Cloncurry (CNJ)"
  },
  {
    "value": "CBX",
    "label": "Condobolin Airport (CBX)"
  },
  {
    "value": "CUD",
    "label": "Caloundra Airport (CUD)"
  },
  {
    "value": "CED",
    "label": "Ceduna Airport (CED)"
  },
  {
    "value": "CVC",
    "label": "Cleve Airport (CVC)"
  },
  {
    "value": "CFI",
    "label": "Camfield Airport (CFI)"
  },
  {
    "value": "CXT",
    "label": "Charters Towers Airport (CXT)"
  },
  {
    "value": "DCN",
    "label": "RAAF Base Curtin (DCN)"
  },
  {
    "value": "CKI",
    "label": "Croker Island Airport (CKI)"
  },
  {
    "value": "CTN",
    "label": "Cooktown Airport (CTN)"
  },
  {
    "value": "CMQ",
    "label": "Clermont Airport (CMQ)"
  },
  {
    "value": "CMA",
    "label": "Cunnamulla Airport (CMA)"
  },
  {
    "value": "CML",
    "label": "Camooweal Airport (CML)"
  },
  {
    "value": "NIF",
    "label": "Camp Nifty Airport (NIF)"
  },
  {
    "value": "CES",
    "label": "Cessnock Airport (CES)"
  },
  {
    "value": "CNB",
    "label": "Coonamble Airport (CNB)"
  },
  {
    "value": "ODL",
    "label": "Cordillo Downs (ODL)"
  },
  {
    "value": "CUQ",
    "label": "Coen Airport (CUQ)"
  },
  {
    "value": "OOM",
    "label": "Cooma (OOM)"
  },
  {
    "value": "CDA",
    "label": "Cooinda Airport (CDA)"
  },
  {
    "value": "CWW",
    "label": "Corowa Airport (CWW)"
  },
  {
    "value": "CYG",
    "label": "Corryong Airport (CYG)"
  },
  {
    "value": "CDQ",
    "label": "Croydon Airport (CDQ)"
  },
  {
    "value": "KCE",
    "label": "Collinsville Airport (KCE)"
  },
  {
    "value": "CMD",
    "label": "Cootamundra Airport (CMD)"
  },
  {
    "value": "CUG",
    "label": "Cudal Airport (CUG)"
  },
  {
    "value": "CUY",
    "label": "Cue Airport (CUY)"
  },
  {
    "value": "CWR",
    "label": "Cowarie Airport (CWR)"
  },
  {
    "value": "CCW",
    "label": "Cowell Airport (CCW)"
  },
  {
    "value": "CWT",
    "label": "Cowra Airport (CWT)"
  },
  {
    "value": "DJR",
    "label": "Dajarra Airport (DJR)"
  },
  {
    "value": "DBY",
    "label": "Dalby Airport (DBY)"
  },
  {
    "value": "DRN",
    "label": "Dirranbandi Airport (DRN)"
  },
  {
    "value": "DNB",
    "label": "Dunbar Airport (DNB)"
  },
  {
    "value": "DRB",
    "label": "Derby Airport (DRB)"
  },
  {
    "value": "DFP",
    "label": "Drumduff (DFP)"
  },
  {
    "value": "DGD",
    "label": "Dalgaranga Gold Mine Airport (DGD)"
  },
  {
    "value": "DXD",
    "label": "New Dixie (DXD)"
  },
  {
    "value": "DLK",
    "label": "Dulkaninna (DLK)"
  },
  {
    "value": "DDN",
    "label": "Delta Downs Airport (DDN)"
  },
  {
    "value": "DLV",
    "label": "Delissaville Airport (DLV)"
  },
  {
    "value": "DYW",
    "label": "Daly Waters (DYW)"
  },
  {
    "value": "DMD",
    "label": "Doomadgee Airport (DMD)"
  },
  {
    "value": "DVR",
    "label": "Daly River Airport (DVR)"
  },
  {
    "value": "NLF",
    "label": "Darnley Island (NLF)"
  },
  {
    "value": "DRD",
    "label": "Dorunda Airport (DRD)"
  },
  {
    "value": "DVP",
    "label": "Davenport Downs Airport (DVP)"
  },
  {
    "value": "DPO",
    "label": "Devonport (DPO)"
  },
  {
    "value": "DOX",
    "label": "Dongara Airport (DOX)"
  },
  {
    "value": "DRY",
    "label": "Drysdale River Airport (DRY)"
  },
  {
    "value": "DHD",
    "label": "Durham Downs Airport (DHD)"
  },
  {
    "value": "DRR",
    "label": "Durrie Airport (DRR)"
  },
  {
    "value": "DKV",
    "label": "Docker River Airport (DKV)"
  },
  {
    "value": "DYA",
    "label": "Dysart Airport (DYA)"
  },
  {
    "value": "WDA",
    "label": "Wadi Ain (WDA)"
  },
  {
    "value": "ECH",
    "label": "Echuca Airport (ECH)"
  },
  {
    "value": "EUC",
    "label": "Eucla Airport (EUC)"
  },
  {
    "value": "ETD",
    "label": "Etadunna (ETD)"
  },
  {
    "value": "ENB",
    "label": "Eneabba (ENB)"
  },
  {
    "value": "EIH",
    "label": "Einasleigh (EIH)"
  },
  {
    "value": "ELC",
    "label": "Elcho Island (ELC)"
  },
  {
    "value": "EMD",
    "label": "Emerald (EMD)"
  },
  {
    "value": "YEQ",
    "label": "Yenkis(Yankisa) Airport (YEQ)"
  },
  {
    "value": "ERB",
    "label": "Ernabella Airport (ERB)"
  },
  {
    "value": "EPR",
    "label": "Esperance Airport (EPR)"
  },
  {
    "value": "EVD",
    "label": "Eva Downs (EVD)"
  },
  {
    "value": "EVH",
    "label": "Evans Head Aerodrome (EVH)"
  },
  {
    "value": "EXM",
    "label": "Exmouth Airport (EXM)"
  },
  {
    "value": "FRB",
    "label": "Forbes, (FRB)"
  },
  {
    "value": "FLY",
    "label": "Finley Airport (FLY)"
  },
  {
    "value": "FLS",
    "label": "Flinders Island Airport (FLS)"
  },
  {
    "value": "FVL",
    "label": "Flora Valley Airport (FVL)"
  },
  {
    "value": "FIK",
    "label": "Finke (FIK)"
  },
  {
    "value": "FOS",
    "label": "Forrest Airport (FOS)"
  },
  {
    "value": "FOT",
    "label": "Forster (Wallis Is) Airport (FOT)"
  },
  {
    "value": "FIZ",
    "label": "Fitzroy Crossing Airport (FIZ)"
  },
  {
    "value": "GAH",
    "label": "Gayndah Airport (GAH)"
  },
  {
    "value": "GBL",
    "label": "South Goulburn Is Airport (GBL)"
  },
  {
    "value": "GUH",
    "label": "Gunnedah Airport (GUH)"
  },
  {
    "value": "GOO",
    "label": "Goondiwindi Airport (GOO)"
  },
  {
    "value": "GDD",
    "label": "Gordon Downs (GDD)"
  },
  {
    "value": "GGD",
    "label": "Gregory Downs Airport (GGD)"
  },
  {
    "value": "GTS",
    "label": "Granite Downs Airport (GTS)"
  },
  {
    "value": "GET",
    "label": "Geraldton Airport (GET)"
  },
  {
    "value": "GFN",
    "label": "Grafton Airport (GFN)"
  },
  {
    "value": "GBV",
    "label": "Gibb River Airport (GBV)"
  },
  {
    "value": "GLT",
    "label": "Gladstone (GLT)"
  },
  {
    "value": "GUL",
    "label": "Goulburn Airport (GUL)"
  },
  {
    "value": "GLG",
    "label": "Glengyle Airport (GLG)"
  },
  {
    "value": "GEX",
    "label": "Geelong Airport (GEX)"
  },
  {
    "value": "GLI",
    "label": "Glen Innes Airport (GLI)"
  },
  {
    "value": "GLM",
    "label": "Glenormiston Airport (GLM)"
  },
  {
    "value": "GVP",
    "label": "Greenvale Airport (GVP)"
  },
  {
    "value": "GPN",
    "label": "Garden Point Airport (GPN)"
  },
  {
    "value": "GTE",
    "label": "Groote Eylandt (GTE)"
  },
  {
    "value": "GFF",
    "label": "Griffith (GFF)"
  },
  {
    "value": "GTT",
    "label": "Georgetown Airport (GTT)"
  },
  {
    "value": "GEE",
    "label": "Georgetown (Tas) Airport (GEE)"
  },
  {
    "value": "GYP",
    "label": "Gympie Airport (GYP)"
  },
  {
    "value": "HWK",
    "label": "Hawker (HWK)"
  },
  {
    "value": "HXX",
    "label": "Hay Airport (HXX)"
  },
  {
    "value": "HVB",
    "label": "Hervey Bay (HVB)"
  },
  {
    "value": "HUB",
    "label": "Humbert River Airport (HUB)"
  },
  {
    "value": "HIP",
    "label": "Headingly Airport (HIP)"
  },
  {
    "value": "HID",
    "label": "Horn Island (HID)"
  },
  {
    "value": "HCQ",
    "label": "Halls Creek Airport (HCQ)"
  },
  {
    "value": "HMG",
    "label": "Hermannsburg Airport (HMG)"
  },
  {
    "value": "HLT",
    "label": "Hamilton Airport (HLT)"
  },
  {
    "value": "HOK",
    "label": "Hooker Creek Airport (HOK)"
  },
  {
    "value": "MHU",
    "label": "Mount Hotham (MHU)"
  },
  {
    "value": "HTU",
    "label": "Hopetoun Airport (HTU)"
  },
  {
    "value": "HSM",
    "label": "Horsham Airport (HSM)"
  },
  {
    "value": "HGD",
    "label": "Hughenden Airport (HGD)"
  },
  {
    "value": "IDK",
    "label": "Indulkana Airport (IDK)"
  },
  {
    "value": "IFL",
    "label": "Innisfail Airport (IFL)"
  },
  {
    "value": "IFF",
    "label": "Iffley Airport (IFF)"
  },
  {
    "value": "IGH",
    "label": "Ingham Airport (IGH)"
  },
  {
    "value": "IKP",
    "label": "Inkerman Airport (IKP)"
  },
  {
    "value": "INJ",
    "label": "Injune Airport (INJ)"
  },
  {
    "value": "INM",
    "label": "Innamincka Airport (INM)"
  },
  {
    "value": "IVW",
    "label": "Inverway (IVW)"
  },
  {
    "value": "ISI",
    "label": "Isisford Airport (ISI)"
  },
  {
    "value": "IVR",
    "label": "Inverell Airport (IVR)"
  },
  {
    "value": "JAB",
    "label": "Jabiru Airport (JAB)"
  },
  {
    "value": "JUN",
    "label": "Jundah Airport (JUN)"
  },
  {
    "value": "QJD",
    "label": "Jindabyne Airport (QJD)"
  },
  {
    "value": "JCK",
    "label": "Julia Creek Airport (JCK)"
  },
  {
    "value": "JUR",
    "label": "Jurien Bay Airport (JUR)"
  },
  {
    "value": "UBU",
    "label": "Kalumburu Airport (UBU)"
  },
  {
    "value": "KAX",
    "label": "Kalbarri Airport (KAX)"
  },
  {
    "value": "KBY",
    "label": "Streaky Bay Airport (KBY)"
  },
  {
    "value": "KCS",
    "label": "Kings Creek Airport (KCS)"
  },
  {
    "value": "KRA",
    "label": "Kerang Airport (KRA)"
  },
  {
    "value": "KNS",
    "label": "King Island Airport (KNS)"
  },
  {
    "value": "KBB",
    "label": "Kirkimbie (KBB)"
  },
  {
    "value": "KFG",
    "label": "Kalkgurung Airport (KFG)"
  },
  {
    "value": "KKP",
    "label": "Koolburra (KKP)"
  },
  {
    "value": "KRB",
    "label": "Karumba Airport (KRB)"
  },
  {
    "value": "KML",
    "label": "Kamileroi Airport (KML)"
  },
  {
    "value": "KPS",
    "label": "Kempsey Airport (KPS)"
  },
  {
    "value": "KNI",
    "label": "Katanning Airport (KNI)"
  },
  {
    "value": "KWM",
    "label": "Kowanyama (KWM)"
  },
  {
    "value": "KGY",
    "label": "Kingaroy Airport (KGY)"
  },
  {
    "value": "KGC",
    "label": "Kingscote Airport (KGC)"
  },
  {
    "value": "KUG",
    "label": "Kubin Airport (KUG)"
  },
  {
    "value": "LWH",
    "label": "Lawn Hill Airport (LWH)"
  },
  {
    "value": "LGH",
    "label": "Leigh Creek Airport (LGH)"
  },
  {
    "value": "LNO",
    "label": "Leonora (LNO)"
  },
  {
    "value": "LEL",
    "label": "Lake Evella Airport (LEL)"
  },
  {
    "value": "LDH",
    "label": "Lord Howe Island (LDH)"
  },
  {
    "value": "IRG",
    "label": "Lockhart River Airport (IRG)"
  },
  {
    "value": "LTP",
    "label": "Lyndhurst (LTP)"
  },
  {
    "value": "LDC",
    "label": "Lindeman Island (LDC)"
  },
  {
    "value": "LSY",
    "label": "Lismore (LSY)"
  },
  {
    "value": "LOC",
    "label": "Lock (LOC)"
  },
  {
    "value": "LOA",
    "label": "Lorraine Airport (LOA)"
  },
  {
    "value": "LTV",
    "label": "Lotus Vale (LTV)"
  },
  {
    "value": "LUU",
    "label": "Laura Airport (LUU)"
  },
  {
    "value": "LHG",
    "label": "Lightning Ridge Airport (LHG)"
  },
  {
    "value": "LRE",
    "label": "Longreach (LRE)"
  },
  {
    "value": "LUT",
    "label": "New Laura Airport (LUT)"
  },
  {
    "value": "LER",
    "label": "Leinster Airport (LER)"
  },
  {
    "value": "LVO",
    "label": "Laverton Airport (LVO)"
  },
  {
    "value": "TGN",
    "label": "Latrobe Valley Airport (TGN)"
  },
  {
    "value": "LZR",
    "label": "Lizard Island Airport (LZR)"
  },
  {
    "value": "UBB",
    "label": "Mabuiag Island (UBB)"
  },
  {
    "value": "AVV",
    "label": "Melbourne (AVV)"
  },
  {
    "value": "ABX",
    "label": "Albury (ABX)"
  },
  {
    "value": "MRG",
    "label": "Mareeba Airport (MRG)"
  },
  {
    "value": "MBB",
    "label": "Marble Bar Airport (MBB)"
  },
  {
    "value": "XMC",
    "label": "Mallacoota Airport (XMC)"
  },
  {
    "value": "MFP",
    "label": "Manners Creek Airport (MFP)"
  },
  {
    "value": "MLR",
    "label": "Millicent Airport (MLR)"
  },
  {
    "value": "DGE",
    "label": "Mudgee (DGE)"
  },
  {
    "value": "MQA",
    "label": "Mandora (MQA)"
  },
  {
    "value": "MKR",
    "label": "Meekatharra Airport (MKR)"
  },
  {
    "value": "MEB",
    "label": "Melbourne Essendon Airport (MEB)"
  },
  {
    "value": "MIM",
    "label": "Merimbula (MIM)"
  },
  {
    "value": "SXE",
    "label": "RAAF Base East Sale (SXE)"
  },
  {
    "value": "MGT",
    "label": "Milingimbi Island (MGT)"
  },
  {
    "value": "MNG",
    "label": "Maningrida (MNG)"
  },
  {
    "value": "GSN",
    "label": "Mount Gunson (GSN)"
  },
  {
    "value": "MGV",
    "label": "Margaret River (Station) Airport (MGV)"
  },
  {
    "value": "HBA",
    "label": "Hobart (HBA)"
  },
  {
    "value": "MHO",
    "label": "Mount House Airport (MHO)"
  },
  {
    "value": "MCV",
    "label": "McArthur River Mine (MCV)"
  },
  {
    "value": "MQL",
    "label": "Mildura (MQL)"
  },
  {
    "value": "XML",
    "label": "Minlaton Airport (XML)"
  },
  {
    "value": "MIH",
    "label": "Mitchell Plateau (MIH)"
  },
  {
    "value": "MTQ",
    "label": "Mitchell Airport (MTQ)"
  },
  {
    "value": "MJP",
    "label": "Manjimup Airport (MJP)"
  },
  {
    "value": "LST",
    "label": "Launceston (LST)"
  },
  {
    "value": "MBW",
    "label": "Melbourne (MBW)"
  },
  {
    "value": "MEL",
    "label": "Melbourne (MEL)"
  },
  {
    "value": "MMM",
    "label": "Middlemount Airport (MMM)"
  },
  {
    "value": "MTL",
    "label": "Maitland Airport (MTL)"
  },
  {
    "value": "WME",
    "label": "Mount Keith Airport (WME)"
  },
  {
    "value": "ONR",
    "label": "Monkira Airport (ONR)"
  },
  {
    "value": "OXY",
    "label": "Morney Airport (OXY)"
  },
  {
    "value": "MMG",
    "label": "Mount Magnet Airport (MMG)"
  },
  {
    "value": "OOR",
    "label": "Mooraberree Airport (OOR)"
  },
  {
    "value": "MRZ",
    "label": "Moree (MRZ)"
  },
  {
    "value": "MET",
    "label": "Moreton (MET)"
  },
  {
    "value": "MIN",
    "label": "Minnipa Airport (MIN)"
  },
  {
    "value": "MQE",
    "label": "Marqua (MQE)"
  },
  {
    "value": "MOV",
    "label": "Moranbah (MOV)"
  },
  {
    "value": "RRE",
    "label": "Marree Airport (RRE)"
  },
  {
    "value": "MWB",
    "label": "Morawa Airport (MWB)"
  },
  {
    "value": "MYA",
    "label": "Moruya (MYA)"
  },
  {
    "value": "MTD",
    "label": "Mount Sanford Station Airport (MTD)"
  },
  {
    "value": "UTB",
    "label": "Muttaburra Airport (UTB)"
  },
  {
    "value": "MGB",
    "label": "Mount Gambier Airport (MGB)"
  },
  {
    "value": "ONG",
    "label": "Mornington Island Airport (ONG)"
  },
  {
    "value": "MNQ",
    "label": "Monto Airport (MNQ)"
  },
  {
    "value": "MUQ",
    "label": "Muccan Station (MUQ)"
  },
  {
    "value": "MNE",
    "label": "Mungeranie (MNE)"
  },
  {
    "value": "MYI",
    "label": "Murray Island (MYI)"
  },
  {
    "value": "MVK",
    "label": "Mulka (MVK)"
  },
  {
    "value": "MXU",
    "label": "Mullewa Airport (MXU)"
  },
  {
    "value": "MXD",
    "label": "Marion Downs Airport (MXD)"
  },
  {
    "value": "MBH",
    "label": "Maryborough Airport (MBH)"
  },
  {
    "value": "RTY",
    "label": "Merty Merty Airport (RTY)"
  },
  {
    "value": "NMR",
    "label": "Nappa Merrie Airport (NMR)"
  },
  {
    "value": "NRA",
    "label": "Narrandera (NRA)"
  },
  {
    "value": "NAA",
    "label": "Narrabri (NAA)"
  },
  {
    "value": "RPM",
    "label": "Ngukurr Airport (RPM)"
  },
  {
    "value": "NBH",
    "label": "Nambucca Heads (NBH)"
  },
  {
    "value": "NLS",
    "label": "Nicholson Airport (NLS)"
  },
  {
    "value": "NAC",
    "label": "Naracoorte Airport (NAC)"
  },
  {
    "value": "QRM",
    "label": "Narromine Airport (QRM)"
  },
  {
    "value": "RVT",
    "label": "Ravensthorpe Airport (RVT)"
  },
  {
    "value": "NSV",
    "label": "Noosa Airport (NSV)"
  },
  {
    "value": "NSM",
    "label": "Norseman Airport (NSM)"
  },
  {
    "value": "NTN",
    "label": "Normanton Airport (NTN)"
  },
  {
    "value": "NUR",
    "label": "Nullabor Motel Airport (NUR)"
  },
  {
    "value": "NLL",
    "label": "Nullagine Airport (NLL)"
  },
  {
    "value": "NUB",
    "label": "Numbulwar Airport (NUB)"
  },
  {
    "value": "ZNE",
    "label": "Newman (ZNE)"
  },
  {
    "value": "NYN",
    "label": "Nyngan Airport (NYN)"
  },
  {
    "value": "OPI",
    "label": "Oenpelli Airport (OPI)"
  },
  {
    "value": "YOI",
    "label": "Opinaca Aerodrome (YOI)"
  },
  {
    "value": "XCO",
    "label": "Colac Airport (XCO)"
  },
  {
    "value": "OLP",
    "label": "Olympic Dam (OLP)"
  },
  {
    "value": "ODD",
    "label": "Oodnadatta Airport (ODD)"
  },
  {
    "value": "MOO",
    "label": "Moomba Airport (MOO)"
  },
  {
    "value": "RBS",
    "label": "Orbost Airport (RBS)"
  },
  {
    "value": "OAG",
    "label": "Orange (OAG)"
  },
  {
    "value": "ODR",
    "label": "Ord River (ODR)"
  },
  {
    "value": "OYN",
    "label": "Ouyen Airport (OYN)"
  },
  {
    "value": "ADL",
    "label": "Adelaide (ADL)"
  },
  {
    "value": "PUG",
    "label": "Port Augusta Airport (PUG)"
  },
  {
    "value": "PMK",
    "label": "Palm Island Airport (PMK)"
  },
  {
    "value": "PBO",
    "label": "Paraburdoo (PBO)"
  },
  {
    "value": "CCK",
    "label": "Cocos (Keeling) Islands (CCK)"
  },
  {
    "value": "PDE",
    "label": "Pandie Pandie Airport (PDE)"
  },
  {
    "value": "DRW",
    "label": "Darwin (DRW)"
  },
  {
    "value": "PRD",
    "label": "Pardoo (PRD)"
  },
  {
    "value": "BEO",
    "label": "Aeropelican Airport (BEO)"
  },
  {
    "value": "GOV",
    "label": "Nhulunbuy (GOV)"
  },
  {
    "value": "PPI",
    "label": "Port Pirie Airport (PPI)"
  },
  {
    "value": "JAD",
    "label": "Perth (JAD)"
  },
  {
    "value": "KTA",
    "label": "Karratha (KTA)"
  },
  {
    "value": "KGI",
    "label": "Kalgoorlie (KGI)"
  },
  {
    "value": "PKE",
    "label": "Parkes (PKE)"
  },
  {
    "value": "PKT",
    "label": "Port Keats Airport (PKT)"
  },
  {
    "value": "KNX",
    "label": "Kununurra (KNX)"
  },
  {
    "value": "PLO",
    "label": "Port Lincoln (PLO)"
  },
  {
    "value": "LEA",
    "label": "Exmouth (LEA)"
  },
  {
    "value": "EDR",
    "label": "Pormpuraaw Airport (EDR)"
  },
  {
    "value": "PQQ",
    "label": "Port Macquarie (PQQ)"
  },
  {
    "value": "PTJ",
    "label": "Portland Airport (PTJ)"
  },
  {
    "value": "PHE",
    "label": "Port Hedland (PHE)"
  },
  {
    "value": "PER",
    "label": "Perth (PER)"
  },
  {
    "value": "PEA",
    "label": "Ironstone (PEA)"
  },
  {
    "value": "KTR",
    "label": "Tindal Airport (KTR)"
  },
  {
    "value": "UMR",
    "label": "Woomera (UMR)"
  },
  {
    "value": "XCH",
    "label": "Christmas Island (XCH)"
  },
  {
    "value": "UIR",
    "label": "Quirindi Airport (UIR)"
  },
  {
    "value": "ULP",
    "label": "Quilpie Airport (ULP)"
  },
  {
    "value": "UEE",
    "label": "Queenstown Airport (UEE)"
  },
  {
    "value": "RMK",
    "label": "Renmark Airport (RMK)"
  },
  {
    "value": "RCM",
    "label": "Richmond Airport (RCM)"
  },
  {
    "value": "RAM",
    "label": "Ramingining Airport (RAM)"
  },
  {
    "value": "ROH",
    "label": "Robinhood Airport (ROH)"
  },
  {
    "value": "RBU",
    "label": "Roebourne (RBU)"
  },
  {
    "value": "RBC",
    "label": "Robinvale Airport (RBC)"
  },
  {
    "value": "RMA",
    "label": "Roma (RMA)"
  },
  {
    "value": "RSB",
    "label": "Roseberth Airport (RSB)"
  },
  {
    "value": "RTS",
    "label": "Rottnest Island Airport (RTS)"
  },
  {
    "value": "RTP",
    "label": "Rutland Plains Airport (RTP)"
  },
  {
    "value": "RHL",
    "label": "Roy Hill Station Airport (RHL)"
  },
  {
    "value": "NDS",
    "label": "Sandstone (NDS)"
  },
  {
    "value": "BWU",
    "label": "Sydney (BWU)"
  },
  {
    "value": "CBR",
    "label": "Canberra (CBR)"
  },
  {
    "value": "CFS",
    "label": "Coffs Harbour (CFS)"
  },
  {
    "value": "CDU",
    "label": "Camden Airport (CDU)"
  },
  {
    "value": "NSO",
    "label": "Scone Airport (NSO)"
  },
  {
    "value": "SQC",
    "label": "Southern Cross Airport (SQC)"
  },
  {
    "value": "DBO",
    "label": "Dubbo (DBO)"
  },
  {
    "value": "SGO",
    "label": "St George Airport (SGO)"
  },
  {
    "value": "SIX",
    "label": "Singleton (SIX)"
  },
  {
    "value": "ZGL",
    "label": "South Galway Airport (ZGL)"
  },
  {
    "value": "SGP",
    "label": "Shay Gap (SGP)"
  },
  {
    "value": "DNM",
    "label": "Shark Bay Airport (DNM)"
  },
  {
    "value": "JHQ",
    "label": "Shute Harbour Airport (JHQ)"
  },
  {
    "value": "SHT",
    "label": "Shepparton Airport (SHT)"
  },
  {
    "value": "SBR",
    "label": "Saibai Island (SBR)"
  },
  {
    "value": "SHU",
    "label": "Smith Point Airport (SHU)"
  },
  {
    "value": "STH",
    "label": "Strathmore Airport (STH)"
  },
  {
    "value": "SNB",
    "label": "Snake Bay Airport (SNB)"
  },
  {
    "value": "NLK",
    "label": "Burnt Pine (NLK)"
  },
  {
    "value": "NOA",
    "label": "Nowra Airport (NOA)"
  },
  {
    "value": "SNH",
    "label": "Stanthorpe Airport (SNH)"
  },
  {
    "value": "SCG",
    "label": "Spring Creek Airport (SCG)"
  },
  {
    "value": "SHQ",
    "label": "Southport Airport (SHQ)"
  },
  {
    "value": "KSV",
    "label": "Springvale Airport (KSV)"
  },
  {
    "value": "SRN",
    "label": "Strahan Airport (SRN)"
  },
  {
    "value": "SYD",
    "label": "Sydney (SYD)"
  },
  {
    "value": "HLS",
    "label": "St Helens Airport (HLS)"
  },
  {
    "value": "TMW",
    "label": "Tamworth (TMW)"
  },
  {
    "value": "WGA",
    "label": "Wagga Wagga (WGA)"
  },
  {
    "value": "SWH",
    "label": "Swan Hill Airport (SWH)"
  },
  {
    "value": "SWC",
    "label": "Stawell Airport (SWC)"
  },
  {
    "value": "XTR",
    "label": "Tara Airport (XTR)"
  },
  {
    "value": "TBL",
    "label": "Tableland Homestead Airport (TBL)"
  },
  {
    "value": "XTO",
    "label": "Taroom Airport (XTO)"
  },
  {
    "value": "TAQ",
    "label": "Tarcoola (TAQ)"
  },
  {
    "value": "TBK",
    "label": "Timber Creek Airport (TBK)"
  },
  {
    "value": "TDR",
    "label": "Theodore Airport (TDR)"
  },
  {
    "value": "TEF",
    "label": "Telfer Airport (TEF)"
  },
  {
    "value": "TEM",
    "label": "Temora Airport (TEM)"
  },
  {
    "value": "TAN",
    "label": "Tangalooma Airport (TAN)"
  },
  {
    "value": "XTG",
    "label": "Thargomindah Airport (XTG)"
  },
  {
    "value": "TYG",
    "label": "Thylungra Airport (TYG)"
  },
  {
    "value": "TYB",
    "label": "Tibooburra Airport (TYB)"
  },
  {
    "value": "TKY",
    "label": "Turkey Creek (TKY)"
  },
  {
    "value": "TUM",
    "label": "Tumut Airport (TUM)"
  },
  {
    "value": "TYP",
    "label": "Tobermorey (TYP)"
  },
  {
    "value": "THG",
    "label": "Biloela (THG)"
  },
  {
    "value": "TCA",
    "label": "Tennant Creek (TCA)"
  },
  {
    "value": "TCW",
    "label": "Tocumwal Airport (TCW)"
  },
  {
    "value": "TRO",
    "label": "Taree (TRO)"
  },
  {
    "value": "YTU",
    "label": "Tasu Water Aerodrome (YTU)"
  },
  {
    "value": "TWB",
    "label": "Toowoomba Airport (TWB)"
  },
  {
    "value": "UDA",
    "label": "Undara Airport (UDA)"
  },
  {
    "value": "CZY",
    "label": "Cluny Airport (CZY)"
  },
  {
    "value": "USL",
    "label": "Useless Loop Airport (USL)"
  },
  {
    "value": "VCD",
    "label": "Victoria River Downs Airport (VCD)"
  },
  {
    "value": "VNR",
    "label": "Vanrook Station Airport (VNR)"
  },
  {
    "value": "WLA",
    "label": "Wallal (WLA)"
  },
  {
    "value": "WAV",
    "label": "Wave Hill Airport (WAV)"
  },
  {
    "value": "WMB",
    "label": "Warrnambool Airport (WMB)"
  },
  {
    "value": "SYU",
    "label": "Sue Islet (SYU)"
  },
  {
    "value": "WIO",
    "label": "Wilcannia Airport (WIO)"
  },
  {
    "value": "WLC",
    "label": "Walcha Airport (WLC)"
  },
  {
    "value": "WAZ",
    "label": "Warwick Airport (WAZ)"
  },
  {
    "value": "WND",
    "label": "Windarra Airport (WND)"
  },
  {
    "value": "WNR",
    "label": "Windorah Airport (WNR)"
  },
  {
    "value": "WGT",
    "label": "Wangaratta Airport (WGT)"
  },
  {
    "value": "WYA",
    "label": "Whyalla (WYA)"
  },
  {
    "value": "WIT",
    "label": "Wittenoom Airport (WIT)"
  },
  {
    "value": "WKB",
    "label": "Warracknabeal Airport (WKB)"
  },
  {
    "value": "WGE",
    "label": "Walgett Airport (WGE)"
  },
  {
    "value": "NTL",
    "label": "Williamtown (NTL)"
  },
  {
    "value": "WUN",
    "label": "Wiluna Airport (WUN)"
  },
  {
    "value": "WPK",
    "label": "Wrotham Park Airport (WPK)"
  },
  {
    "value": "WDI",
    "label": "Wondai Airport (WDI)"
  },
  {
    "value": "WOL",
    "label": "Wollongong Airport (WOL)"
  },
  {
    "value": "QRR",
    "label": "Warren Airport (QRR)"
  },
  {
    "value": "WLO",
    "label": "Waterloo Airport (WLO)"
  },
  {
    "value": "WIN",
    "label": "Winton Airport (WIN)"
  },
  {
    "value": "WUD",
    "label": "Wudinna Airport (WUD)"
  },
  {
    "value": "WEW",
    "label": "Wee Waa Airport (WEW)"
  },
  {
    "value": "WWI",
    "label": "Woodie Woodie (WWI)"
  },
  {
    "value": "WYN",
    "label": "Wyndham Airport (WYN)"
  },
  {
    "value": "BWT",
    "label": "Burnie (BWT)"
  },
  {
    "value": "YLG",
    "label": "Yalgoo (YLG)"
  },
  {
    "value": "OKR",
    "label": "Yorke Island (OKR)"
  },
  {
    "value": "XMY",
    "label": "Yam Island (XMY)"
  },
  {
    "value": "YUE",
    "label": "Yuendumu Airport (YUE)"
  },
  {
    "value": "NGA",
    "label": "Young Airport (NGA)"
  },
  {
    "value": "ORR",
    "label": "Yorketown Airport (ORR)"
  },
  {
    "value": "KYI",
    "label": "Yalata Mission (KYI)"
  },
  {
    "value": "BCC",
    "label": "Bear Creek (BCC)"
  },
  {
    "value": "HPR",
    "label": "Pretoria (HPR)"
  },
  {
    "value": "ULX",
    "label": "Ulusaba (ULX)"
  },
  {
    "value": "TDT",
    "label": "Welverdiend (TDT)"
  },
  {
    "value": "HZV",
    "label": "Hazyview (HZV)"
  },
  {
    "value": "KHO",
    "label": "Khoka Moya (KHO)"
  },
  {
    "value": "MBM",
    "label": "Mkambati (MBM)"
  },
  {
    "value": "INY",
    "label": "Inyati (INY)"
  },
  {
    "value": "TSD",
    "label": "Tshipise (TSD)"
  },
  {
    "value": "KIG",
    "label": "Koingnaas (KIG)"
  },
  {
    "value": "PEK",
    "label": "Beijing (PEK)"
  },
  {
    "value": "CIF",
    "label": "Chifeng (CIF)"
  },
  {
    "value": "CIH",
    "label": "Changzhi (CIH)"
  },
  {
    "value": "DSN",
    "label": "Ordos (DSN)"
  },
  {
    "value": "DAT",
    "label": "Datong (DAT)"
  },
  {
    "value": "ERL",
    "label": "Erenhot, (ERL)"
  },
  {
    "value": "HDG",
    "label": "Handan (HDG)"
  },
  {
    "value": "HET",
    "label": "Hohhot (HET)"
  },
  {
    "value": "ZBK",
    "label": "Å½abljak Airport (ZBK)"
  },
  {
    "value": "HLD",
    "label": "Hailar (HLD)"
  },
  {
    "value": "NAY",
    "label": "Beijing (NAY)"
  },
  {
    "value": "BAV",
    "label": "Baotou (BAV)"
  },
  {
    "value": "SHP",
    "label": "Qinhuangdao (SHP)"
  },
  {
    "value": "SJW",
    "label": "Shijiazhuang (SJW)"
  },
  {
    "value": "TSN",
    "label": "Tianjin (TSN)"
  },
  {
    "value": "TGO",
    "label": "Tongliao (TGO)"
  },
  {
    "value": "HLH",
    "label": "Ulanhot (HLH)"
  },
  {
    "value": "XIL",
    "label": "Xilinhot (XIL)"
  },
  {
    "value": "YCU",
    "label": "Yuncheng (YCU)"
  },
  {
    "value": "TYN",
    "label": "Taiyuan (TYN)"
  },
  {
    "value": "ZEN",
    "label": "Zenag Airport (ZEN)"
  },
  {
    "value": "BHY",
    "label": "Beihai (BHY)"
  },
  {
    "value": "CGD",
    "label": "Changde (CGD)"
  },
  {
    "value": "HJJ",
    "label": "Huaihua (HJJ)"
  },
  {
    "value": "DYG",
    "label": "Dayong (DYG)"
  },
  {
    "value": "CAN",
    "label": "Guangzhou (CAN)"
  },
  {
    "value": "CSX",
    "label": "Changsha (CSX)"
  },
  {
    "value": "HNY",
    "label": "Hengyang (HNY)"
  },
  {
    "value": "KWL",
    "label": "Guilin City (KWL)"
  },
  {
    "value": "MXZ",
    "label": "Meixian (MXZ)"
  },
  {
    "value": "NNG",
    "label": "Nanning (NNG)"
  },
  {
    "value": "SWA",
    "label": "Shantou (SWA)"
  },
  {
    "value": "ZUH",
    "label": "Zhuhai (ZUH)"
  },
  {
    "value": "SZX",
    "label": "Shenzhen (SZX)"
  },
  {
    "value": "WUZ",
    "label": "Wuzhou (WUZ)"
  },
  {
    "value": "XIN",
    "label": "Xingning (XIN)"
  },
  {
    "value": "LZH",
    "label": "Liuzhou (LZH)"
  },
  {
    "value": "ZHA",
    "label": "Zhanjiang (ZHA)"
  },
  {
    "value": "AYN",
    "label": "Anyang (AYN)"
  },
  {
    "value": "CGO",
    "label": "Zhengzhou (CGO)"
  },
  {
    "value": "ENH",
    "label": "Enshi (ENH)"
  },
  {
    "value": "LHK",
    "label": "Guanghua (LHK)"
  },
  {
    "value": "WUH",
    "label": "Wuhan (WUH)"
  },
  {
    "value": "LYA",
    "label": "Luoyang (LYA)"
  },
  {
    "value": "NNY",
    "label": "Nanyang (NNY)"
  },
  {
    "value": "SHS",
    "label": "Shashi (SHS)"
  },
  {
    "value": "XFN",
    "label": "Xiangfan (XFN)"
  },
  {
    "value": "YIH",
    "label": "Yichang (YIH)"
  },
  {
    "value": "ZIZ",
    "label": "Zamzama Gas Field (ZIZ)"
  },
  {
    "value": "HAK",
    "label": "Haikou (HAK)"
  },
  {
    "value": "SYX",
    "label": "Sanya (SYX)"
  },
  {
    "value": "FNJ",
    "label": "Pyongyang (FNJ)"
  },
  {
    "value": "AKA",
    "label": "Ankang (AKA)"
  },
  {
    "value": "DNH",
    "label": "Dunhuang (DNH)"
  },
  {
    "value": "GOQ",
    "label": "Golmud (GOQ)"
  },
  {
    "value": "GYU",
    "label": "Guyuan (GYU)"
  },
  {
    "value": "HZG",
    "label": "Hanzhong (HZG)"
  },
  {
    "value": "INC",
    "label": "Yinchuan (INC)"
  },
  {
    "value": "JNG",
    "label": "Jining (JNG)"
  },
  {
    "value": "JGN",
    "label": "Jiayuguan (JGN)"
  },
  {
    "value": "ZGC",
    "label": "Lanzhou Zhongchuan Airport (ZGC)"
  },
  {
    "value": "IQN",
    "label": "Qingyang (IQN)"
  },
  {
    "value": "SIA",
    "label": "Xi'an (SIA)"
  },
  {
    "value": "XNN",
    "label": "Xining (XNN)"
  },
  {
    "value": "XIY",
    "label": "Xianyang (XIY)"
  },
  {
    "value": "ENY",
    "label": "Yan'an (ENY)"
  },
  {
    "value": "UYN",
    "label": "Yulin (UYN)"
  },
  {
    "value": "CGJ",
    "label": "Chingola (CGJ)"
  },
  {
    "value": "AVK",
    "label": "Arvaikheer (AVK)"
  },
  {
    "value": "LTI",
    "label": "Altai (LTI)"
  },
  {
    "value": "BYN",
    "label": "Bayankhongor (BYN)"
  },
  {
    "value": "UGA",
    "label": "Bulgan (UGA)"
  },
  {
    "value": "UGT",
    "label": "Umnugobitour (UGT)"
  },
  {
    "value": "HBU",
    "label": "Bulgan Sum Airport (HBU)"
  },
  {
    "value": "UUN",
    "label": "Baruun Urt Airport (UUN)"
  },
  {
    "value": "COQ",
    "label": "Choibalsan Airport (COQ)"
  },
  {
    "value": "DLZ",
    "label": "Dalanzadgad (DLZ)"
  },
  {
    "value": "KHR",
    "label": "Kharkhorin Airport (KHR)"
  },
  {
    "value": "HVD",
    "label": "Khovd (HVD)"
  },
  {
    "value": "MXV",
    "label": "MÃ¶rÃ¶n (MXV)"
  },
  {
    "value": "ULN",
    "label": "Ulan Bator (ULN)"
  },
  {
    "value": "ULO",
    "label": "Ulaangom Airport (ULO)"
  },
  {
    "value": "DLU",
    "label": "Xiaguan (DLU)"
  },
  {
    "value": "DIG",
    "label": "Shangri-La (DIG)"
  },
  {
    "value": "JHG",
    "label": "Jinghong (JHG)"
  },
  {
    "value": "LJG",
    "label": "Lijiang (LJG)"
  },
  {
    "value": "LUM",
    "label": "Luxi (LUM)"
  },
  {
    "value": "KMG",
    "label": "Kunming (KMG)"
  },
  {
    "value": "SYM",
    "label": "Simao (SYM)"
  },
  {
    "value": "ZAT",
    "label": "Zhaotong (ZAT)"
  },
  {
    "value": "XMN",
    "label": "Xiamen (XMN)"
  },
  {
    "value": "AQG",
    "label": "Anqing (AQG)"
  },
  {
    "value": "BFU",
    "label": "Bengbu (BFU)"
  },
  {
    "value": "CZX",
    "label": "Changzhou (CZX)"
  },
  {
    "value": "KHN",
    "label": "Nanchang (KHN)"
  },
  {
    "value": "FOC",
    "label": "Fuzhou (FOC)"
  },
  {
    "value": "KOW",
    "label": "Ganzhou (KOW)"
  },
  {
    "value": "HGH",
    "label": "Hangzhou (HGH)"
  },
  {
    "value": "JDZ",
    "label": "Jingdezhen (JDZ)"
  },
  {
    "value": "JIU",
    "label": "Jiujiang (JIU)"
  },
  {
    "value": "TNA",
    "label": "Jinan (TNA)"
  },
  {
    "value": "JUZ",
    "label": "Quzhou (JUZ)"
  },
  {
    "value": "LCX",
    "label": "Longyan (LCX)"
  },
  {
    "value": "LYG",
    "label": "Lianyungang (LYG)"
  },
  {
    "value": "HYN",
    "label": "Huangyan (HYN)"
  },
  {
    "value": "LYI",
    "label": "Linyi (LYI)"
  },
  {
    "value": "NGB",
    "label": "Ningbo (NGB)"
  },
  {
    "value": "NKG",
    "label": "Nanjing (NKG)"
  },
  {
    "value": "HFE",
    "label": "Hefei (HFE)"
  },
  {
    "value": "PVG",
    "label": "Shanghai (PVG)"
  },
  {
    "value": "TAO",
    "label": "Qingdao (TAO)"
  },
  {
    "value": "JJN",
    "label": "Quanzhou (JJN)"
  },
  {
    "value": "RUG",
    "label": "Rugao (RUG)"
  },
  {
    "value": "SHA",
    "label": "Shanghai (SHA)"
  },
  {
    "value": "SZV",
    "label": "Suzhou (SZV)"
  },
  {
    "value": "TXN",
    "label": "Huangshan (TXN)"
  },
  {
    "value": "WEF",
    "label": "Weifang (WEF)"
  },
  {
    "value": "WEH",
    "label": "Weihai (WEH)"
  },
  {
    "value": "WHU",
    "label": "Wuhu (WHU)"
  },
  {
    "value": "WUX",
    "label": "Wuxi (WUX)"
  },
  {
    "value": "WUS",
    "label": "Wuyishan (WUS)"
  },
  {
    "value": "WNZ",
    "label": "Wenzhou (WNZ)"
  },
  {
    "value": "XUZ",
    "label": "Xuzhou (XUZ)"
  },
  {
    "value": "YNZ",
    "label": "Yancheng (YNZ)"
  },
  {
    "value": "YNT",
    "label": "Yantai (YNT)"
  },
  {
    "value": "YIW",
    "label": "Yiwu (YIW)"
  },
  {
    "value": "HSN",
    "label": "Zhoushan (HSN)"
  },
  {
    "value": "NGQ",
    "label": "Shiquanhe (NGQ)"
  },
  {
    "value": "AVA",
    "label": "Anshun (AVA)"
  },
  {
    "value": "BPX",
    "label": "Bangda (BPX)"
  },
  {
    "value": "CKG",
    "label": "Chongqing (CKG)"
  },
  {
    "value": "DAX",
    "label": "Dazhou (DAX)"
  },
  {
    "value": "GYS",
    "label": "Guangyuan (GYS)"
  },
  {
    "value": "KWE",
    "label": "Guiyang (KWE)"
  },
  {
    "value": "JZH",
    "label": "Jiuzhaigou (JZH)"
  },
  {
    "value": "LIA",
    "label": "Liangping (LIA)"
  },
  {
    "value": "LXA",
    "label": "Lhasa (LXA)"
  },
  {
    "value": "LZO",
    "label": "Luzhou (LZO)"
  },
  {
    "value": "MIG",
    "label": "Mianyang (MIG)"
  },
  {
    "value": "NAO",
    "label": "Nanchong (NAO)"
  },
  {
    "value": "LZY",
    "label": "Nyingchi (LZY)"
  },
  {
    "value": "TCZ",
    "label": "Tengchong (TCZ)"
  },
  {
    "value": "TEN",
    "label": "Tongren Fenghuang Airport (TEN)"
  },
  {
    "value": "CTU",
    "label": "Chengdu (CTU)"
  },
  {
    "value": "WXN",
    "label": "Wanxian (WXN)"
  },
  {
    "value": "XIC",
    "label": "Xichang (XIC)"
  },
  {
    "value": "YBP",
    "label": "Yibin (YBP)"
  },
  {
    "value": "ACX",
    "label": "Xingyi (ACX)"
  },
  {
    "value": "AKU",
    "label": "Aksu (AKU)"
  },
  {
    "value": "BPL",
    "label": "Bole (BPL)"
  },
  {
    "value": "IQM",
    "label": "Qiemo (IQM)"
  },
  {
    "value": "HMI",
    "label": "Hami (HMI)"
  },
  {
    "value": "KCA",
    "label": "Kuqa (KCA)"
  },
  {
    "value": "KRL",
    "label": "Korla (KRL)"
  },
  {
    "value": "KRY",
    "label": "Karamay (KRY)"
  },
  {
    "value": "KHG",
    "label": "Kashgar (KHG)"
  },
  {
    "value": "SXJ",
    "label": "Shanshan (SXJ)"
  },
  {
    "value": "HTN",
    "label": "Hotan (HTN)"
  },
  {
    "value": "URC",
    "label": "ÃœrÃ¼mqi (URC)"
  },
  {
    "value": "YIN",
    "label": "Yining (YIN)"
  },
  {
    "value": "AOG",
    "label": "Anshan (AOG)"
  },
  {
    "value": "CGQ",
    "label": "Changchun (CGQ)"
  },
  {
    "value": "CNI",
    "label": "Changhai (CNI)"
  },
  {
    "value": "CHG",
    "label": "Chaoyang (CHG)"
  },
  {
    "value": "HRB",
    "label": "Harbin (HRB)"
  },
  {
    "value": "HEK",
    "label": "Heihe (HEK)"
  },
  {
    "value": "JIL",
    "label": "Jilin (JIL)"
  },
  {
    "value": "JMU",
    "label": "Jiamusi (JMU)"
  },
  {
    "value": "JNZ",
    "label": "Jinzhou (JNZ)"
  },
  {
    "value": "LDS",
    "label": "Yichun (LDS)"
  },
  {
    "value": "YUS",
    "label": "Yushu (YUS)"
  },
  {
    "value": "MDG",
    "label": "Mudanjiang (MDG)"
  },
  {
    "value": "NDG",
    "label": "Qiqihar (NDG)"
  },
  {
    "value": "DLC",
    "label": "Dalian (DLC)"
  },
  {
    "value": "TNH",
    "label": "Tonghua (TNH)"
  },
  {
    "value": "SHE",
    "label": "Shenyang (SHE)"
  },
  {
    "value": "YNJ",
    "label": "Yanji (YNJ)"
  },
  {
    "value": "THD",
    "label": "Thanh Hoa (THD)"
  },
  {
    "value": "IFJ",
    "label": "Isafjordur (IFJ)"
  },
  {
    "value": "NYC",
    "label": "New York (NYC)"
  },
  {
    "value": "VDO",
    "label": "Quang Ninh (VDO)"
  },
  {
    "value": "BUE",
    "label": "All Airports (BUE)"
  },
  {
    "value": "XNA",
    "label": "Northwest Arkansas Regional Airport (XNA)"
  },
  {
    "value": "LBH",
    "label": "Palm Beach Seaplane Base (LBH)"
  },
  {
    "value": "ZYZ",
    "label": "Antwerp (ZYZ)"
  },
  {
    "value": "BHZ",
    "label": "All Airports (BHZ)"
  },
  {
    "value": "RIO",
    "label": "All Airports (RIO)"
  },
  {
    "value": "YEA",
    "label": "All Airports (YEA)"
  },
  {
    "value": "YMQ",
    "label": "All Airports (YMQ)"
  },
  {
    "value": "YTO",
    "label": "All Airports (YTO)"
  },
  {
    "value": "YHG",
    "label": "Charlottetown Airport  (YHG)"
  },
  {
    "value": "ZGS",
    "label": "Gethsemani Airport (ZGS)"
  },
  {
    "value": "ZKG",
    "label": "Kegaska Airport  (ZKG)"
  },
  {
    "value": "YSO",
    "label": "Postville Airport  (YSO)"
  },
  {
    "value": "YWB",
    "label": "Wakeham Bay Airport (YWB)"
  },
  {
    "value": "YHH",
    "label": "Campbell River Water Aerodrome (YHH)"
  },
  {
    "value": "BJS",
    "label": "All Airports (BJS)"
  },
  {
    "value": "LHW",
    "label": "Lanzhou Zhongchuan Airport (LHW)"
  },
  {
    "value": "LLF",
    "label": "Yongzhou Lingling Airport (LLF)"
  },
  {
    "value": "ZYI",
    "label": "Zunyi Airport (ZYI)"
  },
  {
    "value": "HEX",
    "label": "Herrera International Airport  (HEX)"
  },
  {
    "value": "QXB",
    "label": "Aix Les Milles Airport (QXB)"
  },
  {
    "value": "MLH",
    "label": "EuroAirport Basel-Mulhouse-Freiburg (MLH)"
  },
  {
    "value": "TLN",
    "label": "Toulon-Hyères Airport (TLN)"
  },
  {
    "value": "ZWS",
    "label": "Stuttgart Hauptbahnhof (ZWS)"
  },
  {
    "value": "RKV",
    "label": "Reykjavík Airport (RKV)"
  },
  {
    "value": "JKT",
    "label": "All Airports (JKT)"
  },
  {
    "value": "MIL",
    "label": "All Airports (MIL)"
  },
  {
    "value": "ROM",
    "label": "All Airports (ROM)"
  },
  {
    "value": "OSA",
    "label": "All Airports (OSA)"
  },
  {
    "value": "SPK",
    "label": "All Airports (SPK)"
  },
  {
    "value": "TYO",
    "label": "All Airports (TYO)"
  },
  {
    "value": "JSP",
    "label": "Sogwipo Heliport (JSP)"
  },
  {
    "value": "ESF",
    "label": "Esler Regional Airport (ESF)"
  },
  {
    "value": "TGZ",
    "label": "Angel Albino Corzo International Airport (TGZ)"
  },
  {
    "value": "PPE",
    "label": "Mar de Cortés International Airport (PPE)"
  },
  {
    "value": "MCM",
    "label": "Monaco Heliport (MCM)"
  },
  {
    "value": "HKS",
    "label": "Hawkins Field (HKS)"
  },
  {
    "value": "MSB",
    "label": "Marigot Seaplane Base (MSB)"
  },
  {
    "value": "PGV",
    "label": "Pitt-Greenville Airport (PGV)"
  },
  {
    "value": "OAJ",
    "label": "Albert J. Ellis Airport (OAJ)"
  },
  {
    "value": "FKL",
    "label": "Venango Regional Airport  (FKL)"
  },
  {
    "value": "BUH",
    "label": "All Airports (BUH)"
  },
  {
    "value": "MOW",
    "label": "All Airports (MOW)"
  },
  {
    "value": "OJC",
    "label": "Johnson County Executive Airport (OJC)"
  },
  {
    "value": "RVH",
    "label": "Rzhevka Airport (RVH)"
  },
  {
    "value": "CCE",
    "label": "L'Espérance Airport  (CCE)"
  },
  {
    "value": "KMC",
    "label": "King Khaled Military City Airport (KMC)"
  },
  {
    "value": "GMU",
    "label": "Greenville Downtown Airport (GMU)"
  },
  {
    "value": "SPA",
    "label": "Spartanburg Downtown Memorial Airport (SPA)"
  },
  {
    "value": "SEL",
    "label": "All Airports (SEL)"
  },
  {
    "value": "TCI",
    "label": "All Airports (TCI)"
  },
  {
    "value": "MMA",
    "label": "All Airports (MMA)"
  },
  {
    "value": "STO",
    "label": "All Airports (STO)"
  },
  {
    "value": "HUV",
    "label": "Hudiksvall Airport (HUV)"
  },
  {
    "value": "JHE",
    "label": "Hamnen Heliport (JHE)"
  },
  {
    "value": "JLD",
    "label": "Landskrona Heliport (JLD)"
  },
  {
    "value": "JMM",
    "label": "Malmö Harbour Heliport (JMM)"
  },
  {
    "value": "EAP",
    "label": "All Airports (EAP)"
  },
  {
    "value": "LON",
    "label": "All Airports (LON)"
  },
  {
    "value": "TDW",
    "label": "Tradewind Airport (TDW)"
  },
  {
    "value": "FTY",
    "label": "Fulton County Airport  (FTY)"
  },
  {
    "value": "PWK",
    "label": "Palwaukee Municipal Airport (PWK)"
  },
  {
    "value": "CHI",
    "label": "All Airports (CHI)"
  },
  {
    "value": "CIC",
    "label": "Chico Municipal Airport (CIC)"
  },
  {
    "value": "CGF",
    "label": "Cuyahoga County Airport (CGF)"
  },
  {
    "value": "COD",
    "label": "Yellowstone Regional Airport (COD)"
  },
  {
    "value": "UBS",
    "label": "Columbus-Lowndes County Airport (UBS)"
  },
  {
    "value": "GTR",
    "label": "Golden Triangle Regional Airport (GTR)"
  },
  {
    "value": "DTT",
    "label": "All Airports (DTT)"
  },
  {
    "value": "ESD",
    "label": "Orcas Island Airport  (ESD)"
  },
  {
    "value": "FCH",
    "label": "Fresno Chandler Executive Airport (FCH)"
  },
  {
    "value": "FNL",
    "label": "Fort Collins-Loveland Municipal Airport (FNL)"
  },
  {
    "value": "FXE",
    "label": "Fort Lauderdale Executive Airport (FXE)"
  },
  {
    "value": "EGI",
    "label": "Duke Field  (EGI)"
  },
  {
    "value": "GBD",
    "label": "Great Bend Municipal Airport (GBD)"
  },
  {
    "value": "HOB",
    "label": "Lea County Regional Airport (HOB)"
  },
  {
    "value": "HIK",
    "label": "Hickam Air Force Base (HIK)"
  },
  {
    "value": "NIP",
    "label": "NAS Jacksonville  (NIP)"
  },
  {
    "value": "JCI",
    "label": "New Century AirCenter  (JCI)"
  },
  {
    "value": "ILE",
    "label": "Skylark Field (ILE)"
  },
  {
    "value": "KDK",
    "label": "Kodiak Municipal Airport (KDK)"
  },
  {
    "value": "VGT",
    "label": "North Las Vegas Airport (VGT)"
  },
  {
    "value": "LAM",
    "label": "Los Alamos County Airport (LAM)"
  },
  {
    "value": "VNY",
    "label": "Van Nuys Airport (VNY)"
  },
  {
    "value": "MCW",
    "label": "Mason City Municipal Airport (MCW)"
  },
  {
    "value": "NQA",
    "label": "Millington Regional Jetport (NQA)"
  },
  {
    "value": "TMB",
    "label": "Kendall-Tamiami Executive Airport (TMB)"
  },
  {
    "value": "OPF",
    "label": "Opa-locka Airport (OPF)"
  },
  {
    "value": "MPB",
    "label": "Miami Seaplane Base  (MPB)"
  },
  {
    "value": "MIC",
    "label": "Crystal Airport (MIC)"
  },
  {
    "value": "FCM",
    "label": "Flying Cloud Airport (FCM)"
  },
  {
    "value": "NEW",
    "label": "New Orleans Lakefront Airport (NEW)"
  },
  {
    "value": "JCE",
    "label": "Oakland Convention Center Heliport  (JCE)"
  },
  {
    "value": "PWA",
    "label": "Wiley Post Airport (PWA)"
  },
  {
    "value": "MIQ",
    "label": "Millard Airport  (MIQ)"
  },
  {
    "value": "PGA",
    "label": "Page Municipal Airport (PGA)"
  },
  {
    "value": "UDD",
    "label": "Bermuda Dunes Airport (UDD)"
  },
  {
    "value": "PNE",
    "label": "Northeast Philadelphia Airport (PNE)"
  },
  {
    "value": "HPV",
    "label": "Princeville Airport  (HPV)"
  },
  {
    "value": "PVC",
    "label": "Provincetown Municipal Airport (PVC)"
  },
  {
    "value": "RCE",
    "label": "Roche Harbor Seaplane Base (RCE)"
  },
  {
    "value": "RKD",
    "label": "Knox County Regional Airport (RKD)"
  },
  {
    "value": "MHR",
    "label": "Sacramento Mather Airport (MHR)"
  },
  {
    "value": "SSF",
    "label": "Stinson Municipal Airport (SSF)"
  },
  {
    "value": "SDM",
    "label": "Brown Field Municipal Airport (SDM)"
  },
  {
    "value": "MYF",
    "label": "Montgomery Field (MYF)"
  },
  {
    "value": "RHV",
    "label": "Reid-Hillview Airport of Santa Clara County (RHV)"
  },
  {
    "value": "CSL",
    "label": "O'Sullivan Army Heliport (CSL)"
  },
  {
    "value": "SAF",
    "label": "Santa Fe Municipal Airport (SAF)"
  },
  {
    "value": "STS",
    "label": "Charles M. Schulz Sonoma County Airport (STS)"
  },
  {
    "value": "LKE",
    "label": "Kenmore Air Harbor Seaplane Base  (LKE)"
  },
  {
    "value": "KEH",
    "label": "Kenmore Air Harbor  (KEH)"
  },
  {
    "value": "SDY",
    "label": "Sidney-Richland Municipal Airport (SDY)"
  },
  {
    "value": "SFF",
    "label": "Felts Field (SFF)"
  },
  {
    "value": "SGU",
    "label": "St. George Municipal Airport (SGU)"
  },
  {
    "value": "SUS",
    "label": "Spirit of St. Louis Airport (SUS)"
  },
  {
    "value": "CPS",
    "label": "St. Louis Downtown Airport (CPS)"
  },
  {
    "value": "SCK",
    "label": "Stockton Metropolitan Airport (SCK)"
  },
  {
    "value": "TPF",
    "label": "Peter O. Knight Airport (TPF)"
  },
  {
    "value": "TVF",
    "label": "Thief River Falls Regional Airport (TVF)"
  },
  {
    "value": "WAS",
    "label": "All Airports (WAS)"
  },
  {
    "value": "EAT",
    "label": "Pangborn Memorial Airport (EAT)"
  },
  {
    "value": "LNA",
    "label": "Palm Beach County Park Airport (LNA)"
  },
  {
    "value": "WYS",
    "label": "Yellowstone Airport (WYS)"
  },
  {
    "value": "ISN",
    "label": "Sloulin Field International Airport (ISN)"
  },
  {
    "value": "BJI",
    "label": "Bemidji Regional Airport (BJI)"
  },
  {
    "value": "KTS",
    "label": "Brevig Mission Airport (KTS)"
  },
  {
    "value": "CWA",
    "label": "Central Wisconsin Airport (CWA)"
  },
  {
    "value": "JHW",
    "label": "Chautauqua County-Jamestown Airport (JHW)"
  },
  {
    "value": "CVN",
    "label": "Clovis Municipal Airport (CVN)"
  },
  {
    "value": "CEZ",
    "label": "Cortez Municipal Airport (CEZ)"
  },
  {
    "value": "CRG",
    "label": "Craig Municipal Airport (CRG)"
  },
  {
    "value": "ESC",
    "label": "Delta County Airport (ESC)"
  },
  {
    "value": "EAA",
    "label": "Eagle Airport (EAA)"
  },
  {
    "value": "PDT",
    "label": "Eastern Oregon Regional Airport (PDT)"
  },
  {
    "value": "IMT",
    "label": "Ford Airport (IMT)"
  },
  {
    "value": "FMN",
    "label": "Four Corners Regional Airport (FMN)"
  },
  {
    "value": "RIL",
    "label": "Garfield County Regional Airport (RIL)"
  },
  {
    "value": "GCC",
    "label": "Gillette-Campbell County Airport (GCC)"
  },
  {
    "value": "IWD",
    "label": "Gogebic-Iron County Airport (IWD)"
  },
  {
    "value": "CRE",
    "label": "Grand Strand Airport (CRE)"
  },
  {
    "value": "LWB",
    "label": "Greenbrier Valley Airport (LWB)"
  },
  {
    "value": "GUC",
    "label": "Gunnison-Crested Butte Regional Airport (GUC)"
  },
  {
    "value": "HVR",
    "label": "Havre City-County Airport (HVR)"
  },
  {
    "value": "HYS",
    "label": "Hays Regional Airport (HYS)"
  },
  {
    "value": "HSH",
    "label": "Henderson Executive Airport  (HSH)"
  },
  {
    "value": "HHH",
    "label": "Hilton Head Airport  (HHH)"
  },
  {
    "value": "HUS",
    "label": "Hughes Airport (HUS)"
  },
  {
    "value": "HSL",
    "label": "Huslia Airport  (HSL)"
  },
  {
    "value": "IPL",
    "label": "Imperial County Airport (IPL)"
  },
  {
    "value": "IYK",
    "label": "Inyokern Airport (IYK)"
  },
  {
    "value": "JXN",
    "label": "Jackson County Airport  (JXN)"
  },
  {
    "value": "JEF",
    "label": "Jefferson City Memorial Airport (JEF)"
  },
  {
    "value": "KLW",
    "label": "Klawock Airport  (KLW)"
  },
  {
    "value": "LAW",
    "label": "Lawton-Fort Sill Regional Airport (LAW)"
  },
  {
    "value": "SSI",
    "label": "Malcolm McKinnon Airport (SSI)"
  },
  {
    "value": "MMH",
    "label": "Mammoth Yosemite Airport (MMH)"
  },
  {
    "value": "MBL",
    "label": "Manistee County-Blacker Airport (MBL)"
  },
  {
    "value": "NZC",
    "label": "Maria Reiche Neuman Airport (NZC)"
  },
  {
    "value": "CLD",
    "label": "McClellan-Palomar Airport  (CLD)"
  },
  {
    "value": "MCK",
    "label": "McCook Regional Airport (MCK)"
  },
  {
    "value": "MTJ",
    "label": "Montrose Regional Airport (MTJ)"
  },
  {
    "value": "NUL",
    "label": "Nulato Airport (NUL)"
  },
  {
    "value": "OGS",
    "label": "Ogdensburg International Airport (OGS)"
  },
  {
    "value": "OSU",
    "label": "Ohio State University Airport (OSU)"
  },
  {
    "value": "TAL",
    "label": "Ralph M. Calhoun Memorial Airport (TAL)"
  },
  {
    "value": "LCK",
    "label": "Rickenbacker International Airport (LCK)"
  },
  {
    "value": "RIW",
    "label": "Riverton Regional Airport (RIW)"
  },
  {
    "value": "RSH",
    "label": "Russian Mission Airport (RSH)"
  },
  {
    "value": "MQT",
    "label": "Sawyer International Airport  (MQT)"
  },
  {
    "value": "SCF",
    "label": "Scottsdale Airport  (SCF)"
  },
  {
    "value": "WLK",
    "label": "Selawik Airport (WLK)"
  },
  {
    "value": "SOW",
    "label": "Show Low Regional Airport (SOW)"
  },
  {
    "value": "STE",
    "label": "Stevens Point Municipal Airport (STE)"
  },
  {
    "value": "SGR",
    "label": "Sugar Land Regional Airport (SGR)"
  },
  {
    "value": "TEX",
    "label": "Telluride Regional Airport (TEX)"
  },
  {
    "value": "TEB",
    "label": "Teterboro Airport (TEB)"
  },
  {
    "value": "UNK",
    "label": "Unalakleet Airport (UNK)"
  },
  {
    "value": "VEL",
    "label": "Vernal Airport (VEL)"
  },
  {
    "value": "VIS",
    "label": "Visalia Municipal Airport (VIS)"
  },
  {
    "value": "IWS",
    "label": "West Houston Airport (IWS)"
  },
  {
    "value": "MWA",
    "label": "Williamson County Regional Airport (MWA)"
  },
  {
    "value": "YAK",
    "label": "Yakutat Airport (YAK)"
  },
  {
    "value": "HDN",
    "label": "Yampa Valley Airport (HDN)"
  },
  {
    "value": "ZZV",
    "label": "Zanesville Municipal Airport (ZZV)"
  },
  {
    "value": "LOU",
    "label": "Bowman Field (LOU)"
  },
  {
    "value": "CNY",
    "label": "Canyonlands Field (CNY)"
  },
  {
    "value": "JBP",
    "label": "Commerce Business Park Heliport  (JBP)"
  },
  {
    "value": "JRE",
    "label": "East 60th Street Heliport (JRE)"
  },
  {
    "value": "EFD",
    "label": "Ellington Field (EFD)"
  },
  {
    "value": "SEE",
    "label": "Gillespie Field (SEE)"
  },
  {
    "value": "BER",
    "label": "Berlin (BER)"
  },
  {
    "value": "ORL",
    "label": "Orlando Executive Airport (ORL)"
  },
  {
    "value": "UKY",
    "label": "Kansai Airport (UKY)"
  },
  {
    "value": "ZFQ",
    "label": "Bordeaux-Saint-Jean (ZFQ)"
  },
  {
    "value": "XPJ",
    "label": "Saint-Roch Railway Station (XPJ)"
  },
  {
    "value": "FSZ",
    "label": "Mount Fuji (FSZ)"
  },
  {
    "value": "XNB",
    "label": "Travel Mall EY Bus (XNB)"
  },
  {
    "value": "QQS",
    "label": "Pancras Intl Rail (QQS)"
  },
  {
    "value": "IWK",
    "label": "Iwakuni airport (IWK)"
  },
  {
    "value": "MWC",
    "label": "Lawrence J Timmerman airport (MWC)"
  },
  {
    "value": "HBH",
    "label": "Egypt (HBH)"
  },
  {
    "value": "EMY",
    "label": "Egypt (EMY)"
  },
  {
    "value": "RLT",
    "label": "Niger (RLT)"
  },
  {
    "value": "MZF",
    "label": "South Africa (MZF)"
  },
  {
    "value": "DGM",
    "label": "Guangdong, China (DGM)"
  },
  {
    "value": "ZJK",
    "label": "Hong Kong (ZJK)"
  },
  {
    "value": "QNB",
    "label": "India (QNB)"
  },
  {
    "value": "QJU",
    "label": "India (QJU)"
  },
  {
    "value": "QCB",
    "label": "Japan (QCB)"
  },
  {
    "value": "LSG",
    "label": "Japan (LSG)"
  },
  {
    "value": "YOK",
    "label": "Japan (YOK)"
  },
  {
    "value": "GBI",
    "label": "Bahamas (GBI)"
  },
  {
    "value": "BAK",
    "label": "Azerbaijan (BAK)"
  },
  {
    "value": "ROU",
    "label": "Bulgaria (ROU)"
  },
  {
    "value": "TGV",
    "label": "Bulgaria (TGV)"
  },
  {
    "value": "QUF",
    "label": "Estonia (QUF)"
  },
  {
    "value": "QLI",
    "label": "Cyprus (QLI)"
  },
  {
    "value": "NIC",
    "label": "Cyprus (NIC)"
  },
  {
    "value": "FRJ",
    "label": "France (FRJ)"
  },
  {
    "value": "HNN",
    "label": "Germany (HNN)"
  },
  {
    "value": "HAG",
    "label": "Netherlands (HAG)"
  },
  {
    "value": "ZDJ",
    "label": "Switzerland (ZDJ)"
  },
  {
    "value": "SZD",
    "label": "UK (SZD)"
  },
  {
    "value": "JRS",
    "label": "Israel (JRS)"
  },
  {
    "value": "IZM",
    "label": "Turkey (IZM)"
  },
  {
    "value": "SDA",
    "label": "Iraq (SDA)"
  },
  {
    "value": "OSM",
    "label": "Iraq (OSM)"
  },
  {
    "value": "GJN",
    "label": "Lebanon (GJN)"
  },
  {
    "value": "QML",
    "label": "Pakistan (QML)"
  },
  {
    "value": "RWP",
    "label": "Pakistan (RWP)"
  },
  {
    "value": "XLB",
    "label": "Canada (XLB)"
  },
  {
    "value": "YSR",
    "label": "Canada (YSR)"
  },
  {
    "value": "XPK",
    "label": "Canada (XPK)"
  },
  {
    "value": "XSI",
    "label": "Canada (XSI)"
  },
  {
    "value": "SRL",
    "label": "Mexico (SRL)"
  },
  {
    "value": "KCC",
    "label": "USA (KCC)"
  },
  {
    "value": "EKI",
    "label": "USA (EKI)"
  },
  {
    "value": "ELY",
    "label": "USA (ELY)"
  },
  {
    "value": "FMY",
    "label": "USA (FMY)"
  },
  {
    "value": "GAD",
    "label": "USA (GAD)"
  },
  {
    "value": "GDV",
    "label": "USA (GDV)"
  },
  {
    "value": "GPZ",
    "label": "USA (GPZ)"
  },
  {
    "value": "HAR",
    "label": "USA (HAR)"
  },
  {
    "value": "WLB",
    "label": "USA (WLB)"
  },
  {
    "value": "HII",
    "label": "USA (HII)"
  },
  {
    "value": "LIJ",
    "label": "USA (LIJ)"
  },
  {
    "value": "MTH",
    "label": "USA (MTH)"
  },
  {
    "value": "MTO",
    "label": "USA (MTO)"
  },
  {
    "value": "MTM",
    "label": "USA (MTM)"
  },
  {
    "value": "MHE",
    "label": "USA (MHE)"
  },
  {
    "value": "MWH",
    "label": "USA (MWH)"
  },
  {
    "value": "MCL",
    "label": "USA (MCL)"
  },
  {
    "value": "OXR",
    "label": "USA (OXR)"
  },
  {
    "value": "PLB",
    "label": "USA (PLB)"
  },
  {
    "value": "SLE",
    "label": "USA (SLE)"
  },
  {
    "value": "SNS",
    "label": "USA (SNS)"
  },
  {
    "value": "TKA",
    "label": "USA (TKA)"
  },
  {
    "value": "KTB",
    "label": "USA (KTB)"
  },
  {
    "value": "UCA",
    "label": "USA (UCA)"
  },
  {
    "value": "OLF",
    "label": "USA (OLF)"
  },
  {
    "value": "SSL",
    "label": "Colombia (SSL)"
  },
  {
    "value": "DDI",
    "label": "Australia (DDI)"
  },
  {
    "value": "DKI",
    "label": "Australia (DKI)"
  },
  {
    "value": "GKL",
    "label": "Australia (GKL)"
  },
  {
    "value": "GTI",
    "label": "Australia (GTI)"
  },
  {
    "value": "HNK",
    "label": "Australia (HNK)"
  },
  {
    "value": "HMH",
    "label": "Australia (HMH)"
  },
  {
    "value": "NSA",
    "label": "Australia (NSA)"
  },
  {
    "value": "ORS",
    "label": "Australia (ORS)"
  },
  {
    "value": "SOI",
    "label": "Australia (SOI)"
  },
  {
    "value": "TIS",
    "label": "Australia (TIS)"
  },
  {
    "value": "HAP",
    "label": "Australia (HAP)"
  },
  {
    "value": "WHM",
    "label": "Australia (WHM)"
  },
  {
    "value": "SUM",
    "label": "Guam (SUM)"
  },
  {
    "value": "GSI",
    "label": "Solomon Islands (GSI)"
  },
  {
    "value": "KUB",
    "label": "Brunei (KUB)"
  },
  {
    "value": "MFO",
    "label": "Papua New Guinea (MFO)"
  },
  {
    "value": "NOP",
    "label": "Philippines (NOP)"
  },
  {
    "value": "PYX",
    "label": "Thailand (PYX)"
  },
  {
    "value": "KGH",
    "label": "YONGAI (KGH)"
  },
  {
    "value": "KGK",
    "label": "KOLIGANEK,AK (KGK)"
  },
  {
    "value": "KGX",
    "label": "GRAYLING,AK (KGX)"
  },
  {
    "value": "KIB",
    "label": "IVANOFF BAY,AK (KIB)"
  },
  {
    "value": "KIE",
    "label": "KIETA (KIE)"
  },
  {
    "value": "KIL",
    "label": "KILWA (KIL)"
  },
  {
    "value": "KKA",
    "label": "KOYUK,AK (KKA)"
  },
  {
    "value": "KKB",
    "label": "KITOI BAY,AK (KKB)"
  },
  {
    "value": "KKH",
    "label": "KONGIGANAK,AK (KKH)"
  },
  {
    "value": "KKI",
    "label": "AKIACHAK,AK (KKI)"
  },
  {
    "value": "KKK",
    "label": "KALAKAKET CREEK, ALASKA (KKK)"
  },
  {
    "value": "KKU",
    "label": "EKUK,AK (KKU)"
  },
  {
    "value": "KLL",
    "label": "LEVELOCK,AK (KLL)"
  },
  {
    "value": "KLN",
    "label": "LARSEN BAY,AK (KLN)"
  },
  {
    "value": "KMO",
    "label": "MANOKOTAK,AK (KMO)"
  },
  {
    "value": "KMR",
    "label": "KARIMUI (KMR)"
  },
  {
    "value": "KMY",
    "label": "MOSER BAY,AK (KMY)"
  },
  {
    "value": "KNE",
    "label": "KANAINJ (KNE)"
  },
  {
    "value": "KNK",
    "label": "KAKHONAK,AK (KNK)"
  },
  {
    "value": "KOB",
    "label": "KOUTABA (KOB)"
  },
  {
    "value": "KOY",
    "label": "OLGA BAY,AK (KOY)"
  },
  {
    "value": "KOZ",
    "label": "OUZINKIE (KOZ)"
  },
  {
    "value": "KPB",
    "label": "POINT BAKER,AK (KPB)"
  },
  {
    "value": "KPK",
    "label": "PARKS,AK (KPK)"
  },
  {
    "value": "KPN",
    "label": "KIPNUK,AK (KPN)"
  },
  {
    "value": "KPR",
    "label": "PORT WILLIAMS,AK (KPR)"
  },
  {
    "value": "KPV",
    "label": "PERRYVILLE,AK (KPV)"
  },
  {
    "value": "KPY",
    "label": "PORT BAILEY,AK (KPY)"
  },
  {
    "value": "KRU",
    "label": "KERAU (KRU)"
  },
  {
    "value": "KRX",
    "label": "KAR KAR (KRX)"
  },
  {
    "value": "KTH",
    "label": "TIKCHIK, ALASKA (KTH)"
  },
  {
    "value": "KTY",
    "label": "TERROR BAY,AK (KTY)"
  },
  {
    "value": "KUI",
    "label": "KAWAU ISLAND (KUI)"
  },
  {
    "value": "KUK",
    "label": "KASIGLUK,AK (KUK)"
  },
  {
    "value": "KUP",
    "label": "KUPIANO (KUP)"
  },
  {
    "value": "KUQ",
    "label": "KURI (KUQ)"
  },
  {
    "value": "KUW",
    "label": "KUGURUROK, ALASKA (KUW)"
  },
  {
    "value": "KWF",
    "label": "WATERFALL-ALASKA (KWF)"
  },
  {
    "value": "KWK",
    "label": "KWIGILLINGOK,AK (KWK)"
  },
  {
    "value": "KWN",
    "label": "QUINHAGAK,AK (KWN)"
  },
  {
    "value": "KWP",
    "label": "WEST POINT,AK (KWP)"
  },
  {
    "value": "KWT",
    "label": "KWETHLUK,AK (KWT)"
  },
  {
    "value": "KXA",
    "label": "KASAAN,AK (KXA)"
  },
  {
    "value": "DBI",
    "label": "DIEN BIEN (DBI)"
  },
  {
    "value": "DGC",
    "label": "DEGAHBUR (DGC)"
  },
  {
    "value": "DIF",
    "label": "DSF (DIF)"
  },
  {
    "value": "DIO",
    "label": "LITTEL DIOMEDE IS,AK (DIO)"
  },
  {
    "value": "DNQ",
    "label": "DENILIQUIN (DNQ)"
  },
  {
    "value": "DNV",
    "label": "DANVILLE,IL (DNV)"
  },
  {
    "value": "DOF",
    "label": "DORA BAY,AK (DOF)"
  },
  {
    "value": "DPW",
    "label": "SDF (DPW)"
  },
  {
    "value": "DRA",
    "label": "MERCURY (DRA)"
  },
  {
    "value": "DRE",
    "label": "DRUMMOND ISLAND,MI (DRE)"
  },
  {
    "value": "DSL",
    "label": "DARU (DSL)"
  },
  {
    "value": "DUZ",
    "label": "SDF (DUZ)"
  },
  {
    "value": "DWF",
    "label": "SAD (DWF)"
  },
  {
    "value": "DWK",
    "label": "ASD (DWK)"
  },
  {
    "value": "EDA",
    "label": "EDNA BAY,AK (EDA)"
  },
  {
    "value": "EGV",
    "label": "EAGLE RIVER,WI (EGV)"
  },
  {
    "value": "EIA",
    "label": "EIA (EIA)"
  },
  {
    "value": "EKN",
    "label": "ELKINS,WV (EKN)"
  },
  {
    "value": "ELI",
    "label": "ELIM,AK (ELI)"
  },
  {
    "value": "ELJ",
    "label": "EL RECREO (ELJ)"
  },
  {
    "value": "ELV",
    "label": "ELFIN COVE (ELV)"
  },
  {
    "value": "EMO",
    "label": "EMO (EMO)"
  },
  {
    "value": "EMS",
    "label": "EMBESSA (EMS)"
  },
  {
    "value": "ENM",
    "label": "JAEN (ENM)"
  },
  {
    "value": "FBU",
    "label": "OSLO (FBU)"
  },
  {
    "value": "FER",
    "label": "FERGUSONS GULF (FER)"
  },
  {
    "value": "FFM",
    "label": "FERGUS FALLS (FFM)"
  },
  {
    "value": "FIC",
    "label": "FIRE COVE (FIC)"
  },
  {
    "value": "FLT",
    "label": "FLAT (FLT)"
  },
  {
    "value": "FNK",
    "label": "FIN CREEK, ALASKA (FNK)"
  },
  {
    "value": "FOK",
    "label": "WESTHAMTON, N.Y. (FOK)"
  },
  {
    "value": "FRG",
    "label": "LONG ISLAND REPUBLIC (FRG)"
  },
  {
    "value": "FRP",
    "label": "FRESH WATER BAY (FRP)"
  },
  {
    "value": "FRQ",
    "label": "FERAMIN (FRQ)"
  },
  {
    "value": "FUG",
    "label": "FUYANG (FUG)"
  },
  {
    "value": "FUL",
    "label": "FULLERTON, CALIFORNIA (FUL)"
  },
  {
    "value": "FYN",
    "label": "FUYUN (FYN)"
  },
  {
    "value": "GAI",
    "label": "GAITHERSBURG (GAI)"
  },
  {
    "value": "GBC",
    "label": "GASUKE (GBC)"
  },
  {
    "value": "GBG",
    "label": "GALESBURG,IL (GBG)"
  },
  {
    "value": "GBO",
    "label": "BALTIMORE (GBO)"
  },
  {
    "value": "GCA",
    "label": "GUACAMAYA (GCA)"
  },
  {
    "value": "GEN",
    "label": "OSLO/GARDERMOEN (GEN)"
  },
  {
    "value": "GEW",
    "label": "GEWOYA (GEW)"
  },
  {
    "value": "GFB",
    "label": "TOGIAK FISH (GFB)"
  },
  {
    "value": "GFL",
    "label": "GLENS FALLS-NEW YORK (GFL)"
  },
  {
    "value": "GGR",
    "label": "GAROE (GGR)"
  },
  {
    "value": "BEA",
    "label": "BEREINA (BEA)"
  },
  {
    "value": "ONS",
    "label": "ONSLOW,WA (ONS)"
  },
  {
    "value": "OOK",
    "label": "TOKSOOK,AK (OOK)"
  },
  {
    "value": "OPA",
    "label": "KOPASKER (OPA)"
  },
  {
    "value": "OPB",
    "label": "OPEN BAY (OPB)"
  },
  {
    "value": "OPW",
    "label": "OPUWA (OPW)"
  },
  {
    "value": "ORI",
    "label": "PORT LIONS,AK (ORI)"
  },
  {
    "value": "ORV",
    "label": "NOORVIK,AK (ORV)"
  },
  {
    "value": "OSP",
    "label": "SLUPSK (OSP)"
  },
  {
    "value": "OTG",
    "label": "WORTHINGTON,MN (OTG)"
  },
  {
    "value": "OTS",
    "label": "ANACORTES,WN (OTS)"
  },
  {
    "value": "OTU",
    "label": "OTU (OTU)"
  },
  {
    "value": "OWD",
    "label": "NORWOOD,MA (OWD)"
  },
  {
    "value": "OYP",
    "label": "ST GEORGES DE LOYAPOCK (OYP)"
  },
  {
    "value": "PAW",
    "label": "PAMBWA (PAW)"
  },
  {
    "value": "PBA",
    "label": "POINT BARROW,AK (PBA)"
  },
  {
    "value": "PCC",
    "label": "PUERTO RICO (PCC)"
  },
  {
    "value": "PCH",
    "label": "PALACIOS (PCH)"
  },
  {
    "value": "PCO",
    "label": "PUNTA COLORADA (PCO)"
  },
  {
    "value": "PDB",
    "label": "PEDRO BAY,AK (PDB)"
  },
  {
    "value": "PDN",
    "label": "PARNDANA,SA (PDN)"
  },
  {
    "value": "PEC",
    "label": "PELICAN,AK (PEC)"
  },
  {
    "value": "PGM",
    "label": "PORT GRAHAM,AK (PGM)"
  },
  {
    "value": "PGR",
    "label": "PARAGOULD, ARKANSAS (PGR)"
  },
  {
    "value": "PHB",
    "label": "PARNAIBA (PHB)"
  },
  {
    "value": "PHJ",
    "label": "PORT HUNTER (PHJ)"
  },
  {
    "value": "PHR",
    "label": "PACIFIC HARBOUR (PHR)"
  },
  {
    "value": "PHU",
    "label": "PHU-VINH (PHU)"
  },
  {
    "value": "PII",
    "label": "FAIRBANKS/PHILLIPS,AK (PII)"
  },
  {
    "value": "PIP",
    "label": "PILOT POINT,AK (PIP)"
  },
  {
    "value": "PKA",
    "label": "NAPASKIAK,AK (PKA)"
  },
  {
    "value": "PLK",
    "label": "PLEIKU (PLK)"
  },
  {
    "value": "PLX",
    "label": "SEMIPALATINSK (PLX)"
  },
  {
    "value": "PMH",
    "label": "PORTSMOUTH, OHIO (PMH)"
  },
  {
    "value": "PML",
    "label": "PORT MOLLER,AK (PML)"
  },
  {
    "value": "PMN",
    "label": "PUMANI (PMN)"
  },
  {
    "value": "PNC",
    "label": "PONCA CITY,OK (PNC)"
  },
  {
    "value": "POQ",
    "label": "POLK INLET,AK (POQ)"
  },
  {
    "value": "PPC",
    "label": "PROSPECT CREEK,AK (PPC)"
  },
  {
    "value": "PPV",
    "label": "PORT PROTECTION/KETCHIKAN (PPV)"
  },
  {
    "value": "PQS",
    "label": "PILOT STATION,AK (PQS)"
  },
  {
    "value": "PRB",
    "label": "PASO ROBLES, CALIFORNIA (PRB)"
  },
  {
    "value": "PRE",
    "label": "PORE (PRE)"
  },
  {
    "value": "PRF",
    "label": "PORT JOHNSON, ALASKA (PRF)"
  },
  {
    "value": "PRX",
    "label": "PARIS,TX (PRX)"
  },
  {
    "value": "PTC",
    "label": "PORT ALICE,AK (PTC)"
  },
  {
    "value": "PTE",
    "label": "PORT STEPHENES, N.S.W. (PTE)"
  },
  {
    "value": "PTI",
    "label": "PORT DOUGLAS (PTI)"
  },
  {
    "value": "PTL",
    "label": "PORT ARMSTRONG,AK (PTL)"
  },
  {
    "value": "PUA",
    "label": "PUAS (PUA)"
  },
  {
    "value": "PUC",
    "label": "PRICE,UT (PUC)"
  },
  {
    "value": "PUL",
    "label": "POULSBO, WASHINGTON (PUL)"
  },
  {
    "value": "PVU",
    "label": "PROVO,UT (PVU)"
  },
  {
    "value": "PVZ",
    "label": "PAINESVILLE, OHIO (PVZ)"
  },
  {
    "value": "PWI",
    "label": "PAWI (PWI)"
  },
  {
    "value": "KYK",
    "label": "KARLUK,AK (KYK)"
  },
  {
    "value": "KYL",
    "label": "KEY LARGO, FLORIDA (KYL)"
  },
  {
    "value": "KYU",
    "label": "KOYUKUK,AK (KYU)"
  },
  {
    "value": "KYX",
    "label": "YALUMET (KYX)"
  },
  {
    "value": "KZB",
    "label": "ZACHER BAY,AK (KZB)"
  },
  {
    "value": "LAA",
    "label": "LAMAR,CO (LAA)"
  },
  {
    "value": "LAB",
    "label": "LABLAB (LAB)"
  },
  {
    "value": "LAL",
    "label": "LAKELAND, FLORIDA (LAL)"
  },
  {
    "value": "LCI",
    "label": "LACONIA,NH (LCI)"
  },
  {
    "value": "MUT",
    "label": "MUSCATINE, IOWA (MUT)"
  },
  {
    "value": "MVN",
    "label": "MOUNT VERNON,IL (MVN)"
  },
  {
    "value": "MWT",
    "label": "MOOLAWATANA,SA (MWT)"
  },
  {
    "value": "MWU",
    "label": "MUSSAU (MWU)"
  },
  {
    "value": "IVE",
    "label": "IVE (IVE)"
  },
  {
    "value": "SLO",
    "label": "SOLO (SLO)"
  },
  {
    "value": "DJH",
    "label": "(DJH)"
  },
  {
    "value": "YDE",
    "label": "PARADISE RIVER (YDE)"
  },
  {
    "value": "YDI",
    "label": "DAVIS INLET (YDI)"
  },
  {
    "value": "YDL",
    "label": "DEASE LAKE (YDL)"
  },
  {
    "value": "YDX",
    "label": "DOC CREEK (YDX)"
  },
  {
    "value": "YFG",
    "label": "FONTANGES (YFG)"
  },
  {
    "value": "YGG",
    "label": "GANGES HARBOR (YGG)"
  },
  {
    "value": "YGN",
    "label": "GREENWAY SOUND (YGN)"
  },
  {
    "value": "YHC",
    "label": "HAKAI PASS (YHC)"
  },
  {
    "value": "YHS",
    "label": "SECHELT,BC (YHS)"
  },
  {
    "value": "YJO",
    "label": "JOHNNY MOUNTAIN, BC (YJO)"
  },
  {
    "value": "YKC",
    "label": "COLLINS BAY, SASK (YKC)"
  },
  {
    "value": "YKE",
    "label": "KNEE LAKE (YKE)"
  },
  {
    "value": "YKK",
    "label": "KITKATLA (YKK)"
  },
  {
    "value": "YKN",
    "label": "YANKTON,SD (YKN)"
  },
  {
    "value": "YKT",
    "label": "KLEMTU,BC (YKT)"
  },
  {
    "value": "LGZ",
    "label": "LEGUIZAMO (LGZ)"
  },
  {
    "value": "LHL",
    "label": "DFG (LHL)"
  },
  {
    "value": "LHZ",
    "label": "SDG (LHZ)"
  },
  {
    "value": "LMA",
    "label": "LAKE MINCHUMINA,AK (LMA)"
  },
  {
    "value": "LMC",
    "label": "LAMACARENA (LMC)"
  },
  {
    "value": "LMX",
    "label": "LOPEZ DE MICAY (LMX)"
  },
  {
    "value": "LNG",
    "label": "LESE (LNG)"
  },
  {
    "value": "LOF",
    "label": "LOEN (LOF)"
  },
  {
    "value": "LOW",
    "label": "LOUISA, VIRGINIA (LOW)"
  },
  {
    "value": "LOX",
    "label": "ADFSDAF (LOX)"
  },
  {
    "value": "LPE",
    "label": "LA PRIMAVERA (LPE)"
  },
  {
    "value": "LPW",
    "label": "LITTLE PORT WALTER,AK (LPW)"
  },
  {
    "value": "LSN",
    "label": "LOS BANOS, CALIFORNIA (LSN)"
  },
  {
    "value": "LVD",
    "label": "LIME VILLAGE,AK (LVD)"
  },
  {
    "value": "LZD",
    "label": "LANZHOU-LANZHOUDONG (LZD)"
  },
  {
    "value": "MBN",
    "label": "MT. BARNETT, WA (MBN)"
  },
  {
    "value": "MCD",
    "label": "MACKINAC-ISLAN,MI (MCD)"
  },
  {
    "value": "MEO",
    "label": "MANTEO (MEO)"
  },
  {
    "value": "MFD",
    "label": "MANSFIELD,OH (MFD)"
  },
  {
    "value": "MFI",
    "label": "MARSHFIELD (MFI)"
  },
  {
    "value": "MGP",
    "label": "MANGA (MGP)"
  },
  {
    "value": "MGY",
    "label": "DAYTON/MONTGOMERY,OH (MGY)"
  },
  {
    "value": "MHB",
    "label": "AUCKLAND/MECHANICS BAY (MHB)"
  },
  {
    "value": "MHL",
    "label": "MARSHALL, MISSOURI (MHL)"
  },
  {
    "value": "MJJ",
    "label": "MOKI (MJJ)"
  },
  {
    "value": "MKD",
    "label": "CHAGNI (MKD)"
  },
  {
    "value": "MKS",
    "label": "MEKANE SELAM (MKS)"
  },
  {
    "value": "MKT",
    "label": "MANKATO,MN (MKT)"
  },
  {
    "value": "MLC",
    "label": "MC ALESTER,OK (MLC)"
  },
  {
    "value": "MLL",
    "label": "MARSHALL,AK (MLL)"
  },
  {
    "value": "MLY",
    "label": "MANLEY HOT SPGS,AK (MLY)"
  },
  {
    "value": "MML",
    "label": "MARSHALL,MN (MML)"
  },
  {
    "value": "TUZ",
    "label": "TUCUMA (TUZ)"
  },
  {
    "value": "TWA",
    "label": "TWIN HILLS,AK (TWA)"
  },
  {
    "value": "TWG",
    "label": "SDF (TWG)"
  },
  {
    "value": "TWT",
    "label": "TAWITAWI (TWT)"
  },
  {
    "value": "TXR",
    "label": "TANBAR, QLD. (TXR)"
  },
  {
    "value": "TZN",
    "label": "SOUTH ANDROS (TZN)"
  },
  {
    "value": "UDS",
    "label": "SDF (UDS)"
  },
  {
    "value": "UGI",
    "label": "UGANIK,AK (UGI)"
  },
  {
    "value": "UKR",
    "label": "MUKEIRAS (UKR)"
  },
  {
    "value": "UQE",
    "label": "QUEEN,AK (UQE)"
  },
  {
    "value": "URB",
    "label": "URUBUPUNGA,SP (URB)"
  },
  {
    "value": "USA",
    "label": "UUUUUUUU (USA)"
  },
  {
    "value": "UUU",
    "label": "MANUMU (UUU)"
  },
  {
    "value": "UVO",
    "label": "UVOL (UVO)"
  },
  {
    "value": "UWP",
    "label": "SDF (UWP)"
  },
  {
    "value": "VCB",
    "label": "VIEW COVE,AK (VCB)"
  },
  {
    "value": "VEE",
    "label": "VENETIE,AK (VEE)"
  },
  {
    "value": "VGZ",
    "label": "VILLAGARZON (VGZ)"
  },
  {
    "value": "VNG",
    "label": "VIENGXAY (VNG)"
  },
  {
    "value": "VTA",
    "label": "VICTORIA (VTA)"
  },
  {
    "value": "VUE",
    "label": "SDF (VUE)"
  },
  {
    "value": "WAA",
    "label": "WALES,AK (WAA)"
  },
  {
    "value": "WAD",
    "label": "ANDRIAMENA (WAD)"
  },
  {
    "value": "WAE",
    "label": "WADI E DAWASIR (WAE)"
  },
  {
    "value": "WAH",
    "label": "WAHPETON-NORTH DAKOTA (WAH)"
  },
  {
    "value": "WBA",
    "label": "WARRABER ISLAND (WBA)"
  },
  {
    "value": "WBB",
    "label": "STEBBINS,AK (WBB)"
  },
  {
    "value": "WBE",
    "label": "BEALANANA (WBE)"
  },
  {
    "value": "WBQ",
    "label": "BEAVER,AK (WBQ)"
  },
  {
    "value": "WDG",
    "label": "ENID/WOODRING MUNICIPAL,O (WDG)"
  },
  {
    "value": "WDN",
    "label": "WALDRON ISLAND-WASHINGTON (WDN)"
  },
  {
    "value": "WED",
    "label": "WEDAU (WED)"
  },
  {
    "value": "WFK",
    "label": "FRENCHVILLE,ME (WFK)"
  },
  {
    "value": "WHL",
    "label": "WELSHPOOL (WHL)"
  },
  {
    "value": "WHR",
    "label": "AVON STOLPORT,CO (WHR)"
  },
  {
    "value": "WIU",
    "label": "WITU (WIU)"
  },
  {
    "value": "WJF",
    "label": "PALMDALE/LANCASTER,FOX,CA (WJF)"
  },
  {
    "value": "WKN",
    "label": "WAKUNAI (WKN)"
  },
  {
    "value": "WLM",
    "label": "WALTHAM,MA (WLM)"
  },
  {
    "value": "WMK",
    "label": "MEYERS CHUCK,AK (WMK)"
  },
  {
    "value": "WMO",
    "label": "WHITE MOUNTAIN,AK (WMO)"
  },
  {
    "value": "WNC",
    "label": "TUXEKAN ISLAND,AK (WNC)"
  },
  {
    "value": "WOW",
    "label": "WILLOW-ALASKA (WOW)"
  },
  {
    "value": "WRA",
    "label": "WARDER (WRA)"
  },
  {
    "value": "WSA",
    "label": "WASUA (WSA)"
  },
  {
    "value": "WSN",
    "label": "SOUTH NAKNEK,AK (WSN)"
  },
  {
    "value": "WST",
    "label": "WESTERLY,RI (WST)"
  },
  {
    "value": "WSX",
    "label": "WESTSOUND,WN (WSX)"
  },
  {
    "value": "WTL",
    "label": "TUNTATULIAK,AK (WTL)"
  },
  {
    "value": "MMN",
    "label": "STOW, MASSACHUSETTS (MMN)"
  },
  {
    "value": "MNM",
    "label": "MENOMINEE,MI (MNM)"
  },
  {
    "value": "MNT",
    "label": "MINTO,AK (MNT)"
  },
  {
    "value": "MOS",
    "label": "MOSES POINT, ALASKA (MOS)"
  },
  {
    "value": "MPF",
    "label": "MAPODA (MPF)"
  },
  {
    "value": "MPV",
    "label": "MONTPELIER,VT (MPV)"
  },
  {
    "value": "MRL",
    "label": "MINERS LAKE, QLD. (MRL)"
  },
  {
    "value": "MRM",
    "label": "MANARE (MRM)"
  },
  {
    "value": "MSD",
    "label": "MT.PLEASANT,UT (MSD)"
  },
  {
    "value": "MTN",
    "label": "BALTIMORE/GLENN L.MARTIN (MTN)"
  },
  {
    "value": "MTX",
    "label": "FAIRBANKS/METRO,AK (MTX)"
  },
  {
    "value": "HIC",
    "label": "PRETORIA/ISCOR (HIC)"
  },
  {
    "value": "HKA",
    "label": "BLYTHEVILLE,AK (HKA)"
  },
  {
    "value": "HKB",
    "label": "HEALY LAKE,AK (HKB)"
  },
  {
    "value": "HKH",
    "label": "SDF (HKH)"
  },
  {
    "value": "HKI",
    "label": "SDF (HKI)"
  },
  {
    "value": "HKL",
    "label": "SDF (HKL)"
  },
  {
    "value": "TEP",
    "label": "TEPTEP (TEP)"
  },
  {
    "value": "THF",
    "label": "BERLIN/TEMPELHOF (THF)"
  },
  {
    "value": "TKE",
    "label": "TENAKEE,AK (TKE)"
  },
  {
    "value": "TKI",
    "label": "TOKEEN,AK (TKI)"
  },
  {
    "value": "TLA",
    "label": "TELLER,AK (TLA)"
  },
  {
    "value": "TLT",
    "label": "TULUKSAK,AK (TLT)"
  },
  {
    "value": "TNC",
    "label": "TIN CITY,AK (TNC)"
  },
  {
    "value": "TNK",
    "label": "TUNUNAK,AK (TNK)"
  },
  {
    "value": "TOK",
    "label": "TOROKINA (TOK)"
  },
  {
    "value": "TON",
    "label": "TONU (TON)"
  },
  {
    "value": "TOP",
    "label": "TOPEKA,KS (TOP)"
  },
  {
    "value": "TOR",
    "label": "TORRINGTON (TOR)"
  },
  {
    "value": "TOZ",
    "label": "TOUBA (TOZ)"
  },
  {
    "value": "TPZ",
    "label": "?? (TPZ)"
  },
  {
    "value": "TSM",
    "label": "TAOS,NM (TSM)"
  },
  {
    "value": "TSO",
    "label": "ISLES OF SCILLY/TRESCO (TSO)"
  },
  {
    "value": "TTL",
    "label": "TURTLE ISLAND (TTL)"
  },
  {
    "value": "TTM",
    "label": "TABLON DE TAMARA (TTM)"
  },
  {
    "value": "TUJ",
    "label": "TUM (TUJ)"
  },
  {
    "value": "WVL",
    "label": "WATERVILLE,ME (WVL)"
  },
  {
    "value": "WWD",
    "label": "CAPE MAY,NJ (WWD)"
  },
  {
    "value": "WWP",
    "label": "WHALE PASS,AK (WWP)"
  },
  {
    "value": "WWY",
    "label": "WEST WYALONG (WWY)"
  },
  {
    "value": "WZU",
    "label": "CHURCHILL (WZU)"
  },
  {
    "value": "XAY",
    "label": "XAYABURY (XAY)"
  },
  {
    "value": "XCN",
    "label": "CORON (XCN)"
  },
  {
    "value": "XQU",
    "label": "QUALICUM,BC (XQU)"
  },
  {
    "value": "XRR",
    "label": "ROSS RIVER (XRR)"
  },
  {
    "value": "XWA",
    "label": "?? (XWA)"
  },
  {
    "value": "Y T",
    "label": "SDF (Y T)"
  },
  {
    "value": "YAB",
    "label": "ARCTIC BAY (YAB)"
  },
  {
    "value": "YBA",
    "label": "BANFF, ALBERTA (YBA)"
  },
  {
    "value": "YBF",
    "label": "BAMFIELD (YBF)"
  },
  {
    "value": "YBH",
    "label": "BULL HARBOUR, BC (YBH)"
  },
  {
    "value": "YBI",
    "label": "BLACK TICKLE (YBI)"
  },
  {
    "value": "YBJ",
    "label": "BAIE JOHAN BEETZ (YBJ)"
  },
  {
    "value": "YBM",
    "label": "BRONSON CREEK (YBM)"
  },
  {
    "value": "YBZ",
    "label": "TORONTO (YBZ)"
  },
  {
    "value": "YCF",
    "label": "CORTES BAY (YCF)"
  },
  {
    "value": "QDU",
    "label": "MAIN RR-DUESSELDORF (QDU)"
  },
  {
    "value": "QEU",
    "label": "DSF (QEU)"
  },
  {
    "value": "QKL",
    "label": "MAIN RR-COLOGNE, BONN (QKL)"
  },
  {
    "value": "QUI",
    "label": "SDF (QUI)"
  },
  {
    "value": "QZR",
    "label": "APRILIA (QZR)"
  },
  {
    "value": "RAD",
    "label": "TORTOLA/ROAD TOWN (RAD)"
  },
  {
    "value": "RAF",
    "label": "RAS AN NAQB (RAF)"
  },
  {
    "value": "RAL",
    "label": "RIVERSIDE-CALIFORNIA (RAL)"
  },
  {
    "value": "RBH",
    "label": "BROOKS LODGE,AK (RBH)"
  },
  {
    "value": "RBI",
    "label": "RABI (RBI)"
  },
  {
    "value": "RCN",
    "label": "AMERICAN RIVER,SA (RCN)"
  },
  {
    "value": "RCT",
    "label": "REED CITY, MICHGAN (RCT)"
  },
  {
    "value": "RDH",
    "label": "SDF (RDH)"
  },
  {
    "value": "RDV",
    "label": "RED DEVIL,AK (RDV)"
  },
  {
    "value": "REO",
    "label": "ROME, OREGON (REO)"
  },
  {
    "value": "REW",
    "label": "REWA (REW)"
  },
  {
    "value": "RGE",
    "label": "PORGERA (RGE)"
  },
  {
    "value": "RID",
    "label": "RICHMOND, INDIANA (RID)"
  },
  {
    "value": "RIF",
    "label": "RICHFIELD,UT (RIF)"
  },
  {
    "value": "RIP",
    "label": "SDF (RIP)"
  },
  {
    "value": "RMD",
    "label": "RAMAGUNDAM (RMD)"
  },
  {
    "value": "RMZ",
    "label": "RRRRRRR (RMZ)"
  },
  {
    "value": "RNG",
    "label": "RANGELY, COLORADO (RNG)"
  },
  {
    "value": "RNR",
    "label": "ROBINSON RIVER (RNR)"
  },
  {
    "value": "RNT",
    "label": "RENTON, WASHINGTON (RNT)"
  },
  {
    "value": "RON",
    "label": "RONDON (RON)"
  },
  {
    "value": "RPV",
    "label": "ROPER VALLEY, N.T. (RPV)"
  },
  {
    "value": "RSE",
    "label": "SYDNEY/ROSE BAY (RSE)"
  },
  {
    "value": "RSJ",
    "label": "ROSARIO,WN (RSJ)"
  },
  {
    "value": "RSP",
    "label": "RASPBERRY STRAIT, ALASKA (RSP)"
  },
  {
    "value": "RSS",
    "label": "ROSEIRES (RSS)"
  },
  {
    "value": "RVE",
    "label": "SARAVENA (RVE)"
  },
  {
    "value": "RWB",
    "label": "ROWAN BAY,AK (RWB)"
  },
  {
    "value": "RYA",
    "label": "SDF (RYA)"
  },
  {
    "value": "RZW",
    "label": "WOLLASTON LAKE (RZW)"
  },
  {
    "value": "SAJ",
    "label": "SIRAJGANJ (SAJ)"
  },
  {
    "value": "SAK",
    "label": "SAUDARKROKUR (SAK)"
  },
  {
    "value": "SAM",
    "label": "SALAMO (SAM)"
  },
  {
    "value": "SBO",
    "label": "SALINA,UT (SBO)"
  },
  {
    "value": "SBS",
    "label": "STEAMBOAT SPRINGS,CO (SBS)"
  },
  {
    "value": "SCJ",
    "label": "SMITH COVE,AK (SCJ)"
  },
  {
    "value": "SCM",
    "label": "SCAMMON BAY,AK (SCM)"
  },
  {
    "value": "SDX",
    "label": "SEDONA,AZ (SDX)"
  },
  {
    "value": "SDZ",
    "label": "SHETLAND ISLANDS (SDZ)"
  },
  {
    "value": "SED",
    "label": "SEDOM (SED)"
  },
  {
    "value": "SEG",
    "label": "SELINSGROVE, PENNSYLVANIA (SEG)"
  },
  {
    "value": "BEK",
    "label": "RAE BARELI (BEK)"
  },
  {
    "value": "BIC",
    "label": "BIG CREEK,AK (BIC)"
  },
  {
    "value": "BNJ",
    "label": "BONN (BNJ)"
  },
  {
    "value": "BNV",
    "label": "DSFG (BNV)"
  },
  {
    "value": "BOV",
    "label": "BOANG (BOV)"
  },
  {
    "value": "BPB",
    "label": "BORIDI (BPB)"
  },
  {
    "value": "BRH",
    "label": "BRAHMAN (BRH)"
  },
  {
    "value": "BUK",
    "label": "ALBUQ (BUK)"
  },
  {
    "value": "BVT",
    "label": "SDF (BVT)"
  },
  {
    "value": "BXC",
    "label": "BOXBOROUGH,MA (BXC)"
  },
  {
    "value": "CBZ",
    "label": "CABIN CREEK (CBZ)"
  },
  {
    "value": "CEM",
    "label": "CENTRAL,AK (CEM)"
  },
  {
    "value": "CEY",
    "label": "MURRAY, KENTUCKY (CEY)"
  },
  {
    "value": "CFH",
    "label": "CLIFTON HILLS,SA (CFH)"
  },
  {
    "value": "CVA",
    "label": "CIVIC AR HELI-PITTSBURGH, PA (CVA)"
  },
  {
    "value": "CWS",
    "label": "CENTRAL ISLAND (CWS)"
  },
  {
    "value": "CYF",
    "label": "CHEFORNAK,AK (CYF)"
  },
  {
    "value": "CGX",
    "label": "CHICAGO (CGX)"
  },
  {
    "value": "CHD",
    "label": "CHANDLER, ARIZONA (CHD)"
  },
  {
    "value": "CHP",
    "label": "CIRCLE HOT SPRINGS (CHP)"
  },
  {
    "value": "NER",
    "label": "NERYUNGRI (NER)"
  },
  {
    "value": "NIB",
    "label": "NIKOLAI,AK (NIB)"
  },
  {
    "value": "NJT",
    "label": "DSF (NJT)"
  },
  {
    "value": "NKI",
    "label": "NAUKITI,AK (NKI)"
  },
  {
    "value": "NKN",
    "label": "NANKINA (NKN)"
  },
  {
    "value": "NKT",
    "label": "SDF (NKT)"
  },
  {
    "value": "NLE",
    "label": "NILES, MICHIGAN (NLE)"
  },
  {
    "value": "NLG",
    "label": "NELSON LAGDON,AK (NLG)"
  },
  {
    "value": "NME",
    "label": "NIGHTMUTE,AK (NME)"
  },
  {
    "value": "NMG",
    "label": "SAN MIGUEL (NMG)"
  },
  {
    "value": "NNB",
    "label": "SANTA ANA (NNB)"
  },
  {
    "value": "NNK",
    "label": "NAKNEK,AK (NNK)"
  },
  {
    "value": "NNL",
    "label": "NONDALTON,AK (NNL)"
  },
  {
    "value": "NOB",
    "label": "NOSARA BEACH (NOB)"
  },
  {
    "value": "NOE",
    "label": "NORDDEICH (NOE)"
  },
  {
    "value": "NOO",
    "label": "NAORO (NOO)"
  },
  {
    "value": "NPH",
    "label": "NEPHI,UT (NPH)"
  },
  {
    "value": "NRS",
    "label": "SDF (NRS)"
  },
  {
    "value": "NRY",
    "label": "NEWRY, N.T. (NRY)"
  },
  {
    "value": "NSS",
    "label": "NA SAN (NSS)"
  },
  {
    "value": "NSX",
    "label": "NORTH SOUND VIRGIN GORDA (NSX)"
  },
  {
    "value": "NTM",
    "label": "MIRACEMA DO NORTE,TO (NTM)"
  },
  {
    "value": "NUC",
    "label": "SAN CLEMENTE ISLAND (NUC)"
  },
  {
    "value": "NUP",
    "label": "NUNAPITCHUK,AK (NUP)"
  },
  {
    "value": "NZT",
    "label": "SHAMATTAWA (NZT)"
  },
  {
    "value": "OAN",
    "label": "OLANCHITO (OAN)"
  },
  {
    "value": "OBM",
    "label": "MOROBE (OBM)"
  },
  {
    "value": "OBU",
    "label": "KOBUK,AK (OBU)"
  },
  {
    "value": "OCA",
    "label": "OCEAN REEF CLUB,FL (OCA)"
  },
  {
    "value": "OCE",
    "label": "OCEAN CITY,MD (OCE)"
  },
  {
    "value": "OCK",
    "label": "DSGF (OCK)"
  },
  {
    "value": "OCN",
    "label": "OCEANSIDE-CALIFORNIA (OCN)"
  },
  {
    "value": "ODW",
    "label": "OAK HARBOR,WN (ODW)"
  },
  {
    "value": "OFJ",
    "label": "OLAFSFJORDUR (OFJ)"
  },
  {
    "value": "OFW",
    "label": "SDF (OFW)"
  },
  {
    "value": "OHI",
    "label": "OSHAKATI (OHI)"
  },
  {
    "value": "OKK",
    "label": "KOKOMA,IN (OKK)"
  },
  {
    "value": "OKP",
    "label": "OKSAPMIN (OKP)"
  },
  {
    "value": "OLH",
    "label": "OLD HARBOR,AK (OLH)"
  },
  {
    "value": "OLO",
    "label": "OLOMOUC (OLO)"
  },
  {
    "value": "OMN",
    "label": "OSMANABAD (OMN)"
  },
  {
    "value": "ONH",
    "label": "ONEONTA, NEW YORK (ONH)"
  },
  {
    "value": "YRD",
    "label": "DEAN RIVER (YRD)"
  },
  {
    "value": "YRN",
    "label": "RIVERS INLET (YRN)"
  },
  {
    "value": "YSE",
    "label": "SWAN RIVER (YSE)"
  },
  {
    "value": "YSZ",
    "label": "SQUIRREL COVE (YSZ)"
  },
  {
    "value": "YTB",
    "label": "HARTLEY BAY (YTB)"
  },
  {
    "value": "YTC",
    "label": "STURDEE (YTC)"
  },
  {
    "value": "GLD",
    "label": "GOODLAND,AK (GLD)"
  },
  {
    "value": "GLV",
    "label": "GOLOVIN,AK (GLV)"
  },
  {
    "value": "GOC",
    "label": "GORA (GOC)"
  },
  {
    "value": "GRG",
    "label": "GARDEZ (GRG)"
  },
  {
    "value": "GRN",
    "label": "GORDON, NEBRASKA (GRN)"
  },
  {
    "value": "GUV",
    "label": "MOUGULU (GUV)"
  },
  {
    "value": "GVE",
    "label": "GORDONSVILLE (GVE)"
  },
  {
    "value": "GVM",
    "label": "SDF (GVM)"
  },
  {
    "value": "GXP",
    "label": "SEIYUN (GXP)"
  },
  {
    "value": "HAE",
    "label": "HAVASUPAI,AZ. (HAE)"
  },
  {
    "value": "HAL",
    "label": "HALALI (HAL)"
  },
  {
    "value": "HAZ",
    "label": "HATZFELDTHAVEN (HAZ)"
  },
  {
    "value": "HBN",
    "label": "PHU-BON (HBN)"
  },
  {
    "value": "HCS",
    "label": "JOHANNESBURG/RANDBURG (HCS)"
  },
  {
    "value": "HDB",
    "label": "?? (HDB)"
  },
  {
    "value": "HEF",
    "label": "SDAF (HEF)"
  },
  {
    "value": "HFD",
    "label": "HARTFORD CT/BRAINARD,CT (HFD)"
  },
  {
    "value": "HGK",
    "label": "SDF (HGK)"
  },
  {
    "value": "HHA",
    "label": "HUANGHUA (HHA)"
  },
  {
    "value": "ASX",
    "label": "ASHLAND (ASX)"
  },
  {
    "value": "AUW",
    "label": "WAUSAU,WI (AUW)"
  },
  {
    "value": "AWH",
    "label": "AWAREH (AWH)"
  },
  {
    "value": "AWS",
    "label": "SDFSD (AWS)"
  },
  {
    "value": "AXB",
    "label": "ALEXANDRIA BAY NY (AXB)"
  },
  {
    "value": "BAP",
    "label": "BAIBARA (BAP)"
  },
  {
    "value": "BBF",
    "label": "BURLINGTON,MA (BBF)"
  },
  {
    "value": "HLX",
    "label": "SDF (HLX)"
  },
  {
    "value": "HNO",
    "label": "HERCEGNOVI (HNO)"
  },
  {
    "value": "HOE",
    "label": "HOUEISAY (HOE)"
  },
  {
    "value": "HPE",
    "label": "HOPE VALE-QL (HPE)"
  },
  {
    "value": "HRZ",
    "label": "SDF (HRZ)"
  },
  {
    "value": "HSI",
    "label": "HASTINGS,NE (HSI)"
  },
  {
    "value": "HSP",
    "label": "HOT SPRING,VA (HSP)"
  },
  {
    "value": "HTO",
    "label": "EAST HAMPTON,NY (HTO)"
  },
  {
    "value": "HYL",
    "label": "HOLLIS,AK (HYL)"
  },
  {
    "value": "HYR",
    "label": "HAYWARD-WISCONSIN (HYR)"
  },
  {
    "value": "HYY",
    "label": "SDF (HYY)"
  },
  {
    "value": "ICD",
    "label": "?? (ICD)"
  },
  {
    "value": "IDN",
    "label": "INDAGEN (IDN)"
  },
  {
    "value": "IHA",
    "label": "NIIHAMA (IHA)"
  },
  {
    "value": "IMA",
    "label": "IAMALELE (IMA)"
  },
  {
    "value": "IMD",
    "label": "IMONDA (IMD)"
  },
  {
    "value": "IMI",
    "label": "INE (IMI)"
  },
  {
    "value": "IOK",
    "label": "IOKEA TOWN (IOK)"
  },
  {
    "value": "IOP",
    "label": "IOMA (IOP)"
  },
  {
    "value": "IOW",
    "label": "IOWA CITY, IOWA (IOW)"
  },
  {
    "value": "IRC",
    "label": "CIECLE,AK (IRC)"
  },
  {
    "value": "IRN",
    "label": "IRIONA (IRN)"
  },
  {
    "value": "ISH",
    "label": "ISCHIA (ISH)"
  },
  {
    "value": "ITK",
    "label": "ITOKAMA (ITK)"
  },
  {
    "value": "ITL",
    "label": "SDF (ITL)"
  },
  {
    "value": "JAO",
    "label": "ATLANTA/BEAVER RUIN,GA (JAO)"
  },
  {
    "value": "JBC",
    "label": "JCA-BOSTON MASSACHUSETTS (JBC)"
  },
  {
    "value": "JBT",
    "label": "BETHEL/CITY LANDING,AK (JBT)"
  },
  {
    "value": "JCD",
    "label": "ST.CROIX/DOWNTOWN (JCD)"
  },
  {
    "value": "JDB",
    "label": "DALLAS FT.WORTH/DOWNTOWN (JDB)"
  },
  {
    "value": "JDM",
    "label": "MIAMI/DOWNTOWN,FL (JDM)"
  },
  {
    "value": "JDX",
    "label": "HOUSTON/CENTRAL BUSINESS (JDX)"
  },
  {
    "value": "JEK",
    "label": "JTJYHHHK (JEK)"
  },
  {
    "value": "JGC",
    "label": "GRAND CANYON/HELIPORT,AZ (JGC)"
  },
  {
    "value": "JGL",
    "label": "ATLANTA/GALLERIA,GA (JGL)"
  },
  {
    "value": "JGQ",
    "label": "HOUSTON/TRANSCO TWR GALL (JGQ)"
  },
  {
    "value": "JHC",
    "label": "GARDEN CITY,NY (JHC)"
  },
  {
    "value": "JHK",
    "label": "DSF (JHK)"
  },
  {
    "value": "JHY",
    "label": "CAMBRIDGE, MASSACHUSETTS (JHY)"
  },
  {
    "value": "JID",
    "label": "CITY OF INDUSTRY HLPT,CA (JID)"
  },
  {
    "value": "JKP",
    "label": "DG (JKP)"
  },
  {
    "value": "JPT",
    "label": "HOUSTON/PARK TEN HELIPAD (JPT)"
  },
  {
    "value": "JRB",
    "label": "DWTN MANHATTAN-NEW YORK (JRB)"
  },
  {
    "value": "JSL",
    "label": "ATLANTIC CITY/STEEL PIER (JSL)"
  },
  {
    "value": "JSO",
    "label": "SODERTALJE (JSO)"
  },
  {
    "value": "JSZ",
    "label": "ST.TROPEZ (JSZ)"
  },
  {
    "value": "JVL",
    "label": "JANESVILLE,WI (JVL)"
  },
  {
    "value": "JWH",
    "label": "HOUSTON-WESTCHASE (JWH)"
  },
  {
    "value": "KAH",
    "label": "MELBOURNE/CITY HLPT (KAH)"
  },
  {
    "value": "KBC",
    "label": "BIRCH CREEK,AK (KBC)"
  },
  {
    "value": "KBK",
    "label": "KLAG BAY (KBK)"
  },
  {
    "value": "KBW",
    "label": "CHIGNIK BAY,AK (KBW)"
  },
  {
    "value": "KCG",
    "label": "CHIGNIK,AK (KCG)"
  },
  {
    "value": "KCQ",
    "label": "CHIGNIK LAKE,AK (KCQ)"
  },
  {
    "value": "KDS",
    "label": "KAMARAN DOWNS (KDS)"
  },
  {
    "value": "CIB",
    "label": "CATALINA ISLAND (CIB)"
  },
  {
    "value": "CIK",
    "label": "CHALKYITSIK,AK (CIK)"
  },
  {
    "value": "CIL",
    "label": "COUNCIL,AK (CIL)"
  },
  {
    "value": "CIN",
    "label": "CARROL, IOWA (CIN)"
  },
  {
    "value": "CJD",
    "label": "CANDILEJAS (CJD)"
  },
  {
    "value": "CKD",
    "label": "CROOKED CREEK,AK (CKD)"
  },
  {
    "value": "CLP",
    "label": "CLARKS POINT,AK (CLP)"
  },
  {
    "value": "CLW",
    "label": "CLEARWATER FL (CLW)"
  },
  {
    "value": "COE",
    "label": "COEUR D ALENE,ID (COE)"
  },
  {
    "value": "CPM",
    "label": "SDF (CPM)"
  },
  {
    "value": "CPN",
    "label": "CAPE RODNEY (CPN)"
  },
  {
    "value": "CQT",
    "label": "CAQUETANIA (CQT)"
  },
  {
    "value": "CST",
    "label": "CASTAWAY (CST)"
  },
  {
    "value": "AAD",
    "label": "AD-DABBAH (AAD)"
  },
  {
    "value": "AGY",
    "label": "ARGYLE DOWNS, WA. (AGY)"
  },
  {
    "value": "AHT",
    "label": "AMCHITKA, ALASKA. (AHT)"
  },
  {
    "value": "AIC",
    "label": "AIROK (AIC)"
  },
  {
    "value": "AIY",
    "label": "ATLANTIC CITY,NJ (AIY)"
  },
  {
    "value": "ANH",
    "label": "ANUHA ISLAND RESORT (ANH)"
  },
  {
    "value": "ANT",
    "label": "ST. ANTON (ANT)"
  },
  {
    "value": "KGB",
    "label": "KONGE (KGB)"
  },
  {
    "value": "FLC",
    "label": "FALLS CREEK (FLC)"
  },
  {
    "value": "FSL",
    "label": "FOSSIL DOWNS (FSL)"
  },
  {
    "value": "GBP",
    "label": "GAMBOOLA (GBP)"
  },
  {
    "value": "GFE",
    "label": "GRENFELL (GFE)"
  },
  {
    "value": "GLY",
    "label": "MT. GOLDSWORTHY (GLY)"
  },
  {
    "value": "GOS",
    "label": "GOSFORD (GOS)"
  },
  {
    "value": "GSC",
    "label": "GASCOYNE JUNCTION (GSC)"
  },
  {
    "value": "HIH",
    "label": "HOOK ISLAND (HIH)"
  },
  {
    "value": "HLL",
    "label": "HILLSIDE (HLL)"
  },
  {
    "value": "HRN",
    "label": "HERON ISLAND (HRN)"
  },
  {
    "value": "HRY",
    "label": "HENBURY (HRY)"
  },
  {
    "value": "JFM",
    "label": "FREMANTLE (JFM)"
  },
  {
    "value": "JJB",
    "label": "JOHN BREWER REEF (JJB)"
  },
  {
    "value": "KBJ",
    "label": "KINGS CANYON (KBJ)"
  },
  {
    "value": "KDB",
    "label": "KAMBALDA (KDB)"
  },
  {
    "value": "KPP",
    "label": "KALPOWAR (KPP)"
  },
  {
    "value": "KQB",
    "label": "KOONIBBA (KQB)"
  },
  {
    "value": "KRD",
    "label": "KURUNDI (KRD)"
  },
  {
    "value": "KYB",
    "label": "YANGOONABIE (KYB)"
  },
  {
    "value": "LDW",
    "label": "LANSDOWNE (LDW)"
  },
  {
    "value": "LFP",
    "label": "LAKEFIELD (LFP)"
  },
  {
    "value": "LKD",
    "label": "LAKELAND DOWNS (LKD)"
  },
  {
    "value": "LLL",
    "label": "LISSADELL (LLL)"
  },
  {
    "value": "LLP",
    "label": "LINDA DOWNS (LLP)"
  },
  {
    "value": "LNH",
    "label": "LAKE NASH (LNH)"
  },
  {
    "value": "LTB",
    "label": "LATROBE (LTB)"
  },
  {
    "value": "LYT",
    "label": "LADY ELLIOT ISLAND (LYT)"
  },
  {
    "value": "MBF",
    "label": "MOUNT BUFFALO (MBF)"
  },
  {
    "value": "MFL",
    "label": "MT. FULL STOP (MFL)"
  },
  {
    "value": "MHC",
    "label": "MACMAHON CAMP 4 (MHC)"
  },
  {
    "value": "MIY",
    "label": "MITTIEBAH (MIY)"
  },
  {
    "value": "MIZ",
    "label": "MAINORU (MIZ)"
  },
  {
    "value": "MJK",
    "label": "MONKEY MIA (MJK)"
  },
  {
    "value": "MKV",
    "label": "MT. CAVENAGH (MKV)"
  },
  {
    "value": "MLV",
    "label": "MERLUNA (MLV)"
  },
  {
    "value": "MNV",
    "label": "MOUNTAIN VALLEY (MNV)"
  },
  {
    "value": "MRT",
    "label": "MOROAK RIVER (MRT)"
  },
  {
    "value": "MSF",
    "label": "MT. SWAN (MSF)"
  },
  {
    "value": "MVH",
    "label": "MACKSVILLE (MVH)"
  },
  {
    "value": "MVU",
    "label": "MUSGRAVE (MVU)"
  },
  {
    "value": "MXQ",
    "label": "MITCHELL RIVER (MXQ)"
  },
  {
    "value": "NBR",
    "label": "NAMBOUR (NBR)"
  },
  {
    "value": "NMP",
    "label": "NEW MOON (NMP)"
  },
  {
    "value": "NPP",
    "label": "NAPPERBY (NPP)"
  },
  {
    "value": "NRG",
    "label": "NARROGIN (NRG)"
  },
  {
    "value": "OBA",
    "label": "OBAN (OBA)"
  },
  {
    "value": "OXO",
    "label": "ORIENTOS (OXO)"
  },
  {
    "value": "GZI",
    "label": "GHAZNI (GZI)"
  },
  {
    "value": "IMZ",
    "label": "NIMROZ (IMZ)"
  },
  {
    "value": "KUR",
    "label": "KURAN-O-MUNJAN (KUR)"
  },
  {
    "value": "SBF",
    "label": "SARDEN BAND (SBF)"
  },
  {
    "value": "TQN",
    "label": "TALUQAN (TQN)"
  },
  {
    "value": "URN",
    "label": "URGOON (URN)"
  },
  {
    "value": "URZ",
    "label": "URUZGAN (URZ)"
  },
  {
    "value": "LBZ",
    "label": "LUKAPA (LBZ)"
  },
  {
    "value": "LZM",
    "label": "LUZAMBA (LZM)"
  },
  {
    "value": "NGV",
    "label": "NGIVA (NGV)"
  },
  {
    "value": "NRQ",
    "label": "N''RIQUINHA (NRQ)"
  },
  {
    "value": "OLN",
    "label": "COLONIA SARMIENTO (OLN)"
  },
  {
    "value": "SZQ",
    "label": "SAENZ PENA (SZQ)"
  },
  {
    "value": "FTI",
    "label": "FITIUTA (FTI)"
  },
  {
    "value": "QLX",
    "label": "LAUTERACH (QLX)"
  },
  {
    "value": "VDD",
    "label": "DANUBEPIER HOV-VIENNA (VDD)"
  },
  {
    "value": "ZRS",
    "label": "ZURS/LECH (ZRS)"
  },
  {
    "value": "ANZ",
    "label": "ANGAS DOWNS (ANZ)"
  },
  {
    "value": "BEE",
    "label": "BEAGLE BAY (BEE)"
  },
  {
    "value": "PEY",
    "label": "PENONG (PEY)"
  },
  {
    "value": "SEK",
    "label": "KSAR ES SOUK (SEK)"
  },
  {
    "value": "SFM",
    "label": "SANFORD, MAINE (SFM)"
  },
  {
    "value": "SFP",
    "label": "SURFURS PARADISE, QLD (SFP)"
  },
  {
    "value": "SGH",
    "label": "SPRINGFIELD, OHIO (SGH)"
  },
  {
    "value": "SHN",
    "label": "SHELTON, WASHINGTON (SHN)"
  },
  {
    "value": "SJG",
    "label": "SAN PEDRO JAGUA (SJG)"
  },
  {
    "value": "SKK",
    "label": "SHAKTOOLIK (SKK)"
  },
  {
    "value": "SME",
    "label": "SOMERSET, KENTUCKY (SME)"
  },
  {
    "value": "SMP",
    "label": "STOCKOLM (SMP)"
  },
  {
    "value": "SOP",
    "label": "PINEHURST, NORTH CAROLIA (SOP)"
  },
  {
    "value": "SSM",
    "label": "SAULT STE.MARIE (SSM)"
  },
  {
    "value": "SSQ",
    "label": "LA SARRE, QU (SSQ)"
  },
  {
    "value": "SSS",
    "label": "SIASSI (SSS)"
  },
  {
    "value": "STG",
    "label": "ST. GEORGE ISLAND (STG)"
  },
  {
    "value": "SUE",
    "label": "STURGEON BAY,WI (SUE)"
  },
  {
    "value": "SUZ",
    "label": "SURIA (SUZ)"
  },
  {
    "value": "SVS",
    "label": "STEVENS POINT,AK (SVS)"
  },
  {
    "value": "SXC",
    "label": "CATALINA (SXC)"
  },
  {
    "value": "SXD",
    "label": "SOPHIA ANTIPOLIS (SXD)"
  },
  {
    "value": "SXP",
    "label": "SHELDON POINT,AK (SXP)"
  },
  {
    "value": "SYB",
    "label": "SEAL BAY,AK (SYB)"
  },
  {
    "value": "SYK",
    "label": "STYKKISHOLMUR (SYK)"
  },
  {
    "value": "SYS",
    "label": "SDF (SYS)"
  },
  {
    "value": "TAT",
    "label": "TATRY/POPRAD (TAT)"
  },
  {
    "value": "TAU",
    "label": "TAURAMENA (TAU)"
  },
  {
    "value": "TBE",
    "label": "TIMBUKE (TBE)"
  },
  {
    "value": "TCT",
    "label": "TAKOTNA,AK (TCT)"
  },
  {
    "value": "TCV",
    "label": "TETE (TCV)"
  },
  {
    "value": "TDB",
    "label": "TETABEDI (TDB)"
  },
  {
    "value": "TEH",
    "label": "TETLIN,AK (TEH)"
  },
  {
    "value": "MZX",
    "label": "MENA (MZX)"
  },
  {
    "value": "NAD",
    "label": "MACANAL (NAD)"
  },
  {
    "value": "NBA",
    "label": "NOI BAI INTL AIRPORT (NBA)"
  },
  {
    "value": "SPL",
    "label": "SCHIPHOL (SPL)"
  },
  {
    "value": "YMW",
    "label": "MANIWAKI (YMW)"
  },
  {
    "value": "TAA",
    "label": "TARAPAINA (TAA)"
  },
  {
    "value": "SER",
    "label": "SAYMOUR INDIAN (SER)"
  },
  {
    "value": "OLL",
    "label": "ABC (OLL)"
  },
  {
    "value": "ZYR",
    "label": "FRANCE (ZYR)"
  },
  {
    "value": "YLS",
    "label": "LEBEL-SUR-QUEVILLON (YLS)"
  },
  {
    "value": "YMP",
    "label": "PORT MCNEIL (YMP)"
  },
  {
    "value": "YNR",
    "label": "ARNES, MN. (YNR)"
  },
  {
    "value": "YOR",
    "label": "SDGF (YOR)"
  },
  {
    "value": "YOU",
    "label": "SDF (YOU)"
  },
  {
    "value": "YPB",
    "label": "PORT ALBERNI,BC (YPB)"
  },
  {
    "value": "YPI",
    "label": "PORT SIMPSON,BC (YPI)"
  },
  {
    "value": "YPZ",
    "label": "BURNS LAKE (YPZ)"
  },
  {
    "value": "TSG",
    "label": "TANACROSS (TSG)"
  },
  {
    "value": "TSP",
    "label": "TEHACHAPI (TSP)"
  },
  {
    "value": "TTD",
    "label": "TROUTDALE (TTD)"
  },
  {
    "value": "TTO",
    "label": "BRITTON (TTO)"
  },
  {
    "value": "TVI",
    "label": "THOMASVILLE (TVI)"
  },
  {
    "value": "TWD",
    "label": "PORT TOWNSEND (TWD)"
  },
  {
    "value": "TWE",
    "label": "TAYLOR (TWE)"
  },
  {
    "value": "TYE",
    "label": "TYONEK (TYE)"
  },
  {
    "value": "TYZ",
    "label": "TAYLOR (TYZ)"
  },
  {
    "value": "UCC",
    "label": "YUCCA FLAT (UCC)"
  },
  {
    "value": "UCE",
    "label": "EUNICE (UCE)"
  },
  {
    "value": "UCY",
    "label": "UNION CITY (UCY)"
  },
  {
    "value": "UES",
    "label": "WAUKESHA (UES)"
  },
  {
    "value": "UGN",
    "label": "WAUKEGAN (UGN)"
  },
  {
    "value": "UGS",
    "label": "UGASHIK (UGS)"
  },
  {
    "value": "UIL",
    "label": "QUILLAYUTE (UIL)"
  },
  {
    "value": "UIZ",
    "label": "UTICA (UIZ)"
  },
  {
    "value": "UKI",
    "label": "UKIAH (UKI)"
  },
  {
    "value": "UKN",
    "label": "WAUKON (UKN)"
  },
  {
    "value": "UKT",
    "label": "QUAKERTOWN (UKT)"
  },
  {
    "value": "ULM",
    "label": "NEW ULM (ULM)"
  },
  {
    "value": "UMB",
    "label": "UMNAK ISLAND (UMB)"
  },
  {
    "value": "UMM",
    "label": "SUMMIT (UMM)"
  },
  {
    "value": "UMT",
    "label": "UMIAT (UMT)"
  },
  {
    "value": "UNS",
    "label": "UMNAK ISLAND (UNS)"
  },
  {
    "value": "UNU",
    "label": "JUNEAU (UNU)"
  },
  {
    "value": "UOS",
    "label": "SEWANEE (UOS)"
  },
  {
    "value": "UOX",
    "label": "UNIVERSITY/OXFORD (UOX)"
  },
  {
    "value": "UST",
    "label": "ST. AUGUSTINE (UST)"
  },
  {
    "value": "UUK",
    "label": "KUPARUK (UUK)"
  },
  {
    "value": "UVA",
    "label": "UVALDE (UVA)"
  },
  {
    "value": "UWA",
    "label": "WARE (UWA)"
  },
  {
    "value": "VDI",
    "label": "VIDALIA (VDI)"
  },
  {
    "value": "VEX",
    "label": "TIOGA (VEX)"
  },
  {
    "value": "VHN",
    "label": "VAN HORN (VHN)"
  },
  {
    "value": "VIH",
    "label": "VICHY (VIH)"
  },
  {
    "value": "VJI",
    "label": "ABINGDON (VJI)"
  },
  {
    "value": "VKS",
    "label": "VICKSBURG (VKS)"
  },
  {
    "value": "VKW",
    "label": "WEST KAVIK (VKW)"
  },
  {
    "value": "VLA",
    "label": "VANDALIA (VLA)"
  },
  {
    "value": "VLE",
    "label": "VALLE (VLE)"
  },
  {
    "value": "VLO",
    "label": "VALLEJO (VLO)"
  },
  {
    "value": "VNC",
    "label": "VENICE (VNC)"
  },
  {
    "value": "VOK",
    "label": "CAMP DOUGLAS (VOK)"
  },
  {
    "value": "VPZ",
    "label": "VALPARAISO (VPZ)"
  },
  {
    "value": "VRS",
    "label": "VERSAILLES (VRS)"
  },
  {
    "value": "VSF",
    "label": "SPRINGFIELD (VSF)"
  },
  {
    "value": "VTN",
    "label": "VALENTINE (VTN)"
  },
  {
    "value": "VYS",
    "label": "PERU (VYS)"
  },
  {
    "value": "WAL",
    "label": "CHINCOTEAGUE (WAL)"
  },
  {
    "value": "WBR",
    "label": "BIG RAPIDS (WBR)"
  },
  {
    "value": "WBU",
    "label": "BOULDER (WBU)"
  },
  {
    "value": "WCR",
    "label": "CHANDALAR (WCR)"
  },
  {
    "value": "WDB",
    "label": "DEEP BAY (WDB)"
  },
  {
    "value": "WDR",
    "label": "WINDER (WDR)"
  },
  {
    "value": "WEA",
    "label": "WEATHERFORD (WEA)"
  },
  {
    "value": "WFB",
    "label": "WATERFRONT-KETCHIKAN (WFB)"
  },
  {
    "value": "WGO",
    "label": "WINCHESTER (WGO)"
  },
  {
    "value": "WHD",
    "label": "HYDER (WHD)"
  },
  {
    "value": "WHT",
    "label": "WHARTON (WHT)"
  },
  {
    "value": "WKL",
    "label": "WAIKOLOA (WKL)"
  },
  {
    "value": "WLD",
    "label": "WINFIELD (WLD)"
  },
  {
    "value": "WLN",
    "label": "LITTLE NAUKATI (WLN)"
  },
  {
    "value": "WLR",
    "label": "LORING (WLR)"
  },
  {
    "value": "WLW",
    "label": "WILLOWS (WLW)"
  },
  {
    "value": "WMC",
    "label": "WINNEMUCCA (WMC)"
  },
  {
    "value": "WOD",
    "label": "WOOD RIVER (WOD)"
  },
  {
    "value": "WOO",
    "label": "WOODCHOPPER (WOO)"
  },
  {
    "value": "WPO",
    "label": "PAONIA (WPO)"
  },
  {
    "value": "WRH",
    "label": "WRENCH CREEK (WRH)"
  },
  {
    "value": "YTJ",
    "label": "TERRACE (YTJ)"
  },
  {
    "value": "YTP",
    "label": "TOFINO (YTP)"
  },
  {
    "value": "YTX",
    "label": "TELEGRAPH (YTX)"
  },
  {
    "value": "YUF",
    "label": "PELLY BAY (YUF)"
  },
  {
    "value": "YUR",
    "label": "DFG (YUR)"
  },
  {
    "value": "YVD",
    "label": "YEVA (YVD)"
  },
  {
    "value": "YVG",
    "label": "SAD (YVG)"
  },
  {
    "value": "YVK",
    "label": "ASD (YVK)"
  },
  {
    "value": "YWC",
    "label": "SAD (YWC)"
  },
  {
    "value": "YWF",
    "label": "HALIFAX (YWF)"
  },
  {
    "value": "YYO",
    "label": "SDF (YYO)"
  },
  {
    "value": "YZA",
    "label": "ASHCROFT (YZA)"
  },
  {
    "value": "ZAK",
    "label": "CHIUSA (ZAK)"
  },
  {
    "value": "ZBN",
    "label": "BOZEN (ZBN)"
  },
  {
    "value": "ZBV",
    "label": "BEAVER CREEK (ZBV)"
  },
  {
    "value": "ZEL",
    "label": "BELLA BELLA (ZEL)"
  },
  {
    "value": "ZEY",
    "label": "DF (ZEY)"
  },
  {
    "value": "ZHO",
    "label": "HOPEDALE (ZHO)"
  },
  {
    "value": "ZHR",
    "label": "SDF (ZHR)"
  },
  {
    "value": "ZNC",
    "label": "NYAC (ZNC)"
  },
  {
    "value": "ZNH",
    "label": "SDF (ZNH)"
  },
  {
    "value": "ZNU",
    "label": "NAMU (ZNU)"
  },
  {
    "value": "ZOF",
    "label": "OCEAN FALLS (ZOF)"
  },
  {
    "value": "ZQF",
    "label": "DFG (ZQF)"
  },
  {
    "value": "ZQS",
    "label": "QEEN CHARLOTTE (ZQS)"
  },
  {
    "value": "ZRA",
    "label": "ATLANTIC CITY (ZRA)"
  },
  {
    "value": "ZST",
    "label": "STEWART (ZST)"
  },
  {
    "value": "QYG",
    "label": "? (QYG)"
  },
  {
    "value": "HUD",
    "label": "HUDERABAD (HUD)"
  },
  {
    "value": "KLT",
    "label": "KAISERSLAUTERN (KLT)"
  },
  {
    "value": "PJD",
    "label": "? (PJD)"
  },
  {
    "value": "SAC",
    "label": "SACRAMENTO (SAC)"
  },
  {
    "value": "WBN",
    "label": "WBN (WBN)"
  },
  {
    "value": "FUZ",
    "label": "FUZHOU (FUZ)"
  },
  {
    "value": "NTU",
    "label": "NAS OCEANA (NTU)"
  },
  {
    "value": "VBH",
    "label": "BIENHOA (VBH)"
  },
  {
    "value": "LID",
    "label": "LEIDEN (LID)"
  },
  {
    "value": "MPK",
    "label": "SELUL (MPK)"
  },
  {
    "value": "KAI",
    "label": "KAI (KAI)"
  },
  {
    "value": "DLS",
    "label": "DALLES (DLS)"
  },
  {
    "value": "CHZ",
    "label": "CHILOQUIN (CHZ)"
  },
  {
    "value": "QAH",
    "label": "HAI PHONG (QAH)"
  },
  {
    "value": "TMK",
    "label": "Tinh Quang Ngai  (TMK)"
  },
  {
    "value": "CRS",
    "label": "TEXAS (CRS)"
  },
  {
    "value": "JTI",
    "label": "JATAI (JTI)"
  },
  {
    "value": "JUA",
    "label": "JUARA (JUA)"
  },
  {
    "value": "LCB",
    "label": "PONTES E LACERDA (LCB)"
  },
  {
    "value": "LOI",
    "label": "LONTRAS (LOI)"
  },
  {
    "value": "MTG",
    "label": "MATO GROSSO (MTG)"
  },
  {
    "value": "NBV",
    "label": "CANA BRAVA (NBV)"
  },
  {
    "value": "OAL",
    "label": "OAL (OAL)"
  },
  {
    "value": "PBX",
    "label": "PORTO ALEGRE DO NORTE (PBX)"
  },
  {
    "value": "PDR",
    "label": "PRESIDENTE DUTRA (PDR)"
  },
  {
    "value": "PIG",
    "label": "PITINGA (PIG)"
  },
  {
    "value": "QOC",
    "label": "OSASCO (QOC)"
  },
  {
    "value": "RRN",
    "label": "SERRA NORTE (RRN)"
  },
  {
    "value": "RSG",
    "label": "SERRA PELADA (RSG)"
  },
  {
    "value": "XXX",
    "label": "XXX (XXX)"
  },
  {
    "value": "SEI",
    "label": "SENHOR DO BONFIM (SEI)"
  },
  {
    "value": "SFV",
    "label": "SANTA FE DO SUL (SFV)"
  },
  {
    "value": "SWM",
    "label": "SUIA-MISSU (SWM)"
  },
  {
    "value": "TSQ",
    "label": "TORRES (TSQ)"
  },
  {
    "value": "XIG",
    "label": "XINGUARA (XIG)"
  },
  {
    "value": "ZMD",
    "label": "SENA MADUREIRA (ZMD)"
  },
  {
    "value": "PGG",
    "label": "PROGRESSO (PGG)"
  },
  {
    "value": "CEL",
    "label": "CAPE ELEUTHERA (CEL)"
  },
  {
    "value": "GTC",
    "label": "GREEN TURTLE (GTC)"
  },
  {
    "value": "HBI",
    "label": "HARBOUR ISLAND (HBI)"
  },
  {
    "value": "MSK",
    "label": "MASTIC POINT (MSK)"
  },
  {
    "value": "PPO",
    "label": "POWELL POINT (PPO)"
  },
  {
    "value": "SWL",
    "label": "SPANISH WELLS (SWL)"
  },
  {
    "value": "TBI",
    "label": "THE BIGHT (TBI)"
  },
  {
    "value": "WZY",
    "label": "PARADISE I-NASSAU (WZY)"
  },
  {
    "value": "LOQ",
    "label": "LOBATSE (LOQ)"
  },
  {
    "value": "SVT",
    "label": "SAVUTI (SVT)"
  },
  {
    "value": "MZE",
    "label": "MANATEE (MZE)"
  },
  {
    "value": "CJH",
    "label": "CHILKO LAKE BC (CJH)"
  },
  {
    "value": "GOW",
    "label": "GARROW LAKE (GOW)"
  },
  {
    "value": "IUM",
    "label": "SUMMIT LAKE (IUM)"
  },
  {
    "value": "KES",
    "label": "KELSEY (KES)"
  },
  {
    "value": "KNV",
    "label": "KNIGHTS INLET (KNV)"
  },
  {
    "value": "KNY",
    "label": "KINOOSAO (KNY)"
  },
  {
    "value": "LRQ",
    "label": "LAURIE RIVER (LRQ)"
  },
  {
    "value": "NWP",
    "label": "ARGENTIA (NWP)"
  },
  {
    "value": "SYF",
    "label": "SILVA BAY (SYF)"
  },
  {
    "value": "TIL",
    "label": "INVERLAKE (TIL)"
  },
  {
    "value": "TNS",
    "label": "TUNGSTEN (TNS)"
  },
  {
    "value": "TUX",
    "label": "TUMBLER RIDGE (TUX)"
  },
  {
    "value": "WPC",
    "label": "PINCHER CREEK (WPC)"
  },
  {
    "value": "WPL",
    "label": "POWELL LAKE (WPL)"
  },
  {
    "value": "XBB",
    "label": "BLUBBER BAY (XBB)"
  },
  {
    "value": "XBR",
    "label": "BROCKVILLE (XBR)"
  },
  {
    "value": "XBW",
    "label": "KILLINEQ (XBW)"
  },
  {
    "value": "XCL",
    "label": "CLUFF LAKE (XCL)"
  },
  {
    "value": "XGL",
    "label": "GRANVILLE LAKE (XGL)"
  },
  {
    "value": "XKO",
    "label": "KEMANO (XKO)"
  },
  {
    "value": "XLF",
    "label": "LEAF BAY (XLF)"
  },
  {
    "value": "XMP",
    "label": "MACMILLAN PASS (XMP)"
  },
  {
    "value": "XPP",
    "label": "POPLAR RIVER (XPP)"
  },
  {
    "value": "YAD",
    "label": "MOOSE LAKE (YAD)"
  },
  {
    "value": "YAF",
    "label": "ASBESTOS HILL (YAF)"
  },
  {
    "value": "YAJ",
    "label": "LYALL HARBOUR (YAJ)"
  },
  {
    "value": "YAQ",
    "label": "MAPLE BAY (YAQ)"
  },
  {
    "value": "YAR",
    "label": "LAGRANDE 3 (YAR)"
  },
  {
    "value": "YBD",
    "label": "NEW WESTMINISTER (YBD)"
  },
  {
    "value": "YBO",
    "label": "BOBQUINN LAKE (YBO)"
  },
  {
    "value": "YBQ",
    "label": "TELEGRAPH HARBOUR (YBQ)"
  },
  {
    "value": "YCA",
    "label": "COURTENAY (YCA)"
  },
  {
    "value": "YCI",
    "label": "CARIBOU ISLAND (YCI)"
  },
  {
    "value": "YCP",
    "label": "CO-OP POINT (YCP)"
  },
  {
    "value": "YCT",
    "label": "CORNATION (YCT)"
  },
  {
    "value": "YCW",
    "label": "CHILLIWACK (YCW)"
  },
  {
    "value": "YDC",
    "label": "DRAYTON VALLEY (YDC)"
  },
  {
    "value": "YDK",
    "label": "MAIN DUCK ISLAND (YDK)"
  },
  {
    "value": "EPK",
    "label": "EPISKOPI (EPK)"
  },
  {
    "value": "ZDN",
    "label": "BUS STN-BRNO (ZDN)"
  },
  {
    "value": "CSO",
    "label": "COCHSTEDT (CSO)"
  },
  {
    "value": "EIB",
    "label": "EISENACH (EIB)"
  },
  {
    "value": "GHF",
    "label": "GIEBELSTADT (GHF)"
  },
  {
    "value": "GMY",
    "label": "RHEINDAHLEN (GMY)"
  },
  {
    "value": "PEF",
    "label": "PEENEMUENDE (PEF)"
  },
  {
    "value": "PHM",
    "label": "BOEBLINGEN (PHM)"
  },
  {
    "value": "QKU",
    "label": "RR-COLOGNE/DEUTZ (QKU)"
  },
  {
    "value": "SEX",
    "label": "SEMBACH (SEX)"
  },
  {
    "value": "UPF",
    "label": "PFORHEIM (UPF)"
  },
  {
    "value": "WID",
    "label": "WILDENRATH (WID)"
  },
  {
    "value": "ZAQ",
    "label": "MAIN RR-NUREMBERG HBF/FED.REP.GER. (ZAQ)"
  },
  {
    "value": "ZRO",
    "label": "MAIN RR-ROSTOCK (ZRO)"
  },
  {
    "value": "QFH",
    "label": "FREDERIKSHAVN (QFH)"
  },
  {
    "value": "QHJ",
    "label": "HJOERRING (QHJ)"
  },
  {
    "value": "VEJ",
    "label": "VEJLE (VEJ)"
  },
  {
    "value": "ZAW",
    "label": "NYKOBING MORS (ZAW)"
  },
  {
    "value": "ZBJ",
    "label": "SKIVE (ZBJ)"
  },
  {
    "value": "ZBQ",
    "label": "RANDERS (ZBQ)"
  },
  {
    "value": "ZBU",
    "label": "MALLING (ZBU)"
  },
  {
    "value": "SJM",
    "label": "SAN JUAN DE LA M. (SJM)"
  },
  {
    "value": "KDF",
    "label": "KOUBA (KDF)"
  },
  {
    "value": "SKI",
    "label": "SKIKDA (SKI)"
  },
  {
    "value": "SQK",
    "label": "SIDI BARANI (SQK)"
  },
  {
    "value": "YWN",
    "label": "WINISK (YWN)"
  },
  {
    "value": "YWR",
    "label": "WHITE RIVER (YWR)"
  },
  {
    "value": "YXF",
    "label": "SNAKE RIVER (YXF)"
  },
  {
    "value": "YYI",
    "label": "RIVERS (YYI)"
  },
  {
    "value": "YYM",
    "label": "COWLEY (YYM)"
  },
  {
    "value": "YZC",
    "label": "BEATTON RIVER (YZC)"
  },
  {
    "value": "YZL",
    "label": "LIARD RIVER (YZL)"
  },
  {
    "value": "YZM",
    "label": "BUCHANS (YZM)"
  },
  {
    "value": "ZAA",
    "label": "ALICE ARM/KITSAULT (ZAA)"
  },
  {
    "value": "ZFB",
    "label": "OLD FORT BAY (ZFB)"
  },
  {
    "value": "ZFL",
    "label": "SOUTH TROUT LAKE (ZFL)"
  },
  {
    "value": "ZHP",
    "label": "HIGH PRAIRIE (ZHP)"
  },
  {
    "value": "ZPO",
    "label": "PINE HOUSE (ZPO)"
  },
  {
    "value": "ZRR",
    "label": "ARCTIC RED RIVER (ZRR)"
  },
  {
    "value": "ZSP",
    "label": "ST. PAUL (ZSP)"
  },
  {
    "value": "ZTS",
    "label": "TAHSIS (ZTS)"
  },
  {
    "value": "GDA",
    "label": "GOUNDA (GDA)"
  },
  {
    "value": "KOL",
    "label": "KOUMALA (KOL)"
  },
  {
    "value": "KWD",
    "label": "KAWADJIA (KWD)"
  },
  {
    "value": "EPN",
    "label": "EPENA (EPN)"
  },
  {
    "value": "LKC",
    "label": "LEKANA (LKC)"
  },
  {
    "value": "ACO",
    "label": "ASCONA (ACO)"
  },
  {
    "value": "ABO",
    "label": "ABOISSO (ABO)"
  },
  {
    "value": "BGG",
    "label": "BONGOUANOU (BGG)"
  },
  {
    "value": "BRZ",
    "label": "BOROTOU (BRZ)"
  },
  {
    "value": "BUU",
    "label": "BUYO (BUU)"
  },
  {
    "value": "DIV",
    "label": "DIVO (DIV)"
  },
  {
    "value": "DNC",
    "label": "DANANE (DNC)"
  },
  {
    "value": "KTC",
    "label": "KATIOLA (KTC)"
  },
  {
    "value": "LKT",
    "label": "LAKOTA (LKT)"
  },
  {
    "value": "EKA",
    "label": "MURRAY-EUREKA/ARCAPA (EKA)"
  },
  {
    "value": "HAB",
    "label": "XXX (HAB)"
  },
  {
    "value": "MOK",
    "label": "MANKONO (MOK)"
  },
  {
    "value": "TBX",
    "label": "TAABO (TBX)"
  },
  {
    "value": "TGX",
    "label": "TINGRELA (TGX)"
  },
  {
    "value": "XMB",
    "label": "M''BAHIAKRO (XMB)"
  },
  {
    "value": "ZUE",
    "label": "ZUENOULA (ZUE)"
  },
  {
    "value": "COW",
    "label": "COQUIMBO (COW)"
  },
  {
    "value": "ULC",
    "label": "LOS CERRILLOS-SANTIAGO (ULC)"
  },
  {
    "value": "VCC",
    "label": "LIMBE (VCC)"
  },
  {
    "value": "CHW",
    "label": "JIUQUAN (CHW)"
  },
  {
    "value": "DZU",
    "label": "DAZU (DZU)"
  },
  {
    "value": "GHN",
    "label": "GUANGHAN (GHN)"
  },
  {
    "value": "HSC",
    "label": "SHAOGUAN (HSC)"
  },
  {
    "value": "KNC",
    "label": "JI''AN (KNC)"
  },
  {
    "value": "LUZ",
    "label": "LUSHAN (LUZ)"
  },
  {
    "value": "LXI",
    "label": "LINXI (LXI)"
  },
  {
    "value": "SHF",
    "label": "SHANHAIGUAN (SHF)"
  },
  {
    "value": "SZO",
    "label": "SHANZHOU (SZO)"
  },
  {
    "value": "XNT",
    "label": "SINGTAI (XNT)"
  },
  {
    "value": "YLN",
    "label": "YILAN (YLN)"
  },
  {
    "value": "CSR",
    "label": "CASUARITO (CSR)"
  },
  {
    "value": "CUI",
    "label": "CURRILLO (CUI)"
  },
  {
    "value": "DZI",
    "label": "CODAZZI (DZI)"
  },
  {
    "value": "EUO",
    "label": "PARATEBUENO (EUO)"
  },
  {
    "value": "GAA",
    "label": "GUAMAL (GAA)"
  },
  {
    "value": "GGL",
    "label": "GILGAL (GGL)"
  },
  {
    "value": "GMC",
    "label": "GUERIMA (GMC)"
  },
  {
    "value": "GRA",
    "label": "GAMARRA (GRA)"
  },
  {
    "value": "HRR",
    "label": "HERRERA (HRR)"
  },
  {
    "value": "ISD",
    "label": "ISCUANDE (ISD)"
  },
  {
    "value": "IVO",
    "label": "CHIVOLO (IVO)"
  },
  {
    "value": "JUO",
    "label": "JURADO (JUO)"
  },
  {
    "value": "LAT",
    "label": "LA URIBE (LAT)"
  },
  {
    "value": "LGT",
    "label": "LAS GAVIOTAS (LGT)"
  },
  {
    "value": "LRI",
    "label": "LORICA (LRI)"
  },
  {
    "value": "MFB",
    "label": "MONFORT (MFB)"
  },
  {
    "value": "MHF",
    "label": "MORICHAL (MHF)"
  },
  {
    "value": "MIX",
    "label": "MIRITI (MIX)"
  },
  {
    "value": "MND",
    "label": "MEDINA (MND)"
  },
  {
    "value": "MOY",
    "label": "MONTERREY (MOY)"
  },
  {
    "value": "MQR",
    "label": "MOSQUERA (MQR)"
  },
  {
    "value": "NPU",
    "label": "SAN PEDRO URABA (NPU)"
  },
  {
    "value": "NUH",
    "label": "NUNCHIA (NUH)"
  },
  {
    "value": "PAL",
    "label": "PALANQUERO (PAL)"
  },
  {
    "value": "PLA",
    "label": "PLANADAS (PLA)"
  },
  {
    "value": "PLC",
    "label": "PLANETA RICA (PLC)"
  },
  {
    "value": "PYA",
    "label": "PUERTO BOYACA (PYA)"
  },
  {
    "value": "PYN",
    "label": "PAYAN (PYN)"
  },
  {
    "value": "SCA",
    "label": "SANTA CATALINA (SCA)"
  },
  {
    "value": "SJH",
    "label": "SAN JUAN DEL CESAR (SJH)"
  },
  {
    "value": "SJR",
    "label": "SAN JUAN DE URABA (SJR)"
  },
  {
    "value": "SMC",
    "label": "SANTA MARIA (SMC)"
  },
  {
    "value": "SOH",
    "label": "SOLITA (SOH)"
  },
  {
    "value": "SQE",
    "label": "SAN LUIS DE PALENQUE (SQE)"
  },
  {
    "value": "SQF",
    "label": "SOLANO (SQF)"
  },
  {
    "value": "SRO",
    "label": "SANTANA RAMOS (SRO)"
  },
  {
    "value": "SRS",
    "label": "SAN MARCOS (SRS)"
  },
  {
    "value": "TBD",
    "label": "TIMBIQUI (TBD)"
  },
  {
    "value": "TIB",
    "label": "TIBU (TIB)"
  },
  {
    "value": "ULS",
    "label": "MULATOS (ULS)"
  },
  {
    "value": "UNC",
    "label": "UNGUIA (UNC)"
  },
  {
    "value": "URI",
    "label": "URIBE (URI)"
  },
  {
    "value": "VAB",
    "label": "YAVARATE (VAB)"
  },
  {
    "value": "JAP",
    "label": "PUNTA RENES (JAP)"
  },
  {
    "value": "LCS",
    "label": "LAS CANAS (LCS)"
  },
  {
    "value": "SZC",
    "label": "SANTA CRUZ (SZC)"
  },
  {
    "value": "UPA",
    "label": "PUNTA ALEGRE (UPA)"
  },
  {
    "value": "SPO",
    "label": "SAN PABLO (SPO)"
  },
  {
    "value": "UPC",
    "label": "PUERTO LA CRUZ (UPC)"
  },
  {
    "value": "UTL",
    "label": "TORREMOLINOS (UTL)"
  },
  {
    "value": "ALK",
    "label": "ASELA (ALK)"
  },
  {
    "value": "BCY",
    "label": "BULCHI (BCY)"
  },
  {
    "value": "EGL",
    "label": "NEGHELLI (EGL)"
  },
  {
    "value": "ETE",
    "label": "GENDA WUHA (ETE)"
  },
  {
    "value": "GHD",
    "label": "GHIMBI (GHD)"
  },
  {
    "value": "JIJ",
    "label": "JIJIGA (JIJ)"
  },
  {
    "value": "MHJ",
    "label": "MISRAK GASHAMO (MHJ)"
  },
  {
    "value": "MUJ",
    "label": "MUI (MUJ)"
  },
  {
    "value": "MYS",
    "label": "MOYALE (MYS)"
  },
  {
    "value": "OTA",
    "label": "MOTA (OTA)"
  },
  {
    "value": "SKR",
    "label": "SHAKISO (SKR)"
  },
  {
    "value": "SQJ",
    "label": "SHEHDI (SQJ)"
  },
  {
    "value": "AQS",
    "label": "SAQANI (AQS)"
  },
  {
    "value": "BVF",
    "label": "BUA (BVF)"
  },
  {
    "value": "KVU",
    "label": "KOROLEVU (KVU)"
  },
  {
    "value": "NTA",
    "label": "NATADOLA (NTA)"
  },
  {
    "value": "SIW",
    "label": "SIBISA (SIW)"
  },
  {
    "value": "ZKL",
    "label": "STEENKOOL (ZKL)"
  },
  {
    "value": "GHK",
    "label": "GUSH KATIF (GHK)"
  },
  {
    "value": "DAI",
    "label": "DARJEELING (DAI)"
  },
  {
    "value": "DEP",
    "label": "DEPARIZO (DEP)"
  },
  {
    "value": "MOH",
    "label": "MOHANBARI (MOH)"
  },
  {
    "value": "MZA",
    "label": "MUZAFFARNAGAR (MZA)"
  },
  {
    "value": "PUT",
    "label": "PUTTAPARTHI (PUT)"
  },
  {
    "value": "TCR",
    "label": "TUTICORIN (TCR)"
  },
  {
    "value": "IAQ",
    "label": "BAHREGAN (IAQ)"
  },
  {
    "value": "AVF",
    "label": "AVORIAZ (AVF)"
  },
  {
    "value": "DXA",
    "label": "DEUX ALPES (DXA)"
  },
  {
    "value": "JEV",
    "label": "EVRY (JEV)"
  },
  {
    "value": "JLP",
    "label": "JUAN LES PINS (JLP)"
  },
  {
    "value": "JPU",
    "label": "LA DEFENSE HELIPORT-PARIS (JPU)"
  },
  {
    "value": "PLG",
    "label": "LA PLAGNE (PLG)"
  },
  {
    "value": "SEC",
    "label": "SERRE CHEVALIER (SEC)"
  },
  {
    "value": "TGF",
    "label": "TIGNES (TGF)"
  },
  {
    "value": "VAZ",
    "label": "VAL D''ISERE (VAZ)"
  },
  {
    "value": "BAW",
    "label": "BIAWONQUE (BAW)"
  },
  {
    "value": "BGP",
    "label": "BONGO (BGP)"
  },
  {
    "value": "GIM",
    "label": "MIELE MIMBALE (GIM)"
  },
  {
    "value": "GKO",
    "label": "KONGOBOUMBA (GKO)"
  },
  {
    "value": "IGE",
    "label": "IGUELA (IGE)"
  },
  {
    "value": "KMD",
    "label": "MANDJI (KMD)"
  },
  {
    "value": "LEO",
    "label": "LECONI (LEO)"
  },
  {
    "value": "MDV",
    "label": "MEDOUNEU (MDV)"
  },
  {
    "value": "MGO",
    "label": "MANEGA (MGO)"
  },
  {
    "value": "MVG",
    "label": "MEVANG (MVG)"
  },
  {
    "value": "NKA",
    "label": "NKAN (NKA)"
  },
  {
    "value": "OUU",
    "label": "OUANGA (OUU)"
  },
  {
    "value": "OWE",
    "label": "OWENDO (OWE)"
  },
  {
    "value": "WGY",
    "label": "WAGNY (WGY)"
  },
  {
    "value": "WNE",
    "label": "WORA NA YE (WNE)"
  },
  {
    "value": "BRF",
    "label": "BRADFORD (BRF)"
  },
  {
    "value": "BSH",
    "label": "BRIGHTON (BSH)"
  },
  {
    "value": "BUT",
    "label": "BURTONWOOD (BUT)"
  },
  {
    "value": "BWY",
    "label": "WOODBRIDGE (BWY)"
  },
  {
    "value": "CRN",
    "label": "CROMARTY (CRN)"
  },
  {
    "value": "DCS",
    "label": "DONCASTER (DCS)"
  },
  {
    "value": "FWM",
    "label": "FORT WILLIAM (FWM)"
  },
  {
    "value": "GSY",
    "label": "GRIMSBY (GSY)"
  },
  {
    "value": "HEN",
    "label": "HENDON (HEN)"
  },
  {
    "value": "HOY",
    "label": "HOY ISLAND (HOY)"
  },
  {
    "value": "HTF",
    "label": "HATFIELD (HTF)"
  },
  {
    "value": "HYC",
    "label": "HIGH WYCOMBE (HYC)"
  },
  {
    "value": "IPW",
    "label": "IPSWICH (IPW)"
  },
  {
    "value": "KYN",
    "label": "MILTON KEYNES (KYN)"
  },
  {
    "value": "LPH",
    "label": "LOCHGILPHEAD (LPH)"
  },
  {
    "value": "OHP",
    "label": "HLPT-OBAN (OHP)"
  },
  {
    "value": "PME",
    "label": "PORTSMOUTH (PME)"
  },
  {
    "value": "RAY",
    "label": "ROTHESAY (RAY)"
  },
  {
    "value": "SWI",
    "label": "SWINDON (SWI)"
  },
  {
    "value": "UPV",
    "label": "UPAVON (UPV)"
  },
  {
    "value": "WEM",
    "label": "WEST MALLING (WEM)"
  },
  {
    "value": "ZGG",
    "label": "GLASGOW (ZGG)"
  },
  {
    "value": "DUN",
    "label": "DUNDAS (DUN)"
  },
  {
    "value": "JRK",
    "label": "ARSUK (JRK)"
  },
  {
    "value": "HTB",
    "label": "TERRE-DE-BAS (HTB)"
  },
  {
    "value": "DRM",
    "label": "DRAMA (DRM)"
  },
  {
    "value": "EKE",
    "label": "EKEREKU (EKE)"
  },
  {
    "value": "KKG",
    "label": "KONAWARUK (KKG)"
  },
  {
    "value": "KPG",
    "label": "KURUPUNG (KPG)"
  },
  {
    "value": "MWJ",
    "label": "MATTHEWS RIDGE (MWJ)"
  },
  {
    "value": "PIQ",
    "label": "PIPILLIPAI (PIQ)"
  },
  {
    "value": "PKM",
    "label": "PORT KAITUMA (PKM)"
  },
  {
    "value": "PMT",
    "label": "PARAMAKATOI (PMT)"
  },
  {
    "value": "SDC",
    "label": "SANDCREEK (SDC)"
  },
  {
    "value": "SKM",
    "label": "SKELDON (SKM)"
  },
  {
    "value": "VEG",
    "label": "MAIKWAK (VEG)"
  },
  {
    "value": "KTZ",
    "label": "KWUN TONG (KTZ)"
  },
  {
    "value": "CYL",
    "label": "COYOLES (CYL)"
  },
  {
    "value": "EDQ",
    "label": "ERANDIQUE (EDQ)"
  },
  {
    "value": "ENQ",
    "label": "CORONEL ENRIQUE SOTO CANO (ENQ)"
  },
  {
    "value": "GAC",
    "label": "GRACIAS (GAC)"
  },
  {
    "value": "GUO",
    "label": "GUALACO (GUO)"
  },
  {
    "value": "LLH",
    "label": "LAS LIMAS (LLH)"
  },
  {
    "value": "LMH",
    "label": "LIMON (LMH)"
  },
  {
    "value": "LUI",
    "label": "LA UNION (LUI)"
  },
  {
    "value": "MRJ",
    "label": "MARCALA (MRJ)"
  },
  {
    "value": "ORO",
    "label": "YORO (ORO)"
  },
  {
    "value": "SET",
    "label": "SAN ESTEBAN (SET)"
  },
  {
    "value": "TCF",
    "label": "TOCOA (TCF)"
  },
  {
    "value": "PBW",
    "label": "PALIBELO (PBW)"
  },
  {
    "value": "LOM",
    "label": "LAGOS DE MORENO (LOM)"
  },
  {
    "value": "NLU",
    "label": "SANTA LUCIA-MEXICO CITY (NLU)"
  },
  {
    "value": "PJZ",
    "label": "PUERTO JUAREZ (PJZ)"
  },
  {
    "value": "PUH",
    "label": "POCHUTLA (PUH)"
  },
  {
    "value": "SNQ",
    "label": "SAN QUINTIN (SNQ)"
  },
  {
    "value": "TZM",
    "label": "TIZIMIN (TZM)"
  },
  {
    "value": "VIB",
    "label": "VILLA CONSTITUCION (VIB)"
  },
  {
    "value": "QBE",
    "label": "BEGA (QBE)"
  },
  {
    "value": "QBW",
    "label": "BATEMANS BAY (QBW)"
  },
  {
    "value": "QDN",
    "label": "EDEN (QDN)"
  },
  {
    "value": "QLE",
    "label": "LEETON (QLE)"
  },
  {
    "value": "QNA",
    "label": "BUS STN.-BALLINA (QNA)"
  },
  {
    "value": "QPV",
    "label": "PERISHER VALLEY (QPV)"
  },
  {
    "value": "QRX",
    "label": "NAROOMA (QRX)"
  },
  {
    "value": "QTH",
    "label": "THREDBO (QTH)"
  },
  {
    "value": "QYN",
    "label": "BYRON BAY (QYN)"
  },
  {
    "value": "RKY",
    "label": "ROKEBY (RKY)"
  },
  {
    "value": "RLP",
    "label": "ROSELLA PLAINS (RLP)"
  },
  {
    "value": "RPB",
    "label": "ROPER BAR (RPB)"
  },
  {
    "value": "RRV",
    "label": "ROBINSON RIVER (RRV)"
  },
  {
    "value": "SQP",
    "label": "STARCKE (SQP)"
  },
  {
    "value": "SRM",
    "label": "SANDRINGHAM (SRM)"
  },
  {
    "value": "SRR",
    "label": "STRADBROKE ISLAND (SRR)"
  },
  {
    "value": "SSP",
    "label": "SILVER PLAINS (SSP)"
  },
  {
    "value": "STF",
    "label": "STEPHEN ISLAND (STF)"
  },
  {
    "value": "SVM",
    "label": "ST. PAUL''S MISSION (SVM)"
  },
  {
    "value": "TWN",
    "label": "TEWANTIN (TWN)"
  },
  {
    "value": "UTD",
    "label": "NUTWOOD DOWNS (UTD)"
  },
  {
    "value": "WAN",
    "label": "WAVERNEY (WAN)"
  },
  {
    "value": "WAU",
    "label": "WAUCHOPE (WAU)"
  },
  {
    "value": "YDR",
    "label": "BROADVIEW (YDR)"
  },
  {
    "value": "YDS",
    "label": "DESOLATION SOUND (YDS)"
  },
  {
    "value": "YDV",
    "label": "BLOODVEIN (YDV)"
  },
  {
    "value": "YEP",
    "label": "ESTEVAN POINT (YEP)"
  },
  {
    "value": "YGA",
    "label": "GAGNON (YGA)"
  },
  {
    "value": "YGY",
    "label": "DECEPTION (YGY)"
  },
  {
    "value": "YHB",
    "label": "HUDSON BAY (YHB)"
  },
  {
    "value": "YIX",
    "label": "PORT RADIUM (YIX)"
  },
  {
    "value": "YJA",
    "label": "JASPER (YJA)"
  },
  {
    "value": "YKD",
    "label": "KINCARDINE (YKD)"
  },
  {
    "value": "YLA",
    "label": "LANGARA (YLA)"
  },
  {
    "value": "YLF",
    "label": "LAFORGES (YLF)"
  },
  {
    "value": "YLM",
    "label": "CLINTON CREEK (YLM)"
  },
  {
    "value": "YLP",
    "label": "MINGAN (YLP)"
  },
  {
    "value": "YLQ",
    "label": "LA TUQUE (YLQ)"
  },
  {
    "value": "YLY",
    "label": "LYTTON (YLY)"
  },
  {
    "value": "YMB",
    "label": "MERRITT (YMB)"
  },
  {
    "value": "YMC",
    "label": "MARICOURT AIRSTRIP (YMC)"
  },
  {
    "value": "YMF",
    "label": "MONTAGUE HARBOR (YMF)"
  },
  {
    "value": "YMI",
    "label": "MINAKI (YMI)"
  },
  {
    "value": "YMY",
    "label": "DTWN RAIL ST.-MONTREAL (YMY)"
  },
  {
    "value": "YNF",
    "label": "CORNER BROOK (YNF)"
  },
  {
    "value": "YNH",
    "label": "HUDSON HOPE (YNH)"
  },
  {
    "value": "YNI",
    "label": "NITCHEQUON (YNI)"
  },
  {
    "value": "YOE",
    "label": "FALHER (YOE)"
  },
  {
    "value": "YPD",
    "label": "PARRY SOUND (YPD)"
  },
  {
    "value": "YPF",
    "label": "ESQUIMALT (YPF)"
  },
  {
    "value": "YPP",
    "label": "PINE POINT (YPP)"
  },
  {
    "value": "YQE",
    "label": "KIMBERLEY (YQE)"
  },
  {
    "value": "YRE",
    "label": "RESOLUTION ISLAND (YRE)"
  },
  {
    "value": "YRM",
    "label": "ROCKY MOUNTAIN HOUSE (YRM)"
  },
  {
    "value": "YSA",
    "label": "SABLE ISLAND (YSA)"
  },
  {
    "value": "YSI",
    "label": "SANS SOUCI (YSI)"
  },
  {
    "value": "YSV",
    "label": "SAGLEK (YSV)"
  },
  {
    "value": "YSX",
    "label": "SHEARWATER (YSX)"
  },
  {
    "value": "YTG",
    "label": "SULLIVAN BAY (YTG)"
  },
  {
    "value": "YTK",
    "label": "TULUGAK (YTK)"
  },
  {
    "value": "YTN",
    "label": "RIVIERE AU TONNERRE (YTN)"
  },
  {
    "value": "YTT",
    "label": "TISDALE (YTT)"
  },
  {
    "value": "YUJ",
    "label": "LADY FRANKLIN (YUJ)"
  },
  {
    "value": "YVN",
    "label": "CAPE DYER (YVN)"
  },
  {
    "value": "WLL",
    "label": "WOLLOGORANG (WLL)"
  },
  {
    "value": "WOG",
    "label": "WOODGREEN (WOG)"
  },
  {
    "value": "WON",
    "label": "WONDOOLA (WON)"
  },
  {
    "value": "ZBL",
    "label": "BILOELA (ZBL)"
  },
  {
    "value": "KHL",
    "label": "KHULNA (KHL)"
  },
  {
    "value": "RAU",
    "label": "RANGPUR (RAU)"
  },
  {
    "value": "SDW",
    "label": "SANDWIP (SDW)"
  },
  {
    "value": "GNE",
    "label": "GHENT (GNE)"
  },
  {
    "value": "KDG",
    "label": "KARDJALI (KDG)"
  },
  {
    "value": "NWU",
    "label": "NAS-BERMUDA (NWU)"
  },
  {
    "value": "ALT",
    "label": "ALENQUER (ALT)"
  },
  {
    "value": "AUB",
    "label": "ITAUBA (AUB)"
  },
  {
    "value": "CCQ",
    "label": "CACHOEIRA (CCQ)"
  },
  {
    "value": "CMT",
    "label": "CAMETA (CMT)"
  },
  {
    "value": "CSS",
    "label": "CASSILANDIA (CSS)"
  },
  {
    "value": "CSW",
    "label": "COLORADO DO OESTE (CSW)"
  },
  {
    "value": "CZB",
    "label": "CRUZ ALTA (CZB)"
  },
  {
    "value": "ILB",
    "label": "ILHA SOLTEIRA (ILB)"
  },
  {
    "value": "ITE",
    "label": "ITUBERA (ITE)"
  },
  {
    "value": "ITN",
    "label": "ITABUNA (ITN)"
  },
  {
    "value": "BRJ",
    "label": "BRIGHT (BRJ)"
  },
  {
    "value": "CFP",
    "label": "CARPENTARIA DOWNS (CFP)"
  },
  {
    "value": "CIE",
    "label": "COLLIE (CIE)"
  },
  {
    "value": "COY",
    "label": "COOLAWANYAH (COY)"
  },
  {
    "value": "CRH",
    "label": "CHERRIBAH (CRH)"
  },
  {
    "value": "CXQ",
    "label": "CHRISTMAS CREEK (CXQ)"
  },
  {
    "value": "DAJ",
    "label": "DAUAN ISLAND (DAJ)"
  },
  {
    "value": "JCN",
    "label": "INCHEON (JCN)"
  },
  {
    "value": "JGE",
    "label": "GEOJE (JGE)"
  },
  {
    "value": "SUK",
    "label": "SAMCHOK (SUK)"
  },
  {
    "value": "HRC",
    "label": "ZHAIREM (HRC)"
  },
  {
    "value": "SZI",
    "label": "ZAISAN (SZI)"
  },
  {
    "value": "KOG",
    "label": "KHONG (KOG)"
  },
  {
    "value": "PKS",
    "label": "PAKSANE (PKS)"
  },
  {
    "value": "SND",
    "label": "SENO (SND)"
  },
  {
    "value": "UDO",
    "label": "UDOMXAY (UDO)"
  },
  {
    "value": "UON",
    "label": "MUONG SAI (UON)"
  },
  {
    "value": "VGG",
    "label": "VANGRIENG (VGG)"
  },
  {
    "value": "XIE",
    "label": "XIENG LOM (XIE)"
  },
  {
    "value": "ADP",
    "label": "ANURADHAPURA (ADP)"
  },
  {
    "value": "FOY",
    "label": "FOYA (FOY)"
  },
  {
    "value": "GRC",
    "label": "GRAND CESS (GRC)"
  },
  {
    "value": "RVC",
    "label": "RIVERCESS (RVC)"
  },
  {
    "value": "TPT",
    "label": "TAPETA (TPT)"
  },
  {
    "value": "WES",
    "label": "WEASUA (WES)"
  },
  {
    "value": "WOI",
    "label": "WOLOGISSI (WOI)"
  },
  {
    "value": "MSG",
    "label": "MATSAILE (MSG)"
  },
  {
    "value": "RSC",
    "label": "SKULTE-RIGA (RSC)"
  },
  {
    "value": "NFR",
    "label": "NAFOORA (NFR)"
  },
  {
    "value": "QMQ",
    "label": "MURZUQ (QMQ)"
  },
  {
    "value": "TFY",
    "label": "TARFAYA (TFY)"
  },
  {
    "value": "WMV",
    "label": "MADIROVALO (WMV)"
  },
  {
    "value": "AMR",
    "label": "ARNO (AMR)"
  },
  {
    "value": "EBO",
    "label": "EBON (EBO)"
  },
  {
    "value": "NMU",
    "label": "NAMU (NMU)"
  },
  {
    "value": "TBV",
    "label": "TABAL (TBV)"
  },
  {
    "value": "SZU",
    "label": "SEGOU (SZU)"
  },
  {
    "value": "HJT",
    "label": "KHUJIRT (HJT)"
  },
  {
    "value": "KHX",
    "label": "KHUJIRT (KHX)"
  },
  {
    "value": "TSZ",
    "label": "TSETSERLEG (TSZ)"
  },
  {
    "value": "UNR",
    "label": "UNDERKHAAN (UNR)"
  },
  {
    "value": "CGT",
    "label": "CHINGUITTI (CGT)"
  },
  {
    "value": "MBR",
    "label": "MBOUT (MBR)"
  },
  {
    "value": "ZLG",
    "label": "EL GOUERA (ZLG)"
  },
  {
    "value": "LEG",
    "label": "ALEG (LEG)"
  },
  {
    "value": "JCO",
    "label": "COMINO (JCO)"
  },
  {
    "value": "QHZ",
    "label": "HOOFDDORP (QHZ)"
  },
  {
    "value": "UTC",
    "label": "UTRECHT (UTC)"
  },
  {
    "value": "SYG",
    "label": "SVALBARD (SYG)"
  },
  {
    "value": "HRJ",
    "label": "CHAURJHARI (HRJ)"
  },
  {
    "value": "JMO",
    "label": "JOMSOM (JMO)"
  },
  {
    "value": "RPA",
    "label": "ROLPA (RPA)"
  },
  {
    "value": "RPT",
    "label": "MOUNTAIN (RPT)"
  },
  {
    "value": "SYH",
    "label": "SYANGBOCHE (SYH)"
  },
  {
    "value": "QMN",
    "label": "MBABANE (QMN)"
  },
  {
    "value": "SSV",
    "label": "SIASI (SSV)"
  },
  {
    "value": "TGB",
    "label": "TAGBITA (TGB)"
  },
  {
    "value": "XMA",
    "label": "MARAMAG (XMA)"
  },
  {
    "value": "XSO",
    "label": "SIOCON (XSO)"
  },
  {
    "value": "SWV",
    "label": "SHIKARPUR (SWV)"
  },
  {
    "value": "SZY",
    "label": "SZYMANY (SZY)"
  },
  {
    "value": "DVA",
    "label": "DEVA (DVA)"
  },
  {
    "value": "KLF",
    "label": "KALUGA (KLF)"
  },
  {
    "value": "NOI",
    "label": "NOVOROSSIJSK (NOI)"
  },
  {
    "value": "NVR",
    "label": "NOVGOROD (NVR)"
  },
  {
    "value": "GBS",
    "label": "PORT FITZROY (GBS)"
  },
  {
    "value": "KWU",
    "label": "MANSION HOUSE (KWU)"
  },
  {
    "value": "PKL",
    "label": "PAKATOA (PKL)"
  },
  {
    "value": "PZK",
    "label": "PUKA PUKA ISLAND (PZK)"
  },
  {
    "value": "WGN",
    "label": "WAITANGI (WGN)"
  },
  {
    "value": "CDE",
    "label": "CALEDONIA (CDE)"
  },
  {
    "value": "CTE",
    "label": "CARTI (CTE)"
  },
  {
    "value": "CZJ",
    "label": "CORAZON DE JESUS (CZJ)"
  },
  {
    "value": "GHE",
    "label": "GARACHINE (GHE)"
  },
  {
    "value": "MPI",
    "label": "MAMITUPO (MPI)"
  },
  {
    "value": "MPP",
    "label": "MULATUPO (MPP)"
  },
  {
    "value": "NGN",
    "label": "NARGANA (NGN)"
  },
  {
    "value": "PUE",
    "label": "PUERTO OBALDIA (PUE)"
  },
  {
    "value": "PVE",
    "label": "EL PORVENIR (PVE)"
  },
  {
    "value": "PYC",
    "label": "PLAYON CHICO (PYC)"
  },
  {
    "value": "PYV",
    "label": "YAVIZA (PYV)"
  },
  {
    "value": "RIT",
    "label": "RIO TIGRE (RIT)"
  },
  {
    "value": "RIZ",
    "label": "RIO ALZUCAR (RIZ)"
  },
  {
    "value": "RSI",
    "label": "RIO SIDRA (RSI)"
  },
  {
    "value": "SFW",
    "label": "SANTA FE (SFW)"
  },
  {
    "value": "TUE",
    "label": "TUPILE (TUE)"
  },
  {
    "value": "TUW",
    "label": "TUBALA (TUW)"
  },
  {
    "value": "UTU",
    "label": "USTUPO (UTU)"
  },
  {
    "value": "TJN",
    "label": "TAKUME (TJN)"
  },
  {
    "value": "ABW",
    "label": "ABAU (ABW)"
  },
  {
    "value": "AMG",
    "label": "AMBOIN (AMG)"
  },
  {
    "value": "AOA",
    "label": "AROA (AOA)"
  },
  {
    "value": "AON",
    "label": "ARONA (AON)"
  },
  {
    "value": "AWR",
    "label": "AWAR (AWR)"
  },
  {
    "value": "BIJ",
    "label": "BILIAU (BIJ)"
  },
  {
    "value": "BIZ",
    "label": "BIMIN (BIZ)"
  },
  {
    "value": "BNZ",
    "label": "BANZ (BNZ)"
  },
  {
    "value": "BOQ",
    "label": "BOKU (BOQ)"
  },
  {
    "value": "BRP",
    "label": "BIARU (BRP)"
  },
  {
    "value": "BVP",
    "label": "BOLOVIP (BVP)"
  },
  {
    "value": "BXZ",
    "label": "BUNSIL (BXZ)"
  },
  {
    "value": "CGC",
    "label": "CAPE GLOUCESTER (CGC)"
  },
  {
    "value": "DAF",
    "label": "DAUP (DAF)"
  },
  {
    "value": "DLB",
    "label": "DALBERTIS (DLB)"
  },
  {
    "value": "DNU",
    "label": "DINANGAT (DNU)"
  },
  {
    "value": "DOI",
    "label": "DOINI (DOI)"
  },
  {
    "value": "DOO",
    "label": "DOROBISORO (DOO)"
  },
  {
    "value": "DOS",
    "label": "DIOS (DOS)"
  },
  {
    "value": "DPU",
    "label": "DUMPU (DPU)"
  },
  {
    "value": "EGA",
    "label": "ENGATI (EGA)"
  },
  {
    "value": "EMI",
    "label": "EMIRAU (EMI)"
  },
  {
    "value": "EPT",
    "label": "ELIPTAMIN (EPT)"
  },
  {
    "value": "ERU",
    "label": "ERUME (ERU)"
  },
  {
    "value": "FUB",
    "label": "FULLEBORN (FUB)"
  },
  {
    "value": "FUM",
    "label": "FUMA (FUM)"
  },
  {
    "value": "GAR",
    "label": "GARAINA (GAR)"
  },
  {
    "value": "GBF",
    "label": "NEGARBO (GBF)"
  },
  {
    "value": "GEI",
    "label": "GREEN ISLANDS (GEI)"
  },
  {
    "value": "GLP",
    "label": "GULGUBIP (GLP)"
  },
  {
    "value": "GOE",
    "label": "GONALIA (GOE)"
  },
  {
    "value": "GRH",
    "label": "GARUAHI (GRH)"
  },
  {
    "value": "GRL",
    "label": "GARASA (GRL)"
  },
  {
    "value": "GUE",
    "label": "GURIASO (GUE)"
  },
  {
    "value": "GUG",
    "label": "GUARI (GUG)"
  },
  {
    "value": "GWN",
    "label": "GNAROWEIN (GWN)"
  },
  {
    "value": "HIT",
    "label": "HIVARO (HIT)"
  },
  {
    "value": "HNI",
    "label": "HEIWENI (HNI)"
  },
  {
    "value": "HOC",
    "label": "KOMAKO (HOC)"
  },
  {
    "value": "IAU",
    "label": "IAURA (IAU)"
  },
  {
    "value": "IBI",
    "label": "IBOKI (IBI)"
  },
  {
    "value": "ILX",
    "label": "ILEG (ILX)"
  },
  {
    "value": "IMN",
    "label": "IMANE (IMN)"
  },
  {
    "value": "IUS",
    "label": "INUS (IUS)"
  },
  {
    "value": "KAF",
    "label": "KARATO (KAF)"
  },
  {
    "value": "KAK",
    "label": "KAR (KAK)"
  },
  {
    "value": "KDE",
    "label": "KOROBA (KDE)"
  },
  {
    "value": "KDQ",
    "label": "KAMBERATORO (KDQ)"
  },
  {
    "value": "KEG",
    "label": "KEGLSUGL (KEG)"
  },
  {
    "value": "KGM",
    "label": "KUNGUM (KGM)"
  },
  {
    "value": "KIZ",
    "label": "KIKINONDA (KIZ)"
  },
  {
    "value": "KJU",
    "label": "KAMIRABA (KJU)"
  },
  {
    "value": "KNL",
    "label": "KELANOA (KNL)"
  },
  {
    "value": "KOM",
    "label": "KOMO-MANDA (KOM)"
  },
  {
    "value": "KPA",
    "label": "KOPIAGO (KPA)"
  },
  {
    "value": "KPM",
    "label": "KOMPIAM (KPM)"
  },
  {
    "value": "KSB",
    "label": "KASANOMBE (KSB)"
  },
  {
    "value": "KSG",
    "label": "KISENGAN (KSG)"
  },
  {
    "value": "KSP",
    "label": "KOSIPE (KSP)"
  },
  {
    "value": "KSX",
    "label": "YASURU (KSX)"
  },
  {
    "value": "KTK",
    "label": "KANUA (KTK)"
  },
  {
    "value": "KVE",
    "label": "KITAVA (KVE)"
  },
  {
    "value": "KWV",
    "label": "KURWINA (KWV)"
  },
  {
    "value": "KWX",
    "label": "KIWAI ISLAND (KWX)"
  },
  {
    "value": "LGM",
    "label": "LAIAGAM (LGM)"
  },
  {
    "value": "LHP",
    "label": "LEHU (LHP)"
  },
  {
    "value": "LMG",
    "label": "LAMASSA (LMG)"
  },
  {
    "value": "LNF",
    "label": "MUNBIL (LNF)"
  },
  {
    "value": "LNQ",
    "label": "LOANI (LNQ)"
  },
  {
    "value": "LPN",
    "label": "LERON PLAINS (LPN)"
  },
  {
    "value": "LSJ",
    "label": "LONG ISLAND (LSJ)"
  },
  {
    "value": "LTF",
    "label": "LEITRE (LTF)"
  },
  {
    "value": "LWI",
    "label": "LOWAI (LWI)"
  },
  {
    "value": "MBV",
    "label": "MASA (MBV)"
  },
  {
    "value": "MDM",
    "label": "MUNDUKU (MDM)"
  },
  {
    "value": "MFZ",
    "label": "MESELIA (MFZ)"
  },
  {
    "value": "MGG",
    "label": "MARGARIMA (MGG)"
  },
  {
    "value": "MNP",
    "label": "MARON (MNP)"
  },
  {
    "value": "MVI",
    "label": "MANETAI (MVI)"
  },
  {
    "value": "MWG",
    "label": "MARAWAKA (MWG)"
  },
  {
    "value": "MWI",
    "label": "MARAMUNI (MWI)"
  },
  {
    "value": "MZN",
    "label": "MINJ (MZN)"
  },
  {
    "value": "NGR",
    "label": "NINGERUM (NGR)"
  },
  {
    "value": "NMN",
    "label": "NOMANE (NMN)"
  },
  {
    "value": "NPG",
    "label": "NIPA (NPG)"
  },
  {
    "value": "NUT",
    "label": "NUTUVE (NUT)"
  },
  {
    "value": "OML",
    "label": "OMKALAI (OML)"
  },
  {
    "value": "OTY",
    "label": "ORIA (OTY)"
  },
  {
    "value": "PGB",
    "label": "PANGOA (PGB)"
  },
  {
    "value": "PGN",
    "label": "PANGIA (PGN)"
  },
  {
    "value": "PPX",
    "label": "PARAM (PPX)"
  },
  {
    "value": "PUI",
    "label": "PURENI (PUI)"
  },
  {
    "value": "QBO",
    "label": "PX CITY TWO (QBO)"
  },
  {
    "value": "QSM",
    "label": "PX CITY THREE (QSM)"
  },
  {
    "value": "RAA",
    "label": "RAKANDA (RAA)"
  },
  {
    "value": "RTK",
    "label": "TOKUA (RTK)"
  },
  {
    "value": "SBC",
    "label": "SELBANG (SBC)"
  },
  {
    "value": "SBV",
    "label": "SABAH (SBV)"
  },
  {
    "value": "SGB",
    "label": "SINGAUA (SGB)"
  },
  {
    "value": "SGJ",
    "label": "SAGARAI (SGJ)"
  },
  {
    "value": "SGK",
    "label": "SANGAPI (SGK)"
  },
  {
    "value": "SMJ",
    "label": "SIM (SMJ)"
  },
  {
    "value": "SPH",
    "label": "SOPU (SPH)"
  },
  {
    "value": "SPV",
    "label": "SEPIK PLAINS (SPV)"
  },
  {
    "value": "SWR",
    "label": "SILUR (SWR)"
  },
  {
    "value": "SXA",
    "label": "SIALUM (SXA)"
  },
  {
    "value": "SXW",
    "label": "SAUREN (SXW)"
  },
  {
    "value": "TBA",
    "label": "TABIBUGA (TBA)"
  },
  {
    "value": "TCJ",
    "label": "TOREMBI AIRPORT (TCJ)"
  },
  {
    "value": "TCK",
    "label": "TINBOLI AIRPORT (TCK)"
  },
  {
    "value": "TFA",
    "label": "TILFALMIN (TFA)"
  },
  {
    "value": "TIG",
    "label": "TINGWON (TIG)"
  },
  {
    "value": "TKB",
    "label": "TEKADU (TKB)"
  },
  {
    "value": "TLW",
    "label": "TALASEA (TLW)"
  },
  {
    "value": "TRJ",
    "label": "TARAKBITS (TRJ)"
  },
  {
    "value": "TSI",
    "label": "TSILI TSILI (TSI)"
  },
  {
    "value": "TSK",
    "label": "TASKUL (TSK)"
  },
  {
    "value": "TSW",
    "label": "TSEWI (TSW)"
  },
  {
    "value": "TUT",
    "label": "TAUTA (TUT)"
  },
  {
    "value": "TWY",
    "label": "TAWA (TWY)"
  },
  {
    "value": "UMC",
    "label": "UMBA (UMC)"
  },
  {
    "value": "UPR",
    "label": "UPIARA (UPR)"
  },
  {
    "value": "URU",
    "label": "UROUBI (URU)"
  },
  {
    "value": "USO",
    "label": "USINO (USO)"
  },
  {
    "value": "WAB",
    "label": "WABAG (WAB)"
  },
  {
    "value": "WAJ",
    "label": "WAWOI FALLS (WAJ)"
  },
  {
    "value": "WBC",
    "label": "WAPOLU (WBC)"
  },
  {
    "value": "WEP",
    "label": "WEAM (WEP)"
  },
  {
    "value": "WGU",
    "label": "WAGAU (WGU)"
  },
  {
    "value": "WNU",
    "label": "WANUMA (WNU)"
  },
  {
    "value": "WUM",
    "label": "WASUM (WUM)"
  },
  {
    "value": "XYR",
    "label": "YELLOW RIVER (XYR)"
  },
  {
    "value": "BNQ",
    "label": "BAGANGA (BNQ)"
  },
  {
    "value": "CUJ",
    "label": "CULION (CUJ)"
  },
  {
    "value": "ICO",
    "label": "SICOGON ISLAND (ICO)"
  },
  {
    "value": "LWA",
    "label": "LWBAK (LWA)"
  },
  {
    "value": "NCP",
    "label": "LUZON IS (NCP)"
  },
  {
    "value": "ARX",
    "label": "ASBURY PK/MONMOUTH CO (ARX)"
  },
  {
    "value": "ASY",
    "label": "ASHLEY (ASY)"
  },
  {
    "value": "ATU",
    "label": "ATTU IS. (ATU)"
  },
  {
    "value": "AUO",
    "label": "AUBURN/OPELIKA (AUO)"
  },
  {
    "value": "AYE",
    "label": "FORT DEVENS (AYE)"
  },
  {
    "value": "AYZ",
    "label": "AMITYVILLE (AYZ)"
  },
  {
    "value": "BAM",
    "label": "BATTLE MOUNTAIN (BAM)"
  },
  {
    "value": "BCJ",
    "label": "BACA GRANDE (BCJ)"
  },
  {
    "value": "BDG",
    "label": "BLANDING (BDG)"
  },
  {
    "value": "BFB",
    "label": "BLUE FOX BAY (BFB)"
  },
  {
    "value": "BJJ",
    "label": "WOOSTER (BJJ)"
  },
  {
    "value": "BKF",
    "label": "BROOKS LAKE (BKF)"
  },
  {
    "value": "BLW",
    "label": "WAIMANALO (BLW)"
  },
  {
    "value": "BNH",
    "label": "HARTFORD (BNH)"
  },
  {
    "value": "BPA",
    "label": "BETHPAGE (BPA)"
  },
  {
    "value": "BRG",
    "label": "WHITESBURG (BRG)"
  },
  {
    "value": "BTP",
    "label": "BUTLER (BTP)"
  },
  {
    "value": "BVD",
    "label": "BEAVER INLET (BVD)"
  },
  {
    "value": "BWS",
    "label": "BLAINE (BWS)"
  },
  {
    "value": "BYG",
    "label": "BUFFALO (BYG)"
  },
  {
    "value": "BYH",
    "label": "BLYTHEVILLE (BYH)"
  },
  {
    "value": "BYI",
    "label": "BURLEY (BYI)"
  },
  {
    "value": "BZT",
    "label": "BRAZORIA (BZT)"
  },
  {
    "value": "CBA",
    "label": "CORNER BAY (CBA)"
  },
  {
    "value": "PVX",
    "label": "PROVEDENIA (PVX)"
  },
  {
    "value": "RAT",
    "label": "RADUZHNYI (RAT)"
  },
  {
    "value": "SWT",
    "label": "STRZHEWOI (SWT)"
  },
  {
    "value": "TYA",
    "label": "TULA (TYA)"
  },
  {
    "value": "ZKD",
    "label": "LENINGRADSKIY STN-MOSCOW (ZKD)"
  },
  {
    "value": "ZLK",
    "label": "MOSCOVSKIY STN-ST.PETERSBURG (ZLK)"
  },
  {
    "value": "MJH",
    "label": "MAJMA (MJH)"
  },
  {
    "value": "UZH",
    "label": "UNAYZAH (UZH)"
  },
  {
    "value": "KUE",
    "label": "KUKUNDU (KUE)"
  },
  {
    "value": "KWR",
    "label": "KWAI HARBOUR (KWR)"
  },
  {
    "value": "KWS",
    "label": "KWAILABESI (KWS)"
  },
  {
    "value": "ONE",
    "label": "ONEPUSU (ONE)"
  },
  {
    "value": "RRI",
    "label": "BARORA (RRI)"
  },
  {
    "value": "SVY",
    "label": "SAVO (SVY)"
  },
  {
    "value": "DNI",
    "label": "WAD MEDANI (DNI)"
  },
  {
    "value": "ZRG",
    "label": "BRATISLAVA-BUS STATION (ZRG)"
  },
  {
    "value": "JMY",
    "label": "MAMMY YOKO-FREETOWN (JMY)"
  },
  {
    "value": "SRK",
    "label": "SIERRA LEONE (SRK)"
  },
  {
    "value": "SA-",
    "label": "SAN MARINO (SA-)"
  },
  {
    "value": "NIK",
    "label": "NIOKOLO KOBA (NIK)"
  },
  {
    "value": "GBM",
    "label": "GARBAHAREY (GBM)"
  },
  {
    "value": "LGX",
    "label": "LUGH GANANE (LGX)"
  },
  {
    "value": "LKR",
    "label": "LAS KOREI (LKR)"
  },
  {
    "value": "MOJ",
    "label": "MOENGO (MOJ)"
  },
  {
    "value": "PGP",
    "label": "PORTO ALEGRE (PGP)"
  },
  {
    "value": "SOR",
    "label": "AL THAURAH (SOR)"
  },
  {
    "value": "AOD",
    "label": "ABOU DEIA (AOD)"
  },
  {
    "value": "MEF",
    "label": "MELFI (MEF)"
  },
  {
    "value": "OUM",
    "label": "OUM HADJER (OUM)"
  },
  {
    "value": "PBS",
    "label": "PATONG BEACH (PBS)"
  },
  {
    "value": "PHZ",
    "label": "PHI PHI ISLAND (PHZ)"
  },
  {
    "value": "PMM",
    "label": "PHANOM SARAKHAM (PMM)"
  },
  {
    "value": "HSZ",
    "label": "HSINCHU (HSZ)"
  },
  {
    "value": "LHN",
    "label": "LISHAN (LHN)"
  },
  {
    "value": "SMT",
    "label": "SUN MOON LAKE (SMT)"
  },
  {
    "value": "CEJ",
    "label": "CHERNIGOV (CEJ)"
  },
  {
    "value": "KCP",
    "label": "KAMENETS-PODOLSKIY (KCP)"
  },
  {
    "value": "KHU",
    "label": "KREMENCHUG (KHU)"
  },
  {
    "value": "MXR",
    "label": "MIRGOROD (MXR)"
  },
  {
    "value": "KLA",
    "label": "KAMPALA (KLA)"
  },
  {
    "value": "AED",
    "label": "ALENEVA (AED)"
  },
  {
    "value": "AIB",
    "label": "ANITA BAY (AIB)"
  },
  {
    "value": "ANA",
    "label": "ANAHEIM (ANA)"
  },
  {
    "value": "CEU",
    "label": "CLEMSON (CEU)"
  },
  {
    "value": "CEV",
    "label": "CONNERSVILLE (CEV)"
  },
  {
    "value": "CEW",
    "label": "CRESTVIEW (CEW)"
  },
  {
    "value": "CEX",
    "label": "CHENA HOT SPGS. (CEX)"
  },
  {
    "value": "CFA",
    "label": "COFFEE POINT (CFA)"
  },
  {
    "value": "CFD",
    "label": "BRYAN (CFD)"
  },
  {
    "value": "CFT",
    "label": "CLIFTON (CFT)"
  },
  {
    "value": "CFV",
    "label": "COFFEYVILLE (CFV)"
  },
  {
    "value": "CGE",
    "label": "CAMBRIDGE (CGE)"
  },
  {
    "value": "CGS",
    "label": "COLLEGE PARK (CGS)"
  },
  {
    "value": "CGZ",
    "label": "CASA GRANDE (CGZ)"
  },
  {
    "value": "CHK",
    "label": "CHICKASHA (CHK)"
  },
  {
    "value": "CHL",
    "label": "CHALLIS (CHL)"
  },
  {
    "value": "CIG",
    "label": "CRAIG (CIG)"
  },
  {
    "value": "CIR",
    "label": "CAIRO (CIR)"
  },
  {
    "value": "CIV",
    "label": "CHOMLEY (CIV)"
  },
  {
    "value": "CJN",
    "label": "EL CAJON (CJN)"
  },
  {
    "value": "CKA",
    "label": "CHEROKEE (CKA)"
  },
  {
    "value": "CKE",
    "label": "CLEAR LAKE (CKE)"
  },
  {
    "value": "CKK",
    "label": "CHEROKEE (CKK)"
  },
  {
    "value": "CKM",
    "label": "CLARKSDALE (CKM)"
  },
  {
    "value": "CKN",
    "label": "CROOKSTON (CKN)"
  },
  {
    "value": "CKR",
    "label": "CRANE ISLAND (CKR)"
  },
  {
    "value": "CKU",
    "label": "CORDOVA (CKU)"
  },
  {
    "value": "CKV",
    "label": "CLARKSVILLE (CKV)"
  },
  {
    "value": "CKX",
    "label": "CHICKEN (CKX)"
  },
  {
    "value": "CLC",
    "label": "CLEARLAKE (CLC)"
  },
  {
    "value": "CLI",
    "label": "CLINTONVILLE (CLI)"
  },
  {
    "value": "CLK",
    "label": "CLINTON (CLK)"
  },
  {
    "value": "CLR",
    "label": "CALIPATRIA (CLR)"
  },
  {
    "value": "CLS",
    "label": "CHEHALIS (CLS)"
  },
  {
    "value": "CLU",
    "label": "COLUMBUS (CLU)"
  },
  {
    "value": "CMY",
    "label": "SPARTA (CMY)"
  },
  {
    "value": "CNE",
    "label": "CANON CITY (CNE)"
  },
  {
    "value": "CNH",
    "label": "CLAREMONT (CNH)"
  },
  {
    "value": "CNK",
    "label": "CONCORDIA (CNK)"
  },
  {
    "value": "CNO",
    "label": "CHINO (CNO)"
  },
  {
    "value": "CNU",
    "label": "CHANUTE (CNU)"
  },
  {
    "value": "CNW",
    "label": "WACO (CNW)"
  },
  {
    "value": "COA",
    "label": "COLUMBIA (COA)"
  },
  {
    "value": "COI",
    "label": "COCOA (COI)"
  },
  {
    "value": "COM",
    "label": "COLEMAN (COM)"
  },
  {
    "value": "CON",
    "label": "CONCORD (CON)"
  },
  {
    "value": "COP",
    "label": "COOPERSTOWN (COP)"
  },
  {
    "value": "COT",
    "label": "COTULLA (COT)"
  },
  {
    "value": "CRT",
    "label": "CROSSETT (CRT)"
  },
  {
    "value": "CRX",
    "label": "CORINTH (CRX)"
  },
  {
    "value": "CSE",
    "label": "CRESTED BUTTE (CSE)"
  },
  {
    "value": "ISQ",
    "label": "MANISTIQUE (ISQ)"
  },
  {
    "value": "ISS",
    "label": "WISCASSET (ISS)"
  },
  {
    "value": "ISW",
    "label": "WISCONSIN RAPIDS (ISW)"
  },
  {
    "value": "IVH",
    "label": "IVISHAK (IVH)"
  },
  {
    "value": "JAE",
    "label": "TECHNOLOGY PK-ATLANTA (JAE)"
  },
  {
    "value": "JAJ",
    "label": "PERIMETER MALL-ATLANTA (JAJ)"
  },
  {
    "value": "JAS",
    "label": "JASPER (JAS)"
  },
  {
    "value": "JBK",
    "label": "BERKELEY (JBK)"
  },
  {
    "value": "JBS",
    "label": "PLEASANTON (JBS)"
  },
  {
    "value": "JCC",
    "label": "CHINA BASIN-SAN FRANCISCO (JCC)"
  },
  {
    "value": "JCT",
    "label": "JUNCTION (JCT)"
  },
  {
    "value": "JCX",
    "label": "CITICORP PLAZA-LOS ANGELES (JCX)"
  },
  {
    "value": "JCY",
    "label": "JOHNSON (JCY)"
  },
  {
    "value": "JDA",
    "label": "JOHN DAY (JDA)"
  },
  {
    "value": "JDN",
    "label": "JORDAN (JDN)"
  },
  {
    "value": "JDT",
    "label": "DNTN H/P-MINNEAPOLIS/ST PAUL (JDT)"
  },
  {
    "value": "JDY",
    "label": "DOWNEY (JDY)"
  },
  {
    "value": "JEM",
    "label": "EMERYVILLE (JEM)"
  },
  {
    "value": "JFN",
    "label": "JEFFERSON (JFN)"
  },
  {
    "value": "JGP",
    "label": "GREENWAY PLAZA-HOUSTON (JGP)"
  },
  {
    "value": "JGX",
    "label": "GLENDALE (JGX)"
  },
  {
    "value": "JIO",
    "label": "INTL HELI-ONTARIO (JIO)"
  },
  {
    "value": "JKV",
    "label": "JACKSONVILLE (JKV)"
  },
  {
    "value": "JLA",
    "label": "COOPER LODGE (JLA)"
  },
  {
    "value": "JLB",
    "label": "HELIPORT-LONG BEACH (JLB)"
  },
  {
    "value": "JLX",
    "label": "UNION STN-LOS ANGELES (JLX)"
  },
  {
    "value": "JMA",
    "label": "ASTRODROME-HOUSTON (JMA)"
  },
  {
    "value": "JMD",
    "label": "MARKET CENTRE-DALLAS (JMD)"
  },
  {
    "value": "JMH",
    "label": "SCHAUMBURG (JMH)"
  },
  {
    "value": "JMN",
    "label": "MUNICIPAL-MANKATO (JMN)"
  },
  {
    "value": "JNH",
    "label": "NORTH PARK INN-DALLAS (JNH)"
  },
  {
    "value": "JNP",
    "label": "NEWPORT BEACH (JNP)"
  },
  {
    "value": "JOC",
    "label": "CNTRPORT HELIPORT-SANTA ANA CA. USA (JOC)"
  },
  {
    "value": "JOR",
    "label": "DISNEYLAND/ORANGE (JOR)"
  },
  {
    "value": "JOT",
    "label": "JOLIET (JOT)"
  },
  {
    "value": "JPD",
    "label": "PASADENA (JPD)"
  },
  {
    "value": "JRC",
    "label": "MUNICIPAL-ROCHESTER (JRC)"
  },
  {
    "value": "JRD",
    "label": "RIVERSIDE (JRD)"
  },
  {
    "value": "JSD",
    "label": "STRATFORD (JSD)"
  },
  {
    "value": "JSG",
    "label": "HELIPORT-SAN RAFAEL (JSG)"
  },
  {
    "value": "JSK",
    "label": "MUNICIPAL-SAINT CLOUD (JSK)"
  },
  {
    "value": "JSN",
    "label": "SHERMAN OAKS-LOS ANGELES (JSN)"
  },
  {
    "value": "JTO",
    "label": "THOUSAND OAKS (JTO)"
  },
  {
    "value": "JUC",
    "label": "UNIVERSAL CITY-LOS ANGELES (JUC)"
  },
  {
    "value": "JUP",
    "label": "CABLE-UPLAND (JUP)"
  },
  {
    "value": "JVI",
    "label": "MANVILLE (JVI)"
  },
  {
    "value": "JWC",
    "label": "WARNER CTR-LOS ANGELES (JWC)"
  },
  {
    "value": "KBE",
    "label": "BELL ISLAND (KBE)"
  },
  {
    "value": "KCK",
    "label": "KANSAS CITY (KCK)"
  },
  {
    "value": "KCN",
    "label": "CHERNOFSKI (KCN)"
  },
  {
    "value": "KCR",
    "label": "COLORADO CREEK (KCR)"
  },
  {
    "value": "KEB",
    "label": "ENGLISH BAY (KEB)"
  },
  {
    "value": "KEU",
    "label": "KELLY BAR (KEU)"
  },
  {
    "value": "KGZ",
    "label": "GLACIER CREEK (KGZ)"
  },
  {
    "value": "KIC",
    "label": "KING CITY (KIC)"
  },
  {
    "value": "KKF",
    "label": "KAGVIK CREEK (KKF)"
  },
  {
    "value": "KKL",
    "label": "KARLUK LAKE (KKL)"
  },
  {
    "value": "KKT",
    "label": "KENTLAND (KKT)"
  },
  {
    "value": "KLP",
    "label": "KELP BAY (KLP)"
  },
  {
    "value": "KLS",
    "label": "KELSO (KLS)"
  },
  {
    "value": "KNB",
    "label": "KANAB (KNB)"
  },
  {
    "value": "KNT",
    "label": "KENNETT (KNT)"
  },
  {
    "value": "KOT",
    "label": "KOTLIK (KOT)"
  },
  {
    "value": "KPD",
    "label": "KING OF PRUSSIA (KPD)"
  },
  {
    "value": "KPH",
    "label": "PAULOFF HARBOR (KPH)"
  },
  {
    "value": "KPT",
    "label": "JACKPOT (KPT)"
  },
  {
    "value": "KSR",
    "label": "SANDY RIVER (KSR)"
  },
  {
    "value": "KZH",
    "label": "KIZHUYAK (KZH)"
  },
  {
    "value": "LBT",
    "label": "LUMBERTON (LBT)"
  },
  {
    "value": "LDJ",
    "label": "LINDEN (LDJ)"
  },
  {
    "value": "LDL",
    "label": "SMYRNA (LDL)"
  },
  {
    "value": "LEM",
    "label": "LEMMON (LEM)"
  },
  {
    "value": "LEW",
    "label": "LEWISTON (LEW)"
  },
  {
    "value": "LFK",
    "label": "LUFKIN (LFK)"
  },
  {
    "value": "LFN",
    "label": "LOUISBURG (LFN)"
  },
  {
    "value": "CSM",
    "label": "CLINTON (CSM)"
  },
  {
    "value": "CSN",
    "label": "CARSON CITY (CSN)"
  },
  {
    "value": "CSQ",
    "label": "CRESTON (CSQ)"
  },
  {
    "value": "CSV",
    "label": "CROSSVILLE (CSV)"
  },
  {
    "value": "CTB",
    "label": "CUT BANK (CTB)"
  },
  {
    "value": "CTH",
    "label": "COATESVILLE (CTH)"
  },
  {
    "value": "CTK",
    "label": "CANTON (CTK)"
  },
  {
    "value": "CTO",
    "label": "CALVERTON (CTO)"
  },
  {
    "value": "CTW",
    "label": "COTTONWOOD (CTW)"
  },
  {
    "value": "CTX",
    "label": "CORTLAND (CTX)"
  },
  {
    "value": "CTY",
    "label": "CROSS CITY (CTY)"
  },
  {
    "value": "CTZ",
    "label": "CLINTON (CTZ)"
  },
  {
    "value": "CUH",
    "label": "CUSHING (CUH)"
  },
  {
    "value": "CUS",
    "label": "COLUMBUS (CUS)"
  },
  {
    "value": "CUW",
    "label": "CUBE COVE (CUW)"
  },
  {
    "value": "CVO",
    "label": "ALBANY/CORVALLIS (CVO)"
  },
  {
    "value": "CVR",
    "label": "CULVER CITY (CVR)"
  },
  {
    "value": "CWG",
    "label": "CALLAWAY GARDENS (CWG)"
  },
  {
    "value": "CWI",
    "label": "CLINTON (CWI)"
  },
  {
    "value": "CXC",
    "label": "CHITINA (CXC)"
  },
  {
    "value": "CXF",
    "label": "COLDFOOT (CXF)"
  },
  {
    "value": "CXL",
    "label": "CALEXICO (CXL)"
  },
  {
    "value": "CXO",
    "label": "CONROE (CXO)"
  },
  {
    "value": "CYE",
    "label": "CRYSTAL LAKE (CYE)"
  },
  {
    "value": "CYM",
    "label": "CHATHAM (CYM)"
  },
  {
    "value": "CYT",
    "label": "CAPE YAKATAGA (CYT)"
  },
  {
    "value": "CZC",
    "label": "COPPER CENTRE (CZC)"
  },
  {
    "value": "CZK",
    "label": "CASCADE LOCKS (CZK)"
  },
  {
    "value": "CZN",
    "label": "CHISANA (CZN)"
  },
  {
    "value": "CZO",
    "label": "CHISTOCHINA (CZO)"
  },
  {
    "value": "CZP",
    "label": "CAPE POLE (CZP)"
  },
  {
    "value": "CZT",
    "label": "CARRIZO SPRINGS (CZT)"
  },
  {
    "value": "CZZ",
    "label": "CAMPO (CZZ)"
  },
  {
    "value": "DEO",
    "label": "HYATT RGCY-DEARBORN (DEO)"
  },
  {
    "value": "DGB",
    "label": "DANGER BAY (DGB)"
  },
  {
    "value": "DHC",
    "label": "NEWNAN (DHC)"
  },
  {
    "value": "DKK",
    "label": "DUNKIRK (DKK)"
  },
  {
    "value": "DLL",
    "label": "DILLON (DLL)"
  },
  {
    "value": "DLN",
    "label": "DILLON (DLN)"
  },
  {
    "value": "DLO",
    "label": "DOLOMI (DLO)"
  },
  {
    "value": "DMN",
    "label": "DEMING (DMN)"
  },
  {
    "value": "DMO",
    "label": "SEDALIA (DMO)"
  },
  {
    "value": "DNN",
    "label": "DALTON (DNN)"
  },
  {
    "value": "DNS",
    "label": "DENISON (DNS)"
  },
  {
    "value": "DNT",
    "label": "DOWNTOWN HELIPORT-SANTA ANA CA. USA (DNT)"
  },
  {
    "value": "DPK",
    "label": "DEER PARK (DPK)"
  },
  {
    "value": "DRF",
    "label": "DRIFT RIVER (DRF)"
  },
  {
    "value": "DRI",
    "label": "DE RIDDER (DRI)"
  },
  {
    "value": "DTH",
    "label": "DEATH VALLEY (DTH)"
  },
  {
    "value": "DWS",
    "label": "WALT DISNEY WORLD-ORLANDO (DWS)"
  },
  {
    "value": "EAN",
    "label": "WHEATLAND (EAN)"
  },
  {
    "value": "ECA",
    "label": "EAST TAWAS (ECA)"
  },
  {
    "value": "ECS",
    "label": "NEWCASTLE (ECS)"
  },
  {
    "value": "EDE",
    "label": "EDENTON (EDE)"
  },
  {
    "value": "EDK",
    "label": "EL DORADO (EDK)"
  },
  {
    "value": "EDW",
    "label": "EDWARDS (EDW)"
  },
  {
    "value": "EED",
    "label": "NEEDLES (EED)"
  },
  {
    "value": "EFB",
    "label": "EIGHT FATHOM BIGHT (EFB)"
  },
  {
    "value": "EFK",
    "label": "NEWPORT (EFK)"
  },
  {
    "value": "EFO",
    "label": "EAST FORK (EFO)"
  },
  {
    "value": "EFW",
    "label": "JEFFERSON (EFW)"
  },
  {
    "value": "EGP",
    "label": "EAGLE PASS (EGP)"
  },
  {
    "value": "EHT",
    "label": "EAST HARTFORD (EHT)"
  },
  {
    "value": "EKX",
    "label": "ELIZABETHTOWN/FT. KNOX (EKX)"
  },
  {
    "value": "ELA",
    "label": "EAGLE LAKE (ELA)"
  },
  {
    "value": "ELK",
    "label": "ELK CITY (ELK)"
  },
  {
    "value": "ELN",
    "label": "ELLENSBURG (ELN)"
  },
  {
    "value": "ELW",
    "label": "ELLAMAR (ELW)"
  },
  {
    "value": "ELZ",
    "label": "WELLSVILLE (ELZ)"
  },
  {
    "value": "EMB",
    "label": "EMBARKADERO/SAN FRANCISCO (EMB)"
  },
  {
    "value": "EMM",
    "label": "KEMMERER (EMM)"
  },
  {
    "value": "EMP",
    "label": "EMPORIA (EMP)"
  },
  {
    "value": "EMT",
    "label": "EL MONTE (EMT)"
  },
  {
    "value": "ENL",
    "label": "CENTRALIA (ENL)"
  },
  {
    "value": "ENV",
    "label": "WENDOVER (ENV)"
  },
  {
    "value": "ENW",
    "label": "KENOSHA (ENW)"
  },
  {
    "value": "EOK",
    "label": "KEOKUK (EOK)"
  },
  {
    "value": "EOS",
    "label": "NEOSHO (EOS)"
  },
  {
    "value": "EPG",
    "label": "WEEPING WATER (EPG)"
  },
  {
    "value": "EPH",
    "label": "EPHRATA (EPH)"
  },
  {
    "value": "ERO",
    "label": "ELDRED ROCK (ERO)"
  },
  {
    "value": "ERR",
    "label": "ERROL (ERR)"
  },
  {
    "value": "ERV",
    "label": "KERRVILLE (ERV)"
  },
  {
    "value": "ESN",
    "label": "EASTON (ESN)"
  },
  {
    "value": "ESO",
    "label": "ESPANOLA (ESO)"
  },
  {
    "value": "ESP",
    "label": "EAST STROUDSBURG (ESP)"
  },
  {
    "value": "EST",
    "label": "ESTHERVILLE (EST)"
  },
  {
    "value": "ESW",
    "label": "EASTON (ESW)"
  },
  {
    "value": "ETB",
    "label": "WEST BEND (ETB)"
  },
  {
    "value": "ETN",
    "label": "EASTLAND (ETN)"
  },
  {
    "value": "ETS",
    "label": "ENTERPRISE (ETS)"
  },
  {
    "value": "EUE",
    "label": "EUREKA (EUE)"
  },
  {
    "value": "EUF",
    "label": "EUFAULA (EUF)"
  },
  {
    "value": "EVA",
    "label": "EVADALE (EVA)"
  },
  {
    "value": "EVM",
    "label": "EVELETH (EVM)"
  },
  {
    "value": "FAL",
    "label": "ROMA (FAL)"
  },
  {
    "value": "FAM",
    "label": "FARMINGTON (FAM)"
  },
  {
    "value": "FBL",
    "label": "FARIBAULT (FBL)"
  },
  {
    "value": "FBR",
    "label": "FORT BRIDGER (FBR)"
  },
  {
    "value": "FBY",
    "label": "FAIRBURY (FBY)"
  },
  {
    "value": "FCY",
    "label": "FORREST CITY (FCY)"
  },
  {
    "value": "FDK",
    "label": "FREDERICK (FDK)"
  },
  {
    "value": "FDR",
    "label": "FREDERICK (FDR)"
  },
  {
    "value": "FDY",
    "label": "FINDLAY (FDY)"
  },
  {
    "value": "FEP",
    "label": "FREEPORT (FEP)"
  },
  {
    "value": "FET",
    "label": "FREMONT (FET)"
  },
  {
    "value": "FFA",
    "label": "KILL DEVIL HILLS (FFA)"
  },
  {
    "value": "FFL",
    "label": "FAIRFIELD (FFL)"
  },
  {
    "value": "FFT",
    "label": "FRANKFORT (FFT)"
  },
  {
    "value": "FKN",
    "label": "FRANKLIN (FKN)"
  },
  {
    "value": "FLD",
    "label": "FOND DU LAC (FLD)"
  },
  {
    "value": "FLJ",
    "label": "FALLS BAY (FLJ)"
  },
  {
    "value": "FLP",
    "label": "FLIPPIN (FLP)"
  },
  {
    "value": "FLX",
    "label": "FALLON (FLX)"
  },
  {
    "value": "FMH",
    "label": "FALMOUTH (FMH)"
  },
  {
    "value": "FNR",
    "label": "FUNTER BAY (FNR)"
  },
  {
    "value": "FOX",
    "label": "FOX (FOX)"
  },
  {
    "value": "FRR",
    "label": "FRONT ROYAL (FRR)"
  },
  {
    "value": "FRY",
    "label": "FRYEBURG (FRY)"
  },
  {
    "value": "FSK",
    "label": "FORT SCOTT (FSK)"
  },
  {
    "value": "FST",
    "label": "FT. STOCKTON (FST)"
  },
  {
    "value": "FSU",
    "label": "FORT SUMNER (FSU)"
  },
  {
    "value": "FTL",
    "label": "FORTUNA LEDGE (FTL)"
  },
  {
    "value": "FWL",
    "label": "FAREWELL (FWL)"
  },
  {
    "value": "FXM",
    "label": "FLAXMAN ISLAND (FXM)"
  },
  {
    "value": "FXY",
    "label": "FOREST CITY (FXY)"
  },
  {
    "value": "FYM",
    "label": "FAYETTEVILLE (FYM)"
  },
  {
    "value": "GAK",
    "label": "GAKONA (GAK)"
  },
  {
    "value": "GBH",
    "label": "GALBRAITH LAKE (GBH)"
  },
  {
    "value": "GBR",
    "label": "GREAT BARRINGTON (GBR)"
  },
  {
    "value": "GCY",
    "label": "GREENEVILLE (GCY)"
  },
  {
    "value": "GDH",
    "label": "GOLDEN HORN (GDH)"
  },
  {
    "value": "GDM",
    "label": "GARDNER (GDM)"
  },
  {
    "value": "GDW",
    "label": "GLADWIN (GDW)"
  },
  {
    "value": "GED",
    "label": "GEORGETOWN (GED)"
  },
  {
    "value": "GEK",
    "label": "GANES CREEK (GEK)"
  },
  {
    "value": "GEY",
    "label": "GREYBULL (GEY)"
  },
  {
    "value": "GFD",
    "label": "POPE FIELD (GFD)"
  },
  {
    "value": "GGE",
    "label": "GEORGETOWN (GGE)"
  },
  {
    "value": "GHM",
    "label": "CENTERVILLE (GHM)"
  },
  {
    "value": "GIF",
    "label": "WINTER HAVEN (GIF)"
  },
  {
    "value": "GKT",
    "label": "GATLINBURG (GKT)"
  },
  {
    "value": "GLE",
    "label": "GAINESVILLE (GLE)"
  },
  {
    "value": "GLQ",
    "label": "GLENNALLEN (GLQ)"
  },
  {
    "value": "GLR",
    "label": "GAYLORD (GLR)"
  },
  {
    "value": "GLW",
    "label": "GLASGOW (GLW)"
  },
  {
    "value": "GMT",
    "label": "GRANITE MOUNTAIN (GMT)"
  },
  {
    "value": "GMV",
    "label": "MONUMENT VALLEY GOULDIING (GMV)"
  },
  {
    "value": "GNG",
    "label": "GOODING (GNG)"
  },
  {
    "value": "GNT",
    "label": "GRANTS (GNT)"
  },
  {
    "value": "GOK",
    "label": "GUTHRIE (GOK)"
  },
  {
    "value": "GOL",
    "label": "GOLD BEACH (GOL)"
  },
  {
    "value": "GQQ",
    "label": "GALION (GQQ)"
  },
  {
    "value": "GRD",
    "label": "GREENWOOD (GRD)"
  },
  {
    "value": "GRE",
    "label": "GREENVILLE (GRE)"
  },
  {
    "value": "GRM",
    "label": "GRAND MARAIS (GRM)"
  },
  {
    "value": "GSH",
    "label": "GOSHEN (GSH)"
  },
  {
    "value": "GTG",
    "label": "GRANTSBURG (GTG)"
  },
  {
    "value": "GTY",
    "label": "GETTYSBURG (GTY)"
  },
  {
    "value": "GUF",
    "label": "GULF SHORES (GUF)"
  },
  {
    "value": "GUY",
    "label": "GUYMON (GUY)"
  },
  {
    "value": "GVL",
    "label": "GAINESVILLE (GVL)"
  },
  {
    "value": "GVW",
    "label": "GRANDVIEW (GVW)"
  },
  {
    "value": "GWO",
    "label": "GREENWOOD (GWO)"
  },
  {
    "value": "GWS",
    "label": "GLENWOOD SPRINGS (GWS)"
  },
  {
    "value": "GWV",
    "label": "GLENDALE (GWV)"
  },
  {
    "value": "GXY",
    "label": "GREELEY (GXY)"
  },
  {
    "value": "GYR",
    "label": "GOODYEAR (GYR)"
  },
  {
    "value": "HAF",
    "label": "HALF MOON (HAF)"
  },
  {
    "value": "HAI",
    "label": "THREE RIVERS (HAI)"
  },
  {
    "value": "HAO",
    "label": "HAMILTON (HAO)"
  },
  {
    "value": "HAX",
    "label": "MUSKOGEE (HAX)"
  },
  {
    "value": "HAY",
    "label": "HAYCOCK (HAY)"
  },
  {
    "value": "HBB",
    "label": "INDUSTRIAL-HOBBS (HBB)"
  },
  {
    "value": "HBC",
    "label": "HANUS BAY (HBC)"
  },
  {
    "value": "HBG",
    "label": "HATTIESBURG (HBG)"
  },
  {
    "value": "HBO",
    "label": "HUMBOLDT (HBO)"
  },
  {
    "value": "HBR",
    "label": "HOBART (HBR)"
  },
  {
    "value": "HCA",
    "label": "BIG SPRING (HCA)"
  },
  {
    "value": "HCB",
    "label": "SHOAL COVE (HCB)"
  },
  {
    "value": "HCC",
    "label": "HUDSON (HCC)"
  },
  {
    "value": "HCW",
    "label": "CHERAW (HCW)"
  },
  {
    "value": "HDA",
    "label": "HIDDEN FALLS (HDA)"
  },
  {
    "value": "HDE",
    "label": "HOLDREGE (HDE)"
  },
  {
    "value": "HED",
    "label": "HERENDEEN (HED)"
  },
  {
    "value": "HEE",
    "label": "HELENA (HEE)"
  },
  {
    "value": "HES",
    "label": "HERMISTON (HES)"
  },
  {
    "value": "HEZ",
    "label": "NATCHEZ (HEZ)"
  },
  {
    "value": "HGZ",
    "label": "HOGATZA (HGZ)"
  },
  {
    "value": "HHR",
    "label": "HAWTHORNE (HHR)"
  },
  {
    "value": "HIE",
    "label": "WHITEFIELD (HIE)"
  },
  {
    "value": "HIO",
    "label": "HILLSBORO (HIO)"
  },
  {
    "value": "HLB",
    "label": "BATESVILLE (HLB)"
  },
  {
    "value": "HLC",
    "label": "HILL CITY (HLC)"
  },
  {
    "value": "HLG",
    "label": "WHEELING (HLG)"
  },
  {
    "value": "HLI",
    "label": "HOLLISTER (HLI)"
  },
  {
    "value": "HLM",
    "label": "HOLLAND (HLM)"
  },
  {
    "value": "HMS",
    "label": "HOMESHORE (HMS)"
  },
  {
    "value": "HMT",
    "label": "HEMET (HMT)"
  },
  {
    "value": "HNB",
    "label": "HUNTINGBURG (HNB)"
  },
  {
    "value": "HNE",
    "label": "TAHNETA PASS LODGE (HNE)"
  },
  {
    "value": "HNX",
    "label": "HANNA (HNX)"
  },
  {
    "value": "HOL",
    "label": "HOLIKACHU (HOL)"
  },
  {
    "value": "HPT",
    "label": "HAMPTON (HPT)"
  },
  {
    "value": "HPY",
    "label": "BAYTOWN (HPY)"
  },
  {
    "value": "HQM",
    "label": "HOQUIAM-ABERDEEN (HQM)"
  },
  {
    "value": "HSB",
    "label": "HARRISBURG (HSB)"
  },
  {
    "value": "HST",
    "label": "HOMESTEAD (HST)"
  },
  {
    "value": "HTH",
    "label": "HAWTHORNE (HTH)"
  },
  {
    "value": "HTL",
    "label": "HOUGHTON (HTL)"
  },
  {
    "value": "HTV",
    "label": "HUNTSVILLE (HTV)"
  },
  {
    "value": "HTW",
    "label": "CHESAPEAKE (HTW)"
  },
  {
    "value": "HUJ",
    "label": "HUGO (HUJ)"
  },
  {
    "value": "HUL",
    "label": "HOULTON (HUL)"
  },
  {
    "value": "HUM",
    "label": "HOUMA (HUM)"
  },
  {
    "value": "HUT",
    "label": "HUTCHINSON (HUT)"
  },
  {
    "value": "HVE",
    "label": "HANKSVILLE (HVE)"
  },
  {
    "value": "HVS",
    "label": "HARTSVILLE (HVS)"
  },
  {
    "value": "HWD",
    "label": "HAYWARD (HWD)"
  },
  {
    "value": "HWI",
    "label": "HAWK INLET (HWI)"
  },
  {
    "value": "HWO",
    "label": "HOLLYWOOD (HWO)"
  },
  {
    "value": "HZL",
    "label": "HAZLETON (HZL)"
  },
  {
    "value": "ICL",
    "label": "CLARINDA (ICL)"
  },
  {
    "value": "ICY",
    "label": "ICY BAY (ICY)"
  },
  {
    "value": "IDG",
    "label": "IDA GROVE (IDG)"
  },
  {
    "value": "IDI",
    "label": "INDIANA (IDI)"
  },
  {
    "value": "IDP",
    "label": "INDEPENDENCE (IDP)"
  },
  {
    "value": "IFA",
    "label": "IOWA FALLS (IFA)"
  },
  {
    "value": "IJX",
    "label": "JACKSONVILLE (IJX)"
  },
  {
    "value": "IKB",
    "label": "WILKESBORO (IKB)"
  },
  {
    "value": "IKK",
    "label": "KANKAKEE (IKK)"
  },
  {
    "value": "ILN",
    "label": "WILMINGTON (ILN)"
  },
  {
    "value": "IML",
    "label": "IMPERIAL (IML)"
  },
  {
    "value": "IMM",
    "label": "IMMOKALEE (IMM)"
  },
  {
    "value": "INK",
    "label": "WINK (INK)"
  },
  {
    "value": "INW",
    "label": "WINSLOW (INW)"
  },
  {
    "value": "IRB",
    "label": "IRAAN (IRB)"
  },
  {
    "value": "IRS",
    "label": "STURGIS (IRS)"
  },
  {
    "value": "ISM",
    "label": "KISSIMMEE (ISM)"
  },
  {
    "value": "PYM",
    "label": "PLYMOUTH (PYM)"
  },
  {
    "value": "QCE",
    "label": "COPPER MOUNTAIN (QCE)"
  },
  {
    "value": "QFE",
    "label": "FT BENNING-COLUMBUS (QFE)"
  },
  {
    "value": "QKB",
    "label": "BRECKENRIDGE (QKB)"
  },
  {
    "value": "QKS",
    "label": "KEYSTONE (QKS)"
  },
  {
    "value": "QMV",
    "label": "NOMTVALE (QMV)"
  },
  {
    "value": "QMX",
    "label": "FICTITIOUS CITY ONE (QMX)"
  },
  {
    "value": "QMY",
    "label": "FICTITIOUS CITY TWO (QMY)"
  },
  {
    "value": "QPX",
    "label": "FICTITIOUS CITY THREE (QPX)"
  },
  {
    "value": "QPY",
    "label": "FICTITIOUS CITY FOUR (QPY)"
  },
  {
    "value": "QWP",
    "label": "WINTER PARK (QWP)"
  },
  {
    "value": "QZX",
    "label": "FICTITIOUS CITY FIVE (QZX)"
  },
  {
    "value": "RAC",
    "label": "RACINE (RAC)"
  },
  {
    "value": "RBF",
    "label": "BIG BEAR (RBF)"
  },
  {
    "value": "RBG",
    "label": "ROSEBURG (RBG)"
  },
  {
    "value": "RBK",
    "label": "RANCHO (RBK)"
  },
  {
    "value": "RBL",
    "label": "RED BLUFF (RBL)"
  },
  {
    "value": "RBN",
    "label": "FORT JEFFERSON NATL PARK (RBN)"
  },
  {
    "value": "RBW",
    "label": "WALTERBORO (RBW)"
  },
  {
    "value": "RCK",
    "label": "ROCKDALE (RCK)"
  },
  {
    "value": "RDB",
    "label": "RED DOG (RDB)"
  },
  {
    "value": "RED",
    "label": "REEDSVILLE (RED)"
  },
  {
    "value": "REH",
    "label": "REHOBOTH BEACH (REH)"
  },
  {
    "value": "RFG",
    "label": "REFUGIO (RFG)"
  },
  {
    "value": "RFK",
    "label": "ANGUILLA (RFK)"
  },
  {
    "value": "RGR",
    "label": "RANGER (RGR)"
  },
  {
    "value": "RIE",
    "label": "RICE LAKE (RIE)"
  },
  {
    "value": "RKH",
    "label": "ROCK HILL (RKH)"
  },
  {
    "value": "RKP",
    "label": "ROCKPORT (RKP)"
  },
  {
    "value": "RKR",
    "label": "POTEAU (RKR)"
  },
  {
    "value": "RKW",
    "label": "ROCKWOOD (RKW)"
  },
  {
    "value": "RLD",
    "label": "RICHLAND (RLD)"
  },
  {
    "value": "RLI",
    "label": "RILEY-ANNISTON (RLI)"
  },
  {
    "value": "RLU",
    "label": "BORNITE (RLU)"
  },
  {
    "value": "RMC",
    "label": "ROCKFORD (RMC)"
  },
  {
    "value": "RMG",
    "label": "ROME (RMG)"
  },
  {
    "value": "RMP",
    "label": "RAMPART (RMP)"
  },
  {
    "value": "RNC",
    "label": "MCMINNVILLE (RNC)"
  },
  {
    "value": "RNH",
    "label": "NEW RICHMOND (RNH)"
  },
  {
    "value": "RNZ",
    "label": "RENSSELAER (RNZ)"
  },
  {
    "value": "ROG",
    "label": "ROGERS (ROG)"
  },
  {
    "value": "ROL",
    "label": "ROOSEVELT (ROL)"
  },
  {
    "value": "ROX",
    "label": "ROSEAU (ROX)"
  },
  {
    "value": "RPX",
    "label": "ROUNDUP (RPX)"
  },
  {
    "value": "RRL",
    "label": "MERRILL (RRL)"
  },
  {
    "value": "RRT",
    "label": "WARROAD (RRT)"
  },
  {
    "value": "RSL",
    "label": "RUSSELL (RSL)"
  },
  {
    "value": "RSN",
    "label": "RUSTON (RSN)"
  },
  {
    "value": "RSX",
    "label": "ROUSES POINT (RSX)"
  },
  {
    "value": "RTD",
    "label": "ROTUNDA (RTD)"
  },
  {
    "value": "RTE",
    "label": "MARGUERITE BAY (RTE)"
  },
  {
    "value": "RTL",
    "label": "SPIRIT LAKE (RTL)"
  },
  {
    "value": "RTN",
    "label": "RATON (RTN)"
  },
  {
    "value": "RUI",
    "label": "RUIDOSO (RUI)"
  },
  {
    "value": "RVS",
    "label": "JONES-TULSA (RVS)"
  },
  {
    "value": "RWF",
    "label": "REDWOOD FALLS (RWF)"
  },
  {
    "value": "RWL",
    "label": "RAWLINS (RWL)"
  },
  {
    "value": "RZZ",
    "label": "ROANOKE RAPIDS (RZZ)"
  },
  {
    "value": "SAD",
    "label": "SAFFORD (SAD)"
  },
  {
    "value": "SAG",
    "label": "SAGWON (SAG)"
  },
  {
    "value": "SAR",
    "label": "SPARTA (SAR)"
  },
  {
    "value": "SBM",
    "label": "SHEBOYGAN (SBM)"
  },
  {
    "value": "SBT",
    "label": "SAN BERNARDINO (SBT)"
  },
  {
    "value": "SBX",
    "label": "SHELBY (SBX)"
  },
  {
    "value": "SCB",
    "label": "SCRIBNER (SCB)"
  },
  {
    "value": "SCH",
    "label": "SCHENECTADY (SCH)"
  },
  {
    "value": "SCR",
    "label": "SCRANTON (SCR)"
  },
  {
    "value": "SEF",
    "label": "SEBRING (SEF)"
  },
  {
    "value": "SEP",
    "label": "STEPHENVILLE (SEP)"
  },
  {
    "value": "SES",
    "label": "SELMA (SES)"
  },
  {
    "value": "SFR",
    "label": "SAN FERNANDO (SFR)"
  },
  {
    "value": "SFY",
    "label": "SPRINGFIELD (SFY)"
  },
  {
    "value": "SFZ",
    "label": "SMITHFIELD (SFZ)"
  },
  {
    "value": "SGT",
    "label": "STUTTGART (SGT)"
  },
  {
    "value": "SGW",
    "label": "SAGINAW BAY (SGW)"
  },
  {
    "value": "SHG",
    "label": "SHUNGNAK (SHG)"
  },
  {
    "value": "SHX",
    "label": "SHAGELUK (SHX)"
  },
  {
    "value": "SIK",
    "label": "SIKESTON (SIK)"
  },
  {
    "value": "SIV",
    "label": "SULLIVAN (SIV)"
  },
  {
    "value": "SIY",
    "label": "MONTAGUE (SIY)"
  },
  {
    "value": "SJN",
    "label": "ST. JOHNS (SJN)"
  },
  {
    "value": "SKJ",
    "label": "SITKINAK (SKJ)"
  },
  {
    "value": "SKW",
    "label": "SKWENTNA (SKW)"
  },
  {
    "value": "SKY",
    "label": "SANDUSKY (SKY)"
  },
  {
    "value": "SLB",
    "label": "STORM LAKE (SLB)"
  },
  {
    "value": "SLG",
    "label": "SILOAM SPRINGS (SLG)"
  },
  {
    "value": "SLJ",
    "label": "STELLAR-CHANDLER (SLJ)"
  },
  {
    "value": "SLQ",
    "label": "SLEETMUTE (SLQ)"
  },
  {
    "value": "SLR",
    "label": "SULPHUR SPRINGS (SLR)"
  },
  {
    "value": "SLT",
    "label": "SALIDA (SLT)"
  },
  {
    "value": "SMD",
    "label": "SMITH-FORT WAYNE (SMD)"
  },
  {
    "value": "SMK",
    "label": "ST. MICHAEL (SMK)"
  },
  {
    "value": "SMN",
    "label": "SALMON (SMN)"
  },
  {
    "value": "SMO",
    "label": "SANTA MONICA (SMO)"
  },
  {
    "value": "SMU",
    "label": "SHEEP MOUNTAIN (SMU)"
  },
  {
    "value": "SNK",
    "label": "SNYDER (SNK)"
  },
  {
    "value": "SNL",
    "label": "SHAWNEE (SNL)"
  },
  {
    "value": "SNY",
    "label": "SIDNEY (SNY)"
  },
  {
    "value": "SOL",
    "label": "SOLOMON (SOL)"
  },
  {
    "value": "SOV",
    "label": "SELDOVIA (SOV)"
  },
  {
    "value": "SPF",
    "label": "SPEARFISH (SPF)"
  },
  {
    "value": "SPG",
    "label": "WHITTED-TAMPA/ST. PETERSBURG (SPG)"
  },
  {
    "value": "SPQ",
    "label": "SAN PEDRO (SPQ)"
  },
  {
    "value": "SPW",
    "label": "SPENCER (SPW)"
  },
  {
    "value": "LGC",
    "label": "LA GRANGE (LGC)"
  },
  {
    "value": "LGD",
    "label": "LA GRANDE (LGD)"
  },
  {
    "value": "LGU",
    "label": "LOGAN (LGU)"
  },
  {
    "value": "LHV",
    "label": "LOCK HAVEN (LHV)"
  },
  {
    "value": "LIC",
    "label": "LIMON (LIC)"
  },
  {
    "value": "LIV",
    "label": "LIVENGOOD (LIV)"
  },
  {
    "value": "LIZ",
    "label": "TYRONE (LIZ)"
  },
  {
    "value": "LJN",
    "label": "LAKE JACKSON (LJN)"
  },
  {
    "value": "LKK",
    "label": "KULIK LAKE (LKK)"
  },
  {
    "value": "LKP",
    "label": "LAKE PLACID (LKP)"
  },
  {
    "value": "LKS",
    "label": "LAKESIDE (LKS)"
  },
  {
    "value": "LKV",
    "label": "LAKEVIEW (LKV)"
  },
  {
    "value": "LLX",
    "label": "LYNDONVILLE (LLX)"
  },
  {
    "value": "LLY",
    "label": "MOUNT HOLLY (LLY)"
  },
  {
    "value": "LMS",
    "label": "LOUISVILLE (LMS)"
  },
  {
    "value": "LND",
    "label": "LANDER (LND)"
  },
  {
    "value": "LNN",
    "label": "WILLOUGHBY (LNN)"
  },
  {
    "value": "LNP",
    "label": "WISE (LNP)"
  },
  {
    "value": "LNR",
    "label": "LONE ROCK (LNR)"
  },
  {
    "value": "LOG",
    "label": "LONGVIEW (LOG)"
  },
  {
    "value": "LOL",
    "label": "LOVELOCK (LOL)"
  },
  {
    "value": "LOT",
    "label": "LOCKPORT (LOT)"
  },
  {
    "value": "LOZ",
    "label": "LONDON (LOZ)"
  },
  {
    "value": "LPC",
    "label": "LOMPOC (LPC)"
  },
  {
    "value": "LPO",
    "label": "LA PORTE (LPO)"
  },
  {
    "value": "LQK",
    "label": "PICKENS (LQK)"
  },
  {
    "value": "LRJ",
    "label": "LEMARS (LRJ)"
  },
  {
    "value": "LSB",
    "label": "LORDSBURG (LSB)"
  },
  {
    "value": "LSK",
    "label": "LUSK (LSK)"
  },
  {
    "value": "LSR",
    "label": "LOST RIVER (LSR)"
  },
  {
    "value": "LTH",
    "label": "LATHROP WELLS (LTH)"
  },
  {
    "value": "LTS",
    "label": "ALTUS (LTS)"
  },
  {
    "value": "LTW",
    "label": "LEONARDTOWN (LTW)"
  },
  {
    "value": "LUL",
    "label": "LAUREL (LUL)"
  },
  {
    "value": "LVK",
    "label": "LIVERMORE (LVK)"
  },
  {
    "value": "LVL",
    "label": "LAWRENCEVILLE (LVL)"
  },
  {
    "value": "LVM",
    "label": "LIVINGSTON (LVM)"
  },
  {
    "value": "LVS",
    "label": "LAS VEGAS (LVS)"
  },
  {
    "value": "LWC",
    "label": "LAWRENCE (LWC)"
  },
  {
    "value": "LWL",
    "label": "WELLS (LWL)"
  },
  {
    "value": "LWM",
    "label": "LAWRENCE (LWM)"
  },
  {
    "value": "LWV",
    "label": "LAWRENCEVILLE (LWV)"
  },
  {
    "value": "LXN",
    "label": "LEXINGTON (LXN)"
  },
  {
    "value": "LXV",
    "label": "LEADVILLE (LXV)"
  },
  {
    "value": "LYO",
    "label": "LYONS (LYO)"
  },
  {
    "value": "LYU",
    "label": "ELY (LYU)"
  },
  {
    "value": "MAE",
    "label": "MADERA (MAE)"
  },
  {
    "value": "MAW",
    "label": "MALDEN (MAW)"
  },
  {
    "value": "MBG",
    "label": "MOBRIDGE (MBG)"
  },
  {
    "value": "MBY",
    "label": "MOBERLY (MBY)"
  },
  {
    "value": "MCB",
    "label": "MC COMB (MCB)"
  },
  {
    "value": "MDF",
    "label": "MEDFORD (MDF)"
  },
  {
    "value": "MDJ",
    "label": "MADRAS (MDJ)"
  },
  {
    "value": "MDN",
    "label": "MADISON (MDN)"
  },
  {
    "value": "MEJ",
    "label": "MEADVILLE (MEJ)"
  },
  {
    "value": "MEV",
    "label": "MINDEN (MEV)"
  },
  {
    "value": "MFH",
    "label": "MESQUITE (MFH)"
  },
  {
    "value": "MFV",
    "label": "MELFA (MFV)"
  },
  {
    "value": "MGC",
    "label": "MICHIGAN CITY (MGC)"
  },
  {
    "value": "MGJ",
    "label": "MONTGOMERY (MGJ)"
  },
  {
    "value": "MGR",
    "label": "THOMASVILLE/MOULTRIE (MGR)"
  },
  {
    "value": "MHM",
    "label": "MINCHUMINA (MHM)"
  },
  {
    "value": "MHN",
    "label": "MULLEN (MHN)"
  },
  {
    "value": "MHS",
    "label": "MOUNT SHASTA (MHS)"
  },
  {
    "value": "MHV",
    "label": "MOJAVE (MHV)"
  },
  {
    "value": "MIF",
    "label": "MONAHANS (MIF)"
  },
  {
    "value": "MIO",
    "label": "MIAMI (MIO)"
  },
  {
    "value": "MIT",
    "label": "SHAFTER (MIT)"
  },
  {
    "value": "MIV",
    "label": "MILLVILLE (MIV)"
  },
  {
    "value": "MIW",
    "label": "MARSHALLTOWN (MIW)"
  },
  {
    "value": "MJQ",
    "label": "JACKSON (MJQ)"
  },
  {
    "value": "MJX",
    "label": "TOMS RIVER (MJX)"
  },
  {
    "value": "MKO",
    "label": "MUSKOGEE (MKO)"
  },
  {
    "value": "MLD",
    "label": "MALAD CITY (MLD)"
  },
  {
    "value": "MLF",
    "label": "MILFORD (MLF)"
  },
  {
    "value": "MLJ",
    "label": "MILLEDGEVILLE (MLJ)"
  },
  {
    "value": "MLK",
    "label": "MALTA (MLK)"
  },
  {
    "value": "MLT",
    "label": "MILLINOCKET (MLT)"
  },
  {
    "value": "MMI",
    "label": "ATHENS (MMI)"
  },
  {
    "value": "MMS",
    "label": "MARKS (MMS)"
  },
  {
    "value": "MNN",
    "label": "MARION (MNN)"
  },
  {
    "value": "MNZ",
    "label": "MANASSAS (MNZ)"
  },
  {
    "value": "MOP",
    "label": "MT. PLEASANT (MOP)"
  },
  {
    "value": "MOX",
    "label": "MORRIS (MOX)"
  },
  {
    "value": "MPE",
    "label": "MADISON (MPE)"
  },
  {
    "value": "MPJ",
    "label": "MORRILTON (MPJ)"
  },
  {
    "value": "MPO",
    "label": "MT. POCONO (MPO)"
  },
  {
    "value": "MPR",
    "label": "MC PHERSON (MPR)"
  },
  {
    "value": "MPS",
    "label": "MOUNT PLEASANT (MPS)"
  },
  {
    "value": "MPZ",
    "label": "MT. PLEASANT (MPZ)"
  },
  {
    "value": "MQB",
    "label": "MACOMB (MQB)"
  },
  {
    "value": "MQI",
    "label": "QUINCY (MQI)"
  },
  {
    "value": "MQW",
    "label": "MC RAE (MQW)"
  },
  {
    "value": "MQY",
    "label": "SMYRNA (MQY)"
  },
  {
    "value": "MRB",
    "label": "MARTINSBURG (MRB)"
  },
  {
    "value": "MRC",
    "label": "COLUMBIA (MRC)"
  },
  {
    "value": "MRF",
    "label": "MARFA (MRF)"
  },
  {
    "value": "MRK",
    "label": "MARCO ISLAND (MRK)"
  },
  {
    "value": "MRN",
    "label": "MORGANTON (MRN)"
  },
  {
    "value": "MSC",
    "label": "MESA (MSC)"
  },
  {
    "value": "MSV",
    "label": "MONTICELLO SULLIVAN CO. (MSV)"
  },
  {
    "value": "MTC",
    "label": "MT. CLEMENS (MTC)"
  },
  {
    "value": "MTP",
    "label": "MONTAUK (MTP)"
  },
  {
    "value": "MUU",
    "label": "MOUNT UNION (MUU)"
  },
  {
    "value": "MVC",
    "label": "MONROEVILLE (MVC)"
  },
  {
    "value": "MVE",
    "label": "MONTEVIDEO (MVE)"
  },
  {
    "value": "MVL",
    "label": "STOWE (MVL)"
  },
  {
    "value": "MVM",
    "label": "KAYENTA (MVM)"
  },
  {
    "value": "MVW",
    "label": "MOUNT VERNON (MVW)"
  },
  {
    "value": "MWL",
    "label": "MINERAL WELLS (MWL)"
  },
  {
    "value": "MWM",
    "label": "WINDOM (MWM)"
  },
  {
    "value": "MWO",
    "label": "MIDDLETOWN (MWO)"
  },
  {
    "value": "MWS",
    "label": "MOUNT WILSON (MWS)"
  },
  {
    "value": "MXA",
    "label": "MANILA (MXA)"
  },
  {
    "value": "MXC",
    "label": "MONTICELLO (MXC)"
  },
  {
    "value": "MXE",
    "label": "MAXTON (MXE)"
  },
  {
    "value": "MXG",
    "label": "MARLBOROUGH (MXG)"
  },
  {
    "value": "MXO",
    "label": "MONTICELLO (MXO)"
  },
  {
    "value": "MXY",
    "label": "MC CARTHY (MXY)"
  },
  {
    "value": "MYH",
    "label": "MARBLE CANYON (MYH)"
  },
  {
    "value": "MYK",
    "label": "MAY CREEK (MYK)"
  },
  {
    "value": "MYL",
    "label": "MC CALL (MYL)"
  },
  {
    "value": "MYV",
    "label": "MARYSVILLE (MYV)"
  },
  {
    "value": "MZJ",
    "label": "MARANA (MZJ)"
  },
  {
    "value": "MZZ",
    "label": "MARION (MZZ)"
  },
  {
    "value": "NAX",
    "label": "BARBERS POINT (NAX)"
  },
  {
    "value": "NBP",
    "label": "BATTERY PARK CITY-NEW YORK (NBP)"
  },
  {
    "value": "NCN",
    "label": "NEW CHENEGA (NCN)"
  },
  {
    "value": "NDV",
    "label": "ANACOSTIA-WASHINGTON (NDV)"
  },
  {
    "value": "NEN",
    "label": "WHITEHOUSE (NEN)"
  },
  {
    "value": "NES",
    "label": "EAST 34TH ST. LDG.-NEW YORK (NES)"
  },
  {
    "value": "NFL",
    "label": "FALLON (NFL)"
  },
  {
    "value": "NGC",
    "label": "NORTH RIM-GRAND CANYON (NGC)"
  },
  {
    "value": "NGW",
    "label": "CABANISS-CORPUS CHRISTI (NGW)"
  },
  {
    "value": "NHX",
    "label": "FOLEY (NHX)"
  },
  {
    "value": "NIE",
    "label": "NIBLACK (NIE)"
  },
  {
    "value": "NIN",
    "label": "NINILCHIK (NIN)"
  },
  {
    "value": "NKV",
    "label": "NICHEN COVE (NKV)"
  },
  {
    "value": "NOL",
    "label": "NOKOLIK RIVER (NOL)"
  },
  {
    "value": "NOT",
    "label": "NOVATO (NOT)"
  },
  {
    "value": "NPT",
    "label": "NEWPORT (NPT)"
  },
  {
    "value": "NRC",
    "label": "CROWS LANDING (NRC)"
  },
  {
    "value": "NRI",
    "label": "SHANGRI-LA (NRI)"
  },
  {
    "value": "NTJ",
    "label": "MANTI (NTJ)"
  },
  {
    "value": "NUQ",
    "label": "MOUNTAIN VIEW (NUQ)"
  },
  {
    "value": "NUW",
    "label": "WHIDBEY ISLAND (NUW)"
  },
  {
    "value": "NVD",
    "label": "NEVADA (NVD)"
  },
  {
    "value": "NWH",
    "label": "NEWPORT (NWH)"
  },
  {
    "value": "NWS",
    "label": "PIER 11 WALL ST.-NEW YORK (NWS)"
  },
  {
    "value": "NZW",
    "label": "SOUTH WEYMOUTH (NZW)"
  },
  {
    "value": "OBE",
    "label": "OKEECHOBEE (OBE)"
  },
  {
    "value": "OBK",
    "label": "NORTHBROOK (OBK)"
  },
  {
    "value": "OBT",
    "label": "OAKLAND (OBT)"
  },
  {
    "value": "OCF",
    "label": "OCALA (OCF)"
  },
  {
    "value": "OCH",
    "label": "NACOGDOCHES (OCH)"
  },
  {
    "value": "OCI",
    "label": "OCEANIC (OCI)"
  },
  {
    "value": "OCW",
    "label": "WASHINGTON (OCW)"
  },
  {
    "value": "ODM",
    "label": "OAKLAND (ODM)"
  },
  {
    "value": "OEA",
    "label": "VINCENNES (OEA)"
  },
  {
    "value": "OEO",
    "label": "OSCEOLA (OEO)"
  },
  {
    "value": "OFK",
    "label": "NORFOLK (OFK)"
  },
  {
    "value": "OGA",
    "label": "OGALLALA (OGA)"
  },
  {
    "value": "OGB",
    "label": "ORANGEBURG (OGB)"
  },
  {
    "value": "OGD",
    "label": "OGDEN (OGD)"
  },
  {
    "value": "OHC",
    "label": "NORTHEAST CAPE (OHC)"
  },
  {
    "value": "OIC",
    "label": "NORWICH (OIC)"
  },
  {
    "value": "OIL",
    "label": "OIL CITY (OIL)"
  },
  {
    "value": "OKM",
    "label": "OKMULGEE (OKM)"
  },
  {
    "value": "OKS",
    "label": "OSHKOSH (OKS)"
  },
  {
    "value": "OLE",
    "label": "OLEAN (OLE)"
  },
  {
    "value": "OLS",
    "label": "NOGALES (OLS)"
  },
  {
    "value": "OLU",
    "label": "COLUMBUS (OLU)"
  },
  {
    "value": "OLV",
    "label": "OLIVE BRANCH (OLV)"
  },
  {
    "value": "OLY",
    "label": "OLNEY (OLY)"
  },
  {
    "value": "OMK",
    "label": "OMAK (OMK)"
  },
  {
    "value": "ONA",
    "label": "WINONA (ONA)"
  },
  {
    "value": "ONL",
    "label": "ONEILL (ONL)"
  },
  {
    "value": "ONM",
    "label": "SOCORRO (ONM)"
  },
  {
    "value": "ONN",
    "label": "ONION BAY (ONN)"
  },
  {
    "value": "ONO",
    "label": "ONTARIO (ONO)"
  },
  {
    "value": "ONP",
    "label": "NEWPORT (ONP)"
  },
  {
    "value": "ONY",
    "label": "OLNEY (ONY)"
  },
  {
    "value": "OOA",
    "label": "OSKALOOSA (OOA)"
  },
  {
    "value": "OPL",
    "label": "OPELOUSAS (OPL)"
  },
  {
    "value": "ORQ",
    "label": "NORWALK (ORQ)"
  },
  {
    "value": "OSC",
    "label": "OSCODA (OSC)"
  },
  {
    "value": "OSX",
    "label": "KOSCIUSKO (OSX)"
  },
  {
    "value": "OTN",
    "label": "OAKTOWN (OTN)"
  },
  {
    "value": "OTO",
    "label": "OTTO (OTO)"
  },
  {
    "value": "OUN",
    "label": "NORMAN (OUN)"
  },
  {
    "value": "OVE",
    "label": "OROVILLE (OVE)"
  },
  {
    "value": "OWA",
    "label": "OWATONNA (OWA)"
  },
  {
    "value": "OWK",
    "label": "NORRIDGEWOCK (OWK)"
  },
  {
    "value": "OXC",
    "label": "OXFORD (OXC)"
  },
  {
    "value": "OXD",
    "label": "OXFORD (OXD)"
  },
  {
    "value": "OYS",
    "label": "YOSEMITE NATIONAL PARK (OYS)"
  },
  {
    "value": "OZA",
    "label": "OZONA (OZA)"
  },
  {
    "value": "OZR",
    "label": "OZARK (OZR)"
  },
  {
    "value": "PAK",
    "label": "HANAPEPE (PAK)"
  },
  {
    "value": "PAO",
    "label": "PALO ALTO (PAO)"
  },
  {
    "value": "PBF",
    "label": "PINE BLUFF (PBF)"
  },
  {
    "value": "PBK",
    "label": "PACK CREEK (PBK)"
  },
  {
    "value": "PCD",
    "label": "PRAIRIE DU CHIEN (PCD)"
  },
  {
    "value": "PCE",
    "label": "PAINTER CREEK (PCE)"
  },
  {
    "value": "PCK",
    "label": "PORCUPINE CREEK (PCK)"
  },
  {
    "value": "PCT",
    "label": "PRINCETON (PCT)"
  },
  {
    "value": "PCU",
    "label": "PICAYUNE (PCU)"
  },
  {
    "value": "PEQ",
    "label": "PECOS CITY (PEQ)"
  },
  {
    "value": "PFA",
    "label": "PAF WARREN (PFA)"
  },
  {
    "value": "PFD",
    "label": "PORT FREDERICK (PFD)"
  },
  {
    "value": "PGC",
    "label": "PETERSBURG (PGC)"
  },
  {
    "value": "PGD",
    "label": "PUNTA GORDA (PGD)"
  },
  {
    "value": "PGO",
    "label": "PAGOSA SPRINGS (PGO)"
  },
  {
    "value": "PGS",
    "label": "PEACH SPRINGS (PGS)"
  },
  {
    "value": "PHD",
    "label": "NEW PHILADELPHIA (PHD)"
  },
  {
    "value": "PHK",
    "label": "PAHOKEE (PHK)"
  },
  {
    "value": "PHN",
    "label": "PORT HURON (PHN)"
  },
  {
    "value": "PHP",
    "label": "PHILIP (PHP)"
  },
  {
    "value": "PHT",
    "label": "PARIS (PHT)"
  },
  {
    "value": "PIM",
    "label": "PINE MOUNTAIN (PIM)"
  },
  {
    "value": "PJB",
    "label": "PAYSON (PJB)"
  },
  {
    "value": "PJS",
    "label": "PORT SAN JUAN (PJS)"
  },
  {
    "value": "PKD",
    "label": "PARK RAPIDS (PKD)"
  },
  {
    "value": "PKF",
    "label": "PARK FALLS (PKF)"
  },
  {
    "value": "PLR",
    "label": "PELL CITY (PLR)"
  },
  {
    "value": "PLY",
    "label": "PLYMOUTH (PLY)"
  },
  {
    "value": "PMB",
    "label": "PEMBINA (PMB)"
  },
  {
    "value": "PMU",
    "label": "PAIMIUT (PMU)"
  },
  {
    "value": "PMX",
    "label": "PALMER (PMX)"
  },
  {
    "value": "PNF",
    "label": "PETERSON''S POINT (PNF)"
  },
  {
    "value": "PNN",
    "label": "PRINCETON (PNN)"
  },
  {
    "value": "PNU",
    "label": "PANGUITCH (PNU)"
  },
  {
    "value": "PNX",
    "label": "SHERMAN/DENISON (PNX)"
  },
  {
    "value": "POC",
    "label": "LA VERNE (POC)"
  },
  {
    "value": "POE",
    "label": "FORT POLK (POE)"
  },
  {
    "value": "POF",
    "label": "POPLAR BLUFF (POF)"
  },
  {
    "value": "POH",
    "label": "POCAHONTAS (POH)"
  },
  {
    "value": "POY",
    "label": "LOVELL-POWELL (POY)"
  },
  {
    "value": "PPA",
    "label": "PAMPA (PPA)"
  },
  {
    "value": "PPF",
    "label": "PARSONS (PPF)"
  },
  {
    "value": "PPM",
    "label": "POMPANO BEACH (PPM)"
  },
  {
    "value": "PRL",
    "label": "PORT OCEANIC (PRL)"
  },
  {
    "value": "PRO",
    "label": "PERRY (PRO)"
  },
  {
    "value": "PRW",
    "label": "PRENTICE (PRW)"
  },
  {
    "value": "PRZ",
    "label": "PRINEVILLE (PRZ)"
  },
  {
    "value": "PSB",
    "label": "BELLEFONTE-CLRFLD-PHILIPSBRG (PSB)"
  },
  {
    "value": "PSF",
    "label": "PITTSFIELD (PSF)"
  },
  {
    "value": "PSK",
    "label": "DUBLIN (PSK)"
  },
  {
    "value": "PSN",
    "label": "PALESTINE (PSN)"
  },
  {
    "value": "PSX",
    "label": "PALACIOS (PSX)"
  },
  {
    "value": "PTB",
    "label": "PETERSBURG (PTB)"
  },
  {
    "value": "PTK",
    "label": "PONTIAC (PTK)"
  },
  {
    "value": "PTN",
    "label": "MORGAN CITY/PATTERSON (PTN)"
  },
  {
    "value": "PTR",
    "label": "PLEASANT HARBOR (PTR)"
  },
  {
    "value": "PTS",
    "label": "PITTSBURG (PTS)"
  },
  {
    "value": "PTT",
    "label": "PRATT (PTT)"
  },
  {
    "value": "PTV",
    "label": "PORTERVILLE (PTV)"
  },
  {
    "value": "PTW",
    "label": "POTTSTOWN (PTW)"
  },
  {
    "value": "PUO",
    "label": "PRUDHOE BAY (PUO)"
  },
  {
    "value": "PVF",
    "label": "PLACERVILLE (PVF)"
  },
  {
    "value": "PVW",
    "label": "PLAINVIEW (PVW)"
  },
  {
    "value": "PVY",
    "label": "POPE VANOY (PVY)"
  },
  {
    "value": "PWD",
    "label": "PLENTYWOOD (PWD)"
  },
  {
    "value": "PWR",
    "label": "PORT WALTER (PWR)"
  },
  {
    "value": "PXL",
    "label": "POLACCA (PXL)"
  },
  {
    "value": "PYL",
    "label": "PERRY ISLAND (PYL)"
  },
  {
    "value": "SPZ",
    "label": "SPRINGDALE (SPZ)"
  },
  {
    "value": "SQA",
    "label": "SANTA YNEZ (SQA)"
  },
  {
    "value": "SQI",
    "label": "STERLING ROCK FALLS (SQI)"
  },
  {
    "value": "SQL",
    "label": "SAN CARLOS (SQL)"
  },
  {
    "value": "SQV",
    "label": "SEQUIM (SQV)"
  },
  {
    "value": "SRC",
    "label": "SEARCY (SRC)"
  },
  {
    "value": "SRF",
    "label": "SAN RAFAEL (SRF)"
  },
  {
    "value": "SRU",
    "label": "SANTA CRUZ (SRU)"
  },
  {
    "value": "SRV",
    "label": "STONY RIVER (SRV)"
  },
  {
    "value": "SRW",
    "label": "SALISBURY (SRW)"
  },
  {
    "value": "SSC",
    "label": "SUMTER (SSC)"
  },
  {
    "value": "SSU",
    "label": "WHITE SULPHUR SPRGS (SSU)"
  },
  {
    "value": "SSW",
    "label": "STUART ISLAND (SSW)"
  },
  {
    "value": "STJ",
    "label": "ST. JOSEPH (STJ)"
  },
  {
    "value": "STK",
    "label": "STERLING (STK)"
  },
  {
    "value": "STQ",
    "label": "ST. MARYS (STQ)"
  },
  {
    "value": "SUA",
    "label": "STUART (SUA)"
  },
  {
    "value": "SUC",
    "label": "SUNDANCE (SUC)"
  },
  {
    "value": "SUD",
    "label": "STROUD (SUD)"
  },
  {
    "value": "SUW",
    "label": "BONG-DULUTH MN/SUPERIOR (SUW)"
  },
  {
    "value": "SVE",
    "label": "SUSANVILLE (SVE)"
  },
  {
    "value": "SVH",
    "label": "STATESVILLE (SVH)"
  },
  {
    "value": "SWO",
    "label": "STILLWATER (SWO)"
  },
  {
    "value": "SWW",
    "label": "SWEETWATER (SWW)"
  },
  {
    "value": "SXY",
    "label": "SIDNEY (SXY)"
  },
  {
    "value": "SYI",
    "label": "SHELBYVILLE (SYI)"
  },
  {
    "value": "SYV",
    "label": "SYLVESTER (SYV)"
  },
  {
    "value": "TAD",
    "label": "TRINIDAD (TAD)"
  },
  {
    "value": "TBC",
    "label": "TUBA CITY (TBC)"
  },
  {
    "value": "TBR",
    "label": "STATESBORO (TBR)"
  },
  {
    "value": "TCC",
    "label": "TUCUMCARI (TCC)"
  },
  {
    "value": "TCS",
    "label": "TRUTH OR CONSEQUENCES (TCS)"
  },
  {
    "value": "TDO",
    "label": "TOLEDO (TDO)"
  },
  {
    "value": "TEK",
    "label": "TATITLEK (TEK)"
  },
  {
    "value": "TGE",
    "label": "TUSKEGEE (TGE)"
  },
  {
    "value": "THA",
    "label": "TULLAHOMA (THA)"
  },
  {
    "value": "THM",
    "label": "THOMPSONFIELD (THM)"
  },
  {
    "value": "THP",
    "label": "THERMOPOLIS (THP)"
  },
  {
    "value": "THV",
    "label": "YORK (THV)"
  },
  {
    "value": "TIW",
    "label": "TACOMA (TIW)"
  },
  {
    "value": "TIX",
    "label": "TITUSVILLE (TIX)"
  },
  {
    "value": "TKF",
    "label": "TRUCKEE (TKF)"
  },
  {
    "value": "TKL",
    "label": "TAKU LODGE (TKL)"
  },
  {
    "value": "TLF",
    "label": "TELIDA (TLF)"
  },
  {
    "value": "TLR",
    "label": "TULARE (TLR)"
  },
  {
    "value": "TMA",
    "label": "TIFTON (TMA)"
  },
  {
    "value": "TNP",
    "label": "TWENTYNINE PALMS (TNP)"
  },
  {
    "value": "TNU",
    "label": "NEWTON (TNU)"
  },
  {
    "value": "TOA",
    "label": "TORRANCE (TOA)"
  },
  {
    "value": "TOC",
    "label": "TOCCOA (TOC)"
  },
  {
    "value": "TOI",
    "label": "TROY (TOI)"
  },
  {
    "value": "TPH",
    "label": "TONOPAH (TPH)"
  },
  {
    "value": "TPO",
    "label": "TANALIAN POINT (TPO)"
  },
  {
    "value": "TRH",
    "label": "TRONA (TRH)"
  },
  {
    "value": "TRL",
    "label": "TERRELL (TRL)"
  },
  {
    "value": "TRM",
    "label": "THERMAL (TRM)"
  },
  {
    "value": "TRT",
    "label": "TREMONTON (TRT)"
  },
  {
    "value": "TRX",
    "label": "TRENTON (TRX)"
  },
  {
    "value": "WSB",
    "label": "STEAMBOAT BAY (WSB)"
  },
  {
    "value": "WSH",
    "label": "SHIRLEY (WSH)"
  },
  {
    "value": "WSJ",
    "label": "SAN JUAN (WSJ)"
  },
  {
    "value": "WSM",
    "label": "WISEMAN (WSM)"
  },
  {
    "value": "WTC",
    "label": "WRLD TRADE CTR-NEW YORK (WTC)"
  },
  {
    "value": "WTR",
    "label": "WHITERIVER (WTR)"
  },
  {
    "value": "WVI",
    "label": "WATSONVILLE (WVI)"
  },
  {
    "value": "WWA",
    "label": "WASILLA (WWA)"
  },
  {
    "value": "WWR",
    "label": "WOODWARD (WWR)"
  },
  {
    "value": "WYB",
    "label": "YES BAY (WYB)"
  },
  {
    "value": "XES",
    "label": "LAKE GENEVA (XES)"
  },
  {
    "value": "XMD",
    "label": "MADISON (XMD)"
  },
  {
    "value": "XPU",
    "label": "WEST KUPARUK (XPU)"
  },
  {
    "value": "XSM",
    "label": "ST. MARY''S (XSM)"
  },
  {
    "value": "XYZ",
    "label": "DAYTONA BEACH (XYZ)"
  },
  {
    "value": "ZBS",
    "label": "BUS STN.-MESA (ZBS)"
  },
  {
    "value": "ZBX",
    "label": "BRANSON (ZBX)"
  },
  {
    "value": "ZPH",
    "label": "ZEPHYRHILLS (ZPH)"
  },
  {
    "value": "LEE",
    "label": "LEESBURG (LEE)"
  },
  {
    "value": "PLI",
    "label": "PALM ISLAND (PLI)"
  },
  {
    "value": "CGU",
    "label": "CIUDAD GUAYANA (CGU)"
  },
  {
    "value": "PPZ",
    "label": "PUERTO PAEZ (PPZ)"
  },
  {
    "value": "QUC",
    "label": "PUERTO LA CRUZ (QUC)"
  },
  {
    "value": "TOV",
    "label": "WESTEND SP-TORTOLA (TOV)"
  },
  {
    "value": "SJF",
    "label": "ST. JOHN (SJF)"
  },
  {
    "value": "CSJ",
    "label": "CAPE ST. JACQUES (CSJ)"
  },
  {
    "value": "HOO",
    "label": "QUAN DUC (HOO)"
  },
  {
    "value": "SOA",
    "label": "SOC TRANG (SOA)"
  },
  {
    "value": "VSO",
    "label": "PHUOCLONG (VSO)"
  },
  {
    "value": "XLO",
    "label": "LONG XUYEN (XLO)"
  },
  {
    "value": "XNG",
    "label": "QUANG NGAI (XNG)"
  },
  {
    "value": "XVL",
    "label": "VINH LONG (XVL)"
  },
  {
    "value": "EPI",
    "label": "EPI (EPI)"
  },
  {
    "value": "GBA",
    "label": "BIG BAY (GBA)"
  },
  {
    "value": "LAV",
    "label": "LALOMALAVA (LAV)"
  },
  {
    "value": "DAH",
    "label": "DATHINA (DAH)"
  },
  {
    "value": "DHL",
    "label": "DHALA (DHL)"
  },
  {
    "value": "LDR",
    "label": "LODAR (LDR)"
  },
  {
    "value": "MFY",
    "label": "MAYFA''AH (MFY)"
  },
  {
    "value": "MKX",
    "label": "MUKALLA (MKX)"
  },
  {
    "value": "RXA",
    "label": "RAUDHA (RXA)"
  },
  {
    "value": "AJO",
    "label": "ALJOUF (AJO)"
  },
  {
    "value": "BYD",
    "label": "BEIDAH (BYD)"
  },
  {
    "value": "DMR",
    "label": "DHAMAR (DMR)"
  },
  {
    "value": "KAM",
    "label": "KAMARAN IS. (KAM)"
  },
  {
    "value": "QER",
    "label": "SHEHR (QER)"
  },
  {
    "value": "HBL",
    "label": "BABELEGI (HBL)"
  },
  {
    "value": "MWR",
    "label": "MOTSWARI (MWR)"
  },
  {
    "value": "KGN",
    "label": "KASONGO LUNDA (KGN)"
  },
  {
    "value": "BJN",
    "label": "BAJONE (BJN)"
  },
  {
    "value": "CMZ",
    "label": "CAIA (CMZ)"
  },
  {
    "value": "IBO",
    "label": "IBO (IBO)"
  },
  {
    "value": "IMG",
    "label": "INHAMINGA (IMG)"
  },
  {
    "value": "INE",
    "label": "CHINDE (INE)"
  },
  {
    "value": "LBM",
    "label": "LUABO (LBM)"
  },
  {
    "value": "LMZ",
    "label": "PALMA (LMZ)"
  },
  {
    "value": "MFW",
    "label": "MAGARUQUE (MFW)"
  },
  {
    "value": "MJS",
    "label": "MAGANJA DA COSTA (MJS)"
  },
  {
    "value": "MMW",
    "label": "MOMA (MMW)"
  },
  {
    "value": "NND",
    "label": "NANGADE (NND)"
  },
  {
    "value": "NTC",
    "label": "SANTA CAROLINA (NTC)"
  },
  {
    "value": "PEB",
    "label": "PEBANE (PEB)"
  },
  {
    "value": "RRM",
    "label": "MARROMEU (RRM)"
  },
  {
    "value": "VJQ",
    "label": "GURUE (VJQ)"
  },
  {
    "value": "AIW",
    "label": "AI-AIR (AIW)"
  },
  {
    "value": "KAS",
    "label": "KARASBURG (KAS)"
  },
  {
    "value": "MQG",
    "label": "MILGARD (MQG)"
  },
  {
    "value": "OGV",
    "label": "ONGAVA GAME RESERVE (OGV)"
  },
  {
    "value": "OTJ",
    "label": "OTJIWARONGO (OTJ)"
  },
  {
    "value": "SZM",
    "label": "SESRIEM (SZM)"
  },
  {
    "value": "TCY",
    "label": "TERRACE BAY (TCY)"
  },
  {
    "value": "HNG",
    "label": "HIENGHENE (HNG)"
  },
  {
    "value": "BKN",
    "label": "BIRNI NKONI (BKN)"
  },
  {
    "value": "HVM",
    "label": "HVAMMSTANGI (HVM)"
  },
  {
    "value": "RHA",
    "label": "REYKHOLAR (RHA)"
  },
  {
    "value": "SEJ",
    "label": "SEYDISFJORDUR (SEJ)"
  },
  {
    "value": "SUY",
    "label": "SUDUREYRI (SUY)"
  },
  {
    "value": "TLK",
    "label": "TALKNAFJORDUR (TLK)"
  },
  {
    "value": "JLO",
    "label": "JESOLO (JLO)"
  },
  {
    "value": "PRJ",
    "label": "CAPRI (PRJ)"
  },
  {
    "value": "QXE",
    "label": "SORA (QXE)"
  },
  {
    "value": "RRO",
    "label": "SORRENTO (RRO)"
  },
  {
    "value": "SWK",
    "label": "SEGRATE-MILAN (SWK)"
  },
  {
    "value": "MVJ",
    "label": "MANDEVILLE (MVJ)"
  },
  {
    "value": "MPQ",
    "label": "MAAN (MPQ)"
  },
  {
    "value": "BPU",
    "label": "BEPPU (BPU)"
  },
  {
    "value": "IIN",
    "label": "NISHINOOMOTE (IIN)"
  },
  {
    "value": "KUJ",
    "label": "KUSHIMOTO-KATSUURA (KUJ)"
  },
  {
    "value": "OMJ",
    "label": "OMURA (OMJ)"
  },
  {
    "value": "SDO",
    "label": "RYOTSU SADO ISLAND (SDO)"
  },
  {
    "value": "NZO",
    "label": "NZOIA (NZO)"
  },
  {
    "value": "KZD",
    "label": "KRAKOR (KZD)"
  },
  {
    "value": "KZK",
    "label": "KOMPONG THOM (KZK)"
  },
  {
    "value": "OMY",
    "label": "ODDOR MEANCHE (OMY)"
  },
  {
    "value": "PAI",
    "label": "PAILIN (PAI)"
  },
  {
    "value": "SVR",
    "label": "SVAY RIENG (SVR)"
  },
  {
    "value": "TNQ",
    "label": "TERAINA (TNQ)"
  },
  {
    "value": "JCJ",
    "label": "CHU JA-CHEJU (JCJ)"
  },
  {
    "value": "TFU",
    "label": "Chengdu Tianfu (TFU)"
  }
];

export default Airports;
